// @ts-nocheck
import { useState, useEffect } from 'react';
import { MCP_SERVERS_LOCALIZATION, type McpServersStrings } from './mcpServersLocalization';
import { INVALID_PRICING_AGGREGATE_MESSAGES } from './pricingAggregateMessages';

export type Language = 'ru' | 'en';

export interface LocalizationStrings {
  draftFinal: {
    button: string;
    confirmTitle: string;
    confirmMessage: string;
    estimatedCost: string;
    loadError: string;
    started: string;
  };
  mcpServers: McpServersStrings;
  // Header
  appTitle: string;
  appSubtitle: string;
  
  // Status indicators
  statusReady: string;
  
  // AI Settings
  aiSettings: string;
  aiSettingsDescription: string;
  geminiModel: string;
  promptStyle: string;
  generationMode: string;
  advancedSettings: string;
  
  // Image Parameters
  imageParameters: string;
  imageParametersDescription: string;
  quantity: string;
  size: string;
  quantityTooltip: string;
  sizeTooltip: string;
  estimatedTime: string;
  fixedSeedLabel: string;
  fixedSeedTooltip: string;
  
  // Prompt and Content
  promptAndContent: string;
  promptAndContentDescription: string;
  imageUpload: string;
  imageUploadDescription: string;
  imageDescription: string;
  imageDescriptionTooltip: string;
  generationModeTitle: string;
  generationModeDescription: string;
  
  // Modes
  textToImage: string;
  reduxTransform: string;
  imageContext: string;
  multiContext: string;
  removeBg: string;
  textToImageDesc: string;
  reduxTransformDesc: string;
  imageContextDesc: string;
  multiContextDesc: string;
  removeBgDesc: string;
  
  // Gallery (deprecated - use gallery object below)
  // gallery: string;
  galleryDescription: string;
  noImagesYet: string;
  
  // Gemini Settings
  geminiSettings: string;
  geminiSettingsSubtitle: string;
  language: string;
  languageDesc: string;
  readyTemplates: string;
  technicalPrompts: string;
  customPrompt: string;
  currentSelectedPrompt: string;
  stylization: string;
  stylizationDesc: string;
  
  // Technical Prompts
  technicalPromptsTitle: string;
  technicalPromptsDescription: string;
  systemPrompt: string;
  imageAnalysis: string;
  imageAnalysisDesc: string;
  imageContextPrompt: string;
  imageContextDesc: string;
  imageContextTechDesc: string;
  multiContextPrompt: string;
  multiContextDesc: string;
  multiContextTechDesc: string;
  reduxTransformation: string;
  reduxTransformationDesc: string;
  
        // Categories
  creative: string;
  professional: string;
  artistic: string;
  technical: string;
  realism: string;
  portrait: string;
  character: string;
  landscape: string;
  location: string;
  isometric: string;
  icons: string;
  splash: string;
  ui: string;
  sdg: string;
  
  // Actions
  preview: string;
  select: string;
  close: string;
  ready: string;
  save: string;
  saveAndApply: string;
  fixPrompt: string;
  generate: string;
  describeImage: string;
  analyzePhoto: string;
  analyzingPhoto: string;
  
  // Prompt examples
  customPromptTitle: string;
  customPromptDescription: string;
  customPromptExample: string;
  
  // Size options
  square: string;
  squareHd: string;
  portrait43: string;
  portrait169: string;
  landscape43: string;
  landscape169: string;
  
  // Model descriptions
  gemini15Pro: string;
  gemini15Flash: string;
  gemini20Flash: string;
  gemini25ProPreview: string;
  gemini25FlashPreview1: string;
  gemini25FlashPreview2: string;
  
  // Template names and descriptions
  creativeDetailed: string;
  creativeDetailedDesc: string;
  professionalPhoto: string;
  professionalPhotoDesc: string;
  artisticStyle: string;
  artisticStyleDesc: string;
  cinematicEpic: string;
  cinematicEpicDesc: string;
  technicalPrecise: string;
  technicalPreciseDesc: string;
  minimalistClean: string;
  minimalistCleanDesc: string;
  fantasyMagical: string;
  fantasyMagicalDesc: string;
  retroVintage: string;
  retroVintageDesc: string;
  creativeCampaigns: string;
  creativeCampaignsDesc: string;
  portraitCgi: string;
  portraitCgiDesc: string;
  portraitWatercolor: string;
  portraitWatercolorDesc: string;
  portraitAnimeGhibli: string;
  portraitAnimeGhibliDesc: string;
  portraitVector: string;
  portraitVectorDesc: string;
  
  // UI Elements
  dropImages: string;
  dragDropText: string;
  estimatedTimeText: string;
  charactersCount: string;
  madeWith: string;
  poweredBy: string;
  customPromptPlaceholder: string;
  sessionPromptPlaceholder: string;
  sessionChangesNote: string;
  reset: string;
  apply: string;
  selected: string;
  usingCustom: string;
  usingSession: string;
  uiElements: string;
  
  // Tooltips
  notAvailableInMode: string;
  imageCount1: string;
  imageCount2: string;
  imageCount3: string;
  imageCount4: string;

  // NEW ADDITIONS - PromptBox
  promptBoxTitle: string;
  clear: string;
  clearTooltip: string;
  promptPlaceholder: string;
  hideExamples: string;
  showExamples: string;
  enhancing: string;
  describing: string;
  generating: string;
  examplesTitle: string;
  examplesTip: string;

  // NEW ADDITIONS - Gallery
  allImages: string;
  noImagesForMode: string;
  createFirstImage: string;
  tryCreateInMode: string;
  imageLoadError: string;
  loadingImage: string;
  enlarge: string;
  copyPrompt: string;
  download: string;
  downloaded: string;
  downloadOriginal: string;
  downloadWebP: string;
  downloadedWebP: string;
  usePrompt: string;
  enlargedView: string;
  promptLabel: string;
  copy: string;
  downloadError: string;
  
  // NEW ADDITIONS - DropZone
  dropFilesHere: string;
  uploadImages: string;
  dragDropHere: string;
  dragFilesToZone: string;
  clickToSelect: string;
  supportedFormats: string;
  maxSize: string;
  noLimit: string;
  uploadedFiles: string;
  clearAll: string;
  removeImage: string;
  totalFiles: string;
  totalSize: string;
  readyToGenerate: string;
  uploadTips: string;
  qualityTip: string;
  formatTip: string;
  sizeTip: string;
  compositionTip: string;
  readyForProcessing: string;

  // NEW ADDITIONS - Error messages
  fixPromptError: string;
  describeError: string;
  unknownError: string;
  uploadImageFirst: string;
  describeImageError: string;
  generationError: string;
  tooManyImagesError: string;
  
  // Alert messages
  maxReferencesAlert: string;
  filesUploadedAlert: string;
  compressionError: string;
  enterTextToTranslate: string;
  translationError: string;
  jsonParseError: string;
  promptRegenerationError: string;
  removeBgRequiresImage: string;
  removeBgOnlyOneImage: string;
  modeRequiresImage: string;
  fillRequiresMask: string;
  
  // NEW ADDITIONS - Mode descriptions
  text2imgModeDesc: string;
  img2imgModeDesc: string;
  imgKontextModeDesc: string;
  multiKontextModeDesc: string;

  // NEW ADDITIONS - Model descriptions
  gemini15ProDesc: string;
  gemini15FlashDesc: string;
  gemini20FlashDesc: string;
  gemini25ProPreviewDesc: string;
  gemini25FlashPreview1Desc: string;
  gemini25FlashPreview2Desc: string;

  // NEW ADDITIONS - Size descriptions with icons
  squareHdDesc: string;
  squareDesc: string;
  portrait43Desc: string;
  portrait169Desc: string;
  landscape43Desc: string;
  landscape169Desc: string;
  cinematic219: string;
  cinematic921: string;
  photo32: string;
  photo23: string;
  cinematic219Desc: string;
  cinematic921Desc: string;
  photo32Desc: string;
  photo23Desc: string;

  // NEW ADDITIONS - Prompt suggestions
  suggestion1: string;
  suggestion2: string;
  suggestion3: string;
  suggestion4: string;
  suggestion5: string;
  suggestion6: string;
  suggestion7: string;
  suggestion8: string;
  
  // Modal close instruction
  modalCloseInstruction: string;

  // NEW ADDITIONS - Your Prompt
  yourPrompt: string;
  
  // Translation
  translate: string;
  translating: string;
  
  // Auth buttons
  signIn: string;
  signUp: string;
  
  // Raw Mode
  rawMode: string;
  rawModeDesc: string;
  
  // API Limitation notifications
  apiLimitTemplate: string;
  modeNameFill: string;
  modeNameCanny: string;
  modeNameDepth: string;
  
  // Safety levels
  safetyStrict: string;
  safetyBalanced: string;
  safetySoft: string;
  safetyDisabled: string;
  
  // Settings panel
  settings: string;
  imageSize: string;
  numImages: string;
  prompts: string;
  
  // Settings Context
  settingsContext: {
    title: string;
    subtitle: string;
    userSettings: string;
    notifications: string;
    notificationsDesc: string;
    enable: string;
    system: string;
    systemAdministration: string;
    sendFeedback: string;
    sendFeedbackDesc: string;
    logoutDesc: string;
    about: string;
    version: string;
    build: string;
    environment: string;
    copyright: string;
    madeWith: string;
  };
  
  // Gallery Context
  galleryContext: {
    title: string;
    searchImages: string;
    filters: string;
    recent: string;
    viewAll: string;
    statistics: string;
    totalImages: string;
    thisMonth: string;
    storageUsed: string;
    actions: string;
    exportAll: string;
    deleteSelected: string;
    share: string;
    downloadZip: string;
    favorites: string;
    emptyState: string;
  };

  // Gallery Widget - Live Generation
  galleryWidget: {
    generationResults: string;
    noGenerations: string;
    startGenerating: string;
    clearAll: string;
    addFavorite: string;
    removeFavorite: string;
    viewFull: string;
    download: string;
    copyPrompt: string;
    helpTitle: string;
    helpWhatIs: string;
    helpWhatIsDesc: string;
    helpSessionOnly: string;
    helpSessionOnlyDesc: string;
    helpActions: string;
    helpFavorite: string;
    helpDownload: string;
    helpCopy: string;
    helpPreview: string;
  };

  // Session Gallery Widget - for image generation page
  sessionGallery: {
    title: string;
    helpTitle: string;
    helpWhatIs: string;
    helpWhatIsDesc: string;
    helpSessionOnly: string;
    helpSessionOnlyDesc: string;
    helpActions: string;
    helpFavorite: string;
    helpDownload: string;
    helpCopy: string;
    helpPreview: string;
    previousGeneration: string;
    nextGeneration: string;
  };

  // Gallery Page - Comprehensive Image Gallery
  galleryPage: {
    title: string;
    subtitle: string;
    searchPlaceholder: string;
    filters: string;
    clearFilters: string;
    activeFilters: string;
    clearAllFilters: string;
    showFilters: string;
    hideFilters: string;
    collections: string;
    allCollections: string;
    users: string;
    allUsers: string;
    workflows: string;
    allWorkflows: string;
    dateRange: string;
    dateFrom: string;
    dateTo: string;
    urlType: string;
    allTypes: string;
    preview: string;
    original: string;
    external: string;
    mixed: string;
    displaySettings: string;
    viewMode: string;
    gridView: string;
    listView: string;
    zoom: string;
    zoomSmall: string;
    zoomMediumSmall: string;
    zoomMedium: string;
    zoomMediumLarge: string;
    zoomLarge: string;
    loading: string;
    loadingMore: string;
    noResults: string;
    noResultsDesc: string;
    totalImages: string;
    selectedImages: string;
    selectAll: string;
    deselectAll: string;
    bulkActions: string;
    downloadSelected: string;
    deleteSelected: string;
    addToCollection: string;
    removeFromCollection: string;
    imageDetails: string;
    prompt: string;
    createdAt: string;
    createdBy: string;
    workflow: string;
    collection: string;
    dimensions: string;
    fileSize: string;
    generationId: string;
    copyId: string;
    noAccess: string;
    noAccessDesc: string;
    errorLoading: string;
    errorLoadingDesc: string;
    retry: string;
    selectCollections: string;
    searchCollections: string;
    selectUsers: string;
    searchUsers: string;
    selectWorkflows: string;
    searchWorkflows: string;
    filtersAvailableInGallery: string;
    filterSelected: string;
    filterNoWorkflows: string;
    filterNoUsers: string;
    audioLabel: string;
    // Prompt V2 display in preview modal
    selectedReferences: string;
    noReferences: string;
    references: string;
    referenceImages: string;
    holdToZoom: string;
    downloadFailed: string;
    downloadPartialFail: string;
    generationParams: string;
    booleanYes: string;
    booleanNo: string;
  };

  // Prompt Editor Widget
  promptEditor: {
    helpTitle: string;
    helpWhatIs: string;
    helpWhatIsDesc: string;
    helpHowToUse: string;
    helpHowToUseDesc: string;
    helpSubject: string;
    helpStyle: string;
    helpColors: string;
    helpComposition: string;
    helpTips: string;
    helpTip1: string;
    helpTip2: string;
    helpTip3: string;
    helpTip4: string;
  };

  // Modal
  modal: {
    close: string;
  };
  
  // Help Context
  helpContext: {
    title: string;
    subtitle: string;
    linksTitle: string;
    termsOfService: string;
    privacyNotice: string;
    supportEmail: string;
    supportEmailAddress: string;
    mainTitle: string;
    mainDescription: string;
    documentation: string;
    mcpIntegration: string;
  };

  // MCP Documentation Page
  mcpDocs: {
    title: string;
    backToHelp: string;
    loading: string;
    loadError: string;
    forLlm: string;
  };

  // Video Context
  videoContext: {
    title: string;
    comingSoon: string;
  };
  
  // Icon Bar
  iconBar: {
    home: string;
    profile: string;
    image: string;
    multi: string;
    gallery: string;
    video: string;
    audio: string;
    text: string;
    threeD: string;
    settings: string;
    help: string;
    collapse: string;
    expand: string;
    admin: string;
  };

  // Multi (parallel multi-model generation)
  multiGen: {
    title: string;
    subtitle: string;
    models: string;
    taskType: string;
    noModelsForTab: string;
    noTabs: string;
    settings: string;
    settingsFlyoutTitle: string;
    settingsFlyoutClose: string;
    generate: string;
    generateCount: string;
    generating: string;
    results: string;
    totalCost: string;
    noModelsSelected: string;
    sharedInput: string;
    noModelSettings: string;
    unsupportedModel: string;
    multiSlotModel: string;
    multiViewAllPerRequestModel: string;
    requiredViewMissing: string;
    modelInvalid: string;
    sourceImageRequired: string;
    sourceVideoRequired: string;
    secondViewRequired: string;
    sharedInputInvalid: string;
    settingsLoading: string;
    prompt: string;
    settingsLoadFailed: string;
    allModelsInvalid: string;
    someModelsSkipped: string;
    launchFailed: string;
    loadError: string;
    retry: string;
    pendingEstimates: string;
    tabs: {
      text2image: string;
      image2image: string;
      text2video: string;
      image2video: string;
      video2video: string;
      text2_3d: string;
      image2_3d: string;
      multiimage2_3d: string;
    };
  };

  // Organization Context
  organizationContext: {
    profile: string;
  };

  // Admin Context
  adminContext: {
    title: string;
    subtitle: string;
    dashboard: string;
    dashboardDesc: string;
    users: string;
    usersDesc: string;
    organizations: string;
    organizationsDesc: string;
    prompts: string;
    promptsDesc: string;
    'prompts-v2': string;
    'prompts-v2Desc': string;
    'prompt-categories': string;
    'prompt-categoriesDesc': string;
    widgets: string;
    widgetsDesc: string;
    workflows: string;
    workflowsDesc: string;
    debug: string;
    debugDesc: string;
    billing: string;
    billingDesc: string;
    packages: string;
    packagesDesc: string;
    refunds: string;
    refundsDesc: string;
    'api-keys': string;
    'api-keysDesc': string;
    quickStats: string;
    administration: string;
    systemStatus: string;
    operational: string;
    connected: string;
    available: string;
    active: string;
    accessDenied: string;
    accessDeniedDesc: string;
  };

  // Organization Info Page
  organizationInformation: string;
  backToHome: string;
  members: string;
  generationLimit: string;
  tokensRemaining: string;
  used: string;
  yourRole: string;
  organizationMembers: string;
  yourGenerationHistory: string;
  leaveOrganization: string;
  leaving: string;
  cannotLeaveAsOnlyAdmin: string;
  cannotLeaveOrganization: string;
  leaveOrganizationConfirm: string;
  leave: string;
  cancel: string;
  organizationLeft: string;
  leftOrganizationSuccess: string;
  failedToLeaveOrganization: string;
  error: string;
  promptCopiedToClipboard: string;
  failedToCopyPrompt: string;
  loadingMembers: string;
  membersNotFound: string;
  noGenerationsYet: string;
  loadMore: string;
  loading: string;
  joinedOn: string;
  email: string;
  name: string;
  role: string;
  joinedAt: string;

  // Navigation keys
  nav: {
    home: string;
    organization: string;
    manager: string;
    info: string;
    history: string;
    navigateTo: string;
    workflow: string;
    management: string;
    managementDesc: string;
    prompts: string;
    promptsDesc: string;
    promptsOld: string;
    promptsOldDesc: string;
    categories: string;
    categoriesDesc: string;
    corpPrompts: string;
    corpPromptsDesc: string;
    myReferences: string;
    myReferencesDesc: string;
    organizationInfoDesc: string;
    historyDesc: string;
    actions: string;
    collections: string;
    collectionsDesc: string;
    billing: string;
    billingDesc: string;
    billingAddress: string;
    billingAddressDesc: string;
    invoices: string;
    invoicesDesc: string;
    openInNewTab: string;
    logout: string;
    allRefunds: string;
    allRefundsDesc: string;
  };

  // Organization Categories
  orgCategories: {
    title: string;
    description: string;
    searchPlaceholder: string;
    allTypes: string;
    imageOnly: string;
    videoOnly: string;
    import: string;
    export: string;
    noCategories: string;
    categoryEnabled: string;
    categoryDisabled: string;
    fetchError: string;
    toggleError: string;
    exportSuccess: string;
    exportError: string;
    importSuccess: string;
    importError: string;
    imported: string;
    skipped: string;
    // Edit/Delete organization categories
    edit: string;
    delete: string;
    editCategory: string;
    deleteCategory: string;
    confirmDelete: string;
    confirmDeleteMessage: string;
    editSuccess: string;
    editError: string;
    deleteSuccess: string;
    deleteError: string;
    nameEn: string;
    nameRu: string;
    descriptionEn: string;
    descriptionRu: string;
    save: string;
    cancel: string;
    organizationOwned: string;
    // Create subcategory
    categoryCreated: string;
    addSubcategory: string;
    // Delete permission errors
    cannotDeleteOthersPrompts: string;
    cannotDeleteOthersPromptsDetail: string;
    checkingPermissions: string;
    // Prompts list in delete modal
    promptsInCategory: string;
    yourPrompt: string;
    otherUserPrompt: string;
    andMorePrompts: string;
    // Delete all categories
    deleteAll: string;
    deleteAllTitle: string;
    deleteAllConfirmMessage: string;
    deleteAllSuccess: string;
    deleteAllSuccessTitle: string;
    deleteAllResultMessage: string;
    deleteAllError: string;
    noOrgCategoriesToDelete: string;
    typeDeleteToConfirm: string;
    // Import mode selection
    importModeTitle: string;
    importModeDescription: string;
    importModeMerge: string;
    importModeMergeDescription: string;
    importModeReplace: string;
    importModeReplaceDescription: string;
    importModeReplaceWarning: string;
    // Import results - reactivation/cleanup
    reactivated: string;
    reactivatedDescription: string;
    cleanedUp: string;
    cleanedUpDescription: string;
  };

  // Analysis Config (Category Settings)
  analysisConfig: {
    title: string;
    apiUrl: string;
    apiUrlHelp: string;
    workflowUrl: string;
    workflowUrlHelp: string;
    apiKey: string;
    apiKeyHelp: string;
    prompt: string;
    promptHint: string;
    extraParams: string;
    extraParamsHelp: string;
    addParam: string;
    paramKey: string;
    paramValue: string;
    fieldMapping: string;
    requestFields: string;
    responseFields: string;
    inheritHelp: string;
    apiUrlRequired: string;
    apiKeyRequired: string;
  };

  // Organization References
  orgReferences: {
    title: string;
    description: string;
    userDescription: string;
    searchPlaceholder: string;
    allContent: string;
    sfwOnly: string;
    nsfwOnly: string;
    create: string;
    createPrompt: string;
    editPrompt: string;
    import: string;
    export: string;
    deleteAll: string;
    totalPrompts: string;
    noPrompts: string;
    createFirst: string;
    edit: string;
    delete: string;
    titleLabel: string;
    titlePlaceholder: string;
    descriptionLabel: string;
    descriptionPlaceholder: string;
    bodyLabel: string;
    bodyPlaceholder: string;
    categoriesLabel: string;
    selectCategory: string;
    validationError: string;
    createSuccess: string;
    createError: string;
    updateSuccess: string;
    updateError: string;
    deleteSuccess: string;
    deleteError: string;
    deleteConfirmTitle: string;
    deleteConfirmMessage: string;
    deleteAllConfirmTitle: string;
    deleteAllConfirmMessage: string;
    deleteAllSuccess: string;
    deleteAllError: string;
    exportSuccess: string;
    exportError: string;
    importSuccess: string;
    importError: string;
    fetchError: string;
    imported: string;
    skipped: string;
    typeDeleteToConfirm: string;
    // Reference modal - media grid
    createReference: string;
    editReference: string;
    viewReference: string;
    mediaSection: string;
    mediaCounter: string;
    mediaUpload: string;
    mediaFromGallery: string;
    mediaRemove: string;
    mediaDragHint: string;
    mediaMaxReached: string;
    maxImagesReached: string;
    maxVideosReached: string;
    maxAudioReached: string;
    limitsImages: string;
    limitsVideo: string;
    limitsAudio: string;
    limitsDuration: string;
    mediaTypeImage: string;
    mediaTypeVideo: string;
    mediaTypeAudio: string;
    bodyOptionalLabel: string;
    bodyOptionalPlaceholder: string;
    analyzeReferences: string;
    analyzingReferences: string;
    analyzeError: string;
    autoFillAll: string;
    autoFillField: string;
    autoFilling: string;
    autoFillLocked: string;
    autoFillUnlocked: string;
    autoFillHelpText: string;
    analyseReferences: string;
    analyseReferencesHint: string;
    analyseReferencesNoMedia: string;
    analysisPromptPlaceholder: string;
    runAnalysis: string;
    runAutoAnalysis: string;
    cancelAnalysis: string;
    noAnalysisUrl: string;
    previewPayload: string;
    previewPayloadTitle: string;
    previewCurrent: string;
    previewCopy: string;
    previewCopied: string;
    saving: string;
    save: string;
    cancel: string;
    uploading: string;
    uploadError: string;
    generateDescriptionError: string;
    analyzeImages: string;
    analyzing: string;
    expandAll: string;
    collapseAll: string;
    invalidUrl: string;
    uploadFailed: string;
    titleRequired: string;
    visibilityLabel: string;
    visibilityOrg: string;
    visibilityOrgDesc: string;
    visibilityPrivate: string;
    visibilityPrivateDesc: string;
  };

  // Personal References
  personalReferences: {
    title: string;
    description: string;
    searchPlaceholder: string;
    create: string;
    noReferences: string;
    createFirst: string;
    totalReferences: string;
    pageOf: string;
    totalLabel: string;
    fetchError: string;
    deleteConfirmTitle: string;
    deleteConfirmMessage: string;
    deleteSuccess: string;
    deleteError: string;
    allCategories: string;
  };

  // 3D model viewer (GLB/glTF preview)
  model3d: {
    loading: string;
    error: string;
    errorHint: string;
    unsupportedFormat: string;
    unsupportedFormatHint: string;
    download: string;
    alt: string;
    badge: string;
    placeholderHint: string;
    infoTitle: string;
    vertices: string;
    triangles: string;
    meshes: string;
    materials: string;
    textures: string;
    fileSize: string;
    dimensions: string;
  };

  // Session References (temporary media in widget)
  sessionReference: {
    addButton: string;
    modalTitle: string;
    dropzone: string;
    addAction: string;
    legend: string;
    limitReached: string;
    imagesCount: string;
    videosCount: string;
    audioCount: string;
    processing: string;
    unsupportedType: string;
    uploadFailed: string;
    mediaMetadataLoading: string;
    mediaMetadataFailed: string;
    mediaMetadataRetry: string;
    changesPending: string;
    singlePerRequestUnsupported: string;
    descriptionLabel: string;
    descriptionPlaceholder: string;
    helpTitle: string;
    helpWhatTitle: string;
    helpWhatText: string;
    helpDescTitle: string;
    helpDescText: string;
    helpVsTitle: string;
    helpVsText: string;
    helpExamplesTitle: string;
    helpExample1: string;
    helpExample2: string;
    helpExample3: string;
    clickToRemoveHoldPreview: string;
  };

  // Billing System
  billing: {
    title: string;
    creditsTab: string;
    currentBalance: string;
    tokensRemaining: string;
    purchaseTokens: string;
    enterAmount: string;
    youWillGet: string;
    tokensLabel: string;
    minAmount: string;
    purchase: string;
    processing: string;
    securePayment: string;
    vatExclusiveNote: string;
    purchaseSuccess: string;
    purchaseCancelled: string;
    paymentSuccessTitle: string;
    paymentSuccessMessage: string;
    paymentSuccessTokens: string;
    paymentSuccessAmount: string;
    paymentSuccessPackage: string;
    paymentSuccessBonus: string;
    paymentSuccessViewInvoices: string;
    paymentSuccessClose: string;
    transactionHistory: string;
    noTransactions: string;
    date: string;
    amount: string;
    tokens: string;
    status: string;
    statusPending: string;
    statusCompleted: string;
    statusFailed: string;
    statusRefunded: string;
    rateInfo: string;
    used: string;
    usedLast30Days: string;
    usedLast7Days: string;
    // Bundle mode
    selectBundle: string;
    noPackages: string;
    bestValue: string;
    bonus: string;
    baseTokens: string;
    orEnterCustomAmount: string;
    // Billing not available
    billingNotAvailable: string;
    billingNotAvailableDesc: string;
    billingAddressRequired: string;
    fillBillingAddress: string;
    // Payment details
    billingType: string;
    pay: string;
    type: string;
    enterpriseLabel: string;
    standardLabel: string;
    // Access denied
    accessDenied: string;
    accessDeniedDescription: string;
    yourRole: string;
  };

  // Billing Address
  billingAddress: {
    title: string;
    subtitle: string;
    legalName: string;
    legalNamePlaceholder: string;
    addressLine1: string;
    addressLine1Placeholder: string;
    addressLine2: string;
    addressLine2Placeholder: string;
    city: string;
    cityPlaceholder: string;
    postalCode: string;
    postalCodePlaceholder: string;
    state: string;
    statePlaceholder: string;
    country: string;
    countryPlaceholder: string;
    vatType: string;
    vatTypePlaceholder: string;
    vatId: string;
    vatIdPlaceholder: string;
    billingEmail: string;
    billingEmailPlaceholder: string;
    save: string;
    saving: string;
    saveSuccess: string;
    saveError: string;
    loadError: string;
    required: string;
    noChanges: string;
    addressSavedTaxFailed: string;
    searchCountry: string;
    taxIdErrorTitle: string;
    taxIdExpectedFormat: string;
    taxIdErrorClose: string;
  };

  // Invoices
  invoices: {
    title: string;
    subtitle: string;
    invoiceNumber: string;
    date: string;
    amount: string;
    status: string;
    download: string;
    view: string;
    noInvoices: string;
    noInvoicesDesc: string;
    statusPaid: string;
    statusOpen: string;
    statusDraft: string;
    statusVoid: string;
    statusUncollectible: string;
    loadError: string;
    type: string;
    tokens: string;
    typeEnterprise: string;
  };

  // Auto Top-Up
  autoTopUp: {
    title: string;
    subtitle: string;
    enabled: string;
    disabled: string;
    threshold: string;
    thresholdHelp: string;
    topupAmount: string;
    topupAmountHelp: string;
    tokensEquivalent: string;
    monthlyLimit: string;
    monthlyLimitHelp: string;
    monthlySpent: string;
    monthlyProgress: string;
    paymentMethod: string;
    noPaymentMethod: string;
    cardEnding: string;
    expires: string;
    lastError: string;
    save: string;
    enableRequiresCard: string;
    successEnabled: string;
    successDisabled: string;
    successUpdated: string;
  };

  // Saved payment cards (Payment Methods billing tab)
  savedCards: {
    title: string;
    defaultCard: string;
    deleteCard: string;
    confirmDeleteCard: string;
    cardDeleted: string;
    cardDeleteFailed: string;
    autoTopupDisabledNoCard: string;
    noCard: string;
    cardEnding: string;
    expires: string;
    addCard: string;
    makeDefault: string;
    cardAdded: string;
    cardAddCancelled: string;
    addCardFailed: string;
    makeDefaultFailed: string;
    defaultUpdated: string;
  };

  // Admin Billing
  adminBilling: {
    title: string;
    totalRevenue: string;
    totalTokens: string;
    totalTransactions: string;
    completed: string;
    pending: string;
    failed: string;
    searchPlaceholder: string;
    allStatuses: string;
    statusPending: string;
    statusCompleted: string;
    statusFailed: string;
    statusRefunded: string;
    transactionHistory: string;
    noTransactions: string;
    date: string;
    organization: string;
    user: string;
    amount: string;
    tokens: string;
    status: string;
    provider: string;
    showing: string;
    of: string;
    previous: string;
    next: string;
    purchaseType: string;
    typeBundle: string;
    typeEnterprise: string;
    packageName: string;
    exportCSV: string;
    exporting: string;
    noDataToExport: string;
    exportError: string;
    exportModalTitle: string;
    selectOrganizations: string;
    selectAll: string;
    deselectAll: string;
    selectedCount: string;
    period: string;
    exportProgress: string;
    searchOrganizations: string;
    cancel: string;
    downloadCSV: string;
    month1: string;
    month3: string;
    month6: string;
    year1: string;
    custom: string;
    dateFrom: string;
    dateTo: string;
  };

  // Admin Refunds
  adminRefunds: {
    title: string;
    subtitle: string;
    // Stats card
    statsTitle: string;
    totalRefunds: string;
    totalRefundedTokens: string;
    refundRate: string;
    totalGenerations: string;
    last7Days: string;
    topWorkflows: string;
    dailyChart: string;
    noRefundsInWindow: string;
    // Table columns
    date: string;
    organization: string;
    user: string;
    workflow: string;
    tokensCost: string;
    errorMessage: string;
    actions: string;
    viewData: string;
    // Filters
    allWorkflows: string;
    filterByWorkflow: string;
    dateFrom: string;
    dateTo: string;
    resetFilters: string;
    // Pagination
    showing: string;
    of: string;
    previous: string;
    next: string;
    // States
    loading: string;
    noRefunds: string;
    noRefundsDescription: string;
    fetchError: string;
    retryLoad: string;
    // Misc
    refunds: string;
    tokens: string;
    rate: string;
    clearSelection: string;
    noResultsFor: string;
  };

  // Admin Service API Keys (lmx_adm_*)
  adminApiKeys: {
    title: string;
    subtitle: string;
    createKey: string;
    // Table columns
    colName: string;
    colScopes: string;
    colPrefix: string;
    colStatus: string;
    colLastUsed: string;
    colUsage: string;
    colExpires: string;
    colActions: string;
    // Status
    statusActive: string;
    statusRevoked: string;
    statusExpired: string;
    // Row actions / values
    edit: string;
    revoke: string;
    never: string;
    noExpiry: string;
    noKeys: string;
    loading: string;
    // Create / edit modal
    createTitle: string;
    editTitle: string;
    nameLabel: string;
    namePlaceholder: string;
    descriptionLabel: string;
    descriptionPlaceholder: string;
    scopesLabel: string;
    scopesHint: string;
    expiresLabel: string;
    rateMinuteLabel: string;
    rateHourLabel: string;
    nameRequired: string;
    scopesRequired: string;
    save: string;
    create: string;
    cancel: string;
    // Scope labels
    scopeWorkflows: string;
    actionRead: string;
    actionCreate: string;
    actionUpdate: string;
    actionDelete: string;
    // Key-created modal
    keyCreatedTitle: string;
    keyCreatedWarning: string;
    copy: string;
    copied: string;
    done: string;
    // Confirm + messages
    revokeConfirm: string;
    loadError: string;
    createSuccess: string;
    createError: string;
    updateSuccess: string;
    updateError: string;
    revokeSuccess: string;
    revokeError: string;
    copyError: string;
    // Audit log
    auditTitle: string;
    auditFilterLabel: string;
    auditAllKeys: string;
    auditWhen: string;
    auditKey: string;
    auditAction: string;
    auditResource: string;
    auditStatus: string;
    auditError: string;
    auditEmpty: string;
    auditLoadError: string;
    // Pagination
    showing: string;
    of: string;
    previous: string;
    next: string;
    page: string;
    perPage: string;
  };

  // Collections System
  collections: {
    title: string;
    description: string;
    createCollection: string;
    editCollection: string;
    deleteCollection: string;
    collectionName: string;
    collectionDescription: string;
    isPrivate: string;
    isDefault: string;
    totalImages: string;
    imagesThisMonth: string;
    topContributors: string;
    permissions: string;
    managePermissions: string;
    addToCollection: string;
    removeFromCollection: string;
    selectCollections: string;
    noCollections: string;
    defaultCollection: string;
    privateCollection: string;
    publicCollection: string;
    viewPermission: string;
    editPermission: string;
    adminPermission: string;
    grantPermission: string;
    revokePermission: string;
    userEmail: string;
    permissionType: string;
    grantedBy: string;
    grantedAt: string;
    collectionCreated: string;
    collectionUpdated: string;
    collectionDeleted: string;
    cannotDeleteDefault: string;
    collectionNotFound: string;
    accessDenied: string;
    addedToCollections: string;
    removedFromCollection: string;
    favoriteTooltip: string;
    columns: {
      name: string;
      description: string;
      type: string;
      images: string;
      created: string;
      actions: string;
    };
    modal: {
      createTitle: string;
      editTitle: string;
      deleteTitle: string;
      deleteMessage: string;
      selectTitle: string;
      permissionsTitle: string;
      namePlaceholder: string;
      descriptionPlaceholder: string;
      userEmailPlaceholder: string;
    };
    messages: {
      nameRequired: string;
      nameExists: string;
      createSuccess: string;
      createError: string;
      updateSuccess: string;
      updateError: string;
      deleteSuccess: string;
      deleteError: string;
      permissionGranted: string;
      permissionRevoked: string;
      permissionError: string;
    };
    stats: {
      totalCollections: string;
      totalImages: string;
      privateCollections: string;
      mostPopular: string;
    };
  };

  // Workflow Page
  workflow: {
    selectWorkflow: string;
    selectWorkflowDesc: string;
    workflowLabel: string;
    selectWorkflowPlaceholder: string;
    availableWorkflows: string;
    videoComingSoon: string;
    videoComingSoonDesc: string;
    loadingWorkflows: string;
    noWorkflows: string;
    noWorkflowsDesc: string;
    imageGeneration: string;
    imageGenerationDesc: string;
    comingSoon: string;
    backToWorkflows: string;
    noWidgets: string;
    noWidgetsDesc: string;
    widgetComingSoon: string;
    widgetLoadFailed: string;
    widgetLoadRetry: string;
    widgetLoading: string;
    public: string;
    restricted: string;
    selectOrganization: string;
    selectOrganizationDesc: string;
    generate: string;
    generateVideo: string;
    searchWorkflows: string;
    searchWorkflowsPlaceholder: string;
    noWorkflowsFound: string;
    allWorkflows: string;
    filterByTag: string;
    noWorkflowsWithTag: string;
    showArchived: string;
    newBadge: string;
    archivedBadge: string;
    favorites: string;
    addToFavorites: string;
    removeFromFavorites: string;
    keyboardShortcutMac: string;
    keyboardShortcutWindows: string;
    promptRequired: string;
    generating: string;
    enhancing: string;
    processingAsync: string;
    textNoContent: string;
    // Image size constraints
    imageSizeConstraints: string;
    imageSizeConstraintsDesc: string;
    minWidth: string;
    minHeight: string;
    maxWidth: string;
    maxHeight: string;
    defaultWidth: string;
    defaultHeight: string;
    pending: string;
    queued: string;
    noSmallWidgets: string;
    noSmallWidgetsDesc: string;
    accessDenied: string;
    accessDeniedHint: string;
    // Input Media Widget settings
    mediaContentSettings: string;
    mediaContentSettingsDesc: string;
    imagesSettings: string;
    videoSettings: string;
    audioSettings: string;
    maxCount: string;
    maxFileSize: string;
    maxDuration: string;
    actions: {
      generate: string;
      upscale: string;
      process: string;
      create: string;
    };
    validationError: string;
    invalidPricingAggregate: string;
    // Pipeline step progress
    pipelineStep: string;
    pipelineStepCompact: string;
    priceWithoutDiscount: string;
    // Token balance row in the left context panel (values already exist in ru/en)
    tokensRemaining: string;
    topUpTokens: string;
  };

  // Widgets
  widgets: {
    generationSettings: string;
    generationSettingsDesc: string;
    styleSelector: string;
    styleSelectorDesc: string;
    imageUpload: string;
    imageUploadDesc: string;
    promptEditor: string;
    promptEditorDesc: string;
    gallery: string;
    galleryDesc: string;
    imageSize: string;
    numImages: string;
    inferenceSteps: string;
    fast: string;
    quality: string;
    guidanceScale: string;
    precise: string;
    creative: string;
    safety: string;
    safetyDisabled: string;
    safetyStrict: string;
    safetyBalanced: string;
    safetySoft: string;
    noStyles: string;
    noStylesDesc: string;
    noStyle: string;
    noStyleDesc: string;
    loadingStyles: string;
    searchStyles: string;
    noStylesFound: string;
    stylePrompt: string;
    noPrompt: string;
    styleTemplate: string;
    promptTemplate: string;
    promptText: string;
    loadingPrompts: string;
    expand: string;
    collapse: string;
    prompt: string;
    view: string;
    promptTitle: string;
    aspectRatio: string;
    aspectRatioDesc: string;
    numImagesDesc: string;
    inferenceStepsDesc: string;
    guidanceScaleDesc: string;
    safetyDesc: string;
    promptEnhancer: string;
    promptEnhancerDesc: string;
    searchPrompts: string;
    noPrompts: string;
    noPromptsDesc: string;
    noPromptsFound: string;
    enterTextToTranslate: string;
    translatePrompt: string;
    enterTextToEnhance: string;
    enhancePrompt: string;
    selectTemplateAndEnterText: string;
    collectionsSelector: string;
    collectionsSelectorDesc: string;
    originalPrompt: string;
    enhancedPrompt: string;
    swapPrompts: string;
    clearPrompt: string;
    translationError: string;
    enhancePromptError: string;
    searchOptions: string;
    searchOptionsLabel: string;
    refineOptions: string;
    maxSelections: string;

    // Input Images Widget
    inputImages: {
      title: string;
      dropHere: string;
      dragOrClick: string;
      supportedFormats: string;
      maxImages: string;
      noImages: string;
      dragToStart: string;
      selectAll: string;
      deselectAll: string;
      removeSelected: string;
      pasteFromClipboard: string;
      addMoreImages: string;
      // Image size validation
      imageTooSmall: string;
      imageTooLarge: string;
      rejectedImages: string;
      invalidImage: string;
    };

    // Input Media Widget (images, video, audio)
    inputMedia: {
      dropHere: string;
      dragOrClick: string;
      selectFromGallery: string;
      gallerySelectionTitle: string;
      images: string;
      videos: string;
      audio: string;
      noMediaAllowed: string;
      fileTooLarge: string;
      limitReached: string;
      durationTooShort: string;
      durationTooLong: string;
      invalidFile: string;
      rejectedFiles: string;
      limits: string;
      filename: string;
      dimensions: string;
      filesize: string;
      selectedFromGallery: string;
      maxSelectionReached: string;
      confirmSelection: string;
      selectedCount: string;
      search: string;
      addFromGallery: string;
      addFromDisk: string;
      galleryDescription: string;
      imageAutoResized: string;
      imageAutoCompressed: string;
      imageAutoResizedAndCompressed: string;
      imageCroppedToTarget: string;
      imageResizedToTarget: string;
      imageConvertedToJpeg: string;
      imageCroppedAndConverted: string;
      imageResizedAndConverted: string;
      imageAutoProcessedInfo: string;
      selectionCounter: string;
      selectionLimitReached: string;
      selectedSection: string;
      clearAllSelection: string;
      videoWidthTooSmall?: string;
      videoWidthTooLarge?: string;
      videoHeightTooSmall?: string;
      videoHeightTooLarge?: string;
      videoPixelsTooSmall?: string;
      videoPixelsTooLarge?: string;
      videoMetadataLoading?: string;
    };

    // Slots Input Media Widget
    slotsInputMedia: {
      title: string;
      noSlotsConfigured: string;
      dropOrClick: string;
      upload: string;
      gallery: string;
      paste: string;
      noImageInClipboard: string;
      required: string;
      expectedType: string;
      unsupportedFormat: string;
      allowedFormats: string;
      fileRejected: string;
      modelType: string;
      modelMaxFileSizeHint: string;
      modelUnsupportedInSmall: string;
      cropped?: string;
      cropModal?: {
        title?: string;
        apply?: string;
        cancel?: string;
        resetCenter?: string;
        zoom?: string;
        error?: string;
      };
      errors?: {
        invalidUrl?: string;
        fileTooLarge?: string;
        durationTooShort?: string;
        durationTooLong?: string;
        videoWidthTooSmall?: string;
        videoWidthTooLarge?: string;
        videoHeightTooSmall?: string;
        videoHeightTooLarge?: string;
        videoPixelsTooSmall?: string;
        videoPixelsTooLarge?: string;
        stillProcessing?: string;
        processingFailed?: string;
      };
    };

    // 3D Camera Control Widget
    camera3d: {
      title: string;
      horizontalAngle: string;
      verticalAngle: string;
      zoom: string;
      horizontalAngleLabel: string;
      verticalAngleLabel: string;
      zoomLabel: string;
      presets: {
        front: string;
        back: string;
        left: string;
        right: string;
        top: string;
        low: string;
        threeQuarter: string;
      };
      helpTitle: string;
      helpWhatIs: string;
      helpWhatIsDesc: string;
      helpControls: string;
      helpHorizontal: string;
      helpVertical: string;
      helpZoom: string;
      helpUsage: string;
      helpUsageDesc: string;
    };

    // AuraSR Upscale Settings Widget
    auraSrUpscale: {
      title: string;
      description: string;
      upscalingFactor: string;
      upscalingFactorDesc: string;
      checkpoint: string;
      checkpointDesc: string;
      checkpointV1: string;
      checkpointV2: string;
      overlappingTiles: string;
      overlappingTilesDesc: string;
      overlappingEnabled: string;
      overlappingDisabled: string;
      overlappingWarning: string;
    };

    // Clarity Upscaler Widget
    clarityUpscaler: {
      title: string;
      description: string;
      upscaleFactor: string;
      upscaleFactorDesc: string;
      resemblance: string;
      resemblanceDesc: string;
      hiddenParamsInfo: string;
    };
    searchCollections: string;
    loadingCollections: string;
    noCollectionsFound: string;
    oneCollectionSelected: string;
    collectionsSelected: string;
    collectionsTooltip: string;
  };

  // Mask Editor Modal (inpainting mask painter)
  maskEditor: {
    title: string;
    brush: string;
    eraser: string;
    brushSize: string;
    undo: string;
    clear: string;
    zoomIn: string;
    zoomOut: string;
    apply: string;
    cancel: string;
    hint: string;
    openButton: string;
    maskApplied: string;
    maskNotReady: string;
    duplicateKey: string;
    keyCollision: string;
    exportFailed: string;
    polygon: string;
    polygonHint: string;
    addImage: string;
    commitImage: string;
    removeImage: string;
    resizeHint: string;
    rotateHint: string;
    tabCrop: string;
    tabMask: string;
  };

  // Organization Selector
  orgSelector: {
    selectOrganization: string;
    exhausted: string;
    availableOrganizations: string;
    memberSince: string;
    organizationInfo: string;
    management: string;
    adminPanel: string;
  };

  // Common UI elements
  common: {
    close: string;
    save: string;
    cancel: string;
    create: string;
    edit: string;
    delete: string;
    deleting: string;
    add: string;
    saving: string;
    loading: string;
    understood: string;
    loadMore: string;
    selectOrganization: string;
    selectOrganizationDesc: string;
    error: string;
    processing: string;
    safe: string;
    nsfw: string;
    off: string;
    on: string;
  };

  // Authentication messages
  auth: {
    required: string;
    loginRequired: string;
    loginInstructions: string;
    loginToAccess: string;
  };

  // Manager page
  manager: {
    title: string;
    organizationLimit: string;
    organizationTokens: string;
    remaining: string;
    allGenerationsHistory: string;
    inviteUser: string;
    userManagement: string;
    users: string;
    role: string;
    customLimits: string;
    limitGroup: string;
    limits: string;
    usage: string;
    actions: string;
    setLimit: string;
    changeRole: string;
    viewHistory: string;
    editUsage: string;
    editUsageTitle: string;
    currentUsage: string;
    newUsage: string;
    usageUpdated: string;
    invalidUsageValue: string;
    noUsers: string;
    loading: string;
    error: string;
    limitSet: string;
    roleChanged: string;
    sharedPoolMode: string;
    sharedPoolInfo: string;
    sharedPoolDescription: string;
    individualLimitsNotUsed: string;
    invitePending?: string;
    invitePendingNoEmail?: string;
    pendingInvitations?: string;
    pendingInvited?: string;
    pendingExpires?: string;
    resendInvite?: string;
    deletePendingInvite?: string;
    confirmDeletePending?: string;
    pendingInviteDeleted?: string;
    pendingInviteResent?: string;
    pendingInviteResendFailed?: string;
  };

  // Organization History page
  orgHistory: {
    title: string;
    adminMode: string;
    adminWarning: string;
    backToAdmin: string;
    filters: string;
    searchByPrompt: string;
    searchPromptPlaceholder: string;
    generationMode: string; // Keep for backward compatibility
    workflow: string; // New field for workflow column
    searchWorkflowPlaceholder: string; // New field for workflow search
    allModes: string;
    allWorkflows: string;
    user: string;
    allUsers: string;
    historyTitle: string;
    loadingHistory: string;
    historyEmpty: string;
    date: string;
    prompt: string;
    mode: string;
    result: string;
    images: string;
    data: string; // New field for data column
    cost: string; // Token cost column
    success: string;
    error: string;
    copyPromptHint: string;
    loadMore: string;
    loading: string;
    promptCopied: string;
    promptCopyFailed: string;
    actions: string; // Actions column for global admins
    deleteGeneration: string; // Delete generation button tooltip
    deleteNotAllowed: string; // Error message when non-admin tries to delete
    confirmDelete: string; // Confirmation dialog text
    deleteSuccess: string; // Success message after deletion
    deleteFailed: string; // Error message when deletion fails
    editGeneration: string; // Edit generation button tooltip
    editGenerationTitle: string; // Edit modal title
    tokenPrice: string; // Token price field label
    tokenStatus: string; // Token status field label
    tokenStatusPending: string; // Pending status option
    tokenStatusCompleted: string; // Completed status option
    tokenStatusRefunded: string; // Refunded status option
    saveChanges: string; // Save changes button
    editSuccess: string; // Success message after edit
    editFailed: string; // Error message when edit fails
    prevPage: string; // Previous page button
    nextPage: string; // Next page button
    page: string; // Page label (e.g., "Page 1")
    showing: string; // "Showing" in pagination info
    of: string; // "of" in pagination info
    results: string; // "results" in pagination info
    perPage: string; // "Per page" label for items per page selector
    // Export functionality
    export: {
      button: string;
      title: string;
      period: string;
      month1: string;
      month3: string;
      month6: string;
      year1: string;
      custom: string;
      dateFrom: string;
      dateTo: string;
      filterUser: string;
      filterWorkflow: string;
      allUsers: string;
      allWorkflows: string;
      download: string;
      cancel: string;
      loading: string;
      noData: string;
      success: string;
      error: string;
      includeLinks: string;
      details: string;
      summary: string;
      totalGenerations: string;
      totalTokens: string;
      byUsers: string;
      byWorkflow: string;
      generations: string;
      tokens: string;
      links: string;
      reportTitle: string;
      periodLabel: string;
      includeRawData: string;
      includeInput: string;
      includeResponse: string;
      rawInput: string;
      rawResponse: string;
      mark: string;
    };
    tracing: string;
    tracingTitle: string;
    dataPopupCurrent: string;
    dataPopupHistory: string;
    dataPopupTracing: string;
    dataPopupCopy: string;
    dataPopupCopied: string;
    dataPopupNoHistory: string;
    dataPopupAllUsers: string;
    dataPopupAllUsersEmpty: string;
    dataPopupAllUsersError: string;
    dataPopupAllUsersLoading: string;
    textPreview: string;
    viewText: string;
    category: string;
    allCategories: string;
    categoryImage: string;
    categoryVideo: string;
    categoryVoice: string;
    categoryText: string;
    category3D: string;
    // Manager manual "Check" button for pending generations
    check: {
      button: string;
      success: string;
      stillRunning: string;
      failed: string;
    };
    // External actor label (on_behalf_of passed by an MCP api-key caller)
    externalActor: {
      via: string;
      title: string;
    };
  };

  // Text result modal
  textResult: {
    title: string;
    copy: string;
    copied: string;
    download: string;
    close: string;
    tokens: string;
  };

  // Admin cross-org export
  adminExport: {
    title: string;
    button: string;
    filterOrganization: string;
    allOrganizations: string;
    byOrganization: string;
    organizationColumn: string;
    reportTitle: string;
    truncationWarning: string;
    selectAll: string;
    deselectAll: string;
    selectedCount: string;
    searchOrganizations: string;
    exportProgress: string;
    cancel: string;
  };

  // Compact UI texts
  uploadReagents: string;
  compressing: string;
  filled: string;
  dropping: string;
  uploadTipsTitle: string;
  tipHighRes: string;
  tipFormats: string;
  tipAutoCompress: string;
  tipClearScenes: string;
  tipMaxSize: string;

  // Mask editor and dropzone UI
  createMask: string;
  editMask: string;
  uploadedReagents: string;
  reagentsCount: string;
  readyToExperiment: string;

  // Advanced settings labels
  imageInfluenceStrength: string;
  inferenceSteps: string;
  guidanceScale: string;
  safety: string;
  
  // Slider labels
  weak: string;
  strong: string;
  fast: string;
  quality: string;
  precise: string;
  creativeSlider: string;
  
  // Mode tooltips
  text2imgTooltip: string;
  img2imgTooltip: string;
  imgKontextTooltip: string;
  multiKontextTooltip: string;
  cannyTooltip: string;
  depthTooltip: string;
  fillTooltip: string;
  removeBgTooltip: string;
  
  // Action button tooltips
  generateTooltip: string;
  generatingTooltip: string;
  fixPromptTooltip: string;
  fixingPromptTooltip: string;

  // Prompts Management
  promptsManagement: {
    title: string;
    adminMode: string;
    adminWarning: string;
    backToAdmin: string;
    tabs: {
      style: string;
      basic: string;
      workflow: string;
    };
    create: string;
    createButton: string;
    createFirst: string;
    prompt: string;
    edit: string;
    delete: string;
    enable: string;
    disable: string;
    enabled: string;
    disabled: string;
    enabledInOrg: string;
    disabledInOrg: string;
    globalPromptReadonly: string;
    copy: string;
    copyTooltip: string;
    copySuccess: string;
    copyError: string;
    duplicate: string;
    duplicateTooltip: string;
    duplicateSuccess: string;
    globalPrompts: string;
    organizationPrompts: string;
    noGlobalPrompts: string;
    noGlobalPromptsTitle: string;
    noOrgPrompts: string;
    noPromptsTitle: string;
    searchPlaceholder: string;
    columns: {
      title: string;
      description: string;
      status: string;
      created: string;
      createdBy: string;
      actions: string;
    };
    deleteConfirmTitle: string;
    deleteConfirmMessage: string;
    deleteSuccess: string;
    deleteError: string;
    modal: {
      createTitle: string;
      editTitle: string;
      titleLabel: string;
      descriptionLabel: string;
      bodyLabel: string;
      globalLabel: string;
      globalHint: string;
      createButton: string;
      updateButton: string;
      cancelButton: string;
      titlePlaceholder: string;
      descriptionPlaceholder: string;
      bodyPlaceholder: string;
      charactersCount: string;
      titleMinLength: string;
      titleMaxLength: string;
      descriptionMinLength: string;
      descriptionMaxLength: string;
      bodyMinLength: string;
      bodyMaxLength: string;
    };
  };

  // Admin panel sections
  admin: {
    title: string;
    dashboard: string;
    users: string;
    organizations: string;
    globalPrompts: string;
    backToDashboard: string;
    navigation: string;
    widgets: string;
    widgetsDesc: string;
    createWidget: string;
    editWidget: string;
    widgetId: string;
    widgetName: string;
    widgetDescription: string;
    widgetIcon: string;
    widgetActive: string;
    displayType: string;
    displayTypeSmall: string;
    displayTypeBig: string;
    name: string;
    description: string;
    status: string;
    actions: string;
    active: string;
    inactive: string;
    accessDenied: string;
    adminRequired: string;
    noWidgets: string;
    noWidgetsDesc: string;
    dynamicWidget: string;
    configureFields: string;
    fields: string;
    configureFieldsDesc: string;
    addField: string;
    editField: string;
    displayOrder: string;
    configuredFields: string;
    noFieldsYet: string;
    workflowsUsing: string;
    workflowsUsingWidget: string;
    noWorkflowsUsingWidget: string;
    viewWorkflows: string;
    widgetPreview: string;
    widgetState: string;
    fieldType: string;
    fieldId: string;
    fieldLabel: string;
    tooltip: string;
    required: string;
    placeholder: string;
    minLength: string;
    maxLength: string;
    multiline: string;
    rows: string;
    minValue: string;
    maxValue: string;
    step: string;
    defaultValue: string;
    options: string;
    optionsHelp: string;
    optionsHelpKeyValue: string;
    maxSelections: string;
    // Dropdown Prompt field config
    dropdownPrompt: string;
    addOption: string;
    optionLabel: string;
    selectPrompt: string;
    removeOption: string;
    copyVariables: string;
    variablesCopied: string;
    copyFailed: string;
    pasteVariables: string;
    pasteFailed: string;
    nothingToPaste: string;
    // Workflow editor - General section
    basicInfo: string;
    workflowId: string;
    workflowIdDesc: string;
    workflowTitle: string;
    descriptions: string;
    descriptionRu: string;
    descriptionEn: string;
    configuration: string;
    category: string;
    actionButtonType: string;
    inputFilesLogic: string;
    singlePerRequest: string;
    allPerRequest: string;
    uploadFilesLogic: string;
    none: string;
    availability: string;
    pricingFormula: string;
    availableVariables: string;
    examples: string;
    // Pricing formula help modal
    pricingFormulaHelp?: {
      title: string;
      dynamicVariablesTitle: string;
      dynamicVariablesDesc: string;
      dynamicVariablesExamples: string;
      autoVariablesTitle: string;
      examplesTitle: string;
      operationsTitle: string;
      descriptionColumn: string;
      variables: {
        input_img_mpx: string;
        input_img_count: string;
        input_img_count_may_zero: string;
        target_img_mpx: string;
        target_img_width: string;
        target_img_height: string;
        target_long_side: string;
        target_short_side: string;
        target_aspect_ratio: string;
        audio_duration: string;
        video_duration: string;
        audio_duration_exact: string;
        video_duration_exact: string;
        audio_duration_exact_may_zero: string;
        video_duration_exact_may_zero: string;
        has_audio: string;
        has_video: string;
        audio_duration_may_zero: string;
        video_duration_may_zero: string;
        video_width: string;
        video_height: string;
        video_mpx: string;
        prompt_length_1k: string;
        prompt_length_1k_may_zero: string;
        prompt_length_ceil_100: string;
        prompt_length_ceil_100_may_zero: string;
        text_length_ceil_100: string;
        text_length_ceil_100_may_zero: string;
        has_prompt: string;
      };
      operations: {
        arithmetic: string;
        comparison: string;
        ternary: string;
        math: string;
      };
    };
    // Workflow editor - Content restrictions
    contentRestrictions: string;
    contentRestrictionsDesc: string;
    outgoingImages: {
      title: string;
      description: string;
      enabled: string;
      format: string;
      quality: string;
      perImage: string;
      total: string;
      dimension: string;
      units: string;
      base64: string;
      transparency: string;
      invalid: string;
    };
    promptCharLimit: string;
    promptCharLimitDesc: string;
    noInputWidgetsEnabled: string;
    noInputWidgetsEnabledDesc: string;
    forInputImages: string;
    forInputMedia: string;
    restrictionsTips: string;
    restrictionsTip1: string;
    restrictionsTip2: string;
    restrictionsTip3: string;
    // Workflow editor - Input Text settings
    inputTextSettings: string;
    inputTextSettingsDesc: string;
    inputTextTitle: string;
    inputTextPlaceholder: string;
    noInputTextWidget: string;
    noInputTextWidgetDesc: string;
    inputTextLayout: string;
    inputTextSimple: string;
    inputTextSimpleDesc: string;
    inputTextDouble: string;
    inputTextDoubleDesc: string;
    inputTextOutputKey: string;
    inputTextOutputKeyDesc: string;
    inputTextFieldId: string;
    inputTextFieldIdDesc: string;
    inputTextCharLimit: string;
    inputTextRequired: string;
    inputTextField1: string;
    inputTextField2: string;
    // Workflow editor - Slots Input Media settings
    slotsInputMediaSettings: string;
    slotsInputMediaSettingsDesc: string;
    noSlotsInputMediaWidget: string;
    noSlotsInputMediaWidgetDesc: string;
    acceptedFormats: string;
    acceptedFormatsHint: string;
    allFormats: string;
    modelMediaType: string;
    modelRestrictions: string;
    modelMaxFileSize: string;
    modelMaxFileSizeHint: string;
    videoMinDuration: string;
    videoMinPixels: string;
    videoMaxPixels: string;
    // Slot image processing
    targetWidth: string;
    targetWidthDesc: string;
    targetHeight: string;
    targetHeightDesc: string;
    convertToJpeg: string;
    convertToJpegDesc: string;
    imageProcessingTitle: string;
    targetDimensionsPairWarning: string;
    // Slot mask editor
    enableMask: string;
    enableMaskDesc: string;
    maskPayloadKey: string;
    maskPayloadKeyPlaceholder: string;
    maskPayloadKeyRequired: string;
    // Workflow editor - Enhance Mappings sidebar
    enhanceMappings: string;
    // Workflow editor - Pipeline Steps sidebar
    pipelineSteps: string;
    pipelineStepsConfig: {
      title: string;
      description: string;
      stepName: string;
      stepUrl: string;
      stepWorkflowUrl: string;
      stepWorkflowUrlPlaceholder: string;
      stepApiKey: string;
      workflowPrompt: string;
      workflowPromptHint: string;
      outputMappings: string;
      sourceField: string;
      targetField: string;
      addMapping: string;
      extraParameters: string;
      extraParametersHint: string;
      parameterKey: string;
      parameterValue: string;
      addParameter: string;
      deleteParameter: string;
      addStep: string;
      maxStepsReached: string;
      emptyState: string;
      stepNumber: string;
      deleteStep: string;
      deleteMapping: string;
      moveUp: string;
      moveDown: string;
      collapseStep: string;
      expandStep: string;
      onErrorLabel: string;
      onErrorFail: string;
      onErrorRetry: string;
      maxAttemptsLabel: string;
      maxAttemptsHint: string;
      retryDelayLabel: string;
      retryDelayHint: string;
    };
    // Pipeline tracing display
    pipelineTracing: {
      stepLabel: string;
      status: {
        pending: string;
        running: string;
        completed: string;
        failed: string;
        waiting_callback: string;
      };
      input: string;
      output: string;
      response: string;
      error: string;
      duration: string;
      attempts: string;
      attemptNumber: string;
      pollCount: string;
      retryCount: string;
      noSteps: string;
      skipped: string;
      resendStreaming: string;
      resendBlocking: string;
      resending: string;
      resendResult: string;
      httpStatus: string;
    };
    // Workflow editor - Tile config
    tileConfigDesc: string;
    sliderDesc: string;
    autoSwitchDesc: string;
    autoSwitchDelayHint: string;
    videoUploadHint: string;
    noTileConfigured: string;
    noTileConfiguredDesc: string;
    // Workflow editor - Widgets section
    widgetConfiguration: string;
    enabledWidgets: string;
    totalWidgets: string;
    widgetConfigDesc: string;
    noWidgetTypes: string;
    noWidgetTypesDesc: string;
    // Display status
    displayStatus: string;
    displayStatusActive: string;
    displayStatusNew: string;
    displayStatusArchived: string;
    displayStatusActiveDesc: string;
    displayStatusNewDesc: string;
    displayStatusArchivedDesc: string;
    displayStatusUpdated: string;
    // Workflow editor - Sidebar
    references: string;
    editWorkflow: string;
    previewPayload: string;
    previewPayloadTitle: string;
    hasErrors: string;
    complete: string;
    clickToNavigate: string;
    // Workflow settings
    autoPromptEnhance?: {
      label: string;
      description: string;
      mappingsLabel: string;
      mappingsDescription: string;
      sourceField: string;
      targetField: string;
      addMapping: string;
      defaultHint: string;
    };
    pipelineType?: {
      label: string;
      description: string;
      off: string;
      offDescription: string;
      autoPromptEnhance: string;
      autoPromptEnhanceDescription: string;
      pipeline: string;
      pipelineDescription: string;
      deprecated: string;
    };
    noRefundContentPolicy?: {
      label: string;
      description: string;
    };
    multiTaskType?: {
      label: string;
      help: string;
      updated: string;
      categoryMismatch: string;
      none: string;
      text2image: string;
      image2image: string;
      text2video: string;
      image2video: string;
      video2video: string;
      text2_3d: string;
      image2_3d: string;
      multiimage2_3d: string;
    };
    // Organization API keys (Edit Organization → API Keys)
    apiKeys?: {
      title: string;
      description: string;
      noKeys: string;
      columns: {
        name: string;
        keyPrefix: string;
        rateLimits: string;
        status: string;
        usage: string;
        lastUsed: string;
        actions: string;
      };
      status: {
        active: string;
        revoked: string;
      };
      actions: {
        create: string;
        edit: string;
        revoke: string;
        revokeConfirm: string;
        regenerate: string;
        regenerateConfirm: string;
        copy: string;
        done: string;
      };
      createModal: {
        title: string;
        name: string;
        description: string;
        namePlaceholder: string;
        descriptionPlaceholder: string;
        rateMinute: string;
        rateHour: string;
      };
      keyCreatedModal: {
        title: string;
        regeneratedTitle: string;
        warning: string;
      };
      validation: {
        nameRequired: string;
      };
      messages: {
        loadError: string;
        createError: string;
        updateError: string;
        revokeError: string;
        regenerateError: string;
        regenerateConflict: string;
        copyError: string;
      };
    };
    // Controller Dropdown & Variant config
    controllerDropdown: string;
    onlyOneController: string;
    controllerNeedsOptions: string;
    controllerDuplicateValues: string;
    variantConfig: string;
    defaultVariant: string;
    variantOverrideHint: string;
    hiddenInVariant: string;
    requiredField: string;
    requiredFieldHint: string;
    hiddenFieldHint: string;
    hiddenTextPlaceholder: string;
    hiddenTextLabel: string;
    hiddenNumberLabel: string;
    hiddenPromptLabel: string;
    hiddenPromptNeedsPrompt: string;
    selectedPromptId: string;
    override: string;
    variantOptionsHint: string;
    noOverridableFields: string;
    controllerOptionsHelp: string;
    optionValue: string;
    // Image size variant overrides
    minWidth: string;
    maxWidth: string;
    minHeight: string;
    maxHeight: string;
    defaultWidth: string;
    defaultHeight: string;
  };

  adminUsers: {
    title: string;
    administrators: string;
    assignRoleByEmail: string;
    userEmail: string;
    assignRole: string;
    roleDescriptions: string;
    globalRole: string;
    registration: string;
    lastActivity: string;
    noAdminsFound: string;
    assigningRole: string;
    assignRoleButton: string;
    roleAssignNote: string;
    email: string;
    name: string;
    role: string;
    regularUsers?: {
      title: string;
      searchPlaceholder: string;
      noUsersFound: string;
      makeAdmin: string;
      confirmMakeAdmin: string;
      selectRole: string;
      columns?: {
        email: string;
        name: string;
        registered: string;
        lastActivity: string;
        actions: string;
      };
      pagination?: {
        previous: string;
        next: string;
        showing: string;
        of: string;
        users: string;
      };
    };
  };

  adminOrganizations: {
    title: string;
    organizationManagement: string;
    createOrganization: string;
    editLimit: string;
    deleteOrganization: string;
    organizationName: string;
    generationLimit: string;
    usage: string;
    userCount: string;
    created: string;
    actions: string;
    noOrgsFound: string;
    creatingOrg: string;
    createOrgButton: string;
    nameLabel: string;
    limitLabel: string;
    namePlaceholder: string;
    limitPlaceholder: string;
    save: string;
    cancel: string;
    edit: string;
    delete: string;
    manage: string;
    billingTypeColumn: string;
    actionButtons: {
      viewHistory: string;
      deleteOrg: string;
      manageOrg: string;
      clearHistory: string;
      select: string;
      deselect: string;
      edit: string;
    };
    actionsSection: {
      title: string;
      managementTitle: string;
    };
    editModal: {
      title: string;
      save: string;
      saveHint: string;
    };
    sections: {
      general: string;
      apiKeys: string;
      workflows: string;
      domains: string;
      actions: string;
      debug: string;
      usage: string;
      info: string;
    };
    fields: {
      name: string;
      tokenLimit: string;
      marginDiscount: string;
      id: string;
      createdAt: string;
    };
    placeholders: {
      name: string;
    };
    hints: {
      tokenLimit: string;
      marginDiscount: string;
    };
    stats: {
      tokensUsed: string;
      tokenLimit: string;
      users: string;
      usageProgress: string;
    };
    actionsPanel: {
      quickLinks: string;
      manageUsers: string;
      manageUsersDesc: string;
      viewHistory: string;
      viewHistoryDesc: string;
      dangerZone: string;
      clearHistory: string;
      clearHistoryDesc: string;
      clearHistoryConfirm: string;
      historyCleared: string;
      clear: string;
      deleteOrg: string;
      deleteOrgDesc: string;
      deleteConfirmText: string;
      typeToConfirm: string;
      confirmDelete: string;
      delete: string;
    };
    debugPanel: {
      stripeCustomer: string;
      stripeCustomerId: string;
      notSet: string;
      setStripeCustomer: string;
      setStripeCustomerDesc: string;
      set: string;
      setConfirm: string;
      setSuccess: string;
      resetStripeCustomer: string;
      resetStripeCustomerDesc: string;
      resetConfirm: string;
      resetSuccess: string;
    };
    workflows: {
      description: string;
      searchPlaceholder: string;
      found: string;
      of: string;
      columns: {
        id: string;
        description: string;
        availability: string;
      };
      noWorkflows: string;
      noResults: string;
      global: string;
      custom: string;
    };
    domains: {
      description: string;
      addNew: string;
      placeholder: string;
      add: string;
      noDomains: string;
      addFirst: string;
      confirmRemove: string;
      remove: string;
      validation: {
        required: string;
      };
      columns: {
        domain: string;
        addedBy: string;
        dateAdded: string;
        actions: string;
      };
    };
    createForm: {
      title: string;
      nameLabel: string;
      limitLabel: string;
      marginDiscountLabel: string;
      marginDiscountHint: string;
      namePlaceholder: string;
      limitPlaceholder: string;
      createButton: string;
      creatingButton: string;
      confirmMessage: string;
      successMessage: string;
    };
    errors: {
      nameRequired: string;
      limitInvalid: string;
      marginDiscountInvalid: string;
      createError: string;
      updateLimitError: string;
      updateMarginDiscountError: string;
      saveChangesError: string;
      deleteError: string;
    };
    messages: {
      settingsUpdated: string;
      settingsUpdatedFor: string;
      organizationUpdated: string;
    };
    deleteOrganization: {
      title: string;
      confirmMessage: string;
      successMessage: string;
    };
    clearHistory: {
      title: string;
      confirmMessage: string;
      successMessage: string;
    };
    nsfwSettings: {
      label: string;
      enabled: string;
      disabled: string;
      enabledDesc: string;
      disabledDesc: string;
      warning: string;
      saveSuccess: string;
      saveError: string;
    };
    paymentMethods: {
      none: string;
      noneDesc: string;
      standard: string;
      standardDesc: string;
      enterprise: string;
      enterpriseDesc: string;
    };
  };

  organizationSettings: string;

  adminWorkflows: {
    title: string;
    workflowManagement: string;
    createWorkflow: string;
    editWorkflow: string;
    exportWorkflow: string;
    deleteWorkflow: string;
    workflowId: string;
    workflowTitle: string;
    workflowUrls: string;
    workflowUrlMain: string;
    workflowUrlAdditional1: string;
    workflowUrlAdditional2: string;
    workflowUrlAdditional3: string;
    description: string;
    category: string;
    workflowType: string;
    availability: string;
    created: string;
    actions: string;
    noWorkflowsFound: string;
    titleRequired: string;
    mainUrlRequired: string;
    manageUrls: string;
    urlManager: {
      title: string;
      mainUrl: string;
      additionalUrl: string;
      urlIndex: string;
      required: string;
      description: string;
      apiKey: string;
      noApiKey: string;
      apiUrl: string;
      difyWorkflowUrl: string;
      openDifyUrl: string;
      copy: string;
      copied: string;
      roleTranslate: string;
      rolePromptEnhance: string;
      roleHintTranslate: string;
      roleHintPromptEnhance: string;
      enhancerEndpointsTitle: string;
      enhancerEndpointsDesc: string;
      enhancerEndpointsLoadError: string;
      notConfigured: string;
      configureUrl: string;
      saveError: string;
      workflowPromptPlaceholder: string;
      workflowPromptNote: string;
      extraParameters: string;
      extraParametersNote: string;
      parameterKey: string;
      parameterValue: string;
      addParameter: string;
      addUrl: string;
      editUrl: string;
      deleteUrl: string;
      confirmDelete: string;
      addUrlTitle: string;
      editUrlTitle: string;
      descriptionPlaceholder: string;
      urlPlaceholder: string;
      apiKeyPlaceholder: string;
      apiKeyNote: string;
      saving: string;
      save: string;
      cancel: string;
      close: string;
      maxUrlsReached: string;
      cannotDeleteMain: string;
      extractToTextWorkflow: string;
      extractConfirmTitle: string;
      extractConfirmMessage: string;
      extracting: string;
      extractSuccess: string;
      extractError: string;
      extractWorkflowSuffix: string;
      extractMainUrlDescription: string;
    };
    search: {
      placeholder: string;
      clear: string;
      resultsFound: string;
      noResults: string;
      noResultsDesc: string;
      clearSearch: string;
    };
    pagination: {
      showing: string;
      of: string;
      workflows: string;
      previous: string;
      next: string;
    };
    tileDisplay: {
      title: string;
      none: string;
      singleImage: string;
      imagePair: string;
      singleVideo: string;
      slideshow: string;
      uploadImage: string;
      uploadBefore: string;
      uploadAfter: string;
      uploadVideo: string;
      comparisonMode: string;
      slider: string;
      autoSwitch: string;
      delayMs: string;
      uploading: string;
      deleteMedia: string;
      replaceMedia: string;
      confirmDeleteMedia: string;
      fileUploaded: string;
      dropFileHere: string;
      dragDrop: string;
      uploadError: string;
      slideshowImages: string;
      slideshowImage: string;
      transitionType: string;
      transitionInstant: string;
      transitionFade: string;
      transitionSlide: string;
      slideshowDelay: string;
      slideshowDelayHint: string;
    };
    workflowIdDesc: string;
    workflowIdEditDesc: string;
    workflowCreated: string;
    workflowUpdated: string;
    workflowDeleted: string;
    workflowDuplicated: string;
    marginColumn: string;
    marginUpdated: string;
    duplicateWorkflow: string;
    confirmDeleteWorkflow: string;
    additional: string;
    tags: {
      title: string;
      manageTags: string;
      createTag: string;
      editTag: string;
      deleteTag: string;
      tagNameEn: string;
      tagNameRu: string;
      confirmDelete: string;
      noTags: string;
      usedByWorkflows: string;
      columnTags: string;
      saveChanges: string;
      cancel: string;
      close: string;
      selectTags: string;
      noTagsSelected: string;
      tagCreated: string;
      tagUpdated: string;
      tagDeleted: string;
      tagsAssigned: string;
      createNewTag: string;
      displayOrder: string;
    };
    columns: {
      id: string;
      title: string;
      urls: string;
      description: string;
      category: string;
      availability: string;
      created: string;
      actions: string;
    };
    exportModal: {
      title: string;
      filterByCategory: string;
      allCategories: string;
      searchPlaceholder: string;
      selectAll: string;
      deselectAll: string;
      selectedCount: string;
      exportButton: string;
      exporting: string;
      widgetCount: string;
      urlCount: string;
      noWorkflowsToExport: string;
    };
    importModal: {
      title: string;
      selectFile: string;
      foundWorkflows: string;
      selectAllNew: string;
      backToFile: string;
      alreadyExists: string;
      willSkip: string;
      willUpdate: string;
      newWorkflow: string;
      importSelected: string;
      importing: string;
      newCount: string;
      existingCount: string;
      updateExisting: string;
      updateExistingDesc: string;
    };
  };
  debug: {
    title: string;
    subtitle: string;
    repairLinks: {
      title: string;
      description: string;
      button: string;
      repairing: string;
      result: string;
      promptsUpdated: string;
      workflowsCleaned: string;
      errorsOccurred: string;
      andMore: string;
      more: string;
      success: string;
    };
    contentMigration: {
      title: string;
      description: string;
      button: string;
      externalDomains: string;
      modal: {
        title: string;
        selectOrganization: string;
        chooseOrganization: string;
        analyse: string;
        analysing: string;
        migrate: string;
        migrating: string;
        completed: string;
        cancelled: string;
        completedMessage: string;
        currentUrl: string;
        succeeded: string;
        failed: string;
        errors: string;
        andMore: string;
        more: string;
        noMigrationNeeded: string;
        allUrlsInternal: string;
        cancel: string;
        stop: string;
        close: string;
        stats: {
          totalGenerations: string;
          withExternalUrls: string;
          urlsToMigrate: string;
          byDomain: string;
        };
      };
    };
    tokenAudit: {
      title: string;
      description: string;
      button: string;
      running: string;
      columns: {
        organization: string;
        limit: string;
        cached: string;
        sumUsers: string;
        drift: string;
        users: string;
      };
      noDrift: string;
      driftFound: string;
      noOrganizations: string;
      fixButton: string;
      fixing: string;
      fixResult: string;
    };
  };
  adminPrompts: {
    title: string;
    globalPrompts: string;
    createPrompt: string;
    editPrompt: string;
    deletePrompt: string;
    promptTitle: string;
    promptBody: string;
    promptType: string;
    promptCategory: string;
    noPromptsFound: string;
    creatingPrompt: string;
    createPromptButton: string;
    actions: string;
    created: string;
    updated: string;
    author: string;
    loadFromFiles: string;
    exportToFiles: string;
    exportPrompts: string;
    importPrompts: string;
    exporting: string;
    downloadReady: string;
    selectTypeToExport: string;
    exportPreview: string;
    noPromptsToExport: string;
    preparingExport: string;
    downloadStarted: string;
    exportFailed: string;
    exportSuccess: string;
    cancel: string;
    upload: string;
    download: string;
    uploadFiles: string;
    loadPrompts: string;
    dragDropFiles: string;
    dropFiles: string;
    supportedFormats: string;
    uploadedFiles: string;
    searchPlaceholder: string;
    noSearchResults: string;
    promptTypeStyle: string;
    promptTypeBasic: string;
    promptTypeWorkflow: string;
    enabled: string;
    disabled: string;
    promptEnabled: string;
    promptDisabled: string;
    promptTypeUpdated: string;
    updateError: string;
  };

  // API Error messages (Fal.AI and other providers)
  apiErrors?: {
    providerUnavailable: string;
    generationTimeout: string;
    contentPolicy: string;
    imageTooSmall: string;
    imageTooLarge: string;
    imageLoad: string;
    faceNotDetected: string;
    unsupportedFormat: string;
    fileTooLarge: string;
    internalServer: string;
    contentPolicyNoRefund: string;
    contentPolicyNoRefundConfirmed: string;
  };

  // Landing page
  landing: {
    tagline: string;
    openApp: string;
    createNow: string;
    hero: {
      title: string;
      subtitle: string;
      cta: string;
      learn: string;
    };
    stats: {
      images: string;
      users: string;
      uptime: string;
      support: string;
    };
    features: {
      title: string;
      subtitle: string;
      generation: {
        title: string;
        description: string;
      };
      prompts: {
        title: string;
        description: string;
      };
      gallery: {
        title: string;
        description: string;
      };
      organizations: {
        title: string;
        description: string;
      };
    };
    cta: {
      title: string;
      subtitle: string;
      button: string;
    };
    footer: {
      rights: string;
      terms: string;
      privacy: string;
    };
  };

  // Auth section
  auth: {
    signIn: string;
    signUp: string;
    getStarted: string;
    required: string;
    loginRequired: string;
    loginInstructions: string;
  };

  // Terms page
  terms: {
    title: string;
    loading: string;
    loadError: string;
    backToHome: string;
  };

  // Privacy Notice page
  privacy: {
    title: string;
    loading: string;
    loadError: string;
    backToHome: string;
  };

  // Top-level sections for navigation errors
  workflows: {
    title: string;
    noWorkflows: string;
  };
  
  users: {
    title: string;
    noUsers: string;
  };

  gallery: {
    displayOptions: string;
    zoomSmall: string;
    zoomMediumSmall: string;
    zoomMedium: string;
    zoomMediumLarge: string;
    zoomLarge: string;
    viewMode: string;
    gridView: string;
    listView: string;
    zoom: string;
    settingsInfo: string;
    gridDescription: string;
    listDescription: string;
    // Error handling
    error: string;
    viewError: string;
    viewErrorDetails: string;
    errorDetails: string;
    notRefunded: string;
    errorMessage: string;
    apiErrorDetails: string;
    generationInfo: string;
    generationId: string;
    timestamp: string;
    prompt: string;
    noPrompt: string;
    copyError: string;
    copiedError: string;
    close: string;
    unknownError: string;
    expand: string;
    collapse: string;
    // Admin tracing tabs in ErrorDetailsModal
    errorTab: string;
    tracingTab: string;
    rawInputTab: string;
    rawResponseTab: string;
    loadingTrace: string;
    noTraceData: string;
    addFavorite: string;
    removeFavorite: string;
    // Trash functionality
    trash: string;
    trashAutoHide: string;
    viewTrash: string;
    viewingTrash: string;
    moveToTrash: string;
    restore: string;
    select: string;
    selectMode: string;
    selected: string;
    selectAll: string;
    deselectAll: string;
    confirmTrashTitle: string;
    confirmTrashMessage: string;
    confirmTrashSingleMessage: string;
    confirmTrashCount: string;
    confirmTrashNote: string;
    dontShowAgain: string;
    addToCollection: string;
    removeFromCollection: string;
    addToCollectionMenu: string;
    removeFrom: string;
    collectionActions: string;
    // Recreate functionality
    recreate: string;
    workflowUnavailable: string;
    copyPrompt: string;
    promptCopied: string;
    download: string;
    downloaded: string;
    downloadOriginal: string;
    downloadWebP: string;
    downloadedWebP: string;
    // Asset marks (like / dislike / approved)
    mark: {
      like: string;
      dislike: string;
      approved: string;
    };
    markFailed: string;
  };

  // Pricing page
  pricing: {
    title: string;
    tagline: string;
    backToHome: string;
    contactSales: string;
    hero: {
      title: string;
      subtitle: string;
      description: string;
      tokenPrice: string;
      tokenValue: string;
      estimatedImages: string;
    };
    features: {
      title: string;
      subtitle: string;
      allModels: string;
      allModelsDesc: string;
      commercial: string;
      commercialDesc: string;
      unlimited: string;
      unlimitedDesc: string;
      customTraining: string;
      customTrainingDesc: string;
      workspace: string;
      workspaceDesc: string;
      support: string;
      supportDesc: string;
    };
    tokenPacks: {
      title: string;
      tokenPrice: string;
      neverExpire: string;
      description: string;
      estimatedImages: string;
      mostPopular: string;
      contactForMore: string;
    };
    subscription: {
      title: string;
      subtitle: string;
      monthly: {
        title: string;
        subtitle: string;
        price: string;
        period: string;
        discount: string;
        description: string;
      };
      annual: {
        title: string;
        subtitle: string;
        price: string;
        period: string;
        discount: string;
        description: string;
        badge: string;
      };
      example: string;
      exampleText: string;
      startSubscription: string;
      howItWorks: string;
      howItWorksText: string;
      calculator: {
        title: string;
        monthlySpend: string;
        monthlySavings: string;
        yearlySavings: string;
        spendInTokens: string;
      };
    };
    enterprise: {
      badge: string;
      title: string;
      subtitle: string;
      talkToSales: string;
      features: {
        api: string;
        invoicing: string;
        workspace: string;
        slack: string;
        customModels: string;
        earlyAccess: string;
      };
    };
    faq: {
      title: string;
      subtitle: string;
      questions: {
        howPricing: {
          q: string;
          a: string;
        };
        runOut: {
          q: string;
          a: string;
        };
        members: {
          q: string;
          a: string;
        };
        cancel: {
          q: string;
          a: string;
        };
        expire: {
          q: string;
          a: string;
        };
        commercial: {
          q: string;
          a: string;
        };
        invoice: {
          q: string;
          a: string;
        };
        discount: {
          q: string;
          a: string;
        };
        integrate: {
          q: string;
          a: string;
        };
      };
    };
    footer: {
      copyright: string;
    };
  };

  // OpenAPI Modal
  openApiModal?: {
    title: string;
    copy: string;
    copied: string;
    close: string;
  };

  // cURL Examples Modal
  curlExamplesModal?: {
    title: string;
    executeTitle: string;
    executeDescription: string;
    checkTitle: string;
    checkDescription: string;
    request: string;
    copy: string;
    copied: string;
    copyAll: string;
    copiedAll: string;
    successResponse: string;
    inProgressResponse: string;
    errorResponse: string;
    close: string;
    loading: string;
    availableParams: string;
    availableParamsDesc: string;
    parameters: string;
    fileUploadNote: string;
    mediaInputs: string;
    rateLimiting: string;
    rateLimitingDesc: string;
    rateLimitNote: string;
    rateLimitExceeded: string;
    pipelineBadge: string;
    pipelineNote: string;
  };

  // PromptV2 System
  promptsV2: {
    title: string;
    description: string;
    createPrompt: string;
    editPrompt: string;
    deletePrompt: string;
    confirmDelete: string;
    confirmDeleteMessage: string;
    deleteAll: string;
    deleteAllTitle: string;
    confirmDeleteAll: string;
    allPromptsDeleted: string;
    promptCreated: string;
    promptUpdated: string;
    promptDeleted: string;
    created: string;
    updated: string;
    deleted: string;
    loadingPrompts: string;
    noPrompts: string;
    noPromptsMessage: string;
    searchPlaceholder: string;
    // Visibility
    visibility: {
      label: string;
      public: string;
      corporate: string;
      private: string;
      publicDesc: string;
      corporateDesc: string;
      privateDesc: string;
    };
    // NSFW
    nsfw: {
      label: string;
      description: string;
      warning: string;
    };
    // Filters
    filters: {
      all: string;
      public: string;
      corporate: string;
      private: string;
      byCategory: string;
      selectCategory: string;
      selectSubcategory: string;
      nsfwAll: string;
      nsfwSafe: string;
      nsfwOnly: string;
    };
    // Form fields
    form: {
      title: string;
      titlePlaceholder: string;
      titleTranslations: string;
      description: string;
      descriptionPlaceholder: string;
      descriptionTranslations: string;
      body: string;
      bodyPlaceholder: string;
      bodyOptional: string;
      bodyOptionalPlaceholder: string;
      imagesRequired: string;
      imagesOptional: string;
      videoUrls: string;
      audioUrls: string;
      categories: string;
      selectCategories: string;
      mediaUpload: string;
      uploadImage: string;
      uploadVideo: string;
      addSlideshow: string;
      addImagePair: string;
      required: string;
    };
    // Tile config
    tileConfig: {
      displayType: string;
      none: string;
      singleImage: string;
      imagePair: string;
      singleVideo: string;
      singleAudio: string;
      slideshow: string;
      comparisonMode: string;
      slider: string;
      autoSwitch: string;
      autoSwitchDelay: string;
      slideshowTransition: string;
      instant: string;
      fade: string;
      slide: string;
      slideshowDelay: string;
      uploadImage: string;
      uploadBefore: string;
      uploadAfter: string;
      uploadVideo: string;
      uploadAudio: string;
      slideshowImage: string;
      uploading: string;
      deleteMedia: string;
      replaceMedia: string;
      confirmDeleteMedia: string;
      fileUploaded: string;
      dropFileHere: string;
      dragDrop: string;
      uploadError: string;
    };
    visualSettings: string;
    saveFirstToUploadMedia: string;
    // Import/Export
    importExport: {
      export: string;
      exportAll: string;
      import: string;
      importPrompts: string;
      selectFile: string;
      chooseFile: string;
      fileLoaded: string;
      readyToImport: string;
      invalidFormat: string;
      invalidJson: string;
      missingPrompts: string;
      updateMode: string;
      updateExisting: string;
      updateExistingDesc: string;
      skipExisting: string;
      skipExistingDesc: string;
      importSuccess: string;
      importedCount: string;
      updatedCount: string;
      skippedCount: string;
      exportSuccess: string;
      categoryNotFound: string;
      importResults: string;
      errors: string;
      warnings: string;
      noChanges: string;
      importedItems: string;
      updatedItems: string;
      skippedItems: string;
    };
    // Sidebar navigation
    sidebar: {
      general: string;
      content: string;
      contentOptional: string;
      images: string;
      media: string;
      categories: string;
      visual: string;
    };
  };

  // Prompt Categories Management
  promptCategories: {
    title: string;
    description: string;
    subtitle: string;
    categories: string;
    subcategories: string;
    createCategory: string;
    createSubcategory: string;
    createSubSubcategory: string;
    editCategory: string;
    editSubcategory: string;
    deleteCategory: string;
    deleteSubcategory: string;
    confirmDelete: string;
    deleteAll: string;
    deleteAllTitle: string;
    confirmDeleteAll: string;
    allCategoriesDeleted: string;
    categoryCreated: string;
    categoryUpdated: string;
    categoryDeleted: string;
    subcategoryCreated: string;
    subcategoryUpdated: string;
    subcategoryDeleted: string;
    statusUpdated: string;
    loadingCategories: string;
    noCategories: string;
    noSubcategories: string;
    rootCategory: string;
    parentCategoryHint: string;
    maxDepthReached: string;
    repairAssignments: string;
    repairAssignmentsDescription: string;
    repairSuccess: string;
    repairError: string;
    error: string;
    loadError: string;
    // Form fields
    form: {
      categoryId: string;
      categoryIdPlaceholder: string;
      categoryIdHelp: string;
      name: string;
      namePlaceholder: string;
      description: string;
      descriptionPlaceholder: string;
      parentCategory: string;
      selectParent: string;
      nameEn: string;
      nameRu: string;
      descriptionEn: string;
      descriptionRu: string;
      contentType: string;
      mode: string;
      displayOrder: string;
      isActive: string;
      isActiveDesc: string;
      analysisApiUrl: string;
      analysisApiUrlPlaceholder: string;
      analysisApiUrlHelp: string;
    };
    // Columns
    columns: {
      name: string;
      description: string;
      parentCategory: string;
      promptCount: string;
      subcategoryCount: string;
      contentType: string;
      mode: string;
      selectionMode: string;
      status: string;
      actions: string;
    };
    // Status
    status: {
      active: string;
      inactive: string;
    };
    // Content types
    contentType: {
      image: string;
      video: string;
      both: string;
    };
    // Modes
    mode: {
      default: string;
      characters: string;
      defaultDesc: string;
      charactersDesc: string;
    };
    // Selection Modes (multi/single)
    selectionMode: {
      label: string;
      multi: string;
      single: string;
      multiDesc: string;
      singleDesc: string;
      inherited: string;
      inheritedFrom: string;
    };
    // Import/Export
    importExport: {
      export: string;
      exportAll: string;
      import: string;
      importCategories: string;
      selectFile: string;
      chooseFile: string;
      fileLoaded: string;
      readyToImport: string;
      invalidFormat: string;
      invalidJson: string;
      missingCategories: string;
      updateMode: string;
      updateExisting: string;
      updateExistingDesc: string;
      skipExisting: string;
      skipExistingDesc: string;
      importSuccess: string;
      importedCount: string;
      updatedCount: string;
      skippedCount: string;
      exportSuccess: string;
      importResults: string;
      errors: string;
      noChanges: string;
      importedItems: string;
      updatedItems: string;
      skippedItems: string;
    };
    // Reference Limits
    referenceLimits: {
      title: string;
      description: string;
      mediaCountsTitle: string;
      maxTotal: string;
      maxImages: string;
      maxVideos: string;
      maxAudio: string;
      fileSizesTitle: string;
      imageMaxSize: string;
      videoMaxSize: string;
      audioMaxSize: string;
      durationsTitle: string;
      videoMaxDuration: string;
      audioMaxDuration: string;
      noLimit: string;
      compressionTitle: string;
      compressionEnabled: string;
      compressionQuality: string;
      compressionMaxDimension: string;
    };
    // Category Modal Sidebar
    categoryModal?: {
      editTitle: string;
      createTitle: string;
      sidebar: {
        general: string;
        names: string;
        settings: string;
        limits: string;
      };
    };
  };

  // Prompt Selection Modal (for widget)
  promptSelection: {
    title: string;
    selectPrompt: string;
    selectedPrompt: string;
    createYourOwn: string;
    favorites: string;
    addToFavorites: string;
    removeFromFavorites: string;
    // Character mode
    characters: {
      title: string;
      addCharacter: string;
      characterNumber: string;
      selectForCharacter: string;
    };
  };

  // User-created prompts (references)
  userPrompts: {
    addReference: string;
    createReference: string;
    editReference: string;
    viewReference: string;
    titleLabel: string;
    titlePlaceholder: string;
    descLabel: string;
    descPlaceholder: string;
    bodyLabel: string;
    bodyPlaceholder: string;
    bodyOptionalLabel: string;
    bodyOptionalPlaceholder: string;
    promptDetailsTitle: string;
    imagesLabel: string;
    uploadFile: string;
    pasteUrl: string;
    addImageUrl: string;
    visibilityLabel: string;
    visibilityOrg: string;
    visibilityOrgDesc: string;
    visibilityPrivate: string;
    visibilityPrivateDesc: string;
    save: string;
    cancel: string;
    edit: string;
    delete: string;
    confirmDelete: string;
    saving: string;
    uploading: string;
    createSuccess: string;
    updateSuccess: string;
    deleteSuccess: string;
    createError: string;
    updateError: string;
    deleteError: string;
    dragDropHint: string;
    maxImages: string;
    removeImage: string;
    categoryLabel: string;
    selectCategory: string;
    // Subcategory creation
    createSubcategory: string;
    addCategory: string;
    subcategoryName: string;
    subcategoryNamePlaceholder: string;
    subcategoryNameRequired: string;
    subcategoryCreated: string;
    selectionMode: string;
    selectionModeSingle: string;
    selectionModeMulti: string;
    selectionModeDescription: string;
    // Generate description / Analyze images
    generateDescription: string;
    generatingDescription: string;
    generateDescriptionError: string;
    analyzeImages: string;
    analyzing: string;
    expandAll: string;
    collapseAll: string;
    invalidUrl: string;
    uploadFailed: string;
    titleRequired: string;
    saveFailed: string;
    analyzingReferences: string;
  };

  // Prompt Editor V2 Widget
  promptEditorV2: {
    title: string;
    description: string;
    selectCategory: string;
    selectedPrompt: string;
    selectedPrompts: string;
    noPromptsSelected: string;
    noPromptsMessage: string;
    clickToSelect: string;
    searchPlaceholder: string;
    createPrivatePrompt: string;
    // Categories buttons
    style: string;
    background: string;
    characters: {
      title: string;
      characterNumber: string;
      selectForCharacter: string;
    };
    scenario: string;
    // Errors
    errors: {
      noPromptSelected: string;
      noCharactersSelected: string;
      promptRequired: string;
      promptOrSelectionRequired: string;
    };
    // Help content
    helpTitle?: string;
    helpWhatIs?: string;
    helpWhatIsDesc?: string;
    helpCategories?: string;
    helpCategoriesDesc?: string;
    helpCatRecommended?: string;
    helpCatSelected?: string;
    helpCatOptional?: string;
    helpMediaLimits?: string;
    helpMediaLimitsDesc?: string;
    helpSessionRef?: string;
    helpSessionRefDesc?: string;
    helpPrompt?: string;
    helpPromptDesc?: string;
    helpExamplesTitle?: string;
    helpExamplesIntro?: string;
    helpEx1?: string;
    helpEx2?: string;
    helpEx3?: string;
    helpEx4?: string;
  };

  // Input Text Widget
  inputText?: {
    title: string;
    placeholder: string;
    field1: string;
    field2: string;
    requiredHint: string;
    optionalHint: string;
    errors: {
      empty: string;
      tooLong: string;
    };
  };

  // MCP OAuth Consent Page
  mcpAuth?: {
    title: string;
    subtitle: string;
    requestsAccess: string;
    selectOrganization: string;
    scopeLabel: string;
    scopeRead: string;
    scopeReadDesc: string;
    scopeStandard: string;
    scopeStandardDesc: string;
    scopeFull: string;
    scopeFullDesc: string;
    authorize: string;
    deny: string;
    signingIn: string;
    notSignedIn: string;
    signInRequired: string;
    signInButton: string;
    noOrganizations: string;
    noOrganizationsDesc: string;
    error: string;
    unknownClient: string;
    permissionsTitle: string;
    authorizing: string;
    authorizationDenied: string;
    invalidScope: string;
  };

}

export const LOCALIZATION: Record<Language, LocalizationStrings> = {
  ru: {
    draftFinal: {
      button: 'Финал 1080p',
      confirmTitle: 'Создать финал 1080p',
      confirmMessage: 'Создать финальное видео из этого драфта?',
      estimatedCost: 'Примерная стоимость: {cost} токенов',
      loadError: 'Не удалось подготовить финал. Попробуйте ещё раз.',
      started: 'Генерация финала 1080p запущена',
    },
    mcpServers: MCP_SERVERS_LOCALIZATION.ru,
    // Header
    appTitle: 'Art Generator',
    appSubtitle: 'Ваш инструмент для создания изображений с помощью ИИ',
    
    // Status indicators
    statusReady: 'Готов к работе!',
    
    // AI Settings
    aiSettings: 'AI Настройки',
    aiSettingsDescription: 'Выберите AI модель и стиль промпта для создания лучших изображений',
    geminiModel: 'AI Модуль',
    promptStyle: 'Стиль промпта',
    generationMode: 'Режим генерации',
    advancedSettings: 'Продвинутые настройки генерации',
    
    // Image Parameters
    imageParameters: 'Параметры изображения',
    imageParametersDescription: 'Настройте количество и разрешение создаваемых изображений',
    quantity: 'Тираж',
    size: 'Разрешение',
    quantityTooltip: 'Больше изображений = больше вариантов, но дольше генерация',
    sizeTooltip: '1024×1024 • HD Спрайт - идеально для иконок и аватаров персонажей',
    estimatedTime: 'сек',
    fixedSeedLabel: 'Фиксировать',
    fixedSeedTooltip: 'Сохранять базовый сид между запусками, чтобы воспроизводить тот же контент',
    
    // Prompt and Content
    promptAndContent: 'Промпт и референсы',
    promptAndContentDescription: 'Введите текст промпта и загрузите референсы (если требует режим)',
    imageUpload: 'Загрузка референсов',
    imageUploadDescription: 'Перетащите сюда исходные спрайты или текстуры',
    imageDescription: 'Текст промпта',
    imageDescriptionTooltip: 'Опишите арт, который хотите создать. Используйте шаблоны для улучшения промпта',
    generationModeTitle: 'Режим генерации',
    generationModeDescription: 'Выберите, как будет использован ваш промпт и референсы',
    
    // Modes
    textToImage: 'Текст → Спрайт',
    reduxTransform: 'Быстрый рескин',
    imageContext: 'Контекстный рендер',
    multiContext: 'Комбо-рендер',
    removeBg: 'Убрать фон',
    textToImageDesc: 'Создание изображений из текстовых промптов',
    reduxTransformDesc: 'Быстрая перерисовка спрайта',
    imageContextDesc: 'Создание арта с учетом стиля исходника',
    multiContextDesc: 'Комбинирование нескольких спрайтов в один',
    removeBgDesc: 'Автоматическое удаление фона с изображения',
    
    // Gallery (deprecated - use gallery object below)
    // gallery: 'Галерея',
    galleryDescription: 'Ваш созданный контент. Просматривайте, скачивайте и повторяйте промпты',
    noImagesYet: 'У вас пока нет сгенерированного контента',
    
    // Gemini Settings
    geminiSettings: 'Настройки AI генератора',
    geminiSettingsSubtitle: 'Выберите стиль улучшения промптов и язык интерфейса',
    language: 'Язык манускриптов',
    languageDesc: 'Язык интерфейса',
    readyTemplates: 'Готовые промпты',
    technicalPrompts: 'Технические промпты',
    customPrompt: 'Свой промпт',
    currentSelectedPrompt: 'Активный промпт:',
    stylization: 'Стилизация',
    stylizationDesc: 'Применяет выбранный художественный стиль к вашему промпту, добавляя соответствующие ключевые слова.',
    
    // Settings panel
    settings: 'Настройки',
    imageSize: 'Размер',
    numImages: 'Количество',
    prompts: 'Промпты',
    
    // Technical Prompts
    technicalPromptsTitle: 'Технические промпты',
    technicalPromptsDescription: 'Специализированные промпты для анализа изображений и технических задач',
    systemPrompt: 'Системный промпт',
    imageAnalysis: 'Анализ спрайта',
    imageAnalysisDesc: 'Детальный анализ спрайта для извлечения его сущности',
    imageContextPrompt: 'Промпт контекста',
    imageContextTechDesc: 'Создание промпта на основе стиля и контекста референсного изображения',
    multiContextPrompt: 'Комбо-промпт',
    multiContextTechDesc: 'Комбинирование стилей нескольких изображений в один промпт',
    reduxTransformation: 'Промпт рескина',
    reduxTransformationDesc: 'Создание промпта для быстрого рескина изображений',
    
    // Categories
    creative: 'Для квестов',
    professional: 'Для UI/UX',
    artistic: 'Для персонажей',
    technical: 'Для ассетов',
    realism: 'Реализм',
    portrait: 'Портреты',
    character: 'Концепты персонажей',
    landscape: 'Ландшафты',
    location: 'Концепты локаций',
    isometric: 'Изометрия',
    icons: 'Иконки',
    splash: 'Заставки',
    ui: 'Интерфейс',
    sdg: 'SDG',
    
    // Actions
    preview: 'Предпросмотр',
    select: 'Выбрать',
    close: 'Закрыть',
    ready: 'Готово',
    save: 'Сохранить',
    saveAndApply: 'Сохранить и применить',
    fixPrompt: 'Улучшить промпт',
    improvePrompt: 'Улучшить промпт',
    generate: 'Генерировать!',
    describeImage: 'Описать изображение',
    analyzePhoto: '🔮 Анализировать изображение',
    analyzingPhoto: 'Сканирую...',
    improving: 'Улучшаем...',
    translate: 'Перевести',
    translating: 'Переводим...',
    
    // Prompt examples
    customPromptTitle: 'Создание своего промпта',
    customPromptDescription: 'Используйте параметры {mode} и {prompt} для динамического содержимого.',
    customPromptExample: 'Ты - эксперт по созданию изображений. Улучши промпт для режима "{mode}": "{prompt}"',
    
    // Size options
    square: '1:1',
    squareHd: 'HD',
    portrait43: '3:4',
    portrait169: '9:16',
    landscape43: '4:3',
    landscape169: '16:9',
    
    // Model descriptions
    gemini15Pro: 'Gemini 1.5 Pro',
    gemini15Flash: 'Gemini 1.5 Flash',
    gemini20Flash: 'Gemini 2.0 Flash',
    gemini25ProPreview: 'Gemini 2.5 Pro Preview',
    gemini25FlashPreview1: 'Gemini 2.5 Flash Preview',
    gemini25FlashPreview2: 'Gemini 2.5 Flash Preview',
    
    // Template names and descriptions
    creativeDetailed: 'Креативный детальный',
    creativeDetailedDesc: 'Максимально подробное и художественное описание',
    professionalPhoto: 'Профессиональная фотография',
    professionalPhotoDesc: 'Фокус на технических аспектах фотографии',
    artisticStyle: 'Художественный стиль',
    artisticStyleDesc: 'Акцент на художественных стилях и техниках',
    cinematicEpic: 'Кинематографический эпик',
    cinematicEpicDesc: 'Создание эпических кинематографических сцен',
    technicalPrecise: 'Технически точный',
    technicalPreciseDesc: 'Максимальная техническая точность и детализация',
    minimalistClean: 'Минималистичный',
    minimalistCleanDesc: 'Чистый минималистичный подход',
    fantasyMagical: 'Фэнтези магия',
    fantasyMagicalDesc: 'Волшебные и фантастические элементы',
    retroVintage: 'Ретро винтаж',
    retroVintageDesc: 'Винтажные и ретро стили разных эпох',
    creativeCampaigns: 'Креативные кампании',
    creativeCampaignsDesc: 'Нестандартные и инновационные рекламные решения',
    portraitCgi: 'CGI Фотореалистичные',
    portraitCgiDesc: 'CGI-стиль для реалистичных портретов',
    portraitWatercolor: 'Акварельные портреты',
    portraitWatercolorDesc: 'Нежные и воздушные портреты в стиле акварели',
    portraitAnimeGhibli: 'Аниме в стиле Ghibli',
    portraitAnimeGhibliDesc: 'Портреты в духе работ студии Ghibli',
    portraitVector: 'Векторные портреты',
    portraitVectorDesc: 'Чистые и стильные векторные изображения',
    yourPrompt: 'Свой промпт',

    // UI Elements
    dropImages: 'Перетащите референсы',
    dragDropText: 'Перетащите файлы сюда или нажмите для выбора',
    estimatedTimeText: 'сек',
    charactersCount: 'Символов',
    madeWith: 'Скрафчено с',
    poweredBy: 'на движке',
    customPromptPlaceholder: 'Введите ваш промпт для AI генератора...',
    sessionPromptPlaceholder: 'Изменить промпт для текущей генерации...',
    sessionChangesNote: 'Изменения применяются только для текущей генерации',
    reset: 'Сбросить',
    apply: 'Применить',
    selected: 'Выбрано',
    usingCustom: 'Используется свой промпт',
    usingSession: 'Используется промпт сессии',
    uiElements: 'Элементы интерфейса',
    
    // Tooltips
    notAvailableInMode: 'Недоступно в этом режиме',
    imageCount1: '1 изображение',
    imageCount2: '2 изображения',
    imageCount3: '3 изображения',
    imageCount4: '4 изображения',

    // NEW ADDITIONS - PromptBox
    promptBoxTitle: 'Текст промпта',
    clear: 'Стереть',
    clearTooltip: 'Стереть промпт',
    promptPlaceholder: 'Опишите арт, который хотите создать... Например: \'рыцарь в сияющих доспехах, фэнтези, пиксель-арт, вид сбоку, для 2D платформера\'',
    hideExamples: 'Свернуть шаблоны',
    showExamples: '✨ Примеры промптов',
    enhancing: 'Зачаровываю...',
    describing: 'Извлекаю сущность...',
    generating: 'Генерирую...',
    examplesTitle: 'Шаблоны с примерами промптов:',
    examplesTip: '💡 Совет: Кликни на шаблон, чтобы использовать промпт. Его можно изменять и дополнять.',

    // NEW ADDITIONS - Gallery  
    allImages: 'Все',
    noImagesForMode: 'Нет контента для режима',
    createFirstImage: 'Создайте свое первое изображение, нажав "Генерировать!"',
    tryCreateInMode: 'Попробуйте создать что-нибудь в этом режиме',
    imageLoadError: 'Изображение не загрузилось',
    loadingImage: 'Загрузка изображения...',
    enlarge: 'Увеличить',
    copyPrompt: 'Копировать промпт',
    download: 'Скачать',
    downloaded: 'Скачано!',
    downloadOriginal: 'Скачать оригинал',
    downloadWebP: 'Скачать WebP',
    downloadedWebP: 'Скачано WebP!',
    usePrompt: 'Использовать промпт',
    enlargedView: 'Просмотр изображения',
    promptLabel: 'Промпт:',
    copy: 'Копировать',
    downloadError: 'Ошибка скачивания:',

    // NEW ADDITIONS - DropZone
    dropFilesHere: 'Бросайте референсы сюда',
    uploadImages: 'Загрузить референсы',
    dragDropHere: 'Перетащите файлы сюда или нажмите для выбора',
    dragFilesToZone: 'Перетащите файлы в эту область',
    clickToSelect: 'нажмите для выбора',
    supportedFormats: 'PNG, JPG, WEBP',
    maxSize: 'До 10MB',
    noLimit: 'Без ограничений',
    uploadedFiles: 'Загруженные референсы',
    clearAll: 'Очистить все',
    removeImage: 'Убрать референс',
    totalFiles: 'Всего референсов:',
    totalSize: 'Общий вес:',
    readyToGenerate: 'Готово к генерации',
    uploadTips: 'Советы по загрузке референсов:',
    qualityTip: 'Качество: Используйте исходники высокого разрешения',
    formatTip: 'Формат: PNG, JPG, WEBP - все поддерживаются',
    sizeTip: 'Размер: Оптимальный вес файла до 5-10MB',
    compositionTip: 'Композиция: Четкие, хорошо читаемые спрайты дают лучший результат',
    readyForProcessing: 'Готов к обработке',

    // NEW ADDITIONS - Error messages
    fixPromptError: 'Ошибка зачарования: ',
    improvePromptError: 'Ошибка улучшения промпта: {error}',
    enterTextToImprove: 'Введите текст для улучшения',
    describeError: 'Не удалось описать изображение. Попробуйте позже.',
    unknownError: 'Неизвестная ошибка',
    uploadImageFirst: 'Загрузите референс для анализа изображения',
    describeImageError: 'Ошибка извлечения сущности: ',
    generationError: 'Ошибка генерации: ',
    tooManyImagesError: 'Слишком много изображений для режима "{modeName}"!\n\nМаксимум: {maxImages} изображения\nЗагружено: {currentImages} изображений\n\nУдалите лишние изображения или смените режим.',
    
    // Alert messages
    maxReferencesAlert: '❌ Максимум {maxImages} referencer для режима {mode}! Удалите существующие для загрузки новых.',
    filesUploadedAlert: '📋 Загружено {uploaded} из {total} файлов (лимит: {maxImages} референсов)',
    compressionError: '❌ Ошибка при сжатии изображений. Попробуйте еще раз.',
    enterTextToTranslate: 'Введите текст для перевода',
    translationError: 'Ошибка перевода: {error}',
    jsonParseError: 'Ошибка парсинга JSON размышлений. Проверьте синтаксис.',
    promptRegenerationError: 'Ошибка при регенерации промпта: {error}',
    removeBgRequiresImage: 'Для удаления фона требуется загрузить изображение',
    removeBgOnlyOneImage: 'Для удаления фона можно загрузить только одно изображение',
    modeRequiresImage: 'Для этого режима требуется загрузить изображение',
    fillRequiresMask: 'Для режима Fill необходимо создать маску. Нажмите "Создать маску" чтобы выделить области для заполнения.',

    // NEW ADDITIONS - Mode descriptions
    text2imgModeDesc: 'Создание спрайтов из текста с помощью нейросети FLUX Ultra',
    img2imgModeDesc: 'Высокоскоростной рескин спрайтов с помощью FLUX Redux API',
    imgKontextModeDesc: 'Умное редактирование изображений: восстановление, расширение, удаление элементов, изменение стиля',
    multiKontextModeDesc: 'Работа с несколькими спрайтами для создания сложных композиций',

    // NEW ADDITIONS - Model descriptions
    gemini15ProDesc: 'Мощный классический модуль для сложных задач',
    gemini15FlashDesc: 'Быстрый классический модуль для простых промптов',
    gemini20FlashDesc: 'Современный стабильный модуль (рекомендуется)',
    gemini25ProPreviewDesc: 'Новейший мощный модуль в preview режиме',
    gemini25FlashPreview1Desc: 'Быстрая preview версия для тестов',
    gemini25FlashPreview2Desc: 'Самый новый модуль с последними возможностями',

    // NEW ADDITIONS - Size descriptions
    squareHdDesc: '1024×1024 • HD Спрайт - идеально для иконок и аватаров',
    squareDesc: '512×512 • Изображение - быстрая генерация',
    portrait43Desc: '768×1024 • Портрет 3:4 - для карточек персонажей',
    portrait169Desc: '576×1024 • Портрет 9:16 - для мобильных экранов',
    landscape43Desc: '1024×768 • Пейзаж 4:3 - для фонов и локаций',
    landscape169Desc: '1024×576 • Пейзаж 16:9 - для заставок и баннеров',
    cinematic219: '21:9',
    cinematic921: '9:21',
    photo32: '3:2',
    photo23: '2:3',
    cinematic219Desc: '21:9 • Сверхширокий кинематографический формат',
    cinematic921Desc: '9:21 • Вертикальный кинематографический формат',
    photo32Desc: '3:2 • Классический формат карточки',
    photo23Desc: '2:3 • Портретный формат карточки',

    // NEW ADDITIONS - Prompt suggestions
    suggestion1: 'пиксель-арт иконка зелья здоровья для инвентаря в RPG',
    suggestion2: 'спрайт врага-скелета, анимация ходьбы, для 2D-платформера',
    suggestion3: 'концепт-арт киберпанк города с неоновыми вывесками, вид сверху',
    suggestion4: 'бесшовная текстура травы в стиле фэнтези для игровой карты',
    suggestion5: 'UI-кнопка "Play" в мультяшном стиле для мобильной игры',
    suggestion6: 'портрет эльфийской волшебницы, высокое разрешение, для диалогового окна',
    suggestion7: 'изометрический спрайт здания, средневековый замок, для RTS',
    suggestion8: 'промо-арт гоночного болида в стиле ретро-вейв 80-х',
    
    // Modal close instruction
    modalCloseInstruction: 'Нажмите ESC или кликните вне изображения для закрытия',
    
    // Auth buttons
    signIn: 'Войти',
    signUp: 'Регистрация',
    
    // Raw Mode
    rawMode: 'Естественный рендер (RAW)',
    rawModeDesc: 'Менее обработанные, более естественные и реалистичные изображения',
    
    // API Limitation notifications
    apiLimitTemplate: '⚠️ {modeName} режим: запрошено {requested}, но Багодемоны из Fal.AI 🐛  ограничили до {actual} изображения. Зарепортили!',
    modeNameFill: 'Fill (Заполнение)',
    modeNameCanny: 'Canny (Контроль по краям)',
    modeNameDepth: 'Depth (Контроль по глубине)',
    
    // Safety levels
    safetyStrict: 'Строгая',
    safetyBalanced: 'Средняя',
    safetySoft: 'Мягкая',
    safetyDisabled: 'Выключена',
    
    // Compact UI texts
    uploadReagents: 'Загрузить',
    compressing: 'Сжимаем...',
    filled: 'Заполнено',
    dropping: 'Бросайте',
    uploadTipsTitle: 'Советы по загрузке:',
    tipHighRes: 'Высокое разрешение',
    tipFormats: 'PNG, JPG, WEBP',
    tipAutoCompress: 'Авто-сжатие в JPEG',
    tipClearScenes: 'Четкие сцены',
    tipMaxSize: 'До 1024×1024',

    // Mask editor and dropzone UI
    createMask: 'Создать маску',
    editMask: 'Изменить маску',
    uploadedReagents: 'Загруженные референсы',
    reagentsCount: 'Референсов',
    readyToExperiment: 'Готово к экспериментам!',

    // Advanced settings labels
    imageInfluenceStrength: 'Сила влияния изображения',
    inferenceSteps: 'Шаги генерации',
    guidanceScale: 'Точность следования',
    safety: 'Безопасность',
    
    // Slider labels
    weak: 'Слабо',
    strong: 'Сильно',
    fast: 'Быстро',
    quality: 'Качество',
    precise: 'Точно',
    creativeSlider: 'Креативно',

    // Mode tooltips
    text2imgTooltip: '🖼️ Создание изображений исключительно из текстового описания. Можно загрузить до 4 референсных изображений для вдохновения и стилистики.',
    img2imgTooltip: '🔄 Трансформация загруженного изображения согласно текстовому описанию. Сохраняет основную композицию и структуру исходника.',
    imgKontextTooltip: '🎯 Создание нового изображения с учетом стиля и контекста загруженного референса. Использует одно изображение как стилистическую основу.',
    multiKontextTooltip: '🔀 Создание изображения на основе двух референсных изображений. Строго 2 изображения для смешивания стилей и композиций.',
    cannyTooltip: '🔲 Контроль генерации по контурам и краям изображения. Сохраняет четкие границы объектов и их расположение из referencer.',
    depthTooltip: '🌊 Контроль генерации по карте глубины. Сохраняет пространственную структуру, объем и перспективу сцены.',
    fillTooltip: '🖌️ Заполнение выбранных областей изображения новым контентом. Используется маска для указания зон редактирования и замены.',
    removeBgTooltip: '✂️ Автоматическое удаление фона с изображения. Загрузите одно изображение и получите результат с прозрачным фоном.',
    
    // Action button tooltips
    generateTooltip: 'Запустить генерацию',
    generatingTooltip: 'Генерируем...',
    fixPromptTooltip: 'Улучшить промпт с ИИ',
    fixingPromptTooltip: 'Улучшаем промпт...',

    // Prompts Management
    promptsManagement: {
      title: 'Промпты',
      adminMode: 'Режим администратора',
      adminWarning: 'Вы работаете в режиме глобального администратора с организацией, в которой не состоите.',
      backToAdmin: 'Вернуться в админ-панель',
      tabs: {
        style: 'Стиль',
        basic: 'Базовые',
        workflow: 'Воркфлоу',
      },
      create: 'Создать',
      createButton: 'Создать промпт',
      createFirst: 'Создать первый',
      prompt: 'промпт',
      edit: 'Редактировать',
      delete: 'Удалить',
      enable: 'Включить',
      disable: 'Отключить',
      enabled: 'Включен',
      disabled: 'Отключен',
      enabledInOrg: 'Включен в организации',
      disabledInOrg: 'Отключен в организации',
      globalPromptReadonly: 'Только просмотр',
      copy: 'Копировать',
      copyTooltip: 'Скопировать промпт в буфер обмена',
      copySuccess: 'Промпт скопирован в буфер обмена',
      copyError: 'Не удалось скопировать промпт',
      duplicate: 'Дубликат',
      duplicateTooltip: 'Создать дубликат промпта',
      duplicateSuccess: 'Дубликат промпта создан успешно',
      globalPrompts: 'Глобальные промпты',
      organizationPrompts: 'Промпты организации',
      noGlobalPrompts: 'Глобальные промпты не найдены.',
      noGlobalPromptsTitle: 'Нет глобальных промптов',
      noOrgPrompts: 'Промпты организации не найдены.',
      noPromptsTitle: 'Нет промптов',
      searchPlaceholder: 'Поиск промптов...',
      columns: {
        title: 'Название',
        description: 'Описание',
        status: 'Статус',
        created: 'Дата создания',
        createdBy: 'Создатель',
        actions: 'Действия',
      },
      deleteConfirmTitle: 'Удалить промпт',
      deleteConfirmMessage: 'Вы уверены, что хотите удалить этот промпт? Это действие нельзя отменить.',
      deleteSuccess: 'Промпт успешно удален',
      deleteError: 'Ошибка при удалении промпта',
      modal: {
        createTitle: 'Создать промпт',
        editTitle: 'Редактировать промпт',
        titleLabel: 'Название',
        descriptionLabel: 'Описание',
        bodyLabel: 'Текст промпта',
        globalLabel: 'Глобальный промпт',
        globalHint: 'Сделать этот промпт доступным для всех организаций',
        createButton: 'Создать',
        updateButton: 'Обновить',
        cancelButton: 'Отменить',
        titlePlaceholder: 'Введите название промпта...',
        descriptionPlaceholder: 'Введите описание промпта...',
        bodyPlaceholder: 'Введите текст промпта...',
        charactersCount: 'символов',
        titleMinLength: 'Название должно содержать минимум 3 символа',
        titleMaxLength: 'Название не должно превышать 100 символов',
        descriptionMinLength: 'Описание должно содержать минимум 3 символа',
        descriptionMaxLength: 'Описание не должно превышать 300 символов',
        bodyMinLength: 'Текст промпта должен содержать минимум 10 символов',
        bodyMaxLength: 'Текст промпта не должен превышать 3000 символов',
      },
    },
    
    
    // Organization Info Page
    organizationInformation: 'Информация об организации',
    backToHome: 'Главная',
    members: 'Участники',
    generationLimit: 'Лимит генераций',
    tokensRemaining: 'Токенов осталось',
    used: 'Использовано',
    yourRole: 'Ваша роль',
    organizationMembers: 'Участники организации',
    yourGenerationHistory: 'Ваша история генераций',
    leaveOrganization: 'Покинуть организацию',
    leaving: 'Покидаем...',
    cannotLeaveAsOnlyAdmin: 'Вы единственный администратор этой организации. Назначьте другого администратора перед выходом из организации.',
    cannotLeaveOrganization: 'Невозможно покинуть организацию',
    leaveOrganizationConfirm: 'Вы уверены, что хотите покинуть организацию',
    leave: 'Покинуть',
    cancel: 'Отмена',
    organizationLeft: 'Организация покинута',
    leftOrganizationSuccess: 'Вы успешно покинули организацию',
    failedToLeaveOrganization: 'Не удалось покинуть организацию',
    error: 'Ошибка',
    promptCopiedToClipboard: 'Промпт скопирован в буфер обмена',
    failedToCopyPrompt: 'Не удалось скопировать промпт',
    loadingMembers: 'Загрузка участников...',
    membersNotFound: 'Участники не найдены',
    noGenerationsYet: 'У вас пока нет генераций в этой организации',
    loadMore: 'Загрузить еще',
    loading: 'Загрузка...',
    joinedOn: 'Присоединился',
    email: 'Email',
    name: 'Имя',
    role: 'Роль',
    joinedAt: 'Дата присоединения',

    // Navigation keys
    nav: {
      home: 'Главная',
      organization: 'Организация',
      manager: 'Управление',
      info: 'Информация',
      history: 'История',
      navigateTo: 'Перейти к',
      workflow: 'Воркфлоу',
      management: 'Управление',
      managementDesc: 'Управление пользователями и настройками',
      prompts: 'Промпты',
      promptsDesc: 'Управление промптами организации',
      promptsOld: 'Промпты',
      promptsOldDesc: 'Система промптов',
      categories: 'Категории',
      categoriesDesc: 'Включить/отключить категории промптов',
      corpPrompts: 'Референсы',
      corpPromptsDesc: 'Управление референсами организации',
      myReferences: 'Мои референсы',
      myReferencesDesc: 'Персональная коллекция референсов',
      organizationInfoDesc: 'Просмотр деталей и статистики',
      historyDesc: 'Просмотр истории генерации',
      actions: 'Действия',
      collections: 'Коллекции',
      collectionsDesc: 'Управление коллекциями изображений',
      openInNewTab: 'Открыть в новой вкладке',
      logout: 'Выход',
      allRefunds: 'Все возвраты',
      allRefundsDesc: 'Возвраты токенов по всем организациям',
      billing: 'Биллинг',
      billingDesc: 'Покупка токенов',
      billingAddress: 'Платёжные данные',
      billingAddressDesc: 'Юридические данные для инвойсов',
      invoices: 'Инвойсы',
      invoicesDesc: 'Просмотр и скачивание инвойсов'
    },

    // Organization Categories
    orgCategories: {
      title: 'Настройки категорий',
      description: 'Включите или отключите категории для этой организации. Отключенные категории не будут доступны для выбора промптов.',
      searchPlaceholder: 'Поиск категорий...',
      allTypes: 'Все типы',
      imageOnly: 'Только изображения',
      videoOnly: 'Только видео',
      import: 'Импорт',
      export: 'Экспорт',
      noCategories: 'Категории не найдены',
      categoryEnabled: 'Категория включена',
      categoryDisabled: 'Категория отключена',
      fetchError: 'Не удалось загрузить категории',
      toggleError: 'Не удалось обновить категорию',
      exportSuccess: 'Экспорт завершен',
      exportError: 'Не удалось экспортировать категории',
      importSuccess: 'Импорт завершен',
      importError: 'Не удалось импортировать категории',
      imported: 'импортировано',
      skipped: 'пропущено',
      // Edit/Delete organization categories
      edit: 'Редактировать',
      delete: 'Удалить',
      editCategory: 'Редактировать категорию',
      deleteCategory: 'Удалить категорию',
      confirmDelete: 'Подтвердить удаление',
      confirmDeleteMessage: 'Вы уверены, что хотите удалить эту категорию? Это действие необратимо.',
      editSuccess: 'Категория успешно обновлена',
      editError: 'Не удалось обновить категорию',
      deleteSuccess: 'Категория успешно удалена',
      deleteError: 'Не удалось удалить категорию',
      nameEn: 'Название (английский)',
      nameRu: 'Название (русский)',
      descriptionEn: 'Описание (английский)',
      descriptionRu: 'Описание (русский)',
      save: 'Сохранить',
      cancel: 'Отмена',
      organizationOwned: 'Категория организации',
      // Create subcategory
      categoryCreated: 'Категория успешно создана',
      addSubcategory: 'Добавить подкатегорию',
      // Delete permission errors
      cannotDeleteOthersPrompts: 'Нельзя удалить категорию с промптами других пользователей',
      cannotDeleteOthersPromptsDetail: 'Эта категория содержит {total} промптов, но только {yours} из них ваши. Только администраторы организации могут удалять категории с промптами других пользователей.',
      checkingPermissions: 'Проверка прав доступа...',
      // Prompts list in delete modal
      promptsInCategory: 'Промпты в этой категории:',
      yourPrompt: '(ваш)',
      otherUserPrompt: '(чужой)',
      andMorePrompts: '...и ещё {count}',
      // Delete all categories
      deleteAll: 'Удалить все',
      deleteAllTitle: 'Удалить все категории организации',
      deleteAllConfirmMessage: 'Это действие удалит ВСЕ категории, созданные вашей организацией. Глобальные категории затронуты не будут. Введите "delete" для подтверждения.',
      deleteAllSuccess: 'Все категории организации удалены',
      deleteAllSuccessTitle: 'Категории успешно удалены',
      deleteAllResultMessage: 'Успешно удалено категорий: {count}',
      deleteAllError: 'Не удалось удалить категории',
      noOrgCategoriesToDelete: 'Нет категорий организации для удаления',
      typeDeleteToConfirm: 'Введите "delete" для подтверждения',
      // Import mode selection
      importModeTitle: 'Выберите режим импорта',
      importModeDescription: 'В организации уже есть собственные категории. Выберите, как их обрабатывать при импорте.',
      importModeMerge: 'Объединить',
      importModeMergeDescription: 'Добавить новые и обновить существующие категории. Ничего не удалять.',
      importModeReplace: 'Заменить все',
      importModeReplaceDescription: 'Заменить все категории организации на импортируемые. Привязки промптов будут сохранены для совпадающих категорий.',
      importModeReplaceWarning: 'Категории, отсутствующие в файле импорта, будут удалены вместе с их привязками к промптам.',
      // Import results - reactivation/cleanup
      reactivated: 'Восстановлено',
      reactivatedDescription: 'привязки промптов сохранены',
      cleanedUp: 'Удалено устаревших',
      cleanedUpDescription: 'категорий, отсутствующих в импорте'
    },

    // Analysis Config (Category Settings)
    analysisConfig: {
      title: 'Настройка API анализа',
      apiUrl: 'URL API',
      apiUrlHelp: 'URL эндпоинта для отправки данных на анализ',
      workflowUrl: 'URL воркфлоу',
      workflowUrlHelp: 'Ссылка на воркфлоу (для справки)',
      apiKey: 'API ключ',
      apiKeyHelp: 'Ключ авторизации для запросов к API анализа',
      prompt: 'Промпт анализа',
      promptHint: 'Выберите промпт для анализа (опционально)',
      extraParams: 'Дополнительные параметры',
      extraParamsHelp: 'Пары ключ-значение, добавляемые в запрос анализа',
      addParam: 'Добавить параметр',
      paramKey: 'Ключ',
      paramValue: 'Значение',
      fieldMapping: 'Маппинг полей API',
      requestFields: 'Запрос (POST):',
      responseFields: 'Ответ:',
      inheritHelp: 'Отключите для наследования от родительской категории. При включении необходимо указать URL API.',
      apiUrlRequired: 'URL API обязателен при включённой конфигурации анализа',
      apiKeyRequired: 'API ключ обязателен при включённой конфигурации анализа',
    },

    // Organization Prompts
    orgReferences: {
      title: 'Референсы организации',
      description: 'Управление референсами организации. Эти референсы доступны всем участникам.',
      userDescription: 'Просматривайте и создавайте референсы для организации. Вы можете редактировать и удалять только свои референсы.',
      searchPlaceholder: 'Поиск референсов...',
      allContent: 'Весь контент',
      sfwOnly: 'Только SFW',
      nsfwOnly: 'Только NSFW',
      create: 'Создать референс',
      createPrompt: 'Создать референс',
      editPrompt: 'Редактировать референс',
      import: 'Импорт',
      export: 'Экспорт',
      deleteAll: 'Удалить все',
      totalPrompts: '{count} референсов',
      noPrompts: 'Референсы организации не найдены',
      createFirst: 'Создать первый референс',
      edit: 'Редактировать',
      delete: 'Удалить',
      titleLabel: 'Название',
      titlePlaceholder: 'Введите название референса',
      descriptionLabel: 'Описание',
      descriptionPlaceholder: 'Введите описание референса',
      bodyLabel: 'Текст промпта',
      bodyPlaceholder: 'Введите текст промпта',
      categoriesLabel: 'Категории',
      selectCategory: 'Выберите категорию...',
      validationError: 'Название, текст и хотя бы одна категория обязательны',
      createSuccess: 'Референс успешно создан',
      createError: 'Не удалось создать референс',
      updateSuccess: 'Референс успешно обновлен',
      updateError: 'Не удалось обновить референс',
      deleteSuccess: 'Референс успешно удален',
      deleteError: 'Не удалось удалить референс',
      deleteConfirmTitle: 'Удалить референс',
      deleteConfirmMessage: 'Вы уверены, что хотите удалить "{title}"?',
      deleteAllConfirmTitle: 'Удалить все референсы',
      deleteAllConfirmMessage: 'Вы уверены, что хотите удалить ВСЕ референсы организации? Это действие нельзя отменить. Введите "delete" для подтверждения.',
      deleteAllSuccess: 'Удалено {count} референсов',
      deleteAllError: 'Не удалось удалить все референсы',
      exportSuccess: 'Экспорт завершен',
      exportError: 'Не удалось экспортировать референсы',
      importSuccess: 'Импорт завершен',
      importError: 'Не удалось импортировать референсы',
      fetchError: 'Не удалось загрузить референсы',
      imported: 'импортировано',
      skipped: 'пропущено',
      typeDeleteToConfirm: 'Введите "delete" для подтверждения',
      createReference: 'Создать референс',
      editReference: 'Редактировать референс',
      viewReference: 'Просмотр референса',
      mediaSection: 'Медиа референсы',
      mediaCounter: 'Референсы ({current}/{max})',
      mediaUpload: 'Загрузить',
      mediaFromGallery: 'Галерея',
      mediaRemove: 'Удалить',
      mediaDragHint: 'Перетащите файлы сюда или нажмите кнопку',
      mediaMaxReached: 'Достигнут максимум медиафайлов ({max})',
      maxImagesReached: 'Достигнут максимум изображений ({max})',
      maxVideosReached: 'Достигнут максимум видеофайлов ({max})',
      maxAudioReached: 'Достигнут максимум аудиофайлов ({max})',
      limitsImages: 'Изображения: макс. {count}, до {size} МБ',
      limitsVideo: 'Видео: макс. {count}, до {size} МБ',
      limitsAudio: 'Аудио: макс. {count}, до {size} МБ',
      limitsDuration: ', макс. {min} мин',
      mediaTypeImage: 'Изображение',
      mediaTypeVideo: 'Видео',
      mediaTypeAudio: 'Аудио',
      bodyOptionalLabel: 'Дополнительные данные (ключевые слова, формула)',
      bodyOptionalPlaceholder: 'Введите дополнительные ключевые слова, формулы или данные',
      analyzeReferences: 'Анализ референсов',
      analyzingReferences: 'Анализ...',
      analyzeError: 'Не удалось проанализировать референсы',
      autoFillAll: 'Заполнить всё',
      autoFillField: 'Автозаполнение',
      autoFilling: 'Заполняю...',
      autoFillLocked: 'Поле заблокировано',
      autoFillUnlocked: 'Поле разблокировано',
      autoFillHelpText: 'ИИ анализирует медиа и заполняет незаблокированные поля. Заблокируйте поле, чтобы сохранить его значение.',
      analyseReferences: 'Анализ референсов',
      analyseReferencesHint: 'Нажмите чтобы автоматически заполнить все поля на основе представленных референсов. Нажмите на замочки для полей которые не хотите менять.',
      analyseReferencesNoMedia: 'Добавьте референсы (изображения, видео или аудио) выше, чтобы включить анализ.',
      analysisPromptPlaceholder: 'Добавьте инструкции для ИИ-анализа (необязательно)...',
      runAnalysis: 'Запустить анализ',
      runAutoAnalysis: 'Авто-анализ',
      cancelAnalysis: 'Отмена',
      noAnalysisUrl: 'URL анализа не настроен для этой категории',
      previewPayload: 'Предпросмотр данных запроса',
      previewPayloadTitle: 'Данные запроса анализа',
      previewCurrent: 'Текущий',
      previewCopy: 'Копировать',
      previewCopied: 'Скопировано',
      saving: 'Сохранение...',
      save: 'Сохранить',
      cancel: 'Отмена',
      uploading: 'Загрузка...',
      uploadError: 'Ошибка загрузки файла',
    },

    // Personal References
    personalReferences: {
      title: 'Мои референсы',
      description: 'Ваша персональная коллекция референсов. Создавайте и управляйте своими референсами.',
      searchPlaceholder: 'Поиск референсов...',
      create: 'Создать референс',
      noReferences: 'Персональных референсов не найдено',
      createFirst: 'Создайте свой первый референс',
      totalReferences: '{count} референсов',
      pageOf: '{current} из {total}',
      totalLabel: 'Всего: {count}',
      fetchError: 'Не удалось загрузить референсы',
      deleteConfirmTitle: 'Удалить референс',
      deleteConfirmMessage: 'Вы уверены, что хотите удалить "{title}"?',
      deleteSuccess: 'Референс успешно удалён',
      deleteError: 'Не удалось удалить референс',
      allCategories: 'Все категории',
    },

    // 3D model viewer (GLB/glTF preview)
    model3d: {
      loading: 'Загрузка 3D-модели…',
      error: 'Не удалось загрузить 3D-модель',
      errorHint: 'Файл может быть повреждён или иметь неподдерживаемый формат. Его всё ещё можно скачать.',
      unsupportedFormat: 'Просмотр этого формата недоступен',
      unsupportedFormatHint: 'Встроенный просмотр работает только с .glb и .gltf. Файл можно скачать и открыть в 3D-редакторе.',
      download: 'Скачать модель',
      alt: '3D-модель',
      badge: '3D',
      placeholderHint: 'Откройте, чтобы посмотреть модель',
      infoTitle: 'Информация о модели',
      vertices: 'Вершины',
      triangles: 'Треугольники',
      meshes: 'Меши',
      materials: 'Материалы',
      textures: 'Текстуры',
      fileSize: 'Размер файла',
      dimensions: 'Габариты',
    },

    // Session References (temporary media in widget)
    sessionReference: {
      addButton: 'Добавить референс',
      modalTitle: 'Добавить сессионные референсы',
      dropzone: 'Перетащите файлы или нажмите для выбора',
      addAction: 'Добавить',
      legend: 'Сессионные',
      limitReached: 'Лимит сессионных медиа достигнут',
      imagesCount: 'Изобр.',
      videosCount: 'Видео',
      audioCount: 'Аудио',
      processing: 'Обработка...',
      unsupportedType: 'Неподдерживаемый тип файла',
      uploadFailed: 'Ошибка загрузки',
      mediaMetadataLoading: 'Данные выбранного видео или аудио ещё загружаются',
      mediaMetadataFailed: 'Не удалось определить длительность выбранного видео или аудио',
      mediaMetadataRetry: 'Повторить замер',
      changesPending: 'Закройте окно сессионных референсов перед запуском',
      singlePerRequestUnsupported: 'Видео или аудио из редактора референсов не поддерживается этим режимом расчёта',
      descriptionLabel: 'Описание',
      descriptionPlaceholder: 'Введите описание для этого референса...',
      helpTitle: 'Сессионные референсы',
      helpWhatTitle: 'Что такое сессионные референсы?',
      helpWhatText: 'Сессионные референсы — это временные медиафайлы (изображения, видео, аудио), которые вы добавляете для текущей сессии генерации. Каждый референс отправляется в модель ИИ вместе с его описанием для управления результатом.',
      helpDescTitle: 'Зачем добавлять описания?',
      helpDescText: 'Описания отправляются вместе с медиафайлами в модель. Они помогают ИИ понять, что изображает референс, какие стилевые элементы извлечь или как использовать его при генерации. Чем точнее описание, тем лучше результат.',
      helpVsTitle: 'Сессионные vs. Сохранённые референсы',
      helpVsText: 'Сохранённые референсы (через "Создать референс") — постоянные, категоризированные и доступные всей организации. Сессионные референсы — для разового или экспериментального использования: быстро загрузите эталонное изображение для текущей задачи без создания постоянной записи. Используйте сессионные референсы, когда хотите проверить идею, использовать референс один раз или быстро итерировать.',
      helpExamplesTitle: 'Примеры',
      helpExample1: 'Загрузите мудборд с описанием "тёмная готическая атмосфера, свечи, бархатные текстуры"',
      helpExample2: 'Добавьте скриншот цветовой палитры с описанием "использовать эти точные оттенки для фона"',
      helpExample3: 'Загрузите скетч персонажа с описанием "поза и пропорции главного персонажа, сохранить стиль одежды"',
      clickToRemoveHoldPreview: 'Клик — удалить, удерживать — превью',
    },

    // Collections System
    collections: {
      title: 'Коллекции',
      description: 'Управление коллекциями изображений',
      createCollection: 'Создать коллекцию',
      editCollection: 'Редактировать коллекцию',
      deleteCollection: 'Удалить коллекцию',
      collectionName: 'Название коллекции',
      collectionDescription: 'Описание коллекции',
      isPrivate: 'Приватная коллекция',
      isDefault: 'Коллекция по умолчанию',
      totalImages: 'Всего изображений',
      imagesThisMonth: 'За этот месяц',
      topContributors: 'Топ участники',
      permissions: 'Разрешения',
      managePermissions: 'Управление разрешениями',
      addToCollection: 'Добавить в коллекцию',
      removeFromCollection: 'Удалить из коллекции',
      selectCollections: 'Выберите коллекции',
      noCollections: 'Коллекции не найдены',
      defaultCollection: 'По умолчанию',
      privateCollection: 'Приватная',
      publicCollection: 'Публичная',
      characters: 'символов',
      privateDesc: 'Доступна только выбранным пользователям',
      publicDesc: 'Доступна всем участникам организации',
      defaultCollectionDesc: 'Все новые изображения автоматически добавляются в эту коллекцию',
      descriptionColumn: 'Описание',
      viewPermission: 'Просмотр',
      editPermission: 'Редактирование',
      adminPermission: 'Администрирование',
      grantPermission: 'Предоставить доступ',
      revokePermission: 'Отозвать доступ',
      userEmail: 'Email пользователя',
      permissionType: 'Тип разрешения',
      grantedBy: 'Предоставил',
      grantedAt: 'Дата предоставления',
      collectionCreated: 'Коллекция создана',
      collectionUpdated: 'Коллекция обновлена',
      collectionDeleted: 'Коллекция удалена',
      cannotDeleteDefault: 'Нельзя удалить коллекцию по умолчанию',
      collectionNotFound: 'Коллекция не найдена',
      accessDenied: 'Доступ запрещен',
      addedToCollections: 'Добавлено в коллекции',
      removedFromCollection: 'Удалено из коллекции',
      favoriteTooltip: 'Добавить в коллекции',
      columns: {
        name: 'Название',
        description: 'Описание',
        type: 'Тип',
        images: 'Изображения',
        created: 'Создана',
        actions: 'Действия'
      },
      modal: {
        createTitle: 'Создать коллекцию',
        editTitle: 'Редактировать коллекцию',
        deleteTitle: 'Удалить коллекцию',
        deleteMessage: 'Вы уверены, что хотите удалить эту коллекцию? Все изображения будут удалены из неё.',
        selectTitle: 'Выберите коллекции',
        permissionsTitle: 'Управление разрешениями',
        namePlaceholder: 'Введите название коллекции',
        descriptionPlaceholder: 'Введите описание коллекции (необязательно)',
        userEmailPlaceholder: 'email@example.com'
      },
      messages: {
        nameRequired: 'Название коллекции обязательно',
        nameExists: 'Коллекция с таким названием уже существует',
        createSuccess: 'Коллекция успешно создана',
        createError: 'Ошибка при создании коллекции',
        updateSuccess: 'Коллекция успешно обновлена',
        updateError: 'Ошибка при обновлении коллекции',
        deleteSuccess: 'Коллекция успешно удалена',
        deleteError: 'Ошибка при удалении коллекции',
        permissionGranted: 'Разрешение предоставлено',
        permissionRevoked: 'Разрешение отозвано',
        permissionError: 'Ошибка при управлении разрешениями'
      },
      stats: {
        totalCollections: 'Всего коллекций',
        totalImages: 'Всего изображений',
        privateCollections: 'Приватных коллекций',
        mostPopular: 'Самая популярная'
      }
    },

    // Billing Section
    billing: {
      title: 'Биллинг',
      creditsTab: 'Кредиты',
      currentBalance: 'Текущий баланс',
      tokensRemaining: 'токенов доступно',
      purchaseTokens: 'Купить токены',
      enterAmount: 'Введите сумму',
      youWillGet: 'Вы получите',
      tokensLabel: 'токенов',
      minAmount: 'Минимум €100.00',
      purchase: 'Оплатить',
      processing: 'Обработка...',
      securePayment: 'Безопасная оплата через Stripe',
      vatExclusiveNote: 'Если ваша организация облагается НДС (VAT), налог будет добавлен к указанной сумме при оплате',
      purchaseSuccess: 'Токены успешно добавлены!',
      purchaseCancelled: 'Платеж отменен',
      paymentSuccessTitle: 'Платёж успешен!',
      paymentSuccessMessage: 'Токены зачислены на баланс вашей организации.',
      paymentSuccessTokens: 'Токены зачислены',
      paymentSuccessAmount: 'Сумма оплаты',
      paymentSuccessPackage: 'Пакет',
      paymentSuccessBonus: 'Бонус',
      paymentSuccessViewInvoices: 'Перейти к инвойсам',
      paymentSuccessClose: 'Закрыть',
      transactionHistory: 'История транзакций',
      noTransactions: 'Нет транзакций',
      date: 'Дата',
      amount: 'Сумма',
      tokens: 'Токены',
      status: 'Статус',
      statusPending: 'Ожидание',
      statusCompleted: 'Завершен',
      statusFailed: 'Ошибка',
      statusRefunded: 'Возврат',
      rateInfo: '1000 токенов за €1',
      used: 'Использовано',
      usedLast30Days: 'Использовано за 30 дней',
      usedLast7Days: 'Использовано за 7 дней',
      // Bundle mode
      selectBundle: 'Выберите пакет токенов',
      noPackages: 'Пакеты не доступны',
      bestValue: 'Лучшее предложение',
      bonus: 'бонус',
      baseTokens: 'базовых',
      orEnterCustomAmount: 'Или введите произвольную сумму',
      // Billing not available
      billingNotAvailable: 'Биллинг недоступен',
      billingNotAvailableDesc: 'Покупка токенов недоступна для этой организации. Обратитесь к администратору.',
      billingAddressRequired: 'Пожалуйста, заполните платёжный адрес перед покупкой',
      fillBillingAddress: 'Заполнить адрес',
      // Payment details
      billingType: 'Тип биллинга',
      pay: 'Оплатить',
      type: 'Тип',
      enterpriseLabel: 'Корпоративный',
      standardLabel: 'Стандартный',
      accessDenied: 'Доступ ограничен',
      accessDeniedDescription: 'Пополнение баланса и управление платёжными данными доступно только администраторам и менеджерам организации.',
      yourRole: 'Ваша текущая роль:',
    },

    // Billing Address
    billingAddress: {
      title: 'Платёжный адрес',
      subtitle: 'Юридические данные для инвойсов',
      legalName: 'Наименование юр. лица',
      legalNamePlaceholder: 'Immersive Tech Ltd',
      addressLine1: 'Адрес (строка 1)',
      addressLine1Placeholder: '28 Oktovriou, 367, Mediterranean Court',
      addressLine2: 'Адрес (строка 2)',
      addressLine2Placeholder: 'Офис, корпус (необязательно)',
      city: 'Город',
      cityPlaceholder: 'Limassol',
      postalCode: 'Почтовый индекс',
      postalCodePlaceholder: '3107',
      state: 'Область / Регион',
      statePlaceholder: 'Область (необязательно)',
      country: 'Страна',
      countryPlaceholder: 'Выберите страну',
      vatType: 'Тип налогового ID',
      vatTypePlaceholder: 'Выберите тип',
      vatId: 'Налоговый ID',
      vatIdPlaceholder: 'Например: DE123456789',
      billingEmail: 'Email для инвойсов',
      billingEmailPlaceholder: 'billing@company.com',
      save: 'Сохранить',
      saving: 'Сохранение...',
      saveSuccess: 'Платёжный адрес сохранён',
      saveError: 'Ошибка сохранения платёжного адреса',
      loadError: 'Ошибка загрузки платёжного адреса',
      required: 'Обязательное поле',
      noChanges: 'Нет изменений для сохранения',
      addressSavedTaxFailed: 'Адрес сохранён, но налоговый ID некорректен. Пожалуйста, исправьте и сохраните ещё раз.',
      taxIdErrorTitle: 'Ошибка Tax ID',
      taxIdExpectedFormat: 'Ожидаемый формат',
      taxIdErrorClose: 'Закрыть',
      searchCountry: 'Поиск страны...',
    },

    // Invoices
    invoices: {
      title: 'Инвойсы',
      subtitle: 'История инвойсов из Stripe',
      invoiceNumber: '№ инвойса',
      date: 'Дата',
      amount: 'Сумма',
      status: 'Статус',
      download: 'Скачать PDF',
      view: 'Открыть',
      noInvoices: 'Нет инвойсов',
      noInvoicesDesc: 'Инвойсы появятся после первого платежа',
      statusPaid: 'Оплачен',
      statusOpen: 'Открыт',
      statusDraft: 'Черновик',
      statusVoid: 'Аннулирован',
      statusUncollectible: 'Невзыскуемый',
      loadError: 'Не удалось загрузить инвойсы',
      type: 'Тип',
      tokens: 'Токены',
      typeEnterprise: 'Enterprise',
    },

    // Auto Top-Up
    autoTopUp: {
      title: 'Автопополнение',
      subtitle: 'Автоматическое пополнение токенов при низком балансе',
      enabled: 'Включено',
      disabled: 'Выключено',
      threshold: 'Порог баланса',
      thresholdHelp: 'Автопополнение сработает, когда баланс опустится ниже этого значения',
      topupAmount: 'Сумма пополнения (без НДС)',
      topupAmountHelp: 'Сумма одного пополнения без НДС — налог добавляется сверху при списании',
      tokensEquivalent: '≈ {tokens} токенов',
      monthlyLimit: 'Месячный лимит (без НДС)',
      monthlyLimitHelp: 'Максимальная сумма автопополнений в месяц без учёта НДС',
      monthlySpent: 'Потрачено в этом месяце (без НДС)',
      monthlyProgress: '{spent} из {limit} EUR',
      paymentMethod: 'Способ оплаты',
      noPaymentMethod: 'Карта не привязана. Совершите первую покупку для сохранения карты.',
      cardEnding: 'Карта •••• {last4}',
      expires: 'Истекает {month}/{year}',
      lastError: 'Последняя ошибка',
      save: 'Сохранить',
      enableRequiresCard: 'Для включения автопополнения необходимо привязать карту',
      successEnabled: 'Автопополнение включено',
      successDisabled: 'Автопополнение выключено',
      successUpdated: 'Настройки автопополнения обновлены',
    },

    // Saved payment cards (Payment Methods billing tab)
    savedCards: {
      title: 'Способы оплаты',
      defaultCard: 'По умолчанию',
      deleteCard: 'Удалить карту',
      confirmDeleteCard: 'Удалить эту сохранённую карту? Это действие нельзя отменить.',
      cardDeleted: 'Карта удалена',
      cardDeleteFailed: 'Не удалось удалить карту',
      autoTopupDisabledNoCard: 'Карта удалена. Автопополнение выключено — не осталось карты для списания.',
      noCard: 'Нет сохранённых карт. Совершите покупку, чтобы карта сохранилась автоматически.',
      cardEnding: 'Карта •••• {last4}',
      expires: 'Истекает {month}/{year}',
      addCard: 'Добавить карту',
      makeDefault: 'Сделать основной',
      cardAdded: 'Карта добавлена',
      cardAddCancelled: 'Добавление карты отменено',
      addCardFailed: 'Не удалось добавить карту',
      makeDefaultFailed: 'Не удалось сделать карту основной',
      defaultUpdated: 'Карта по умолчанию обновлена',
    },

    // Admin Billing
    adminBilling: {
      title: 'Управление биллингом',
      totalRevenue: 'Доход',
      totalTokens: 'Токенов продано',
      totalTransactions: 'Транзакций',
      completed: 'Завершено',
      pending: 'Ожидание',
      failed: 'Ошибка',
      searchPlaceholder: 'Поиск по организации или email...',
      allStatuses: 'Все статусы',
      statusPending: 'Ожидание',
      statusCompleted: 'Завершен',
      statusFailed: 'Ошибка',
      statusRefunded: 'Возврат',
      transactionHistory: 'История транзакций',
      noTransactions: 'Транзакции не найдены',
      date: 'Дата',
      organization: 'Организация',
      user: 'Пользователь',
      amount: 'Сумма',
      tokens: 'Токены',
      status: 'Статус',
      provider: 'Провайдер',
      showing: 'Показано',
      of: 'из',
      previous: 'Назад',
      next: 'Вперед',
      // Purchase type
      purchaseType: 'Тип покупки',
      typeBundle: 'Пакет',
      typeEnterprise: 'Enterprise',
      packageName: 'Пакет',
      // Export
      exportCSV: 'Экспорт CSV',
      exporting: 'Экспорт...',
      noDataToExport: 'Нет данных для экспорта',
      exportError: 'Ошибка экспорта данных',
      exportModalTitle: 'Экспорт биллинга',
      selectOrganizations: 'Организации',
      selectAll: 'Выбрать все',
      deselectAll: 'Снять выделение',
      selectedCount: 'Выбрано: {count}',
      period: 'Период',
      exportProgress: 'Экспорт: {org} ({current}/{total})',
      searchOrganizations: 'Поиск организаций...',
      cancel: 'Отмена',
      downloadCSV: 'Скачать CSV',
      month1: '1 месяц',
      month3: '3 месяца',
      month6: '6 месяцев',
      year1: '1 год',
      custom: 'Произвольный',
      dateFrom: 'С даты',
      dateTo: 'По дату'
    },

    // Admin Refunds
    adminRefunds: {
      title: 'Все возвраты',
      subtitle: 'Возвращённые токены по всем организациям',
      // Stats card
      statsTitle: 'Статистика за 7 дней',
      totalRefunds: 'Всего возвратов',
      totalRefundedTokens: 'Возвращено токенов',
      refundRate: 'Процент возвратов',
      totalGenerations: 'Всего генераций',
      last7Days: 'Последние 7 дней',
      topWorkflows: 'Топ воркфлоу по возвратам',
      dailyChart: 'Возвраты по дням',
      noRefundsInWindow: 'Нет возвратов за период',
      // Table columns
      date: 'Дата',
      organization: 'Организация',
      user: 'Пользователь',
      workflow: 'Воркфлоу',
      tokensCost: 'Токены',
      errorMessage: 'Сообщение об ошибке',
      actions: 'Действия',
      viewData: 'Данные',
      // Filters
      allWorkflows: 'Все воркфлоу',
      filterByWorkflow: 'Фильтр по воркфлоу',
      dateFrom: 'С даты',
      dateTo: 'По дату',
      resetFilters: 'Сбросить',
      // Pagination
      showing: 'Показано',
      of: 'из',
      previous: 'Назад',
      next: 'Вперёд',
      // States
      loading: 'Загрузка...',
      noRefunds: 'Возвраты не найдены',
      noRefundsDescription: 'За выбранный период возвратов нет',
      fetchError: 'Не удалось загрузить данные',
      retryLoad: 'Повторить',
      // Misc
      refunds: 'возвратов',
      tokens: 'токенов',
      rate: '%',
      clearSelection: 'Сбросить выбор',
      noResultsFor: 'Нет результатов для',
    },

    // Admin Service API Keys (lmx_adm_*)
    adminApiKeys: {
      title: 'Сервисные API-ключи',
      subtitle: 'Ключи lmx_adm_* для машинного доступа к конфигурации воркфлоу',
      createKey: 'Создать ключ',
      colName: 'Название',
      colScopes: 'Права доступа',
      colPrefix: 'Префикс',
      colStatus: 'Статус',
      colLastUsed: 'Последнее использование',
      colUsage: 'Использований',
      colExpires: 'Истекает',
      colActions: 'Действия',
      statusActive: 'Активен',
      statusRevoked: 'Отозван',
      statusExpired: 'Истёк',
      edit: 'Изменить',
      revoke: 'Отозвать',
      never: '—',
      noExpiry: 'Бессрочно',
      noKeys: 'Ключей пока нет. Создайте первый, чтобы начать.',
      loading: 'Загрузка...',
      createTitle: 'Создать сервисный ключ',
      editTitle: 'Изменить сервисный ключ',
      nameLabel: 'Название',
      namePlaceholder: 'Например, dify-migration',
      descriptionLabel: 'Описание',
      descriptionPlaceholder: 'Необязательное описание...',
      scopesLabel: 'Права доступа',
      scopesHint: 'Выберите хотя бы одно право',
      expiresLabel: 'Срок действия (необязательно)',
      rateMinuteLabel: 'Лимит/мин',
      rateHourLabel: 'Лимит/час',
      nameRequired: 'Укажите название',
      scopesRequired: 'Выберите хотя бы одно право доступа',
      save: 'Сохранить',
      create: 'Создать',
      cancel: 'Отмена',
      scopeWorkflows: 'Воркфлоу',
      actionRead: 'Чтение',
      actionCreate: 'Создание',
      actionUpdate: 'Изменение',
      actionDelete: 'Удаление',
      keyCreatedTitle: 'Ключ создан',
      keyCreatedWarning: 'Это единственный раз, когда вы видите этот ключ. Скопируйте и сохраните его в надёжном месте.',
      copy: 'Копировать',
      copied: 'Скопировано',
      done: 'Готово',
      revokeConfirm: 'Вы уверены, что хотите отозвать этот ключ? Доступ по нему прекратится немедленно.',
      loadError: 'Не удалось загрузить ключи',
      createSuccess: 'Ключ создан',
      createError: 'Не удалось создать ключ',
      updateSuccess: 'Ключ обновлён',
      updateError: 'Не удалось обновить ключ',
      revokeSuccess: 'Ключ отозван',
      revokeError: 'Не удалось отозвать ключ',
      copyError: 'Не удалось скопировать ключ',
      auditTitle: 'Журнал обращений',
      auditFilterLabel: 'Фильтр по ключу',
      auditAllKeys: 'Все ключи',
      auditWhen: 'Когда',
      auditKey: 'Ключ',
      auditAction: 'Действие',
      auditResource: 'Ресурс',
      auditStatus: 'Статус',
      auditError: 'Ошибка',
      auditEmpty: 'Записей пока нет',
      auditLoadError: 'Не удалось загрузить журнал',
      showing: 'Показано',
      of: 'из',
      previous: 'Назад',
      next: 'Вперёд',
      page: 'Страница',
      perPage: 'На странице',
    },

    // Admin Packages
    adminPackages: {
      title: 'Пакеты токенов',
      createPackage: 'Создать пакет',
      editPackage: 'Редактировать пакет',
      packagesList: 'Список пакетов',
      noPackages: 'Пакеты не найдены',
      createFirst: 'Создайте первый пакет',
      infoBannerTitle: 'Система пакетов токенов',
      infoBannerText: 'Стандартные организации покупают из предопределенных пакетов. Корпоративные организации используют произвольные платежи.',
      // Table columns
      columnOrder: 'Порядок',
      columnName: 'Название',
      columnPrice: 'Цена',
      columnBaseTokens: 'Базовые токены',
      columnBonus: 'Бонус %',
      columnTotalTokens: 'Всего токенов',
      columnStatus: 'Статус',
      columnActions: 'Действия',
      // Form fields
      fieldName: 'Название пакета',
      fieldPrice: 'Цена (USD)',
      fieldTokens: 'Базовые токены',
      fieldBonus: 'Процент бонуса',
      fieldSortOrder: 'Порядок сортировки',
      fieldDescription: 'Описание',
      fieldActive: 'Активный (виден пользователям)',
      optional: 'необязательно',
      // Actions
      edit: 'Редактировать',
      delete: 'Удалить',
      confirmDelete: 'Подтвердить',
      cancel: 'Отмена',
      save: 'Сохранить изменения',
      create: 'Создать пакет',
      saving: 'Сохранение...',
      deleting: 'Удаление...',
      preview: 'Предпросмотр',
      statusActive: 'Активный',
      statusInactive: 'Неактивный',
      // Delete confirmation modal
      deleteConfirmTitle: 'Удаление пакета',
      deleteConfirmText: 'Вы уверены, что хотите удалить этот пакет?',
      deleteConfirmWarning: 'Пакет будет помечен как неактивный. Его можно будет восстановить позже.'
    },

    // Workflow Page
    workflow: {
      selectWorkflow: 'Выберите воркфлоу',
      selectWorkflowDesc: 'Выберите воркфлоу для начала генерации контента',
      workflowLabel: 'Воркфлоу',
      selectWorkflowPlaceholder: 'Выберите воркфлоу...',
      availableWorkflows: 'доступных воркфлоу',
      videoComingSoon: 'Генерация видео скоро появится',
      videoComingSoonDesc: 'Функции генерации видео будут доступны в ближайшее время',
      loadingWorkflows: 'Загрузка воркфлоу...',
      noWorkflows: 'Нет доступных воркфлоу',
      noWorkflowsDesc: 'Для вашей организации нет доступных воркфлоу. Обратитесь к администратору.',
      imageGeneration: 'Генерация изображений',
      imageGenerationDesc: 'Создавайте потрясающие ИИ-изображения с помощью передовых инструментов и промптов.',
      comingSoon: 'Новый интерфейс скоро появится...',
      backToWorkflows: 'Назад к воркфлоу',
      noWidgets: 'Виджеты не настроены',
      noWidgetsDesc: 'Для этого воркфлоу еще не настроены виджеты.',
      widgetComingSoon: 'Реализация виджета скоро появится',
      widgetLoadFailed: 'Не удалось загрузить настройки',
      widgetLoadRetry: 'Повторить',
      widgetLoading: 'Настройки ещё загружаются — повторите через секунду',
      public: 'Публичный',
      restricted: 'Ограниченный',
      selectOrganization: 'Выберите организацию',
      selectOrganizationDesc: 'Выберите активную организацию в боковой панели для доступа к воркфлоу.',
      generate: 'Генерировать',
      generateVideo: 'Генерировать видео',
      searchWorkflows: 'Поиск воркфлоу...',
      searchWorkflowsPlaceholder: 'Поиск по названию или описанию...',
      noWorkflowsFound: 'Воркфлоу не найдены',
      allWorkflows: 'Все Workflows',
      filterByTag: 'Фильтр по тегу',
      noWorkflowsWithTag: 'Нет workflows с этим тегом',
      showArchived: 'Показать архивные',
      newBadge: 'Новое',
      archivedBadge: 'Архивный',
      favorites: 'Избранное',
      addToFavorites: 'Добавить в избранное',
      removeFromFavorites: 'Убрать из избранного',
      keyboardShortcutMac: '⌘↩',
      keyboardShortcutWindows: 'Ctrl+↩',
      promptRequired: 'Введите промпт для генерации',
      // Image size constraints
      imageSizeConstraints: 'Ограничения размера изображений',
      imageSizeConstraintsDesc: 'Установите минимальные и максимальные размеры изображений для виджета Input Images. Оставьте пустым для отсутствия ограничений.',
      minWidth: 'Мин. ширина',
      minHeight: 'Мин. высота',
      maxWidth: 'Макс. ширина',
      maxHeight: 'Макс. высота',
      defaultWidth: 'Ширина по умолчанию',
      defaultHeight: 'Высота по умолчанию',
      tokensPerGeneration: 'токенов за генерацию',
      tokensForGeneration: 'токенов за генерацию',
      tokensForGenerations: 'токенов за генерации',
      tokensRemaining: 'Осталось токенов',
      topUpTokens: 'Пополнить токены',
      tokensTotal: 'токенов всего',
      perRequest: 'за запрос',
      requests: 'запросов',
      tokensEach: 'токенов каждый',
      requiresImages: 'Добавьте изображения для расчета стоимости',
      requiresAudio: 'Добавьте аудио для расчета стоимости',
      requiresVideo: 'Добавьте видео для расчета стоимости',
      requiresAudioOrVideo: 'Добавьте аудио или видео для расчета стоимости',
      requiresPrompt: 'Введите промпт для расчета стоимости',
      requiresText: 'Введите текст для расчета стоимости',
      requiresAnyInput: 'Предоставьте',
      inputAudio: 'аудио',
      inputVideo: 'видео',
      inputPrompt: 'промпт',
      inputText: 'текст',
      orSeparator: 'или',
      invalidPricingFormula: 'Некорректная формула расчёта. Обратитесь к администратору.',
      invalidPricingAggregate: INVALID_PRICING_AGGREGATE_MESSAGES.ru,
      contentPolicyChargeNotice: 'При нарушении политики контента токены будут списаны без возврата.',
      calculating: 'Вычисление...',
      limitExceededTitle: 'Лимит токенов исчерпан',
      organizationLimitExceeded: 'Общий лимит токенов организации исчерпан. Обратитесь к администратору организации.',
      actions: {
        generate: 'Генерировать',
        upscale: 'Увеличить',
        process: 'Обработать',
        create: 'Создать'
      },
      generating: 'Генерируем...',
      enhancing: 'Улучшаем промпт...',
      processingAsync: 'Обрабатываем...',
      textNoContent: 'Текст сгенерирован',
      pending: 'В ожидании...',
      queued: '{count} в очереди',
      noSmallWidgets: 'Малые виджеты не настроены',
      noSmallWidgetsDesc: 'Для этого воркфлоу нет малых виджетов для боковой панели.',
      accessDenied: 'Доступ запрещён',
      accessDeniedHint: 'Этот workflow недоступен для вашей организации.',
      // Input Media Widget settings
      mediaContentSettings: 'Настройки медиа-контента',
      mediaContentSettingsDesc: 'Настройте лимиты для каждого типа медиа. Оставьте пустым для значений по умолчанию.',
      imagesSettings: 'Изображения',
      videoSettings: 'Видео',
      audioSettings: 'Аудио',
      maxCount: 'Макс. кол-во',
      maxFileSize: 'Макс. размер (МБ)',
      maxDuration: 'Макс. длительность (с)',
      validationError: 'Ошибка валидации',
      // Pipeline step progress
      pipelineStep: 'Шаг {current}/{total}: {name}',
      pipelineStepCompact: '{current}/{total}',
      priceWithoutDiscount: 'Цена без скидки',
    },

    // Widgets
    widgets: {
      generationSettings: 'Настройки генерации',
      generationSettingsDesc: 'Виджет для настройки параметров генерации изображений',
      styleSelector: 'Выбор стиля',
      styleSelectorDesc: 'Виджет для выбора визуальных стилей',
      imageUpload: 'Загрузка изображения',
      imageUploadDesc: 'Виджет для загрузки референсных изображений',
      promptEditor: 'Редактор промптов',
      promptEditorDesc: 'Редактирование и улучшение промптов для генерации',
      gallery: 'Галерея контента',
      galleryDesc: 'Просмотр и управление созданным контентом',
      imageSize: 'Размер изображения',
      numImages: 'Количество изображений',
      inferenceSteps: 'Шаги вывода',
      fast: 'Быстро',
      quality: 'Качество',
      guidanceScale: 'Масштаб управления',
      precise: 'Точно',
      creative: 'Креативно',
      safety: 'Безопасность',
      safetyDisabled: 'Отключена',
      safetyStrict: 'Строгая',
      safetyBalanced: 'Сбалансированная',
      safetySoft: 'Мягкая',
      noStyles: 'Стили недоступны',
      noStylesDesc: 'Обратитесь к администратору для добавления стилей',
      noStyle: 'Без стиля',
      noStyleDesc: 'Генерация без изменения стиля',
      loadingStyles: 'Загрузка стилей...',
      searchStyles: 'Поиск стилей...',
      noStylesFound: 'Стили не найдены',
      stylePrompt: 'Промт стиля:',
      noPrompt: 'Без шаблона',
      styleTemplate: 'Шаблон стиля',
      promptTemplate: 'Шаблон промпта',
      promptText: 'Текст промпта',
      loadingPrompts: 'Загрузка промптов...',
      expand: 'Развернуть',
      collapse: 'Свернуть',
      prompt: 'Промпт',
      view: 'Посмотреть',
      promptTitle: 'Промпт стиля',
      aspectRatio: 'Соотношение сторон',
      aspectRatioDesc: 'Выберите соотношение сторон для ваших изображений',
      numImagesDesc: 'Количество изображений для генерации в одной партии (1-16)',
      inferenceStepsDesc: 'Количество шагов денойзинга. Больше шагов = выше качество, но медленнее генерация',
      guidanceScaleDesc: 'Насколько точно ИИ следует вашему промпту. Высокие значения = точнее, низкие = креативнее',
      safetyDesc: 'Уровень фильтрации контента. Отключен разрешает любой контент, Строгий блокирует большинство взрослого контента',
      promptEnhancer: 'Улучшение промптов',
      promptEnhancerDesc: 'Выбор и улучшение базовых промптов',
      searchPrompts: 'Поиск промптов...',
      noPrompts: 'Промпты недоступны',
      noPromptsDesc: 'Обратитесь к администратору для добавления базовых промптов',
      noPromptsFound: 'Промпты не найдены',
      enterTextToTranslate: 'Введите текст для перевода',
      translatePrompt: 'Перевести промпт',
      enterTextToEnhance: 'Введите текст для улучшения',
      enhancePrompt: 'Улучшить промпт',
      selectTemplateAndEnterText: 'Выберите стиль или шаблон промпта и введите текст для улучшения',
      collectionsSelector: 'Выбор коллекций',
      collectionsSelectorDesc: 'Выберите коллекции для сохранения ваших изображений',
      originalPrompt: 'Изначальный промпт',
      enhancedPrompt: 'Улучшенный промпт',
      swapPrompts: 'Поменять местами',
      clearPrompt: 'Очистить',
      translationError: 'Ошибка перевода',
      enhancePromptError: 'Ошибка улучшения промпта',
      dynamicWidget: 'Динамический виджет',
      dynamicWidgetLoading: 'Загрузка конфигурации виджета...',
      noFieldsConfigured: 'Для этого виджета не настроены поля',
      searchOptions: 'Поиск по вариантам...',
      searchOptionsLabel: 'Поиск по вариантам',
      refineOptions: 'Показаны первые {count} вариантов. Уточните поиск.',
      maxSelections: 'Максимум: {max}',
      
      // Input Images Widget
      inputImages: {
        title: 'Входящие изображения',
        dropHere: 'Перетащите изображения сюда',
        dragOrClick: 'Перетащите изображения сюда или нажмите для выбора',
        supportedFormats: 'Поддерживаются PNG, JPG, GIF, WEBP',
        maxImages: 'Максимум {max} изображений',
        noImages: 'Изображения не загружены',
        dragToStart: 'Перетащите изображения для начала работы',
        selectAll: 'Выбрать все',
        deselectAll: 'Снять выделение',
        removeSelected: 'Удалить выбранные',
        pasteFromClipboard: 'Или нажмите Ctrl+V для вставки из буфера обмена',
        addMoreImages: 'Добавьте ещё изображений в коллекцию',
        // Image size validation
        imageTooSmall: 'Изображение слишком маленькое',
        imageTooLarge: 'Изображение слишком большое',
        rejectedImages: 'Некоторые изображения были отклонены',
        invalidImage: 'Не удалось загрузить изображение'
      },

      // Input Media Widget (images, video, audio)
      inputMedia: {
        dropHere: 'Перетащите файлы сюда',
        dragOrClick: 'Перетащите файлы сюда или нажмите для выбора',
        selectFromGallery: 'Выбрать из галереи',
        gallerySelectionTitle: 'Выберите медиа из галереи',
        images: 'Изображения',
        videos: 'Видео',
        audio: 'Аудио файлы',
        noMediaAllowed: 'Нет разрешённых типов медиа',
        fileTooLarge: 'Файл слишком большой',
        limitReached: 'Достигнут лимит',
        durationTooShort: 'Длительность слишком маленькая',
        durationTooLong: 'Длительность слишком большая',
        invalidFile: 'Не удалось загрузить файл',
        rejectedFiles: 'Файлы отклонены',
        limits: 'Лимиты',
        filename: 'Имя файла',
        dimensions: 'Размеры',
        filesize: 'Размер',
        selectedFromGallery: 'Из галереи',
        maxSelectionReached: 'Достигнут лимит выбора',
        confirmSelection: 'Подтвердить выбор',
        selectedCount: 'Выбрано',
        search: 'Поиск',
        addFromGallery: 'Из галереи',
        addFromDisk: 'С диска',
        galleryDescription: 'Ваши сгенерированные файлы',
        imageAutoResized: 'Изображение уменьшено до допустимого размера',
        imageAutoCompressed: 'Изображение сжато до допустимого веса',
        imageAutoResizedAndCompressed: 'Изображение уменьшено и сжато',
        imageCroppedToTarget: 'Обрезано до',
        imageResizedToTarget: 'Масштабировано до',
        imageConvertedToJpeg: 'Конвертировано в JPEG',
        imageCroppedAndConverted: 'Обрезано и конвертировано в JPEG',
        imageResizedAndConverted: 'Масштабировано и конвертировано в JPEG',
        imageAutoProcessedInfo: 'Автоматически обработано',
        selectionCounter: 'выбрано',
        selectionLimitReached: 'Лимит достигнут',
        selectedSection: 'Выбранные',
        clearAllSelection: 'Очистить все',
        videoWidthTooSmall: 'Ширина видео слишком маленькая',
        videoWidthTooLarge: 'Ширина видео слишком большая',
        videoHeightTooSmall: 'Высота видео слишком маленькая',
        videoHeightTooLarge: 'Высота видео слишком большая',
        videoPixelsTooSmall: 'Количество пикселей в кадре слишком маленькое',
        videoPixelsTooLarge: 'Количество пикселей в кадре слишком большое',
        videoMetadataLoading: 'Загрузка метаданных видео'
      },

      // Slots Input Media Widget
      slotsInputMedia: {
        title: 'Медиа слоты',
        noSlotsConfigured: 'Слоты не настроены',
        dropOrClick: 'Перетащите или нажмите',
        upload: 'Загрузить',
        gallery: 'Галерея',
        paste: 'Вставить',
        noImageInClipboard: 'В буфере обмена нет изображения',
        required: 'Обязательный',
        expectedType: 'Ожидаемый тип',
        unsupportedFormat: 'Неподдерживаемый формат',
        allowedFormats: 'Допустимые форматы',
        fileRejected: 'Файл отклонён',
        modelType: '3D модель',
        modelMaxFileSizeHint: 'Максимальный размер файла: {size} MB',
        modelUnsupportedInSmall: '3D-модели поддерживаются только в большом виджете медиа-слотов.',
        cropped: 'Обрезано — нажмите для настройки',
        cropModal: {
          title: 'Настройка обрезки',
          apply: 'Применить',
          cancel: 'Отмена',
          resetCenter: 'Сбросить в центр',
          zoom: 'Масштаб',
          error: 'Не удалось применить обрезку',
        },
        errors: {
          invalidUrl: 'Неверный URL 3D-модели',
          fileTooLarge: 'Файл слишком большой',
          durationTooShort: 'Длительность слишком маленькая',
          durationTooLong: 'Длительность слишком большая',
          videoWidthTooSmall: 'Ширина видео слишком маленькая',
          videoWidthTooLarge: 'Ширина видео слишком большая',
          videoHeightTooSmall: 'Высота видео слишком маленькая',
          videoHeightTooLarge: 'Высота видео слишком большая',
          videoPixelsTooSmall: 'Количество пикселей в кадре слишком маленькое',
          videoPixelsTooLarge: 'Количество пикселей в кадре слишком большое',
          stillProcessing: 'Изображения ещё обрабатываются',
          processingFailed: 'Не удалось обработать изображение'
        }
      },

      // 3D Camera Control Widget
      camera3d: {
        title: '3D Управление камерой',
        horizontalAngle: 'Горизонтальный',
        verticalAngle: 'Вертикальный',
        zoom: 'Зум',
        horizontalAngleLabel: 'Горизонтальный угол',
        verticalAngleLabel: 'Вертикальный угол',
        zoomLabel: 'Зум',
        presets: {
          front: 'Спереди',
          back: 'Сзади',
          left: 'Слева',
          right: 'Справа',
          top: 'Сверху',
          low: 'Снизу',
          threeQuarter: '3/4'
        },
        helpTitle: 'Справка: 3D Управление камерой',
        helpWhatIs: 'Что такое 3D Управление камерой?',
        helpWhatIsDesc: 'Этот виджет позволяет управлять положением и углом камеры для генерации изображений с разных ракурсов.',
        helpControls: 'Элементы управления',
        helpHorizontal: 'Зеленое кольцо: Горизонтальный угол поворота',
        helpVertical: 'Розовая дуга: Вертикальный угол',
        helpZoom: 'Оранжевый маркер: Приближение камеры',
        helpUsage: 'Как использовать',
        helpUsageDesc: 'Перетаскивайте цветные маркеры в 3D виде или используйте слайдеры ниже. Используйте кнопки пресетов для быстрого позиционирования камеры.'
      },

      // AuraSR Upscale Settings Widget
      auraSrUpscale: {
        title: 'Настройки Увеличения',
        description: 'Конфигурация параметров увеличения разрешения изображений',
        upscalingFactor: 'Коэффициент увеличения',
        upscalingFactorDesc: 'Множитель увеличения изображения. В настоящее время поддерживается только 4x.',
        checkpoint: 'Модель',
        checkpointDesc: 'Версия модели для использования. v1 более стабильная, v2 с последними улучшениями.',
        checkpointV1: 'v1 (Стабильная)',
        checkpointV2: 'v2 (Новейшая)',
        overlappingTiles: 'Перекрывающиеся плитки',
        overlappingTilesDesc: 'Удаляет швы между плитками, но удваивает время обработки. Используйте для лучшего качества за счет скорости.',
        overlappingEnabled: 'Включено (в 2 раза медленнее)',
        overlappingDisabled: 'Отключено (быстрее)',
        overlappingWarning: 'Это удвоит время обработки, но обеспечит лучшее качество за счет удаления швов плитки.'
      },

      // Clarity Upscaler Settings Widget
      clarityUpscaler: {
        title: 'Настройки Clarity Upscaler',
        description: 'Конфигурация параметров увеличения четкости изображений',
        upscaleFactor: 'Коэффициент увеличения',
        upscaleFactorDesc: 'Множитель увеличения изображения от 1x до 4x',
        resemblance: 'Сходство',
        resemblanceDesc: 'Насколько увеличенное изображение должно походить на оригинал. Более высокие значения сохраняют оригинальный вид.',
        hiddenParamsInfo: 'Дополнительные параметры настроены автоматически для оптимальных результатов'
      },
      searchCollections: 'Поиск коллекций...',
      selectCollections: 'Поиск коллекций...',
      loadingCollections: 'Загрузка коллекций...',
      noCollectionsFound: 'Коллекции не найдены',
      oneCollectionSelected: '1 коллекция выбрана',
      collectionsSelected: '{count} коллекций выбрано',
      selectedCollections: 'Выбранные коллекции',
      selectedWorkflows: 'Выбранные процессы',
      selectedUsers: 'Выбранные пользователи',
      selected: 'выбрано',
      
      // Gallery Filters Widget
      galleryFilters: 'Фильтры галереи',
      galleryFiltersDesc: 'Фильтрация и поиск содержимого галереи',
      
      // Tooltips
      dateRangeTooltip: 'Фильтрация изображений по дате создания',
      collectionsTooltip: 'Фильтрация по коллекциям, содержащим изображения',
      workflowsTooltip: 'Фильтрация по процессам, используемым для генерации',
      usersTooltip: 'Фильтрация по пользователям, создавшим изображения',
      dateFromTooltip: 'Начальная дата для фильтрации',
      dateToTooltip: 'Конечная дата для фильтрации',
      clearFiltersTooltip: 'Удалить все активные фильтры и показать все изображения',
      contentTypeTooltip: 'Фильтрация по типу медиа (изображения, видео, аудио или 3D)',
      selectedContentTypes: 'Выбранные типы контента',
      approveStateTooltip: 'Фильтрация по оценке: удачный / неудачный / одобрено',
      selectedApproveState: 'Выбранный статус оценки',
      removeFromSelection: 'Убрать из выбора'
    },

    // Mask Editor Modal
    maskEditor: {
      title: 'Редактор маски',
      brush: 'Кисть',
      eraser: 'Ластик',
      brushSize: 'Размер кисти',
      undo: 'Отменить',
      clear: 'Очистить',
      zoomIn: 'Приблизить',
      zoomOut: 'Отдалить',
      apply: 'Применить',
      cancel: 'Отмена',
      hint: 'Закрасьте область, которую нужно изменить. Незакрашенное останется без изменений.',
      openButton: 'Маска',
      maskApplied: 'Маска применена',
      maskNotReady: 'Маска ещё не готова, подождите завершения экспорта',
      duplicateKey: 'Несколько слотов используют один ключ маски — задайте разные ключи',
      keyCollision: 'Ключ маски конфликтует с другим полем запроса — задайте уникальный ключ',
      exportFailed: 'Не удалось экспортировать маску',
      polygon: 'Полигон',
      polygonHint: 'Кликайте, чтобы ставить точки. Двойной клик или Enter — замкнуть область.',
      addImage: 'Добавить изображение',
      commitImage: 'Применить изображение',
      removeImage: 'Убрать изображение',
      resizeHint: 'Тяните за тело — переместить, за углы — размер, за верхний маркер — поворот (Shift: шаг 15° и свободное растяжение).',
      rotateHint: 'Тяните для поворота (удерживайте Shift для шага 15°)',
      tabCrop: 'Кадрирование',
      tabMask: 'Маска',
    },

    // Organization Selector
    orgSelector: {
      selectOrganization: 'Выберите организацию',
      exhausted: 'исчерпано',
      availableOrganizations: 'Доступные организации',
      memberSince: 'Участник с',
      organizationInfo: 'Информация об организации',
      management: 'Управление',
      adminPanel: 'Админ-панель'
    },

    // Common UI elements
    common: {
      close: 'Закрыть',
      save: 'Сохранить',
      cancel: 'Отмена',
      create: 'Создать',
      edit: 'Редактировать',
      delete: 'Удалить',
      deleting: 'Удаление...',
      add: 'Добавить',
      saving: 'Сохранение...',
      loading: 'Загрузка...',
      understood: 'Понятно!',
      loadMore: 'Загрузить ещё',
      selectOrganization: 'Выберите организацию',
      selectOrganizationDesc: 'Пожалуйста, выберите организацию для просмотра галереи',
      error: 'Произошла ошибка',
      processing: 'Обработка...',
      safe: 'Безопасный',
      nsfw: 'NSFW',
      off: 'Выкл',
      on: 'Вкл'
    },


    // Manager page
    manager: {
      title: 'Управление организацией',
      organizationLimit: 'Лимит организации',
      organizationTokens: 'Токены организации',
      remaining: 'Осталось',
      allGenerationsHistory: 'Вся история генераций',
      inviteUser: 'Пригласить пользователя',
      userManagement: 'Управление пользователями',
      users: 'Пользователи',
      role: 'Роль',
      customLimits: 'Индивидуальные лимиты',
      limitGroup: 'Группа',
      limits: 'Лимиты',
      usage: 'Использование',
      actions: 'Действия',
      setLimit: 'Установить лимит',
      changeRole: 'Изменить роль',
      viewHistory: 'История',
      editUsage: 'Редактировать использование',
      editUsageTitle: 'Редактировать количество использованных токенов',
      currentUsage: 'Текущее использование',
      newUsage: 'Новое значение',
      usageUpdated: 'Использование обновлено',
      invalidUsageValue: 'Значение должно быть числом >= 0',
      noUsers: 'Пользователи не найдены',
      loading: 'Загрузка...',
      error: 'Ошибка',
      limitSet: 'Лимит установлен',
      roleChanged: 'Роль изменена',
      sharedPoolMode: 'Режим общего пула',
      sharedPoolInfo: 'Общий пул токенов',
      sharedPoolDescription: 'Все пользователи этой организации используют общий пул из {limit} токенов. Индивидуальные лимиты не применяются.',
      individualLimitsNotUsed: 'Индивидуальные лимиты не используются в режиме общего пула',
      confirmRoleChange: 'Изменить роль пользователя',
      userRemoved: 'Пользователь успешно удален из организации',
      userInvited: 'Пользователь успешно приглашен',
      inviteSuccess: 'Пользователь приглашен',
      invitePending: 'Приглашение отправлено. Пользователь присоединится к организации после входа через Google:',
      invitePendingNoEmail: 'Пользователь добавлен как ожидающий, но письмо с приглашением не отправлено:',
      pendingInvitations: 'Приглашения в ожидании',
      pendingInvited: 'Приглашён',
      pendingExpires: 'Истекает',
      resendInvite: 'Отправить повторно',
      deletePendingInvite: 'Отменить приглашение',
      confirmDeletePending: 'Отменить приглашение в ожидании для',
      pendingInviteDeleted: 'Приглашение в ожидании отменено:',
      pendingInviteResent: 'Приглашение отправлено повторно:',
      pendingInviteResendFailed: 'Приглашение обновлено, но письмо не удалось отправить:',
      insufficientRights: 'Недостаточно прав',
      globalAdminMode: 'Вы работаете в режиме глобального администратора с организацией, в которой не состоите.',
      removeFromOrg: 'Удалить из организации',
      remove: 'Удалить'
    },

    // Organization History page
    orgHistory: {
      title: 'История организации',
      adminMode: 'Режим администратора',
      adminWarning: 'Вы работаете в режиме глобального администратора с организацией, в которой не состоите.',
      backToAdmin: 'Вернуться в админ-панель',
      insufficientRights: 'Недостаточно прав',
      accessRequiredMessage: 'Для доступа к истории необходимы права Admin или Manager',
      filters: 'Фильтры',
      searchByPrompt: 'Поиск по промпту',
      searchPromptPlaceholder: 'Поиск по тексту промпта...',
      generationMode: 'Режим генерации',
      workflow: 'Workflow',
      searchWorkflowPlaceholder: 'Поиск по workflow ID...',
      allModes: 'Все режимы',
      allWorkflows: 'Все workflow',
      user: 'Пользователь',
      allUsers: 'Все пользователи',
      historyTitle: 'История генераций',
      loadingHistory: 'Загрузка истории...',
      historyEmpty: 'История генераций пуста',
      date: 'Дата',
      prompt: 'Промпт',
      mode: 'Режим',
      result: 'Результат',
      images: 'Картинки',
      data: 'Данные',
      cost: 'Стоимость',
      success: 'Успех',
      error: 'Ошибка',
      copyPromptHint: 'Нажмите, чтобы скопировать',
      loadMore: 'Загрузить еще',
      loading: 'Загрузка...',
      promptCopied: 'Промпт скопирован в буфер обмена',
      promptCopyFailed: 'Не удалось скопировать промпт',
      actions: 'Действия',
      deleteGeneration: 'Удалить генерацию',
      deleteNotAllowed: 'Только глобальные администраторы могут удалять генерации',
      confirmDelete: 'Вы уверены, что хотите удалить эту генерацию?',
      deleteSuccess: 'Генерация успешно удалена',
      deleteFailed: 'Не удалось удалить генерацию',
      editGeneration: 'Редактировать генерацию',
      editGenerationTitle: 'Редактирование стоимости генерации',
      tokenPrice: 'Стоимость в токенах',
      tokenStatus: 'Статус оплаты',
      tokenStatusPending: 'Ожидание',
      tokenStatusCompleted: 'Завершено',
      tokenStatusRefunded: 'Возврат',
      saveChanges: 'Сохранить изменения',
      editSuccess: 'Генерация успешно обновлена',
      editFailed: 'Не удалось обновить генерацию',
      prevPage: 'Предыдущая',
      nextPage: 'Следующая',
      page: 'Страница',
      showing: 'Показано',
      of: 'из',
      results: 'результатов',
      perPage: 'На странице',
      // Export functionality
      export: {
        button: 'Экспорт отчёта',
        title: 'Экспорт статистики',
        period: 'Период',
        month1: '1 месяц',
        month3: '3 месяца',
        month6: '6 месяцев',
        year1: '1 год',
        custom: 'Произвольный',
        dateFrom: 'С даты',
        dateTo: 'По дату',
        filterUser: 'Пользователь',
        filterWorkflow: 'Тип генерации',
        allUsers: 'Все пользователи',
        allWorkflows: 'Все типы',
        download: 'Скачать CSV',
        cancel: 'Отмена',
        loading: 'Формирование отчёта...',
        noData: 'Нет данных за выбранный период',
        success: 'Отчёт скачан',
        error: 'Ошибка при создании отчёта',
        includeLinks: 'Включить ссылки на контент',
        details: 'ДЕТАЛИЗАЦИЯ',
        summary: 'ИТОГО',
        totalGenerations: 'Всего генераций',
        totalTokens: 'Всего токенов',
        byUsers: 'ПО ПОЛЬЗОВАТЕЛЯМ',
        byWorkflow: 'ПО ТИПАМ ГЕНЕРАЦИИ',
        generations: 'Генераций',
        tokens: 'Токенов',
        links: 'Ссылки',
        reportTitle: 'Отчёт организации',
        periodLabel: 'Период',
        includeRawData: 'Включить raw input и raw response',
        includeInput: 'Включить параметры запроса (raw input)',
        includeResponse: 'Включить ответ API (raw response)',
        rawInput: 'Raw Input',
        rawResponse: 'Raw Response',
        mark: 'Оценка'
      },
      tracing: 'Трассировка',
      tracingTitle: 'Трассировка пайплайна',
      dataPopupCurrent: 'Текущий',
      dataPopupHistory: 'История',
      dataPopupTracing: 'Трассировка',
      dataPopupCopy: 'Копировать',
      dataPopupCopied: 'Скопировано!',
      dataPopupNoHistory: 'История запросов пуста. Она появится после отправки запросов.',
      dataPopupAllUsers: 'Все пользователи',
      dataPopupAllUsersEmpty: 'Для этого воркфлоу ещё нет запросов.',
      dataPopupAllUsersError: 'Не удалось загрузить запросы. Закройте и откройте окно, чтобы повторить.',
      dataPopupAllUsersLoading: 'Загрузка запросов…',
      textPreview: 'Текст',
      viewText: 'Просмотреть текст',
      category: 'Категория',
      allCategories: 'Все категории',
      categoryImage: 'Изображение',
      categoryVideo: 'Видео',
      categoryVoice: 'Голос',
      categoryText: 'Текст',
      category3D: '3D',
      check: {
        button: 'Проверить',
        success: 'Генерация завершена',
        stillRunning: 'Генерация ещё выполняется',
        failed: 'Не удалось проверить генерацию',
      },
      externalActor: {
        via: 'от имени',
        title: 'Внешний инициатор, переданный внешней системой',
      },
    },

    // Text result modal
    textResult: {
      title: 'Текстовый результат',
      copy: 'Копировать в буфер',
      copied: 'Скопировано!',
      download: 'Скачать как .txt',
      close: 'Закрыть',
      tokens: 'токенов',
    },

    // Admin cross-org export
    adminExport: {
      title: 'Экспорт отчёта по организациям',
      button: 'Экспорт отчёта',
      filterOrganization: 'Организация',
      allOrganizations: 'Все организации',
      byOrganization: 'ПО ОРГАНИЗАЦИЯМ',
      organizationColumn: 'Организация',
      reportTitle: 'Отчёт по организациям',
      truncationWarning: 'Отчёт содержит только {count} из {total} записей. Уменьшите период или выберите конкретную организацию.',
      selectAll: 'Выбрать все',
      deselectAll: 'Снять выделение',
      selectedCount: 'Выбрано: {count}',
      searchOrganizations: 'Поиск организаций...',
      exportProgress: 'Экспорт: {org} ({current}/{total})',
      cancel: 'Отмена',
    },

    // Admin panel sections
    admin: {
      title: 'Панель администратора',
      dashboard: 'Дашборд',
      users: 'Администраторы',
      organizations: 'Организации',
      globalPrompts: 'Глобальные промпты',
      backToDashboard: 'Вернуться к дашборду',
      navigation: 'Навигация',
      widgets: 'Виджеты',
      widgetsDesc: 'Управление типами виджетов и их настройками отображения',
      createWidget: 'Создать виджет',
      editWidget: 'Редактировать виджет',
      duplicateWidget: 'Дублировать виджет',
      widgetId: 'ID виджета',
      widgetName: 'Название виджета',
      widgetDescription: 'Описание',
      widgetIcon: 'Иконка',
      widgetActive: 'Активен',
      displayType: 'Тип отображения',
      displayTypeSmall: 'Боковая панель',
      displayTypeBig: 'Основная область',
      name: 'Название',
      description: 'Описание',
      status: 'Статус',
      actions: 'Действия',
      active: 'Активен',
      inactive: 'Неактивен',
      accessDenied: 'Доступ запрещен',
      adminRequired: 'Требуются права администратора',
      noWidgets: 'Типы виджетов не найдены',
      noWidgetsDesc: 'Создайте первый тип виджета для начала работы',
      dynamicWidget: 'Динамический виджет',
      dynamicWidgetDesc: 'Настройка полей без кода',
      dynamic: 'Динамический',
      configureFields: 'Настроить поля',
      fields: 'Поля',
      configureFieldsDesc: 'Настройте динамические поля для этого виджета',
      addField: 'Добавить поле',
      editField: 'Редактировать поле',
      displayOrder: 'Порядок отображения',
      configuredFields: 'Настроенные поля',
      noFieldsYet: 'Поля еще не настроены',
      workflowsUsing: 'Workflows',
      workflowsUsingWidget: 'Workflows использующие этот виджет',
      noWorkflowsUsingWidget: 'Нет workflows использующих этот виджет',
      viewWorkflows: 'Показать workflows',
      widgetPreview: 'Предпросмотр виджета',
      widgetState: 'Состояние виджета',
      fieldType: 'Тип поля',
      fieldId: 'ID поля',
      fieldLabel: 'Название поля',
      tooltip: 'Подсказка',
      required: 'Обязательное',
      placeholder: 'Плейсхолдер',
      minLength: 'Минимальная длина',
      maxLength: 'Максимальная длина',
      multiline: 'Многострочный',
      rows: 'Строк',
      minValue: 'Минимальное значение',
      maxValue: 'Максимальное значение',
      step: 'Шаг',
      defaultValue: 'Значение по умолчанию',
      options: 'Варианты',
      optionsHelp: 'Введите каждый вариант с новой строки',
      optionsHelpKeyValue: 'Каждый вариант с новой строки. Формат "Название::значение" (например, "HD::hd") или просто текст.',
      maxSelections: 'Максимум выборов',
      // Dropdown Prompt field config
      dropdownPrompt: 'Выпадающий список (промпт)',
      addOption: 'Добавить вариант',
      optionLabel: 'Название варианта',
      selectPrompt: 'Выберите промпт...',
      removeOption: 'Удалить вариант',
      copyVariables: 'Копировать переменные',
      variablesCopied: 'Скопировано!',
      copyFailed: 'Не удалось скопировать',
      pasteVariables: 'Вставить переменные',
      pasteFailed: 'Не удалось вставить',
      nothingToPaste: 'Буфер обмена пуст',
      // Descriptions for dashboard cards
      usersDescription: 'Системные администраторы и менеджеры',
      organizationsDescription: 'Зарегистрированные организации',
      globalPromptsDescription: 'Глобальные системные промпты',
      activeUsersDescription: 'Недавно активные пользователи',
      // Quick actions descriptions
      usersActionDesc: 'Управление администраторами системы и глобальными ролями',
      organizationsActionDesc: 'Управление организациями и их настройками',
      globalPromptsActionDesc: 'Создание и управление глобальными системными промптами',
      // Section navigation for EditWorkflowModal
      general: 'Основное',
      apiEndpoints: 'Dify Endpoints',
      tileConfig: 'Плитка',
      tags: 'Теги',
      tagsDesc: 'Выберите теги для этого workflow.',
      restrictions: 'Ограничения',
      api: 'API',
      apiDescription: 'Документация API и примеры cURL для этого workflow',
      references: 'Референсы',
      editWorkflow: 'Редактировать Workflow',
      previewPayload: 'Предпросмотр данных запроса',
      previewPayloadTitle: 'Данные для отправки в API',
      clickToNavigate: 'Кликните для навигации между секциями',
      hasErrors: 'Есть ошибки',
      complete: 'Заполнено',
      basicInfo: 'Базовая информация',
      workflowId: 'ID Workflow',
      workflowIdDesc: 'Уникальный идентификатор для URL',
      workflowTitle: 'Заголовок',
      descriptions: 'Описания',
      descriptionRu: 'Описание (Русский)',
      descriptionEn: 'Описание (English)',
      configuration: 'Конфигурация',
      category: 'Категория',
      actionButtonType: 'Тип кнопки действия',
      inputFilesLogic: 'Логика входных файлов',
      uploadFilesLogic: 'Логика загрузки файлов',
      availability: 'Доступность',
      displayStatus: 'Статус отображения',
      displayStatusActive: 'Активный',
      displayStatusNew: 'Новый',
      displayStatusArchived: 'Архивный',
      displayStatusActiveDesc: 'Стандартная видимость в селекторе workflows',
      displayStatusNewDesc: 'Отображается вверху селектора с бейджем "Новое"',
      displayStatusArchivedDesc: 'Скрыт по умолчанию, отображается серым при включении "Показать архивные"',
      displayStatusUpdated: 'Статус отображения обновлён',
      promptCharLimit: 'Лимит символов промпта',
      promptCharLimitDesc: 'По умолчанию: 5000 (мин: 100, макс: 50000)',
      singlePerRequest: 'По одному за запрос',
      allPerRequest: 'Все за один запрос',
      none: 'Нет',
      pricingFormula: 'Формула расчёта стоимости',
      availableVariables: 'Доступные переменные',
      examples: 'Примеры',
      pricingFormulaHelp: {
        title: 'Справка по формуле расчёта стоимости',
        dynamicVariablesTitle: 'Динамические переменные',
        dynamicVariablesDesc: 'Любой параметр из inputs workflow может использоваться в формуле. Имена переменных соответствуют именам виджетов.',
        dynamicVariablesExamples: 'Примеры: num_images, width, height, quality, duration, steps и т.д.',
        autoVariablesTitle: 'Автоматически рассчитываемые',
        examplesTitle: 'Примеры формул',
        operationsTitle: 'Поддерживаемые операции',
        descriptionColumn: 'Описание',
        variables: {
          input_img_mpx: 'Мегапиксели входного изображения (макс. из загруженных файлов)',
          input_img_count: 'Количество входных изображений (референсов); расчёт цены ждёт загрузки хотя бы одного',
          input_img_count_may_zero: 'Количество входных изображений (0 если не загружены, не блокирует расчёт)',
          target_img_mpx: 'Мегапиксели выходного изображения (из параметров width/height)',
          target_img_width: 'Ширина выходного изображения в пикселях',
          target_img_height: 'Высота выходного изображения в пикселях',
          target_long_side: 'Длинная сторона выходного изображения в пикселях (max(width, height))',
          target_short_side: 'Короткая сторона выходного изображения в пикселях (min(width, height))',
          target_aspect_ratio: 'Соотношение сторон выходного изображения (длинная / короткая сторона, ≥ 1; 0 если размер не задан)',
          audio_duration: 'Длительность аудио в секундах (сумма из загруженных файлов)',
          video_duration: 'Длительность видео в секундах (сумма из загруженных файлов)',
          audio_duration_exact: 'Сумма длительностей аудио в секундах, округлённая вверх до сотых, без минимума 1 с на файл. Аудио обязательно; если точное значение отсутствует, используется audio_duration',
          video_duration_exact: 'Сумма длительностей видео в секундах, округлённая вверх до сотых, без минимума 1 с на файл. Видео обязательно; если точное значение отсутствует, используется video_duration',
          audio_duration_exact_may_zero: 'Вычисляется из audio_duration_exact (или audio_duration, если точное значение отсутствует); 0 без аудио. Проверки наличия входных данных по-прежнему действуют',
          video_duration_exact_may_zero: 'Вычисляется из video_duration_exact (или video_duration, если точное значение отсутствует); 0 без видео. Проверки наличия входных данных по-прежнему действуют',
          has_audio: 'Флаг наличия аудио (1 если загружено, 0 если нет)',
          has_video: 'Флаг наличия видео (1 если загружено, 0 если нет)',
          audio_duration_may_zero: 'Длительность аудио (0 если аудио не загружено, не блокирует расчёт)',
          video_duration_may_zero: 'Длительность видео (0 если видео не загружено, не блокирует расчёт)',
          video_width: 'Ширина видео в пикселях (макс. из загруженных файлов)',
          video_height: 'Высота видео в пикселях (макс. из загруженных файлов)',
          video_mpx: 'Мегапиксели видео (макс. из загруженных файлов)',
          prompt_length_1k: 'Длина промпта в тысячах символов (length / 1000)',
          prompt_length_1k_may_zero: 'Длина промпта в тысячах символов (0 если промпт не задан, не блокирует расчёт)',
          prompt_length_ceil_100: 'Длина промпта в сотнях символов, ступенчатая (Math.ceil(length / 100))',
          prompt_length_ceil_100_may_zero: 'Длина промпта в сотнях символов, ступенчатая (0 если промпт не задан, не блокирует расчёт)',
          text_length_ceil_100: 'Длина поля text в сотнях символов, ступенчатая (Math.ceil(length / 100))',
          text_length_ceil_100_may_zero: 'Длина поля text в сотнях символов, ступенчатая (0 если text не задан, не блокирует расчёт)',
          has_prompt: '1 если промпт задан, 0 если пустой'
        },
        operations: {
          arithmetic: 'Арифметика: +, -, *, /, %',
          comparison: 'Сравнение: >, <, >=, <=, ===, !==',
          ternary: 'Тернарный оператор: условие ? значение1 : значение2',
          math: 'Math функции: Math.ceil(), Math.floor(), Math.round(), Math.min(), Math.max(), Math.abs()'
        }
      },
      widgetConfiguration: 'Настройка виджетов',
      widgetConfigDesc: 'Перетащите виджеты из левой колонки в правую для включения.',
      enabledWidgets: 'Включённые виджеты',
      totalWidgets: 'Всего',
      noWidgetTypes: 'Типы виджетов недоступны',
      noWidgetTypesDesc: 'Сначала необходимо настроить типы виджетов в системе.',
      widgetTips: 'Советы',
      widgetTip1: 'Перетащите виджет вправо для включения',
      widgetTip2: 'Перетащите виджет влево для отключения',
      widgetTip3: 'Порядок виджетов влияет на их отображение на странице workflow',
      availableWidgets: 'Доступные виджеты',
      searchWidgets: 'Поиск...',
      noWidgetsFound: 'Виджеты не найдены',
      noWidgetsAvailable: 'Нет доступных виджетов',
      noWidgetsSelected: 'Выберите виджеты для превью',
      noWidgetsEnabled: 'Нет включённых виджетов. Включите виджеты для превью.',
      selectWidgetsHint: 'Выберите виджеты из левой панели для настройки workflow',
      allWidgetsEnabled: 'Все виджеты включены',
      dragToEnableHint: 'Перетащите вправо для включения',
      dragToReorderHint: 'Для сортировки тяните, влево — отключение',
      dropWidgetsHere: 'Перетащите виджеты сюда',
      orClickPlus: 'или нажмите +',
      enableWidget: 'Включить',
      disableWidget: 'Отключить',
      moveUp: 'Вверх',
      moveDown: 'Вниз',
      apiEndpointsDesc: 'Настройте API URL для этого workflow. Основной URL обязателен, дополнительные опциональны.',
      mainUrlConfigured: 'Основной URL настроен',
      mainUrlMissing: 'Основной URL отсутствует',
      totalEndpoints: 'Всего',
      noApiEndpoints: 'API endpoints не настроены',
      noApiEndpointsDesc: 'Добавьте хотя бы один основной URL для работы workflow.',
      tileConfigDesc: 'Настройте отображение этого workflow в галерее.',
      noTileConfigured: 'Плитка не настроена',
      noTileConfiguredDesc: 'Выберите тип отображения выше для настройки галерейной плитки.',
      sliderDesc: 'Интерактивный слайдер для сравнения изображений',
      autoSwitchDesc: 'Автоматическое переключение между изображениями',
      autoSwitchDelayHint: 'Время между переключениями (500-10000мс)',
      videoUploadHint: 'Макс. размер: 20MB. Поддерживаемые форматы: MP4, WebM',
      contentRestrictions: 'Ограничения контента',
      contentRestrictionsDesc: 'Настройте ограничения по размеру и количеству загружаемого контента.',
      outgoingImages: {
        title: 'Изображения для внешнего API',
        description: 'Сжимать изображения, включая галерею и референсы, только при превышении лимита файла или общего объёма. Исходники сохраняются.',
        enabled: 'Ограничивать размер отправляемых изображений',
        format: 'Формат при сжатии',
        quality: 'Начальное качество (%)',
        perImage: 'Размер файла одного изображения (MB)',
        total: 'Общий объём изображений после base64 (MB)',
        dimension: 'Максимальная сторона при сжатии (px)',
        units: '1 MB = 1 048 576 байт. Лимиты до 100 MB, дробные значения округляются вниз до целого байта.',
        base64: 'Общий лимит учитывает увеличение при base64 (примерно 4/3). Оставьте запас для текста и JSON; это не размер полного HTTP-запроса.',
        transparency: 'JPEG заменяет прозрачность белым фоном; WebP сохраняет прозрачность. Формат и размер стороны меняются только при необходимом сжатии.',
        invalid: 'Заполните лимиты от одного байта до 100 MB, качество 10–100% и сторону 512–8192 px.',
      },
      noInputWidgetsEnabled: 'Нет включённых виджетов ввода',
      noInputWidgetsEnabledDesc: 'Включите виджет "Input Images" или "Input Media" в секции Виджеты для настройки ограничений контента.',
      forInputImages: 'для виджета Input Images',
      forInputMedia: 'для виджета Input Media',
      restrictionsTips: 'Советы',
      restrictionsTip1: 'Оставьте поля пустыми для использования системных значений по умолчанию',
      restrictionsTip2: 'Ограничения размера помогают обеспечить качество результата',
      restrictionsTip3: 'Лимиты размера файлов предотвращают длительную загрузку',
      // Input Text settings
      inputTextSettings: 'Настройки текстового ввода',
      inputTextSettingsDesc: 'Настройте заголовок и текст-подсказку для виджета ввода текста.',
      inputTextTitle: 'Заголовок виджета',
      inputTextPlaceholder: 'Текст подсказки',
      noInputTextWidget: 'Виджет не включён',
      noInputTextWidgetDesc: 'Включите виджет "Input Text" в секции Виджеты для настройки его параметров.',
      inputTextLayout: 'Режим отображения',
      inputTextSimple: 'Простой',
      inputTextSimpleDesc: 'Одно текстовое поле',
      inputTextDouble: 'Двойной',
      inputTextDoubleDesc: 'Два текстовых поля',
      inputTextOutputKey: 'Ключ вывода (API)',
      inputTextOutputKeyDesc: 'Имя ключа, используемое в API payload (по умолчанию: "prompt")',
      inputTextFieldId: 'ID поля (API ключ)',
      inputTextFieldIdDesc: 'Этот ключ будет использоваться в API payload',
      inputTextCharLimit: 'Лимит символов',
      inputTextRequired: 'Обязательное',
      inputTextField1: 'Поле 1',
      inputTextField2: 'Поле 2',
      // Slots Input Media settings
      slotsInputMediaSettings: 'Настройки слотов медиа',
      slotsInputMediaSettingsDesc: 'Настройте слоты загрузки медиа с индивидуальными ограничениями для каждого слота.',
      noSlotsInputMediaWidget: 'Виджет не включён',
      noSlotsInputMediaWidgetDesc: 'Включите виджет "Slots Input Media" в секции Виджеты для настройки его параметров.',
      acceptedFormats: 'Принимаемые форматы',
      acceptedFormatsHint: 'Снимите галочки чтобы ограничить форматы. Минимум 1 формат.',
      allFormats: 'Все форматы',
      modelMediaType: '3D модель',
      modelRestrictions: 'Ограничения для 3D-моделей',
      modelMaxFileSize: 'Макс. размер файла (MB)',
      modelMaxFileSizeHint: 'Максимальный размер одного загружаемого файла 3D-модели.',
      videoMinDuration: 'Мин. длительность (сек)',
      videoMinPixels: 'Мин. пикселей в кадре',
      videoMaxPixels: 'Макс. пикселей в кадре',
      targetWidth: 'Целевая ширина (px)',
      targetWidthDesc: 'Изображение будет обрезано по центру и масштабировано до указанной ширины',
      targetHeight: 'Целевая высота (px)',
      targetHeightDesc: 'Изображение будет обрезано по центру и масштабировано до указанной высоты',
      convertToJpeg: 'Конвертировать в JPEG (убрать прозрачность)',
      convertToJpegDesc: 'PNG с альфа-каналом будут конвертированы в JPEG с белым фоном',
      imageProcessingTitle: 'Обработка изображений',
      targetDimensionsPairWarning: 'Для кропа/ресайза необходимо указать и ширину, и высоту',
      enableMask: 'Включить редактор маски',
      enableMaskDesc: 'Показывать кнопку «Маска» на заполненном слоте для рисования маски инпейнтинга',
      maskPayloadKey: 'Ключ маски в payload',
      maskPayloadKeyPlaceholder: 'mask_image',
      maskPayloadKeyRequired: 'Укажите ключ маски в payload',
      enhanceMappings: 'Маппинг Enhance',
      pipelineSteps: 'Шаги пайплайна',
      pipelineStepsConfig: {
        title: 'Шаги пайплайна',
        description: 'Настройка многошаговой конвейерной обработки для этого workflow',
        stepName: 'Название шага',
        stepUrl: 'API URL',
        stepWorkflowUrl: 'Workflow URL',
        stepWorkflowUrlPlaceholder: 'https://api.loremax.ai/app/.../workflow',
        stepApiKey: 'API Ключ',
        workflowPrompt: 'Workflow промпт',
        workflowPromptHint: 'Необязательно: выберите workflow промпт для этого шага',
        outputMappings: 'Маппинг выходных данных',
        sourceField: 'Поле источника',
        targetField: 'Целевое поле',
        addMapping: 'Добавить маппинг',
        extraParameters: 'Дополнительные параметры',
        extraParametersHint: 'Эти параметры будут добавлены к данным запроса',
        parameterKey: 'Ключ',
        parameterValue: 'Значение',
        addParameter: 'Добавить параметр',
        deleteParameter: 'Удалить параметр',
        addStep: 'Добавить шаг',
        maxStepsReached: 'Достигнут максимум в 10 шагов',
        emptyState: 'Шаги пайплайна не настроены. Добавьте шаг для создания многошагового workflow.',
        stepNumber: 'Шаг',
        deleteStep: 'Удалить шаг',
        deleteMapping: 'Удалить маппинг',
        moveUp: 'Переместить вверх',
        moveDown: 'Переместить вниз',
        collapseStep: 'Свернуть шаг',
        expandStep: 'Развернуть шаг',
        onErrorLabel: 'При ошибке',
        onErrorFail: 'Остановить пайплайн',
        onErrorRetry: 'Повторить шаг',
        maxAttemptsLabel: 'Макс. попыток',
        maxAttemptsHint: 'От 1 до 5 попыток',
        retryDelayLabel: 'Задержка (сек)',
        retryDelayHint: 'От 1 до 60 секунд',
      },
      pipelineTracing: {
        stepLabel: 'Шаг',
        status: {
          pending: 'Ожидание',
          running: 'Выполняется',
          completed: 'Завершён',
          failed: 'Ошибка',
          waiting_callback: 'Ожидание ответа',
        },
        input: 'Входные данные',
        output: 'Выходные данные',
        response: 'Ответ',
        error: 'Ошибка',
        duration: 'Длительность',
        attempts: 'Попытки',
        attemptNumber: 'Попытка',
        pollCount: 'Кол-во опросов',
        retryCount: 'Кол-во повторов',
        noSteps: 'Нет шагов для отображения',
        skipped: 'Пропущен',
        resendStreaming: 'Повторить (streaming)',
        resendBlocking: 'Повторить (blocking)',
        resending: 'Отправка...',
        resendResult: 'Результат повтора',
        httpStatus: 'HTTP',
      },
      allSectionsWillBeSaved: 'Все секции будут сохранены вместе',
      cancel: 'Отмена',
      saving: 'Сохранение...',
      saveWorkflow: 'Сохранить Workflow',
      // DynamicWidget section
      addFieldHint: 'Добавьте поля для создания виджета',
      basic: 'Базовое',
      design: 'Дизайн',
      displayOrderDesc: 'Позиция виджета среди других виджетов',
      fieldConfig: 'Настройка поля',
      fieldIdHelp: 'Уникальный ID поля (латиница и _)',
      label: 'Название',
      noDefault: 'Без значения',
      noFields: 'Поля не добавлены',
      preview: 'Предпросмотр',
      removeWidget: 'Удалить виджет',
      special1: 'Специальное',
      widgetInfo: 'Информация о виджете',
      embedded: 'Встроенный',
      // Workflow settings
      autoPromptEnhance: {
        label: 'Авто-улучшение промпта',
        description: 'Автоматически улучшать промпты с помощью AI',
        mappingsLabel: 'Маппинг полей улучшения',
        mappingsDescription: 'Настройка соответствия полей вывода API улучшения полям генерации',
        sourceField: 'Исходное поле',
        targetField: 'Целевое поле',
        addMapping: 'Добавить маппинг',
        defaultHint: 'Если пусто, используется: text → prompt, is_nsfw → is_nsfw'
      },
      pipelineType: {
        label: 'Тип пайплайна',
        description: 'Выберите способ обработки промптов',
        off: 'Выключено',
        offDescription: 'Стандартное выполнение через Dify Endpoints',
        autoPromptEnhance: 'Авто-улучшение промпта',
        autoPromptEnhanceDescription: 'Улучшение промптов перед генерацией (устаревший)',
        pipeline: 'Пайплайн',
        pipelineDescription: 'Многошаговое выполнение пайплайна',
        deprecated: 'устаревший'
      },
      noRefundContentPolicy: {
        label: 'Не возвращать токены при нарушении политики контента',
        description: 'Не возвращать токены при ошибке, вызванной нарушением политики контента провайдера (например, xAI/Grok)'
      },
      multiTaskType: {
        label: 'Тип задачи для «Мульти»',
        help: 'Делает модель доступной в разделе «Мульти» для параллельной генерации. «Нет» — модель не участвует в «Мульти». Типы image2* и video2video ставьте только тем воркфлоу, которые читают общие слоты source_image / source_video. Воркфлоу multiimage2_3d должны использовать all_per_request и читать front_image / back_image / left_image / right_image. Иначе модель будет заблокирована или получит пустую переменную.',
        updated: 'Тип задачи для «Мульти» обновлён',
        categoryMismatch: 'Тип задачи не соответствует категории воркфлоу — проверьте, что указано верно',
        none: 'Нет',
        text2image: 'Текст → изображение',
        image2image: 'Изображение → изображение',
        text2video: 'Текст → видео',
        image2video: 'Изображение → видео',
        video2video: 'Видео → видео',
        text2_3d: 'Текст → 3D',
        image2_3d: 'Изображение → 3D',
        multiimage2_3d: 'Мульти-фото → 3D'
      },
      apiKeys: {
        title: 'API-ключи',
        description: 'Управление API-ключами для программного доступа',
        noKeys: 'API-ключей пока нет. Создайте первый, чтобы начать.',
        columns: {
          name: 'Название',
          keyPrefix: 'Префикс ключа',
          rateLimits: 'Лимиты запросов',
          status: 'Статус',
          usage: 'Использование',
          lastUsed: 'Последнее использование',
          actions: 'Действия'
        },
        status: {
          active: 'Активен',
          revoked: 'Отозван'
        },
        actions: {
          create: 'Создать ключ',
          edit: 'Изменить',
          revoke: 'Отозвать',
          revokeConfirm: 'Вы уверены, что хотите отозвать этот API-ключ?',
          regenerate: 'Перевыпустить',
          regenerateConfirm: 'Перевыпустить этот API-ключ? Текущий ключ перестанет работать сразу — обновите его во всех интеграциях, которые его используют.',
          copy: 'Копировать',
          done: 'Готово'
        },
        createModal: {
          title: 'Создание API-ключа',
          name: 'Название',
          description: 'Описание',
          namePlaceholder: 'Мой API-ключ',
          descriptionPlaceholder: 'Необязательное описание...',
          rateMinute: 'Запросов/мин',
          rateHour: 'Запросов/час'
        },
        keyCreatedModal: {
          title: 'API-ключ создан',
          regeneratedTitle: 'API-ключ перевыпущен',
          warning: 'Ключ показывается только один раз. Скопируйте его сейчас и сохраните в надёжном месте.'
        },
        validation: {
          nameRequired: 'Укажите название'
        },
        messages: {
          loadError: 'Не удалось загрузить API-ключи',
          createError: 'Не удалось создать API-ключ',
          updateError: 'Не удалось обновить API-ключ',
          revokeError: 'Не удалось отозвать API-ключ',
          regenerateError: 'Не удалось перевыпустить API-ключ',
          regenerateConflict: 'Этот ключ уже был перевыпущен или отозван. Список ключей обновлён.',
          copyError: 'Не удалось скопировать ключ'
        }
      },
      // Controller Dropdown & Variant config
      controllerDropdown: 'Управляющий список',
      onlyOneController: 'Допускается только один управляющий список на виджет',
      controllerNeedsOptions: 'Управляющий список должен содержать хотя бы один вариант',
      controllerDuplicateValues: 'Значения вариантов управляющего списка должны быть уникальными',
      variantConfig: 'Настройка вариантов',
      defaultVariant: 'По умолчанию',
      variantOverrideHint: 'Задавайте только отличающиеся от Default значения. Пустые поля наследуют настройки по умолчанию.',
      hiddenInVariant: 'Скрыто для этого варианта',
      requiredField: 'Обязательное поле',
      requiredFieldHint: 'Генерация не запустится, пока поле не заполнено. Действует для всех вариантов, а в MCP-профилях поле публикуется как обязательный аргумент.',
      hiddenFieldHint: 'Скрытое — не видно пользователям',
      hiddenTextPlaceholder: 'Постоянное текстовое значение...',
      hiddenTextLabel: 'Скрытый текст',
      hiddenNumberLabel: 'Скрытое число',
      hiddenPromptLabel: 'Скрытый промпт',
      hiddenPromptNeedsPrompt: 'Скрытый промпт должен иметь выбранный промпт',
      selectedPromptId: 'ID выбранного промпта',
      override: 'переопр.',
      variantOptionsHint: 'Оставьте пустым для наследования вариантов по умолчанию',
      noOverridableFields: 'Нет переопределяемых полей для этого типа. Можно скрыть поле для конкретного варианта.',
      controllerOptionsHelp: 'Каждому варианту нужны отображаемое название и уникальный идентификатор значения. Значение используется для сопоставления конфигов вариантов в зависимых полях.',
      optionValue: 'Значение варианта',
      minWidth: 'Мин. ширина',
      maxWidth: 'Макс. ширина',
      minHeight: 'Мин. высота',
      maxHeight: 'Макс. высота',
      defaultWidth: 'Ширина по умолчанию',
      defaultHeight: 'Высота по умолчанию'
    },

    adminUsers: {
      title: 'Управление пользователями',
      administrators: 'Администраторы',
      assignRoleByEmail: 'Назначить роль по email',
      noAdministratorsFound: 'Администраторы не найдены',
      columns: {
        email: 'Email',
        name: 'Имя',
        globalRole: 'Глобальная роль',
        registered: 'Регистрация',
        lastActivity: 'Последняя активность'
      },
      assignRole: {
        title: 'Назначить роль по email',
        emailLabel: 'Email пользователя',
        emailPlaceholder: 'user@example.com',
        roleLabel: 'Роль',
        assignButton: 'Назначить роль',
        assigningButton: 'Назначаем...'
      },
      userEmail: 'Email пользователя',
      roleDescriptions: 'Описание ролей',
      globalRole: 'Глобальная роль',
      registration: 'Регистрация',
      lastActivity: 'Последняя активность',
      noAdminsFound: 'Администраторы не найдены',
      assigningRole: 'Назначение...',
      assignRoleButton: 'Назначить роль',
      roleAssignNote: 'Пользователь должен быть зарегистрирован в системе. После назначения роли администратора пользователь появится в списке выше.',
      email: 'Email',
      name: 'Имя',
      role: 'Роль',
      regularUsers: {
        title: 'Обычные пользователи',
        searchPlaceholder: 'Поиск по email или имени...',
        noUsersFound: 'Пользователи не найдены',
        makeAdmin: 'Сделать администратором',
        confirmMakeAdmin: 'Вы уверены, что хотите сделать {email} администратором?',
        selectRole: 'Выберите роль',
        columns: {
          email: 'Email',
          name: 'Имя',
          registered: 'Регистрация',
          lastActivity: 'Последняя активность',
          actions: 'Действия'
        },
        pagination: {
          previous: 'Предыдущая',
          next: 'Следующая',
          showing: 'Показано',
          of: 'из',
          users: 'пользователей'
        }
      }
    },

    adminOrganizations: {
      title: 'Управление организациями',
      organizationManagement: 'Управление организациями',
      createOrganization: 'Создать организацию',
      organizationName: 'Название организации',
      generationLimit: 'Токены',
      usage: 'Использование',
      userCount: 'Количество пользователей',
      created: 'Создана',
      actions: 'Действия',
      noOrgsFound: 'Организации не найдены',
      creatingOrg: 'Создание...',
      createOrgButton: 'Создать организацию',
      nameLabel: 'Название',
      limitLabel: 'Лимит генераций',
      namePlaceholder: 'Введите название организации',
      limitPlaceholder: 'Например: 100000',
      save: 'Сохранить',
      cancel: 'Отмена',
      edit: 'Редактировать',
      delete: 'Удалить',
      manage: 'Управлять',
      billingTypeColumn: 'Тип оплаты',
      actionButtons: {
        viewHistory: 'Посмотреть историю',
        deleteOrg: 'Удалить организацию',
        manageOrg: 'Управление организацией',
        clearHistory: 'Очистить историю',
        select: 'Выбрать',
        deselect: 'Отменить выбор',
        edit: 'Редактировать'
      },
      actionsSection: {
        title: 'Действия для {name}',
        managementTitle: 'Управление'
      },
      editModal: {
        title: 'Редактирование организации',
        save: 'Сохранить изменения',
        saveHint: 'Изменения будут сохранены немедленно'
      },
      sections: {
        general: 'Основное',
        apiKeys: 'API ключи',
        workflows: 'Workflows',
        domains: 'Домены',
        actions: 'Действия',
        debug: 'Отладка',
        usage: 'Использование',
        info: 'Информация'
      },
      fields: {
        name: 'Название организации',
        tokenLimit: 'Лимит токенов',
        marginDiscount: 'Скидка на маржу',
        paymentMethod: 'Способ оплаты',
        id: 'ID',
        createdAt: 'Создана'
      },
      placeholders: {
        name: 'Введите название организации'
      },
      hints: {
        tokenLimit: 'Максимальное количество токенов для организации',
        marginDiscount: 'Процент скидки на стоимость токенов (0% = без скидки)'
      },
      stats: {
        tokensUsed: 'Использовано токенов',
        tokenLimit: 'Лимит токенов',
        users: 'Пользователей',
        usageProgress: 'Использование'
      },
      actionsPanel: {
        quickLinks: 'Быстрые ссылки',
        manageUsers: 'Управление пользователями',
        manageUsersDesc: 'Просмотр и управление участниками организации',
        viewHistory: 'Просмотр истории',
        viewHistoryDesc: 'Просмотр истории генераций',
        dangerZone: 'Опасная зона',
        clearHistory: 'Очистить историю генераций',
        clearHistoryDesc: 'Удалить все записи генераций для этой организации',
        clearHistoryConfirm: 'Вы уверены, что хотите очистить всю историю генераций для этой организации? Это действие нельзя отменить.',
        historyCleared: 'История генераций успешно очищена',
        clear: 'Очистить',
        deleteOrg: 'Удалить организацию',
        deleteOrgDesc: 'Полностью удалить организацию и все связанные данные',
        deleteConfirmText: 'Это действие нельзя отменить. Введите название организации для подтверждения:',
        typeToConfirm: 'Введите название организации...',
        confirmDelete: 'Удалить организацию',
        delete: 'Удалить'
      },
      debugPanel: {
        stripeCustomer: 'Stripe Customer',
        stripeCustomerId: 'Stripe Customer ID',
        notSet: 'Не задан',
        setStripeCustomer: 'Установить Stripe Customer ID',
        setStripeCustomerDesc: 'Вручную установить или заменить Stripe Customer ID для этой организации.',
        set: 'Установить',
        setConfirm: 'Установить Stripe Customer ID?',
        setSuccess: 'Stripe Customer ID успешно установлен',
        resetStripeCustomer: 'Сбросить Stripe Customer',
        resetStripeCustomerDesc: 'Удалить привязку к Stripe Customer ID. Используйте при смене Stripe аккаунта.',
        resetConfirm: 'Вы уверены, что хотите сбросить Stripe Customer ID? Организация будет отвязана от Stripe-клиента. Адрес биллинга и счета будут потеряны.',
        resetSuccess: 'Stripe Customer ID успешно сброшен'
      },
      workflows: {
        description: 'Управление доступными workflow для этой организации',
        searchPlaceholder: 'Поиск workflows...',
        found: 'Найдено',
        of: 'из',
        columns: {
          id: 'ID',
          description: 'Описание',
          availability: 'Доступность'
        },
        noWorkflows: 'Workflow не найдены',
        noResults: 'Ничего не найдено',
        global: 'Глобальный',
        custom: 'Кастомный'
      },
      domains: {
        description: 'Управление доменами для автоматического назначения пользователей. Пользователи с email из этих доменов будут автоматически добавлены в организацию.',
        addNew: 'Добавить новый домен',
        placeholder: 'example.com',
        add: 'Добавить',
        noDomains: 'Домены не настроены',
        addFirst: 'Добавьте домены для автоматического назначения пользователей',
        confirmRemove: 'Вы уверены, что хотите удалить домен "{domain}"?',
        remove: 'Удалить',
        validation: {
          required: 'Домен обязателен'
        },
        columns: {
          domain: 'Домен',
          addedBy: 'Добавил',
          dateAdded: 'Дата добавления',
          actions: 'Действия'
        }
      },
      createForm: {
        title: 'Создать новую организацию',
        nameLabel: 'Название организации',
        limitLabel: 'Лимит генераций',
        marginDiscountLabel: 'Скидка на маржу',
        marginDiscountHint: '0% = без скидки',
        namePlaceholder: 'Название компании',
        limitPlaceholder: '100000',
        createButton: 'Создать организацию',
        creatingButton: 'Создание...',
        confirmMessage: 'Создать организацию "{name}" с лимитом {limit} генераций?',
        successMessage: 'Организация "{name}" успешно создана'
      },
      errors: {
        nameRequired: 'Введите название организации',
        limitInvalid: 'Введите корректный лимит генераций',
        marginDiscountInvalid: 'Введите корректную скидку на маржу (0-99%)',
        createError: 'Ошибка при создании организации',
        updateLimitError: 'Ошибка при обновлении лимита',
        updateMarginDiscountError: 'Ошибка при обновлении скидки на маржу',
        saveChangesError: 'Ошибка при сохранении изменений',
        deleteError: 'Ошибка при удалении организации'
      },
      messages: {
        settingsUpdated: 'Настройки обновлены',
        settingsUpdatedFor: 'Настройки для "{name}" успешно обновлены',
        organizationUpdated: 'Организация "{name}" успешно обновлена',
      },
      editLimit: {
        title: 'Редактировать лимит',
        save: 'Сохранить',
        cancel: 'Отменить'
      },
      deleteOrganization: {
        title: 'Удалить организацию',
        confirmMessage: 'Вы уверены, что хотите удалить организацию "{name}"?\n\nЭто действие необратимо и удалит всех пользователей из организации.',
        successMessage: 'Организация "{name}" успешно удалена'
      },
      clearHistory: {
        title: 'Очистить историю',
        confirmMessage: 'Вы уверены, что хотите очистить всю историю генераций и данные галереи для "{name}"? Это действие необратимо.',
        successMessage: 'История успешно очищена для "{name}"'
      },
      nsfwSettings: {
        label: 'NSFW контент',
        enabled: 'Разрешен',
        disabled: 'Запрещен',
        enabledDesc: 'NSFW контент доступен',
        disabledDesc: 'NSFW контент заблокирован',
        warning: 'Внимание: Включение NSFW контента позволяет пользователям организации использовать workflows и промпты для взрослых.',
        saveSuccess: 'Настройки NSFW успешно обновлены',
        saveError: 'Не удалось обновить настройки NSFW'
      },
      paymentMethods: {
        none: 'Нет (Отключено)',
        noneDesc: 'Биллинг отключен для этой организации',
        standard: 'Стандарт (Пакеты)',
        standardDesc: 'Покупка из предопределённых пакетов токенов',
        enterprise: 'Корпоративный (Кастомный)',
        enterpriseDesc: 'Гибкое ценообразование'
      }
    },

    organizationSettings: 'Настройки организации',

    adminWorkflows: {
      title: 'Управление рабочими процессами',
      workflowManagement: 'Управление рабочими процессами',
      createWorkflow: 'Создать рабочий процесс',
      editWorkflow: 'Редактировать рабочий процесс',
      exportWorkflow: 'Экспорт',
      deleteWorkflow: 'Удалить рабочий процесс',
      workflowId: 'ID рабочего процесса',
      workflowTitle: 'Название',
      workflowUrls: 'URL адреса',
      workflowUrlMain: 'Основной URL',
      workflowUrlAdditional1: 'Дополнительный URL 1',
      workflowUrlAdditional2: 'Дополнительный URL 2',
      workflowUrlAdditional3: 'Дополнительный URL 3',
      description: 'Описание',
      category: 'Категория',
      workflowType: 'Тип',
      availability: 'Доступность',
      created: 'Создан',
      actions: 'Действия',
      noWorkflowsFound: 'Рабочие процессы не найдены',
      titleRequired: 'Название обязательно',
      mainUrlRequired: 'Основной URL обязателен',
      manageUrls: 'Управление URL',
      urlManager: {
        title: 'Управление URL рабочего процесса',
        mainUrl: 'Основной URL',
        additionalUrl: 'Дополнительный URL',
        urlIndex: 'URL {index}',
        required: 'Обязательный',
        description: 'Описание',
        apiKey: 'API ключ',
        noApiKey: 'Нет API ключа',
        copy: 'Копировать',
        copied: 'Скопировано',
        roleTranslate: '→ Перевод',
        rolePromptEnhance: '→ Улучшение промпта',
        roleHintTranslate: 'Этот URL используется для перевода промпта',
        roleHintPromptEnhance: 'Этот URL используется для улучшения промпта',
        enhancerEndpointsTitle: 'Эндпоинты улучшения',
        enhancerEndpointsDesc: 'Эндпоинт улучшения промпта для этого рабочего процесса',
        enhancerEndpointsLoadError: 'Не удалось загрузить эндпоинты улучшения',
        notConfigured: 'Не настроено',
        configureUrl: 'Настроить',
        saveError: 'Не удалось сохранить URL',
        workflowPromptPlaceholder: 'Выберите промпт...',
        workflowPromptNote: 'Опционально: промпт, который будет использоваться с этим URL',
        extraParameters: 'Дополнительные параметры',
        extraParametersNote: 'Эти параметры будут добавлены в данные запроса',
        parameterKey: 'Ключ',
        parameterValue: 'Значение',
        addParameter: 'Добавить параметр',
        addUrl: 'Добавить дополнительный URL',
        editUrl: 'Редактировать URL',
        deleteUrl: 'Удалить URL',
        confirmDelete: 'Вы уверены, что хотите удалить {urlType}? Это действие нельзя отменить.',
        addUrlTitle: 'Добавить URL',
        editUrlTitle: 'Редактировать URL',
        descriptionPlaceholder: 'Введите описание URL...',
        urlPlaceholder: 'https://api.example.com/v1/endpoint',
        apiKeyPlaceholder: 'Введите API ключ...',
        apiKeyNote: 'Оставьте пустым, если API ключ включен в URL как параметр запроса',
        saving: 'Сохранение...',
        save: 'Сохранить',
        cancel: 'Отменить',
        close: 'Закрыть',
        maxUrlsReached: 'Достигнуто максимальное количество URL (6 всего)',
        cannotDeleteMain: 'Нельзя удалить основной URL рабочего процесса',
        apiUrl: 'API URL',
        difyWorkflowUrl: 'Dify Workflow URL',
        difyUrlPlaceholder: 'https://api.dify.ai/v1/workflows/run',
        extraParameters: 'Дополнительные параметры',
        extraParametersNote: 'Эти параметры будут добавлены к данным запроса',
        parameterKey: 'Ключ',
        parameterValue: 'Значение',
        addParameter: 'Добавить параметр',
        openDifyUrl: 'Открыть Dify URL',
        extractToTextWorkflow: 'Извлечь в текстовый Workflow',
        extractConfirmTitle: 'Создать текстовый Workflow',
        extractConfirmMessage: 'Создать новый текстовый Workflow, используя этот URL улучшения как основной endpoint?',
        extracting: 'Создание...',
        extractSuccess: 'Текстовый Workflow успешно создан',
        extractError: 'Не удалось создать текстовый Workflow',
        extractWorkflowSuffix: 'Улучшение промпта',
        extractMainUrlDescription: 'Основной URL'
      },
      search: {
        placeholder: 'Поиск по названию или описанию...',
        clear: 'Очистить',
        resultsFound: 'результатов найдено',
        noResults: 'Ничего не найдено',
        noResultsDesc: 'Не найдено рабочих процессов, соответствующих запросу "{query}"',
        clearSearch: 'Очистить поиск'
      },
      pagination: {
        showing: 'Показано',
        of: 'из',
        workflows: 'рабочих процессов',
        previous: 'Назад',
        next: 'Вперед'
      },
      tags: {
        title: 'Управление тегами',
        manageTags: 'Управление тегами',
        createTag: 'Создать тег',
        editTag: 'Редактировать тег',
        deleteTag: 'Удалить тег',
        tagNameEn: 'Название тега (English)',
        tagNameRu: 'Название тега (Русский)',
        confirmDelete: 'Удалить этот тег? Он будет убран из всех workflows.',
        noTags: 'Теги отсутствуют',
        usedByWorkflows: 'Используется в {count} workflows',
        columnTags: 'Теги',
        saveChanges: 'Сохранить изменения',
        cancel: 'Отменить',
        close: 'Закрыть',
        selectTags: 'Выберите теги',
        noTagsSelected: 'Теги не выбраны',
        tagCreated: 'Тег создан успешно',
        tagUpdated: 'Тег обновлен успешно',
        tagDeleted: 'Тег удален успешно',
        tagsAssigned: 'Теги назначены успешно',
        createNewTag: 'Создать новый тег',
        displayOrder: 'Порядок отображения'
      },
      workflowIdDesc: 'Уникальный идентификатор рабочего процесса',
      workflowIdEditDesc: 'Если не указан, будет сгенерирован автоматически',
      workflowCreated: 'Рабочий процесс успешно создан',
      workflowUpdated: 'Рабочий процесс успешно обновлен',
      workflowDeleted: 'Рабочий процесс успешно удален',
      workflowDuplicated: 'Рабочий процесс успешно дублирован',
      marginColumn: 'Маржа',
      marginUpdated: 'Маржа успешно обновлена',
      duplicateWorkflow: 'Дублировать',
      confirmDeleteWorkflow: 'Вы уверены, что хотите удалить этот рабочий процесс?',
      additional: 'Дополнительные',
      tileDisplay: {
        title: 'Настройка плитки',
        none: 'Без плитки',
        singleImage: 'Одно изображение',
        imagePair: 'Пара изображений (до/после)',
        singleVideo: 'Видео',
        uploadImage: 'Загрузить изображение',
        uploadBefore: 'Загрузить изображение "До"',
        uploadAfter: 'Загрузить изображение "После"',
        uploadVideo: 'Загрузить видео',
        comparisonMode: 'Режим сравнения',
        slider: 'Слайдер',
        autoSwitch: 'Автопереключение',
        delayMs: 'Задержка (мс)',
        uploading: 'Загрузка...',
        deleteMedia: 'Удалить',
        replaceMedia: 'Заменить',
        confirmDeleteMedia: 'Удалить это медиа?',
        fileUploaded: 'Файл загружен',
        dropFileHere: 'Отпустите файл здесь...',
        dragDrop: 'Перетащите файл сюда или нажмите для выбора',
        uploadError: 'Ошибка загрузки файла'
      },
      columns: {
        id: 'ID',
        title: 'Название',
        urls: 'URL адреса',
        description: 'Описание',
        category: 'Категория',
        availability: 'Доступность',
        created: 'Создан',
        actions: 'Действия'
      },
      exportModal: {
        title: 'Экспорт рабочих процессов',
        filterByCategory: 'Фильтр по категории',
        allCategories: 'Все категории',
        searchPlaceholder: 'Поиск...',
        selectAll: 'Выбрать все',
        deselectAll: 'Снять все',
        selectedCount: 'Выбрано: {selected} из {total}',
        exportButton: 'Экспортировать ({count})',
        exporting: 'Экспорт...',
        widgetCount: '{count} виджетов',
        urlCount: '{count} URL',
        noWorkflowsToExport: 'Нет рабочих процессов для экспорта'
      },
      importModal: {
        title: 'Импорт рабочих процессов',
        selectFile: 'Выбрать JSON файл',
        foundWorkflows: 'Найдено {count} рабочих процессов в файле',
        selectAllNew: 'Выбрать все новые ({count})',
        backToFile: 'Назад',
        alreadyExists: 'Уже существует',
        willSkip: 'Будет пропущен',
        willUpdate: 'Обновить',
        newWorkflow: 'Новый',
        importSelected: 'Импортировать выбранные ({count})',
        importing: 'Импорт...',
        newCount: '{count} новых',
        existingCount: '{count} существующих (будут пропущены)',
        updateExisting: 'Обновить существующие воркфлоу',
        updateExistingDesc: 'Заменить данные для воркфлоу, которые уже существуют'
      }
    },

    debug: {
      title: 'Инструменты отладки',
      subtitle: 'Обслуживание системы и диагностика',
      repairLinks: {
        title: 'Восстановление связей',
        description: 'Исправляет нарушенные связи категорий при изменении иерархии. Обеспечивает привязку всех промптов к действительным корневым категориям.',
        button: 'Восстановить',
        repairing: 'Восстановление...',
        result: 'Результат',
        promptsUpdated: 'Промптов обновлено',
        workflowsCleaned: 'Workflows очищено',
        errorsOccurred: 'Ошибки',
        andMore: 'и ещё',
        more: 'ещё',
        success: 'Восстановление завершено успешно'
      },
      contentMigration: {
        title: 'Миграция контента',
        description: 'Переносит изображения из внешних хранилищ (fal.media, Backblaze) на content.loremax.ai для единообразной CDN-доставки.',
        button: 'Открыть инструмент миграции',
        externalDomains: 'Внешние домены для миграции',
        modal: {
          title: 'Миграция контента',
          selectOrganization: 'Выберите организацию',
          chooseOrganization: 'Выберите организацию...',
          analyse: 'Анализировать',
          analysing: 'Анализ...',
          migrate: 'Мигрировать',
          migrating: 'Миграция...',
          completed: 'Миграция завершена',
          cancelled: 'Миграция отменена',
          completedMessage: 'Миграция завершена: {count} URL перенесено',
          currentUrl: 'Текущий',
          succeeded: 'Успешно',
          failed: 'Ошибки',
          errors: 'Ошибки',
          andMore: 'и ещё',
          more: 'ещё',
          noMigrationNeeded: 'Миграция не требуется',
          allUrlsInternal: 'Все URL уже на content.loremax.ai',
          cancel: 'Отмена',
          stop: 'Остановить',
          close: 'Закрыть',
          stats: {
            totalGenerations: 'Всего генераций',
            withExternalUrls: 'С внешними URL',
            urlsToMigrate: 'URL для миграции',
            byDomain: 'По доменам'
          }
        }
      },
      tokenAudit: {
        title: 'Аудит использования токенов',
        description: 'Сравнивает кэшированные счётчики использования организаций с фактической суммой пользовательских счётчиков для обнаружения расхождений.',
        button: 'Запустить аудит',
        running: 'Аудит...',
        columns: {
          organization: 'Организация',
          limit: 'Лимит',
          cached: 'Кэш (org_usage)',
          sumUsers: 'SUM (users)',
          drift: 'Дрифт',
          users: 'Пользователи'
        },
        noDrift: 'Расхождений не обнаружено — все счётчики синхронизированы',
        driftFound: 'Обнаружены расхождения в {count} организации(ях)',
        noOrganizations: 'Организации не найдены',
        fixButton: 'Исправить дрифт',
        fixing: 'Исправление...',
        fixResult: 'Рекончилировано {fixed}/{total} организаций'
      }
    },

    adminPrompts: {
      title: 'Управление глобальными промптами',
      globalPrompts: 'Глобальные промпты',
      createPrompt: 'Создать референс',
      editPrompt: 'Редактировать референс',
      deletePrompt: 'Удалить промпт',
      promptTitle: 'Название промпта',
      promptBody: 'Текст промпта',
      promptType: 'Тип промпта',
      promptCategory: 'Категория',
      noPromptsFound: 'Глобальные промпты не найдены',
      creatingPrompt: 'Создание...',
      createPromptButton: 'Создать референс',
      actions: 'Действия',
      created: 'Создан',
      updated: 'Обновлен',
      author: 'Автор',
      loadFromFiles: 'Загрузить из файлов',
      exportToFiles: 'Экспортировать в файлы',
      exportPrompts: 'Экспорт промптов',
      importPrompts: 'Импорт промптов',
      exporting: 'Экспорт...',
      downloadReady: 'Скачивание готово',
      selectTypeToExport: 'Выберите тип для экспорта',
      exportPreview: 'Предварительный просмотр экспорта',
      noPromptsToExport: 'Нет промптов для экспорта',
      preparingExport: 'Подготовка экспорта...',
      downloadStarted: 'Скачивание начато',
      exportFailed: 'Ошибка экспорта',
      exportSuccess: 'Экспорт завершен успешно',
      cancel: 'Отмена',
      upload: 'Загрузить',
      download: 'Скачать',
      uploadFiles: 'Загрузить JSON файлы',
      loadPrompts: 'Загрузить промпты',
      dragDropFiles: 'Перетащите JSON файлы сюда или нажмите для выбора',
      dropFiles: 'Отпустите файлы здесь...',
      supportedFormats: 'Поддерживаемые форматы: .json',
      uploadedFiles: 'Загруженные файлы',
      searchPlaceholder: 'Поиск промптов...',
      noSearchResults: 'Промпты не найдены по вашему запросу',
      promptTypeStyle: 'Стили',
      promptTypeBasic: 'Базовые',
      promptTypeWorkflow: 'Рабочие процессы',
      enabled: 'Включен',
      disabled: 'Отключен',
      promptEnabled: 'Промпт включен',
      promptDisabled: 'Промпт отключен',
      promptTypeUpdated: 'Тип промпта обновлен на',
      updateError: 'Ошибка обновления промпта',
      exportInfo: 'Информация об экспорте',
      exportDescription: 'Промпты будут экспортированы как отдельные JSON файлы, упакованные в ZIP архив. Формат совместим с функцией "Загрузить из файлов".',
      loading: 'Загрузка...'
    },

    // API Error messages (Fal.AI and other providers)
    apiErrors: {
      providerUnavailable: 'Провайдер API временно недоступен. Попробуйте позже.',
      generationTimeout: 'Превышено время ожидания генерации. Попробуйте ещё раз.',
      contentPolicy: 'Контент нарушает правила использования сервиса.',
      imageTooSmall: 'Изображение слишком маленькое. Используйте изображение большего размера.',
      imageTooLarge: 'Изображение слишком большое. Уменьшите размер и попробуйте снова.',
      imageLoad: 'Не удалось загрузить изображение. Проверьте файл и попробуйте снова.',
      faceNotDetected: 'Лицо не обнаружено на изображении.',
      unsupportedFormat: 'Неподдерживаемый формат файла.',
      fileTooLarge: 'Файл слишком большой. Уменьшите размер и попробуйте снова.',
      internalServer: 'Внутренняя ошибка сервера. Попробуйте позже.',
      contentPolicyNoRefund: 'Нарушение политики контента может привести к невозврату токенов, в зависимости от настроек воркфлоу.',
      contentPolicyNoRefundConfirmed: 'Обнаружено нарушение политики контента. Токены за эту генерацию не были возвращены.',
    },

    // Landing page
    landing: {
      tagline: 'Мультимодальная AI-платформа',
      openApp: 'Открыть приложение',
      createNow: 'Создать сейчас',
      hero: {
        title: 'Создавайте изображения, видео и многое другое с помощью AI',
        subtitle: 'Профессиональная мультимодальная AI-платформа на основе ведущих моделей: Видео (Veo, Sora, Kling), Изображения (FLUX, Imagen4, WAN) и специализированные инструменты редактирования',
        cta: 'Начать создавать сейчас',
        learn: 'Узнать больше'
      },
      stats: {
        images: 'Изображений создано',
        users: 'Активных пользователей',
        uptime: 'Время работы',
        support: 'Поддержка'
      },
      features: {
        title: 'Мощные возможности',
        subtitle: 'Всё что нужно для создания профессиональных ИИ-изображений',
        generation: {
          title: 'ИИ-генерация изображений',
          description: 'Создавайте потрясающие изображения с помощью передовых технологий Flux AI'
        },
        prompts: {
          title: 'Умные промпты',
          description: 'Улучшенные промпты с ИИ Google Gemini для лучших результатов'
        },
        gallery: {
          title: 'Организованная галерея',
          description: 'Управляйте и организуйте свои творения в профессиональной галерее'
        },
        organizations: {
          title: 'Командная работа',
          description: 'Работайте с командой и эффективно управляйте лимитами использования'
        }
      },
      cta: {
        title: 'Готовы начать создавать?',
        subtitle: 'Присоединяйтесь к тысячам творцов, использующих нашу ИИ-платформу для воплощения идей в жизнь',
        button: 'Начать бесплатно'
      },
      footer: {
        rights: 'Все права защищены.',
        terms: 'Общие условия',
        privacy: 'Политика конфиденциальности'
      }
    },

    // Top-level sections for navigation errors
    workflows: {
      title: 'Процессы',
      noWorkflows: 'Нет процессов'
    },
    
    users: {
      title: 'Пользователи',
      noUsers: 'Нет пользователей'
    },

    gallery: {
      displayOptions: 'Настройки отображения',
      zoomSmall: 'Мелко',
      zoomMediumSmall: 'Средне-',
      zoomMedium: 'Средне',
      zoomMediumLarge: 'Средне+',
      zoomLarge: 'Крупно',
      viewMode: 'Режим просмотра',
      gridView: 'Сетка',
      listView: 'Список',
      zoom: 'Масштаб',
      settingsInfo: 'Настройки сохраняются автоматически',
      gridDescription: 'Сетка показывает изображения в адаптивной сетке',
      listDescription: 'Список показывает изображения в компактном формате списка',
      // Error handling
      error: 'Ошибка',
      viewError: 'Показать ошибку',
      viewErrorDetails: 'Посмотреть детали ошибки',
      errorDetails: 'Детали ошибки',
      notRefunded: 'Не возвращено',
      errorMessage: 'Сообщение об ошибке',
      apiErrorDetails: 'Детали ошибки API',
      generationInfo: 'Информация о генерации',
      generationId: 'ID',
      timestamp: 'Время',
      prompt: 'Промпт',
      noPrompt: 'Нет промпта',
      copyError: 'Копировать ошибку',
      copiedError: 'Скопировано!',
      close: 'Закрыть',
      unknownError: 'Произошла неизвестная ошибка',
      expand: 'Развернуть',
      collapse: 'Свернуть',
      // Admin tracing tabs in ErrorDetailsModal
      errorTab: 'Ошибка',
      tracingTab: 'Трассировка',
      rawInputTab: 'Входные данные',
      rawResponseTab: 'Ответ API',
      loadingTrace: 'Загрузка трассировки...',
      noTraceData: 'Нет данных трассировки',
      addFavorite: 'Добавить в избранное',
      removeFavorite: 'Убрать из избранного',
      // Trash functionality
      trash: 'Корзина',
      trashAutoHide: 'Элементы будут удалены через 30 дней',
      viewTrash: 'Просмотр удалённых элементов',
      viewingTrash: 'Просмотр корзины',
      moveToTrash: 'В корзину',
      restore: 'Восстановить',
      select: 'Выбрать',
      selectMode: 'Режим выбора',
      selected: 'Выбрано',
      selectAll: 'Выбрать все',
      deselectAll: 'Снять выбор',
      confirmTrashTitle: 'Переместить в корзину?',
      confirmTrashMessage: 'Выбранные элементы будут перемещены в корзину.',
      confirmTrashSingleMessage: 'Этот элемент будет перемещён в корзину.',
      confirmTrashCount: 'Выбрано элементов: {count}',
      confirmTrashNote: 'Элементы будут удалены через 30 дней.',
      dontShowAgain: 'Больше не показывать',
      addToCollection: 'В коллекцию',
      removeFromCollection: 'Убрать из коллекции',
      addToCollectionMenu: 'Добавить в коллекцию...',
      removeFrom: 'Убрать из:',
      collectionActions: 'Коллекции',
      // Recreate functionality
      recreate: 'Повторить генерацию',
      workflowUnavailable: 'Воркфлоу недоступен или был удалён',
      copyPrompt: 'Копировать промпт',
      promptCopied: 'Скопировано!',
      download: 'Скачать',
      downloaded: 'Скачано!',
      downloadOriginal: 'Скачать оригинал',
      downloadWebP: 'Скачать WebP',
      downloadedWebP: 'Скачано WebP!',
      mark: {
        like: 'Удачный',
        dislike: 'Неудачный',
        approved: 'Одобрено',
      },
      markFailed: 'Не удалось обновить отметку',
    },

    // Auth section
    auth: {
      signIn: 'Войти',
      signUp: 'Регистрация',
      getStarted: 'Начать',
      required: 'Требуется авторизация',
      loginRequired: 'Необходимо войти в систему',
      loginInstructions: 'Пожалуйста, войдите в систему для доступа к платформе',
      loginToAccess: 'Войдите для доступа'
    },

    // Terms page
    terms: {
      title: 'Общие условия',
      loading: 'Загрузка...',
      loadError: 'Не удалось загрузить документ',
      backToHome: 'Вернуться на главную'
    },

    // Privacy Notice page
    privacy: {
      title: 'Политика конфиденциальности',
      loading: 'Загрузка...',
      loadError: 'Не удалось загрузить документ',
      backToHome: 'Вернуться на главную'
    },

    // Pricing page
    pricing: {
      title: 'Тарифы',
      tagline: 'Простая токен-система для AI-творцов',
      backToHome: 'На главную',
      contactSales: 'Связаться с отделом продаж',
      hero: {
        title: 'Гибкие тарифы для всех творцов',
        subtitle: 'Оплата за использование. Без планов. Без ограничений.',
        description: 'Единый баланс для всех моделей изображений, 3D и видео. Все функции включены. Неограниченное количество пользователей. Полные коммерческие права.',
        tokenPrice: 'Цена токена',
        tokenValue: '1 токен = $0.001',
        estimatedImages: '≈ 30–60 изображений за $1'
      },
      features: {
        title: 'Всё включено. Без блокировок.',
        subtitle: 'Все функции доступны каждому пользователю — вы платите только за то, что создаёте.',
        allModels: 'Доступ ко всем моделям Image, 3D и Video AI',
        allModelsDesc: 'Используйте любые доступные модели',
        commercial: 'Коммерческая лицензия для всех пользователей',
        commercialDesc: 'Используйте созданный контент в коммерческих целях',
        unlimited: 'Неограниченное количество участников и проектов',
        unlimitedDesc: 'Добавляйте сколько угодно пользователей',
        customTraining: 'Кастомное обучение AI для студий (по запросу)',
        customTrainingDesc: 'Обучение моделей на ваших данных',
        workspace: 'Безопасные рабочие пространства и Google SSO',
        workspaceDesc: 'Корпоративная авторизация и безопасность',
        support: 'Поддержка по email (Standard SLA)',
        supportDesc: 'Техническая поддержка по электронной почте'
      },
      tokenPacks: {
        title: 'Купить токены',
        tokenPrice: '1 токен = $0.001',
        neverExpire: 'Токены никогда не истекают',
        description: 'Купите один раз и используйте в любое время. Без ограничений, без срока действия.',
        estimatedImages: 'изображений',
        mostPopular: 'Самый популярный',
        contactForMore: 'Нужно больше? Свяжитесь с отделом продаж для оптовых закупок'
      },
      subscription: {
        title: 'Подписка: Создавайте больше за те же деньги',
        subtitle: 'Получите до 30% скидки на каждый токен с подпиской LoreMax',
        monthly: {
          title: 'Месячный план',
          subtitle: 'Идеально для регулярных творцов',
          price: 'от $29',
          period: '/месяц',
          discount: '10% скидка на все токены',
          description: 'Подпишитесь на $29, $100, $300/мес или любую сумму — вы выбираете!'
        },
        annual: {
          title: 'Годовой план',
          subtitle: 'Максимальная экономия для преданных творцов',
          price: 'от $290',
          period: '/год',
          discount: '30% скидка на все токены',
          description: 'Подпишитесь на $290, $1,200, $3,600/год или любую сумму — вы выбираете!',
          badge: 'Лучшее предложение'
        },
        example: 'Пример:',
        exampleText: 'Если вы тратите $500 на токены каждый месяц, годовая подписка экономит вам $150/мес — это $1,800 в год (30% скидка).',
        startSubscription: 'Начать подписку →',
        howItWorks: 'Как это работает:',
        howItWorksText: 'Скидка по подписке применяется автоматически ко всем токенам, включенным в размер вашей подписки. Дополнительные разовые покупки токенов не получают скидку.',
        calculator: {
          title: 'Калькулятор экономии',
          monthlySpend: 'Ваш месячный расход на токены: $',
          monthlySavings: 'Месячная экономия (с годовой подпиской):',
          yearlySavings: 'Годовая экономия (с годовой подпиской):',
          spendInTokens: 'Месячный расход в токенах:'
        }
      },
      enterprise: {
        badge: 'От $2,500/месяц или индивидуальный договор',
        title: 'Корпоративные решения и студийные партнёры',
        subtitle: 'Для команд, управляющих высоконагруженными процессами и кастомными AI-настройками.',
        talkToSales: 'Связаться с отделом продаж →',
        features: {
          api: 'Доступ к API и скидки на объём',
          invoicing: 'Гибкая система счетов и заказов',
          workspace: 'Расширенное управление рабочими пространствами и пользователями',
          slack: 'Выделенная поддержка в Slack с SLA',
          customModels: 'Кастомное обучение моделей и оптимизация процессов',
          earlyAccess: 'Ранний доступ к новым функциям'
        }
      },
      faq: {
        title: 'Частые вопросы',
        subtitle: 'Всё, что вам нужно знать о ценах LoreMax',
        questions: {
          howPricing: {
            q: 'Как работает ценообразование на LoreMax?',
            a: 'LoreMax делает ценообразование простым — никаких лицензий на места, никаких заблокированных функций. Всё работает на прозрачной системе оплаты по мере использования, основанной на токенах. Каждая генерация — будь то изображение, видео, 3D-сцена или аудио — потребляет определённое количество токенов. Вы платите только за то, что создаёте. Опциональные месячные или годовые подписки предоставляют более низкие ставки на токены и большую гибкость.'
          },
          runOut: {
            q: 'Что произойдет, если у меня закончатся токены?',
            a: 'Вы можете пополнить баланс в любое время. Купите разовые пакеты токенов или активируйте (или увеличьте) подписку, чтобы автоматически получать токены со скидкой. Токены по подписке обновляются в начале каждого платёжного цикла для активных подписчиков.'
          },
          members: {
            q: 'Сколько участников может присоединиться к моему рабочему пространству?',
            a: 'Неограниченно. Приглашайте столько членов команды, сколько хотите — дизайнеров, продюсеров или сотрудников. Все участники используют один и тот же баланс токенов внутри организации, и вы платите только за то, что создаёт ваша команда. Ограничения на количество пользователей и разрешения могут быть настроены в корпоративном плане.'
          },
          cancel: {
            q: 'Могу ли я продолжать использовать LoreMax после отмены подписки?',
            a: 'Да. Весь ваш созданный контент и данные учётной записи остаются доступными. Вам нужны только токены на балансе, чтобы продолжать создавать новые активы. Ваши данные остаются доступными в соответствии со стандартной политикой хранения данных LoreMax.'
          },
          expire: {
            q: 'Истекают ли токены?',
            a: 'Разовые купленные токены никогда не истекают и остаются действительными до тех пор, пока не будут использованы. Токены по подписке обновляются автоматически в начале каждого платёжного цикла. Создавайте, когда хотите — без дедлайнов, без давления.'
          },
          commercial: {
            q: 'Могу ли я использовать созданный контент в коммерческих целях?',
            a: 'Да — все пользователи получают полную коммерческую лицензию на всё, что создано из публичных базовых моделей. Для моделей, обученных на заказ, вы несёте ответственность за то, чтобы иметь права на ваши обучающие данные. Используйте свои творения свободно в играх, приложениях, трейлерах, маркетинговых кампаниях и многом другом.'
          },
          invoice: {
            q: 'Могу ли я оплачивать по счёту или заказу на покупку?',
            a: 'Да. Корпоративные клиенты могут оплачивать по счёту, заказу на покупку или другими согласованными способами. Свяжитесь с sales@loremax.ai для выставления счетов или вариантов оплаты.'
          },
          discount: {
            q: 'Какова скидка по подписке?',
            a: 'Подписки делают каждый токен дешевле: 10% скидка при месячной подписке, 30% скидка при годовой подписке. Без ограничений — просто более низкая стоимость за токен.'
          },
          integrate: {
            q: 'Могу ли я интегрировать LoreMax в наш рабочий процесс или API?',
            a: 'Да. Корпоративные клиенты могут получить доступ к API LoreMax и запросить интеграцию пользовательских процессов. Свяжитесь с нашим отделом продаж для получения подробностей: sales@loremax.ai'
          }
        }
      },
      footer: {
        copyright: '© 2025 LoreMax.ai - Все права защищены'
      }
    },

    // Settings Context
    settingsContext: {
      title: 'Настройки',
      subtitle: 'Настройте свой опыт',
      userSettings: 'Пользовательские настройки',
      notifications: 'Уведомления',
      notificationsDesc: 'Email и push уведомления',
      enable: 'Включить',
      system: 'Система',
      systemAdministration: 'Системное администрирование',
      sendFeedback: 'Отправить отзыв',
      sendFeedbackDesc: 'Сообщить об ошибках или предложить функции',
      logoutDesc: 'Выйти из аккаунта',
      about: 'О программе',
      version: 'Версия:',
      build: 'Сборка:',
      environment: 'Среда:',
      copyright: `© ${new Date().getFullYear()} LoreMax AI`,
      madeWith: 'Сделано с ❤️ для создателей'
    },

    // Gallery Context
    galleryContext: {
      title: 'Галерея',
      searchImages: 'Поиск контента...',
      filters: 'Фильтры',
      recent: 'Недавние',
      viewAll: 'Посмотреть все →',
      statistics: 'Статистика',
      totalImages: 'Всего изображений:',
      thisMonth: 'За этот месяц:',
      storageUsed: 'Использовано места:',
      actions: 'Действия',
      exportAll: 'Экспортировать все',
      deleteSelected: 'Удалить выбранные',
      share: 'Поделиться',
      downloadZip: 'Скачать архив',
      favorites: 'Избранное',
      emptyState: 'Создавайте контент, чтобы увидеть его здесь'
    },

    // Gallery Widget - Live Generation
    galleryWidget: {
      generationResults: 'Результаты генерации',
      noGenerations: 'Пока нет генераций',
      startGenerating: 'Начните генерировать контент, чтобы увидеть его здесь',
      clearAll: 'Очистить всё',
      addFavorite: 'Добавить в избранное',
      removeFavorite: 'Убрать из избранного',
      viewFull: 'Просмотр в полном размере',
      download: 'Скачать',
      copyPrompt: 'Копировать промпт',
      helpTitle: 'Помощь по галерее',
      helpWhatIs: 'Что такое галерея генерации?',
      helpWhatIsDesc: 'Это живая галерея генерации, которая показывает ваши ИИ-изображения в реальном времени во время текущей сессии.',
      helpSessionOnly: 'Хранение только в сессии',
      helpSessionOnlyDesc: 'Все генерации, показанные здесь, доступны только во время текущей сессии. При обновлении или перезагрузке страницы они перемещаются в вашу историю.',
      helpActions: 'Доступные действия',
      helpFavorite: 'Звезда: Добавить в избранное',
      helpDownload: 'Скачать: Сохранить изображение на устройство',
      helpCopy: 'Копировать: Скопировать промпт в буфер',
      helpPreview: 'Клик в любом месте: Просмотр в полном размере',
      // Display settings
      displayOptions: 'Настройки отображения',
      viewMode: 'Режим просмотра',
      gridView: 'Сетка',
      listView: 'Список',
      zoom: 'Масштаб',
      zoomLarge: 'Крупно',
      zoomMediumLarge: 'Средне+',
      zoomMedium: 'Средне',
      zoomMediumSmall: 'Средне-',
      zoomSmall: 'Мелко',
      settingsInfo: 'Информация',
      gridDescription: 'Сетка показывает изображения в адаптивной сетке',
      listDescription: 'Список показывает изображения в компактном формате списка'
    },

    // Session Gallery Widget - for image generation page
    sessionGallery: {
      title: 'Галерея сессии',
      helpTitle: 'Помощь по галерее сессии',
      helpWhatIs: 'Что такое галерея сессии?',
      helpWhatIsDesc: 'Это живая галерея, которая показывает ваши ИИ-изображения в реальном времени во время текущей сессии генерации.',
      helpSessionOnly: 'Хранение только в сессии',
      helpSessionOnlyDesc: 'Все генерации, показанные здесь, доступны только во время текущей сессии. При обновлении или перезагрузке страницы они перемещаются в вашу историю.',
      helpActions: 'Доступные действия',
      helpFavorite: 'Звезда: Добавить в избранное',
      helpDownload: 'Скачать: Сохранить изображение на устройство',
      helpCopy: 'Копировать: Скопировать промпт в буфер',
      helpPreview: 'Клик в любом месте: Просмотр изображения в полном размере',
      previousGeneration: 'Предыдущая генерация (↑)',
      nextGeneration: 'Следующая генерация (↓)'
    },

    // Gallery Page - Comprehensive Content Gallery
    galleryPage: {
      title: 'Галерея контента',
      subtitle: 'Просматривайте и управляйте всем сгенерированным контентом',
      searchPlaceholder: 'Поиск по промптам и описаниям...',
      filters: 'Фильтры',
      clearFilters: 'Очистить фильтры',
      activeFilters: 'Активные фильтры:',
      clearAllFilters: 'Очистить все фильтры',
      showFilters: 'Показать фильтры',
      hideFilters: 'Скрыть фильтры',
      collections: 'Коллекции',
      allCollections: 'Все коллекции',
      users: 'Пользователи',
      allUsers: 'Все пользователи',
      workflows: 'Рабочие процессы',
      allWorkflows: 'Все процессы',
      dateRange: 'Период',
      dateFrom: 'С',
      dateTo: 'По',
      urlType: 'Тип изображения',
      allTypes: 'Все типы',
      preview: 'Превью',
      original: 'Оригинал',
      external: 'Внешний',
      mixed: 'Смешанный',
      displaySettings: 'Настройки отображения',
      viewMode: 'Режим просмотра',
      gridView: 'Сетка',
      listView: 'Список',
      zoom: 'Масштаб',
      zoomSmall: 'Мелко',
      zoomMediumSmall: 'Средне-',
      zoomMedium: 'Средне',
      zoomMediumLarge: 'Средне+',
      zoomLarge: 'Крупно',
      loading: 'Загрузка...',
      loadingMore: 'Загрузка еще...',
      noResults: 'Ничего не найдено',
      noResultsDesc: 'Попробуйте изменить параметры поиска или фильтры',
      totalImages: 'Всего изображений',
      selectedImages: 'Выбрано изображений',
      selectAll: 'Выбрать все',
      deselectAll: 'Снять выделение',
      bulkActions: 'Массовые действия',
      downloadSelected: 'Скачать выбранные',
      deleteSelected: 'Удалить выбранные',
      addToCollection: 'Добавить в коллекцию',
      removeFromCollection: 'Удалить из коллекции',
      imageDetails: 'Детали изображения',
      prompt: 'Промпт',
      createdAt: 'Создано',
      createdBy: 'Автор',
      workflow: 'Процесс',
      collection: 'Коллекция',
      dimensions: 'Размеры',
      fileSize: 'Размер файла',
      generationId: 'ID генерации',
      copyId: 'Копировать ID',
      noAccess: 'Нет доступа',
      noAccessDesc: 'У вас нет доступа к галерее контента',
      errorLoading: 'Ошибка загрузки',
      errorLoadingDesc: 'Не удалось загрузить контент. Попробуйте обновить страницу.',
      retry: 'Повторить',
      selectCollections: 'Поиск коллекций...',
      searchCollections: 'Поиск коллекций...',
      selectUsers: 'Выберите пользователей...',
      searchUsers: 'Поиск пользователей...',
      noUsersFound: 'Пользователи не найдены',
      selectWorkflows: 'Выберите процессы...',
      searchWorkflows: 'Поиск процессов...',
      filtersAvailableInGallery: 'Фильтры доступны в галерее',
      filterSelected: 'Выбрано',
      filterNoWorkflows: 'Нет воркфлоу',
      filterNoUsers: 'Нет пользователей',
      audioLabel: 'Аудио',
      contentType: 'Тип контента',
      allMedia: 'Все',
      images: 'Изображения',
      videos: 'Видео',
      audio: 'Аудио',
      threeD: '3D модели',
      textType: 'Текст',
      selectContentTypes: 'Выберите типы контента...',
      searchContentTypes: 'Поиск типов контента...',
      noContentTypesFound: 'Типы контента не найдены',
      approveState: 'Статус оценки',
      selectApproveState: 'Выберите статус оценки...',
      searchApproveState: 'Поиск статуса оценки...',
      noApproveStateFound: 'Статусы оценки не найдены',
      // Prompt V2 display in preview modal
      selectedReferences: 'Выбранные референсы',
      noReferences: 'Нет референсов',
      references: 'Референсы',
      referenceImages: 'Референсные изображения',
      holdToZoom: 'Удерживайте для увеличения',
      downloadFailed: 'Все загрузки завершились с ошибкой',
      downloadPartialFail: '{count} файл(ов) не удалось скачать',
      generationParams: 'Параметры генерации',
      booleanYes: 'Да',
      booleanNo: 'Нет'
    },

    // Prompt Editor Widget
    promptEditor: {
      helpTitle: 'Помощь по редактору промптов',
      helpWhatIs: 'Что такое редактор промптов?',
      helpWhatIsDesc: 'Редактор промптов — это ваш основной инструмент для создания и редактирования текстовых описаний изображений, которые вы хотите сгенерировать с помощью ИИ.',
      helpHowToUse: 'Как использовать',
      helpHowToUseDesc: 'Напишите подробное описание изображения, которое хотите создать. Будьте конкретны в:',
      helpSubject: 'Объект (человек, предмет, сцена)',
      helpStyle: 'Стиль искусства (реалистичный, мультяшный, живопись)',
      helpColors: 'Цвета и освещение',
      helpComposition: 'Композиция и детали',
      helpTips: 'Советы для лучших результатов',
      helpTip1: 'Используйте конкретные, описательные слова',
      helpTip2: 'Разделяйте идеи запятыми',
      helpTip3: 'Начинайте с главного объекта',
      helpTip4: 'Добавляйте ключевые слова стиля для лучшей эстетики'
    },

    // Modal
    modal: {
      close: 'Закрыть'
    },

    // Help Context
    helpContext: {
      title: 'Справка и поддержка',
      subtitle: 'Полезные ссылки и контакты',
      linksTitle: 'Важные ссылки',
      termsOfService: 'Общие условия',
      privacyNotice: 'Политика конфиденциальности',
      supportEmail: 'Написать на почту поддержки',
      supportEmailAddress: 'support@loremax.ai',
      mainTitle: 'Добро пожаловать в раздел помощи',
      mainDescription: 'Здесь вы найдете полезные ссылки и контактную информацию. Используйте боковую панель для доступа к важным документам и связи с поддержкой.',
      documentation: 'Документация',
      mcpIntegration: 'MCP интеграция'
    },

    // MCP Documentation Page
    mcpDocs: {
      title: 'MCP интеграция',
      backToHelp: 'Назад к справке',
      loading: 'Загрузка...',
      loadError: 'Не удалось загрузить документ',
      forLlm: 'For LLM'
    },

    // Video Context
    videoContext: {
      title: 'Генерация видео',
      comingSoon: 'Скоро...'
    },
    // Icon Bar
    iconBar: {
      home: 'Главная',
      profile: 'Профиль',
      image: 'Изображ.',
      multi: 'Мульти',
      gallery: 'Галерея',
      video: 'Видео',
      audio: 'Аудио',
      text: 'Текст',
      threeD: '3D',
      settings: 'Настройки',
      help: 'Помощь',
      collapse: 'Свернуть',
      expand: 'Развер.',
      admin: 'Админ'
    },

    // Multi (parallel multi-model generation)
    multiGen: {
      title: 'Мульти-генерация',
      subtitle: 'Выберите несколько моделей и сгенерируйте во всех сразу',
      models: 'Модели',
      taskType: 'Тип задачи',
      noModelsForTab: 'Нет моделей для этого типа задачи',
      noTabs: 'Нет доступных моделей для «Мульти». Отметьте тип задачи у моделей в админке.',
      settings: 'Настройки',
      settingsFlyoutTitle: 'Настройки модели',
      settingsFlyoutClose: 'Закрыть настройки модели',
      generate: 'Сгенерировать',
      generateCount: 'Сгенерировать ({count})',
      generating: 'Генерация…',
      results: 'Результаты',
      totalCost: 'Итого',
      noModelsSelected: 'Выберите хотя бы одну модель',
      sharedInput: 'Общий ввод',
      noModelSettings: 'Нет настраиваемых параметров',
      unsupportedModel: 'Эта модель требует входных данных, которых нет в «Мульти» — запустите её на своей странице',
      multiSlotModel: 'Этой модели нужно несколько исходных медиа — запустите её на своей странице',
      multiViewAllPerRequestModel: 'Для этой модели выбрана обработка по одному файлу — для «Мульти-фото → 3D» включите все файлы в одном запросе',
      requiredViewMissing: 'Этой модели нужен незаполненный ракурс',
      modelInvalid: 'Исправьте настройки модели',
      sourceImageRequired: 'Добавьте исходное изображение',
      sourceVideoRequired: 'Добавьте исходное видео',
      secondViewRequired: 'Загрузите минимум два ракурса (Front и ещё один)',
      sharedInputInvalid: 'Заполните обязательные поля общего ввода',
      settingsLoading: 'Настройки моделей ещё загружаются — повторите через секунду',
      prompt: 'Промпт',
      settingsLoadFailed: 'Не удалось загрузить настройки некоторых моделей — раскройте их и нажмите «Повторить»',
      allModelsInvalid: 'У всех выбранных моделей есть ошибки в настройках — исправьте их и повторите',
      someModelsSkipped: 'Пропущено моделей из-за ошибок в настройках: {count}',
      launchFailed: 'Не удалось запустить генерацию — попробуйте ещё раз',
      loadError: 'Не удалось загрузить список моделей',
      retry: 'Повторить',
      pendingEstimates: '+{count} без оценки',
      tabs: {
        text2image: 'Текст → изображение',
        image2image: 'Изображение → изображение',
        text2video: 'Текст → видео',
        image2video: 'Изображение → видео',
        video2video: 'Видео → видео',
        text2_3d: 'Текст → 3D',
        image2_3d: 'Изображение → 3D',
        multiimage2_3d: 'Мульти-фото → 3D'
      }
    },

    // Organization Context
    organizationContext: {
      profile: 'Профиль'
    },

    // Admin Context
    adminContext: {
      title: 'Админ панель',
      subtitle: 'Системное администрирование',
      dashboard: 'Панель управления',
      dashboardDesc: 'Обзор системы и статистика',
      users: 'Пользователи',
      usersDesc: 'Управление администраторами системы',
      organizations: 'Организации',
      organizationsDesc: 'Управление организациями и лимитами',
      prompts: 'Глобальные промпты',
      promptsDesc: 'Управление системными промптами',
      'prompts-v2': 'Референсы',
      'prompts-v2Desc': 'Управление референсами с категориями',
      'prompt-categories': 'Категории референсов',
      'prompt-categoriesDesc': 'Управление категориями и подкатегориями референсов',
      widgets: 'Виджеты',
      widgetsDesc: 'Управление типами виджетов и настройками',
      workflows: 'Рабочие процессы',
      workflowsDesc: 'Управление процессами генерации ИИ',
      debug: 'Инструменты отладки',
      debugDesc: 'Обслуживание системы и диагностика',
      billing: 'Биллинг',
      billingDesc: 'Просмотр платежей',
      packages: 'Пакеты токенов',
      packagesDesc: 'Управление пакетами токенов',
      refunds: 'Все возвраты',
      refundsDesc: 'Мониторинг возвратов токенов по всем организациям',
      'api-keys': 'Сервисные ключи',
      'api-keysDesc': 'Сервисные API-ключи для машинного доступа',
      quickStats: 'Быстрая статистика',
      administration: 'Администрирование',
      systemStatus: 'Состояние системы',
      operational: 'Работает',
      connected: 'Подключено',
      available: 'Доступно',
      active: 'Активно',
      accessDenied: 'Доступ запрещен',
      accessDeniedDesc: 'У вас нет прав администратора'
    },

    // OpenAPI Modal
    openApiModal: {
      title: 'API Документация',
      copy: 'Копировать',
      copied: 'Скопировано!',
      close: 'Закрыть'
    },

    // cURL Examples Modal
    curlExamplesModal: {
      title: 'Примеры cURL',
      executeTitle: 'Запуск Workflow',
      executeDescription: 'Запуск новой генерации с этим workflow',
      checkTitle: 'Проверка статуса генерации',
      checkDescription: 'Опрос статуса асинхронной генерации',
      request: 'Запрос',
      copy: 'Копировать',
      copied: 'Скопировано!',
      copyAll: 'Копировать всё',
      copiedAll: 'Скопировано!',
      successResponse: 'Успешный ответ',
      inProgressResponse: 'В процессе',
      errorResponse: 'Ответ с ошибкой',
      close: 'Закрыть',
      loading: 'Загрузка схемы...',
      availableParams: 'Доступные параметры',
      availableParamsDesc: 'Параметры, принимаемые этим workflow',
      parameters: 'Параметры',
      fileUploadNote: 'Примечание: Этот workflow поддерживает загрузку файлов через multipart/form-data',
      mediaInputs: 'Медиа входы (URLs)',
      rateLimiting: 'Лимиты запросов',
      rateLimitingDesc: 'API запросы ограничены по частоте для каждого API ключа',
      rateLimitNote: 'Лимиты настраиваются для каждого API ключа. Все успешные ответы включают заголовки с информацией о лимитах, кроме проверок статуса (/generations/:id/check), которые не ограничиваются:',
      rateLimitExceeded: 'При превышении лимита вы получите ответ 429 с заголовком Retry-After, указывающим время ожидания в секундах.',
      pipelineBadge: 'Pipeline — API v2',
      pipelineNote: 'Этот workflow использует многошаговый pipeline и требует API v2 эндпоинты.'
    },

    // PromptV2 System
    promptsV2: {
      title: 'Референсы',
      subtitle: 'Управление референсами для виджета Prompt Editor',
      createNew: 'Создать промпт',
      createPrivate: 'Создать личный промпт',
      editPrompt: 'Редактировать промпт',
      deletePrompt: 'Удалить промпт',
      deleteConfirm: 'Вы уверены, что хотите удалить этот промпт?',
      deleteAll: 'Удалить все',
      deleteAllTitle: 'Удалить все промпты?',
      confirmDeleteAll: 'Это действие удалит ВСЕ промпты и не может быть отменено. Введите "delete" для подтверждения:',
      allPromptsDeleted: 'Все промпты удалены',
      noPrompts: 'Промпты не найдены',
      searchPlaceholder: 'Поиск по заголовку или содержимому...',

      visibility: {
        label: 'Видимость',
        public: 'Публичный',
        corporate: 'Организации',
        private: 'Личный',
        publicDesc: 'Доступен всем пользователям системы',
        corporateDesc: 'Доступен только пользователям вашей организации',
        privateDesc: 'Доступен только вам'
      },

      nsfw: {
        label: 'NSFW контент',
        description: 'Отметить этот промпт как содержащий контент для взрослых. Виден только организациям с включенным NSFW.',
        warning: 'Этот промпт будет виден только организациям с включенным NSFW контентом.'
      },

      filters: {
        all: 'Все',
        public: 'Публичные',
        corporate: 'Организации',
        private: 'Личные',
        category: 'Категория',
        subcategory: 'Подкатегория',
        selectCategory: 'Выберите категорию',
        selectSubcategory: 'Выберите подкатегорию',
        nsfwAll: 'Весь контент',
        nsfwSafe: 'Только безопасный',
        nsfwOnly: 'Только NSFW'
      },

      form: {
        title: 'Заголовок',
        titlePlaceholder: 'Введите заголовок промпта',
        titleTranslations: 'Переводы заголовка',
        description: 'Описание',
        descriptionPlaceholder: 'Введите описание промпта...',
        descriptionTranslations: 'Переводы описания',
        body: 'Содержимое',
        bodyPlaceholder: 'Введите текст промпта',
        bodyOptional: 'Содержимое (опционально)',
        bodyOptionalPlaceholder: 'Введите дополнительный текст промпта...',
        imagesRequired: 'Обязательные изображения',
        imagesOptional: 'Дополнительные изображения',
        videoUrls: 'Видео URL',
        audioUrls: 'Аудио URL',
        visibility: 'Видимость',
        categories: 'Категории',
        selectCategories: 'Выберите категории',
        tileConfig: 'Настройки плитки',
        charactersMode: 'Режим персонажей',
        charactersModeDesc: 'Позволяет создавать промпты с несколькими персонажами',
        characters: 'Персонажи',
        addCharacter: 'Добавить персонажа',
        characterName: 'Имя персонажа',
        characterPrompt: 'Промпт персонажа',
        characterSubcategory: 'Подкатегория персонажа',
        removeCharacter: 'Удалить персонажа'
      },

      visualSettings: 'Визуальные настройки',
      saveFirstToUploadMedia: 'Сначала сохраните промпт, чтобы загрузить медиа',

      tileConfig: {
        displayType: 'Тип отображения',
        none: 'Без плитки',
        singleImage: 'Одно изображение',
        imagePair: 'Пара изображений (до/после)',
        singleVideo: 'Видео',
        singleAudio: 'Аудио',
        slideshow: 'Слайдшоу (до 5 изображений)',

        uploadImage: 'Загрузить изображение',
        uploadBefore: 'Загрузить изображение "До"',
        uploadAfter: 'Загрузить изображение "После"',
        uploadVideo: 'Загрузить видео',
        uploadAudio: 'Загрузить аудио',
        slideshowImage: 'Изображение',

        comparisonMode: 'Режим сравнения',
        slider: 'Слайдер',
        autoSwitch: 'Авто-переключение',
        autoSwitchDelay: 'Задержка авто-переключения (мс)',

        slideshowTransition: 'Эффект перехода',
        instant: 'Мгновенно',
        fade: 'Затухание',
        slide: 'Слайд',
        slideshowDelay: 'Задержка между слайдами (секунды)',

        uploading: 'Загрузка...',
        deleteMedia: 'Удалить',
        replaceMedia: 'Заменить',
        confirmDeleteMedia: 'Удалить это медиа?',
        fileUploaded: 'Файл загружен',
        dropFileHere: 'Перетащите файл сюда...',
        dragDrop: 'Перетащите файл сюда или нажмите для выбора',
        uploadError: 'Ошибка загрузки файла'
      },

      // Messages as top-level properties
      created: 'Промпт успешно создан',
      updated: 'Промпт успешно обновлен',
      deleted: 'Промпт успешно удален',
      error: 'Ошибка при выполнении операции',
      loadError: 'Не удалось загрузить промпты',
      favoriteAdded: 'Добавлено в избранное',
      favoriteRemoved: 'Удалено из избранного',

      // Import/Export
      importExport: {
        export: 'Экспорт',
        exportAll: 'Экспортировать все',
        exportOptions: 'Параметры экспорта',
        includeIds: 'Включить ID промптов',
        includeIdsDesc: 'Включить ID базы данных для маппинга по ID при импорте. При импорте промпты будут обновляться по ID вместо заголовка.',
        import: 'Импорт',
        importing: 'Импортирую...',
        importPrompts: 'Импорт промптов',
        selectFile: 'Выберите файл',
        chooseFile: 'Выбрать файл...',
        fileLoaded: 'Файл загружен',
        readyToImport: 'Готово к импорту из',
        invalidFormat: 'Неверный формат файла',
        invalidJson: 'Неверный JSON файл',
        missingPrompts: 'Отсутствует массив prompts',
        updateMode: 'Режим обновления',
        updateExisting: 'Обновить существующие',
        updateExistingDesc: 'Если найден промпт с таким же заголовком - обновить данные',
        skipExisting: 'Пропустить существующие',
        skipExistingDesc: 'Если найдено совпадение - пропустить, импортировать только новые',
        importSuccess: 'Импорт завершён',
        importedCount: 'Создано',
        updatedCount: 'Обновлено',
        skippedCount: 'Пропущено',
        exportSuccess: 'Экспорт завершён',
        categoryNotFound: 'Категория не найдена',
        importResults: 'Результаты импорта',
        errors: 'Ошибки',
        warnings: 'Предупреждения',
        noChanges: 'Нет изменений',
        importedItems: 'Добавленные промпты',
        updatedItems: 'Обновлённые промпты',
        skippedItems: 'Пропущенные промпты'
      },
      sidebar: {
        general: 'Основное',
        content: 'Содержимое',
        contentOptional: 'Опционально',
        images: 'Изображения',
        media: 'Медиа',
        categories: 'Категории',
        visual: 'Визуальные'
      }
    },

    promptCategories: {
      title: 'Категории референсов',
      subtitle: 'Управление категориями и подкатегориями для референсов',
      categories: 'Категории',
      subcategories: 'Подкатегории',
      createCategory: 'Создать категорию',
      createSubcategory: 'Создать подкатегорию',
      createSubSubcategory: 'Создать под-подкатегорию',
      editCategory: 'Редактировать категорию',
      editSubcategory: 'Редактировать подкатегорию',
      deleteCategory: 'Удалить категорию',
      deleteSubcategory: 'Удалить подкатегорию',
      confirmDelete: 'Вы уверены, что хотите удалить',
      deleteAll: 'Удалить все',
      deleteAllTitle: 'Удалить все категории?',
      confirmDeleteAll: 'Это действие удалит ВСЕ категории и не может быть отменено. Введите "delete" для подтверждения:',
      allCategoriesDeleted: 'Все категории удалены',
      noCategories: 'Категории не найдены',
      noSubcategories: 'Подкатегории не найдены',
      rootCategory: 'Корневая категория (без родителя)',
      parentCategoryHint: 'Выберите родителя для создания подкатегории (макс. 3 уровня)',
      maxDepthReached: 'Достигнута максимальная глубина вложенности',
      repairAssignments: 'Починить связи',
      repairAssignmentsDescription: 'Обновить связи промптов с категориями после изменения иерархии',
      repairSuccess: 'Обновлено связей',
      repairError: 'Ошибка при починке связей',

      form: {
        name: 'Название',
        namePlaceholder: 'Введите название',
        description: 'Описание',
        descriptionPlaceholder: 'Введите описание',
        parentCategory: 'Родительская категория',
        selectParent: 'Выберите категорию',
        isActive: 'Активна',
        isActiveDesc: 'Неактивные категории скрыты от пользователей',
        analysisApiUrl: 'URL API анализа',
        analysisApiUrlPlaceholder: 'https://api.example.com/analyze',
        analysisApiUrlHelp: 'URL для автоматической генерации описания промптов из изображений. Оставьте пустым для наследования от родительской категории.'
      },

      columns: {
        name: 'Название',
        description: 'Описание',
        parentCategory: 'Категория',
        promptCount: 'Промптов',
        subcategoryCount: 'Подкатегорий',
        contentType: 'Тип контента',
        mode: 'Режим',
        selectionMode: 'Выбор',
        status: 'Статус',
        actions: 'Действия'
      },

      status: {
        active: 'Активна',
        inactive: 'Неактивна'
      },

      contentType: {
        image: 'Изображения',
        video: 'Видео',
        both: 'Изобр. и видео'
      },

      mode: {
        default: 'По умолчанию',
        characters: 'Персонажи'
      },

      selectionMode: {
        label: 'Режим выбора',
        multi: 'Несколько',
        single: 'Один',
        multiDesc: 'По 1 промпту из каждой подкатегории',
        singleDesc: '1 промпт из всего дерева категорий',
        inherited: 'Наследуется',
        inheritedFrom: 'Наследуется от родителя'
      },

      // Messages as top-level properties
      categoryCreated: 'Категория успешно создана',
      categoryUpdated: 'Категория успешно обновлена',
      categoryDeleted: 'Категория успешно удалена',
      subcategoryCreated: 'Подкатегория успешно создана',
      subcategoryUpdated: 'Подкатегория успешно обновлена',
      subcategoryDeleted: 'Подкатегория успешно удалена',
      statusUpdated: 'Статус успешно обновлен',
      error: 'Ошибка при выполнении операции',
      loadError: 'Не удалось загрузить данные',

      // Import/Export
      importExport: {
        export: 'Экспорт',
        exportAll: 'Экспортировать все',
        import: 'Импорт',
        importCategories: 'Импорт категорий',
        selectFile: 'Выберите файл',
        chooseFile: 'Выбрать файл...',
        fileLoaded: 'Файл загружен',
        readyToImport: 'Готово к импорту из',
        invalidFormat: 'Неверный формат файла',
        invalidJson: 'Неверный JSON файл',
        missingCategories: 'Отсутствует массив categories',
        updateMode: 'Режим обновления',
        updateExisting: 'Обновить существующие',
        updateExistingDesc: 'Если найдено совпадение по ID или названию - обновить данные',
        skipExisting: 'Пропустить существующие',
        skipExistingDesc: 'Если найдено совпадение - пропустить, импортировать только новые',
        importSuccess: 'Импорт завершён',
        importedCount: 'Создано',
        updatedCount: 'Обновлено',
        skippedCount: 'Пропущено',
        exportSuccess: 'Экспорт завершён',
        importResults: 'Результаты импорта',
        errors: 'Ошибки',
        noChanges: 'Нет изменений',
        importedItems: 'Добавленные категории',
        updatedItems: 'Обновлённые категории',
        skippedItems: 'Пропущенные категории'
      },
      referenceLimits: {
        title: 'Лимиты референсов',
        description: 'Настройте лимиты медиафайлов для референсов в этой категории',
        mediaCountsTitle: 'Лимиты количества',
        maxTotal: 'Макс. всего',
        maxImages: 'Макс. изображений',
        maxVideos: 'Макс. видео',
        maxAudio: 'Макс. аудио',
        fileSizesTitle: 'Лимиты размера файлов (МБ)',
        imageMaxSize: 'Изображение',
        videoMaxSize: 'Видео',
        audioMaxSize: 'Аудио',
        durationsTitle: 'Лимиты длительности (секунды)',
        videoMaxDuration: 'Макс. длительность видео',
        audioMaxDuration: 'Макс. длительность аудио',
        noLimit: 'Без лимита',
        compressionTitle: 'Сжатие изображений',
        compressionEnabled: 'Включить сжатие',
        compressionQuality: 'Качество',
        compressionMaxDimension: 'Макс. размер (пикс.)'
      },
      categoryModal: {
        editTitle: 'Редактирование',
        createTitle: 'Новая категория',
        sidebar: {
          general: 'Основное',
          names: 'Названия',
          settings: 'API Анализа',
          limits: 'Лимиты референсов',
        },
      },
    },

    promptSelection: {
      title: 'Выбор промпта',
      subtitle: 'Выберите промпт из доступных категорий',
      searchPlaceholder: 'Поиск промптов...',
      noResults: 'Промпты не найдены',
      selectPrompt: 'Выбрать промпт',
      favorites: 'Избранное',
      recent: 'Недавние',
      category: 'Категория',
      allCategories: 'Все категории',
      close: 'Закрыть',

      tabs: {
        all: 'Все',
        public: 'Публичные',
        corporate: 'Организации',
        private: 'Мои промпты',
        favorites: 'Избранное'
      }
    },

    // User-created prompts (references)
    userPrompts: {
      addReference: 'Добавить референс',
      createReference: 'Создать референс',
      editReference: 'Редактировать референс',
      viewReference: 'Просмотр референса',
      titleLabel: 'Название',
      titlePlaceholder: 'Введите название',
      descLabel: 'Описание',
      descPlaceholder: 'Введите описание (необязательно)',
      bodyLabel: 'Текст промпта',
      bodyPlaceholder: 'Введите текст промпта',
      bodyOptionalLabel: 'Дополнительные данные (ключевые слова, формула)',
      bodyOptionalPlaceholder: 'Введите дополнительные ключевые слова, формулы или данные',
      promptDetailsTitle: 'Детали промпта',
      imagesLabel: 'Изображения (до 10)',
      uploadFile: 'Загрузить файл',
      pasteUrl: 'Вставить URL',
      addImageUrl: 'Добавить URL изображения',
      visibilityLabel: 'Видимость',
      visibilityOrg: 'Организация',
      visibilityOrgDesc: 'Видно всем участникам организации',
      visibilityPrivate: 'Личный',
      visibilityPrivateDesc: 'Видно только вам',
      save: 'Сохранить',
      cancel: 'Отмена',
      edit: 'Редактировать',
      delete: 'Удалить',
      confirmDelete: 'Удалить этот референс?',
      saving: 'Сохранение...',
      uploading: 'Загрузка...',
      createSuccess: 'Референс успешно создан',
      updateSuccess: 'Референс успешно обновлен',
      deleteSuccess: 'Референс успешно удален',
      createError: 'Ошибка при создании референса',
      updateError: 'Ошибка при обновлении референса',
      deleteError: 'Ошибка при удалении референса',
      dragDropHint: 'Перетащите изображения сюда или нажмите для выбора',
      maxImages: 'Максимум 10 изображений',
      removeImage: 'Удалить изображение',
      categoryLabel: 'Категория',
      selectCategory: 'Выберите категорию',
      // Subcategory creation
      createSubcategory: 'Создать подкатегорию',
      addCategory: 'Добавить категорию',
      subcategoryName: 'Название',
      subcategoryNamePlaceholder: 'Введите название',
      subcategoryNameRequired: 'Введите название',
      subcategoryCreated: 'Подкатегория создана',
      selectionMode: 'Режим выбора',
      selectionModeSingle: 'Одиночный',
      selectionModeMulti: 'Множественный',
      selectionModeDescription: 'Одиночный: можно выбрать только один элемент. Множественный: можно выбрать несколько.',
      generateDescription: 'Сгенерировать описание',
      generatingDescription: 'Генерация описания...',
      generateDescriptionError: 'Ошибка генерации описания',
      analyzeImages: 'Анализ референсов',
      analyzing: 'Анализ...',
      expandAll: 'Раскрыть все',
      collapseAll: 'Свернуть все',
      invalidUrl: 'Неверный URL',
      uploadFailed: 'Ошибка загрузки',
      titleRequired: 'Название обязательно',
      saveFailed: 'Ошибка сохранения',
      analyzingReferences: 'Анализ референсов...',
    },

    promptEditorV2: {
      title: 'Reference Builder',
      description: 'Выбор референсов с категориями и подкатегориями',
      selectCategory: 'Выберите категорию',
      selectedPrompt: 'Выбранный промпт',
      selectedPrompts: 'Выбранные промпты',
      noPromptsSelected: 'Промпты не выбраны',
      noPromptsMessage: 'Промпты не найдены',
      clickToSelect: 'Нажмите для выбора',
      searchPlaceholder: 'Поиск промптов...',
      createPrivatePrompt: 'Создать личный промпт',
      style: 'Стиль',
      background: 'Фон',
      characters: {
        title: 'Персонажи',
        characterNumber: 'Персонаж',
        selectForCharacter: 'Выберите промпт...'
      },
      scenario: 'Сценарий',
      errors: {
        noPromptSelected: 'Пожалуйста, выберите хотя бы один промпт из базы данных',
        noCharactersSelected: 'Пожалуйста, выберите промпты для персонажей',
        promptRequired: 'Пожалуйста, введите промпт для генерации',
        promptOrSelectionRequired: 'Введите промпт или выберите хотя бы один промпт из базы данных'
      },
      helpTitle: 'Reference Builder',
      helpWhatIs: 'Что такое Reference Builder?',
      helpWhatIsDesc: 'Reference Builder позволяет составлять запросы к ИИ, используя библиотеку визуальных, аудио и текстовых референсов. Выбирайте референсы из организованных категорий, чтобы направить модель ИИ на создание именно того, что вам нужно.',
      helpCategories: 'Категории и референсы',
      helpCategoriesDesc: 'Референсы организованы по категориям (Персонажи, Камера, Объекты, Настроение и др.). Нажмите на категорию, чтобы просмотреть и выбрать референсы. Каждый референс может включать изображения, видео или аудио, которые отправляются в модель ИИ.',
      helpCatRecommended: 'Оранжевая точка: Рекомендованные — выбраны автоматически, можно отменить',
      helpCatSelected: 'Зелёная точка: Выбранные — выбраны вручную',
      helpCatOptional: 'Серая точка: Опциональные — доступные медиа из референсов',
      helpMediaLimits: 'Лимиты медиа',
      helpMediaLimitsDesc: 'Модели ИИ принимают ограниченное количество медиафайлов на генерацию. Счётчик (например, "8/14") показывает, сколько слотов использовано. Вы можете выбирать изображения, видео и аудио из референсов в пределах настроенных лимитов.',
      helpSessionRef: 'Сессионные референсы',
      helpSessionRefDesc: 'Используйте "Добавить референс" для загрузки временных референсов для текущей сессии — быстрая загрузка или выбор из галереи для разового использования. Сохранённые референсы (через "Создать референс" на странице Референсов) — постоянные и доступны всей организации.',
      helpPrompt: 'Промпт',
      helpPromptDesc: 'Текстовый промпт внизу объединяется с данными выбранных референсов и отправляется в модель ИИ. Описания референсов и текст промпта работают вместе, направляя результат генерации.',
      helpExamplesTitle: 'Примеры использования',
      helpExamplesIntro: 'Типичные сценарии работы с Reference Builder:',
      helpEx1: 'Игровой ассет: Выберите категорию "Объекты" → выберите референс (например, "Шахматная пешка") → его изображения и промпт отправляются в модель вместе с вашим текстовым промптом',
      helpEx2: 'Композиция сцены: Выберите референсы из "Место/Фон" + "Персонажи" + "Камера" → модель получает стилевые изображения и описания из каждой категории для создания сцены',
      helpEx3: 'Быстрый эксперимент: Нажмите "Добавить референс" → загрузите фото → добавьте описание "использовать эту цветовую палитру и освещение" → генерируйте без создания постоянного референса',
      helpEx4: 'Перенос стиля: Выберите референс "Настроение" со стилевыми изображениями → добавьте сессионный референс с вашим скетчем → модель объединит стиль с вашей композицией',
    },

    // Input Text Widget
    inputText: {
      title: 'Ввод текста',
      placeholder: 'Введите текст здесь...',
      field1: 'Поле 1',
      field2: 'Поле 2',
      requiredHint: 'обязательное',
      optionalHint: 'необязательное',
      errors: {
        empty: 'Текст обязателен',
        tooLong: 'Текст слишком длинный'
      }
    },

    // MCP OAuth Consent Page
    mcpAuth: {
      title: 'Авторизация приложения',
      subtitle: 'Внешнее приложение запрашивает доступ к вашему аккаунту',
      requestsAccess: 'запрашивает доступ',
      selectOrganization: 'Выберите организацию',
      scopeLabel: 'Запрашиваемый уровень доступа',
      scopeRead: 'Чтение',
      scopeReadDesc: 'Просмотр рабочих процессов, референсов и баланса',
      scopeStandard: 'Стандартный',
      scopeStandardDesc: 'Чтение + генерация контента и загрузка файлов',
      scopeFull: 'Полный',
      scopeFullDesc: 'Стандартный + создание и изменение референсов',
      authorize: 'Разрешить',
      deny: 'Отклонить',
      signingIn: 'Загрузка...',
      notSignedIn: 'Необходима авторизация',
      signInRequired: 'Для предоставления доступа приложению необходимо войти в аккаунт.',
      signInButton: 'Войти',
      noOrganizations: 'Нет доступных организаций',
      noOrganizationsDesc: 'У вас нет организаций. Обратитесь к администратору.',
      error: 'Ошибка авторизации',
      unknownClient: 'Неизвестное приложение',
      permissionsTitle: 'Разрешения',
      authorizing: 'Авторизация...',
      authorizationDenied: 'Авторизация отклонена. Вы можете закрыть это окно.',
      invalidScope: 'Запрошена недопустимая область доступа. Возможно, приложение настроено некорректно.',
    }
  },

  en: {
    draftFinal: {
      button: 'Finalize 1080p',
      confirmTitle: 'Create 1080p final',
      confirmMessage: 'Create a final video from this draft?',
      estimatedCost: 'Estimated cost: {cost} tokens',
      loadError: 'Could not prepare the final. Please try again.',
      started: '1080p final generation started',
    },
    mcpServers: MCP_SERVERS_LOCALIZATION.en,
    // Header
    appTitle: 'Art Generator',
    appSubtitle: 'Your AI-powered image generation tool',
    
    // Status indicators
    statusReady: 'Ready to work!',
    
    // AI Settings
    aiSettings: 'AI Settings',
    aiSettingsDescription: 'Choose AI model and prompt style to create the best images',
    geminiModel: 'AI Module',
    promptStyle: 'Prompt Style',
    generationMode: 'Generation Mode',
    advancedSettings: 'Advanced Generation Settings',
    
    // Image Parameters
    imageParameters: 'Image Parameters',
    imageParametersDescription: 'Configure the quantity and resolution of created images',
    quantity: 'Quantity',
    size: 'Resolution',
    quantityTooltip: 'More images = more options, but longer generation time',
    sizeTooltip: '1024×1024 • HD Sprite - perfect for icons and character avatars',
    estimatedTime: 'sec',
    fixedSeedLabel: 'Fixed',
    fixedSeedTooltip: 'Keep the base seed between launches to reproduce the same content',
    
    // Prompt and Content
    promptAndContent: 'Prompt and References',
    promptAndContentDescription: 'Enter the prompt text and upload reference files (if the mode requires it)',
    imageUpload: 'Upload References',
    imageUploadDescription: 'Drag and drop reference images here',
    imageDescription: 'Prompt Text',
    imageDescriptionTooltip: 'Describe the image you want to create. Use templates to enhance the prompt',
    generationModeTitle: 'Generation Mode',
    generationModeDescription: 'Choose how your prompt and references will be used',
    
    // Modes
    textToImage: 'Text → Sprite',
    reduxTransform: 'Quick Reskin',
    imageContext: 'Contextual Render',
    multiContext: 'Combo Render',
    removeBg: 'Remove BG',
    textToImageDesc: 'Create images from text prompts',
    reduxTransformDesc: 'Quick sprite redraw',
    imageContextDesc: 'Create art based on source style',
    multiContextDesc: 'Combine multiple images into one',
    removeBgDesc: 'Automatically remove background from image',
    
    // Gallery
    // gallery: 'Gallery',
    galleryDescription: 'Your generated media. View, download, and reuse prompts',
    noImagesYet: 'You don\'t have any generated media yet',
    
    // Gemini Settings
    geminiSettings: 'AI Generator Settings',
    geminiSettingsSubtitle: 'Choose prompt enhancement style and interface language',
    language: 'Interface Language',
    languageDesc: 'Interface language',
    readyTemplates: 'Ready Prompts',
    technicalPrompts: 'Technical Prompts',
    customPrompt: 'Custom Prompt',
    currentSelectedPrompt: 'Active prompt:',
    stylization: 'Stylization',
    stylizationDesc: 'Applies the selected artistic style to your prompt by adding relevant keywords.',
    
    // Settings panel
    settings: 'Settings',
    imageSize: 'Size',
    numImages: 'Quantity',
    prompts: 'Prompts',
    
    // Technical Prompts
    technicalPromptsTitle: 'Technical Prompts',
    technicalPromptsDescription: 'Specialized prompts for image analysis and technical tasks',
    systemPrompt: 'System Rune',
    imageAnalysis: 'Sprite Analysis',
    imageAnalysisDesc: 'Detailed image analysis to understand its content',
    imageContextPrompt: 'Context Rune',
    imageContextTechDesc: 'Create prompt based on reference image\'s style and context',
    multiContextPrompt: 'Combo Rune',
    multiContextTechDesc: 'Combine styles of multiple images into one prompt',
    reduxTransformation: 'Reskin Rune',
    reduxTransformationDesc: 'Create prompt for quick image reskinning',
    
    // Categories
    creative: 'For Quests',
    professional: 'For UI/UX',
    artistic: 'For Characters',
    technical: 'For Assets',
    realism: 'Realism',
    portrait: 'Portraits',
    character: 'Character Concepts',
    landscape: 'Landscapes',
    location: 'Location Concepts',
    isometric: 'Isometric',
    icons: 'Icons',
    splash: 'Splash Screens',
    ui: 'Interface',
    sdg: 'SDG',
    
    // Actions
    preview: 'Preview',
    select: 'Select',
    close: 'Close',
    ready: 'Ready',
    save: 'Save',
    saveAndApply: 'Save and Apply',
    fixPrompt: 'Improve Prompt',
    improvePrompt: 'Improve Prompt',
    generate: 'Generate!',
    describeImage: 'Describe Image',
    analyzePhoto: '🔮 Analyze Image',
    analyzingPhoto: 'Analyzing...',
    improving: 'Improving...',
    translate: 'Translate',
    translating: 'Translating...',
    
    // Prompt examples
    customPromptTitle: 'Creating a Custom Prompt',
    customPromptDescription: 'Use magic words {mode} and {prompt} for dynamic magic.',
    customPromptExample: 'You are an image generation expert. Improve the prompt for "{mode}" mode: "{prompt}"',
    
    // Size options
    square: '1:1',
    squareHd: 'HD',
    portrait43: '3:4',
    portrait169: '9:16',
    landscape43: '4:3',
    landscape169: '16:9',
    
    // Model descriptions
    gemini15Pro: 'Gemini 1.5 Pro',
    gemini15Flash: 'Gemini 1.5 Flash',
    gemini20Flash: 'Gemini 2.0 Flash',
    gemini25ProPreview: 'Gemini 2.5 Pro Preview',
    gemini25FlashPreview1: 'Gemini 2.5 Flash Preview',
    gemini25FlashPreview2: 'Gemini 2.5 Flash Preview',
    
    // Template names and descriptions
    creativeDetailed: 'Detailed Concept Art',
    creativeDetailedDesc: 'For creating detailed concepts of characters, locations, and items',
    professionalPhoto: 'Game Icon',
    professionalPhotoDesc: 'For creating crisp icons for items, skills, and achievements',
    artisticStyle: 'Pixel Art Sprite',
    artisticStyleDesc: 'Create classic pixel art images for 2D games',
    cinematicEpic: 'Promo Art / Splash Screen',
    cinematicEpicDesc: 'For creating epic splash screens, wallpapers, and promo materials',
    technicalPrecise: 'Texture / Tileset',
    technicalPreciseDesc: 'Generate seamless textures and tilesets for game worlds',
    minimalistClean: 'UI Element',
    minimalistCleanDesc: 'For creating clean and clear interface elements (buttons, icons)',
    fantasyMagical: 'Fantasy RPG Asset',
    fantasyMagicalDesc: 'Generate items, characters, and environments in a fantasy style',
    retroVintage: 'Retrowave Art',
    retroVintageDesc: 'Create art in the style of the 80s and 90s, cyberpunk, and retro-futurism',
    creativeCampaigns: 'Isometric Sprite',
    creativeCampaignsDesc: 'Create images for isometric games and strategies',
    portraitCgi: 'CGI Photoréaliste',
    portraitCgiDesc: 'CGI style for realistic portraits',
    portraitWatercolor: 'Watercolor Portraits',
    portraitWatercolorDesc: 'Gentle and airy portraits in watercolor style',
    portraitAnimeGhibli: 'Anime in Ghibli Style',
    portraitAnimeGhibliDesc: 'Portraits in the spirit of Studio Ghibli works',
    portraitVector: 'Vector Portraits',
    portraitVectorDesc: 'Clean and stylish vector images',
    yourPrompt: 'Your Prompt',
    
    // UI Elements existing
    dropImages: 'Drop references here',
    dragDropText: 'Drag files here or click to select',
    estimatedTimeText: 'sec',
    charactersCount: 'Characters',
    madeWith: 'Generated with',
    poweredBy: 'on the engine',
    customPromptPlaceholder: 'Enter your prompt for the AI generator...',
    sessionPromptPlaceholder: 'Edit prompt for the current generation...',
    sessionChangesNote: 'Changes apply only to the current generation',
    reset: 'Reset',
    apply: 'Apply',
    selected: 'Selected',
    usingCustom: 'Using custom prompt',
    usingSession: 'Using session prompt',
    uiElements: 'UI Elements',
    
    // Tooltips
    notAvailableInMode: 'Not available in this mode',
    imageCount1: '1 image',
    imageCount2: '2 images',
    imageCount3: '3 images',
    imageCount4: '4 images',

    // NEW - PromptBox
    promptBoxTitle: 'Prompt Text',
    clear: 'Clear',
    clearTooltip: 'Clear prompt',
    promptPlaceholder: 'Describe the art you want to create... For example: \'knight in shining armor, fantasy, pixel art, side view, for a 2D platformer\'',
    hideExamples: 'Hide scrolls',
    showExamples: '✨ Prompt Examples',
    enhancing: 'Enchanting...',
    describing: 'Analyzing image...',
    generating: 'Generating...',
    examplesTitle: 'Templates with prompt examples:',
    examplesTip: '💡 Tip: Click on a template to use the prompt. You can modify and expand it.',

    // NEW - Gallery  
    allImages: 'All',
    noImagesForMode: 'No media for mode',
    createFirstImage: 'Create your first image by clicking "Generate!"',
    tryCreateInMode: 'Try generating something in this mode',
    imageLoadError: 'Image failed to load',
    loadingImage: 'Loading image...',
    enlarge: 'Enlarge',
    copyPrompt: 'Copy prompt',
    download: 'Download',
    downloaded: 'Downloaded!',
    downloadOriginal: 'Download original',
    downloadWebP: 'Download WebP',
    downloadedWebP: 'Downloaded WebP!',
    usePrompt: 'Use prompt',
    enlargedView: 'Image view',
    promptLabel: 'Prompt:',
    copy: 'Copy',
    downloadError: 'Download error:',

    // NEW - DropZone
    dropFilesHere: 'Drop references here',
    uploadImages: 'Upload references',
    dragDropHere: 'Drag files here or click to select',
    dragFilesToZone: 'Drop files into this magic cauldron',
    clickToSelect: 'click to select',
    supportedFormats: 'PNG, JPG, WEBP',
    maxSize: 'Up to 10MB',
    noLimit: 'No limit',
    uploadedFiles: 'Uploaded references',
    clearAll: 'Clear cauldron',
    removeImage: 'Remove reference',
    totalFiles: 'Total fichiers:',
    totalSize: 'Taille totale:',
    readyToGenerate: 'Ready to generate',
    uploadTips: 'Reference upload tips:',
    qualityTip: 'Quality: Use high-resolution source files',
    formatTip: 'Format: PNG, JPG, WEBP - all supported',
    sizeTip: 'Size: Optimal file weight is up to 5-10MB',
    compositionTip: 'Composition: Clear, readable images give the best results',
    readyForProcessing: 'Ready for ritual',

    // NEW - Error messages
    fixPromptError: 'Enchantment failed: ',
    improvePromptError: 'Improve prompt error: {error}',
    enterTextToImprove: 'Enter text to improve',
    describeError: 'Failed to describe image. Please try again later.',
    unknownError: 'Unknown error',
    uploadImageFirst: 'Please upload a reference for image analysis',
    describeImageError: 'Image analysis error: ',
    generationError: 'Generation error: ',
    tooManyImagesError: 'Too many images for "{modeName}" mode!\n\nMaximum: {maxImages} images\nUploaded: {currentImages} images\n\nRemove extra images or change mode.',
    
    // Alert messages
    maxReferencesAlert: '❌ Maximum {maxImages} references for {mode} mode! Remove existing files to upload new ones.',
    filesUploadedAlert: '📋 Uploaded {uploaded} of {total} files (limit: {maxImages} references)',
    compressionError: '❌ Error compressing images. Please try again.',
    enterTextToTranslate: 'Enter text to translate',
    translationError: 'Translation error: {error}',
    jsonParseError: 'JSON parsing error in thoughts. Check syntax.',
    promptRegenerationError: 'Error regenerating prompt: {error}',
    removeBgRequiresImage: 'Background removal requires uploading an image',
    removeBgOnlyOneImage: 'Only one image can be uploaded for background removal',
    modeRequiresImage: 'This mode requires uploading an image',
    fillRequiresMask: 'Fill mode requires creating a mask. Click "Create Mask" to select areas for filling.',

    // NEW - Mode descriptions
    text2imgModeDesc: 'Create images from text description using FLUX Ultra neural network',
    img2imgModeDesc: 'High-speed sprite reskinning using FLUX Redux API',
    imgKontextModeDesc: 'Smart image editing: restoration, expansion, element removal, style changes',
    multiKontextModeDesc: 'Working with multiple images to create complex compositions',

    // NEW - Model descriptions
    gemini15ProDesc: 'Powerful classic module for complex rituals',
    gemini15FlashDesc: 'Fast classic module for simple prompts',
    gemini20FlashDesc: 'Modern stable module (recommended)',
    gemini25ProPreviewDesc: 'Latest powerful module in preview mode',
    gemini25FlashPreview1Desc: 'Fast preview version for testing',
    gemini25FlashPreview2Desc: 'Latest model with newest capabilities',

    // NEW - Size descriptions
    squareHdDesc: '1024×1024 • HD Sprite - perfect for icons and avatars',
    squareDesc: '512×512 • Sprite - fast generation',
    portrait43Desc: '768×1024 • Portrait 3:4 - for character cards',
    portrait169Desc: '576×1024 • Portrait 9:16 - for mobile screens',
    landscape43Desc: '1024×768 • Landscape 4:3 - for backgrounds and locations',
    landscape169Desc: '1024×576 • Landscape 16:9 - for splash screens and banners',
    cinematic219: '21:9',
    cinematic921: '9:21',
    photo32: '3:2',
    photo23: '2:3',
    cinematic219Desc: '21:9 • Ultra-wide cinematic format',
    cinematic921Desc: '9:21 • Vertical cinematic format',
    photo32Desc: '3:2 • Classic card format',
    photo23Desc: '2:3 • Portrait card format',

    // NEW - Prompt suggestions
    suggestion1: 'pixel art icon of a magic potion for an RPG inventory',
    suggestion2: 'sprite of a skeleton enemy, walking animation, for a 2D platformer',
    suggestion3: 'concept art of a cyberpunk city with neon signs, top-down view',
    suggestion4: 'seamless grass texture in a fantasy style for a game map',
    suggestion5: 'UI "Play" button in a cartoon style for a mobile game',
    suggestion6: 'high-resolution portrait of an elven sorceress for a dialogue box',
    suggestion7: 'isometric sprite of a building, a medieval castle, for an RTS',
    suggestion8: 'promo art of a racing car in an 80s retrowave style',
    
    // Modal close instruction
    modalCloseInstruction: 'Press ESC or click outside the image to close',
    
    // Auth buttons
    signIn: 'Sign In',
    signUp: 'Sign Up',
    
    // Raw Mode
    rawMode: 'Natural Render (RAW)',
    rawModeDesc: 'Less processed, more natural-looking and realistic images',
    
    // API Limitation notifications
    apiLimitTemplate: '⚠️ {modeName} mode: requested {requested}, but Fal.AI Bug Demons 🐛 limited to {actual} images. Reported!',
    modeNameFill: 'Fill (Inpainting)',
    modeNameCanny: 'Canny (Edge Control)',
    modeNameDepth: 'Depth (Depth Control)',
    
    // Safety levels
    safetyStrict: 'Strict',
    safetyBalanced: 'Balanced',
    safetySoft: 'Soft',
    safetyDisabled: 'Disabled',
    
    // Compact UI texts
    uploadReagents: 'Upload',
    compressing: 'Compressing...',
    filled: 'Full',
    dropping: 'Drop here',
    uploadTipsTitle: 'Upload tips:',
    tipHighRes: 'High resolution',
    tipFormats: 'PNG, JPG, WEBP',
    tipAutoCompress: 'Auto-compression to JPEG',
    tipClearScenes: 'Clear scenes',
    tipMaxSize: 'Up to 1024×1024',

    // Mask editor and dropzone UI
    createMask: 'Create Mask',
    editMask: 'Edit Mask',
    uploadedReagents: 'Uploaded References',
    reagentsCount: 'References',
    readyToExperiment: 'Ready to experiment!',

    // Advanced settings labels
    imageInfluenceStrength: 'Image Influence Strength',
    inferenceSteps: 'Inference Steps',
    guidanceScale: 'Guidance Scale',
    safety: 'Safety',
    
    // Slider labels
    weak: 'Weak',
    strong: 'Strong',
    fast: 'Fast',
    quality: 'Quality',
    precise: 'Precise',
    creativeSlider: 'Creative',

    // Mode tooltips
    text2imgTooltip: '🖼️ Create images purely from text description. You can upload up to 4 reference images for inspiration and stylistic guidance.',
    img2imgTooltip: '🔄 Transform uploaded image according to text description. Preserves the main composition and structure of the source.',
    imgKontextTooltip: '🎯 Create new image based on style and context of uploaded reference. Uses one image as stylistic foundation.',
    multiKontextTooltip: '🔀 Create image based on two reference images. Exactly 2 images required for style and composition blending.',
    cannyTooltip: '🔲 Control generation by image contours and edges. Preserves clear object boundaries and their positioning from reference.',
    depthTooltip: '🌊 Control generation by depth map. Preserves spatial structure, volume and scene perspective.',
    fillTooltip: '🖌️ Fill selected image areas with new content. Uses mask to specify editing and replacement zones.',
    removeBgTooltip: '✂️ Automatically remove background from image. Upload one image and get result with transparent background.',
    
    // Action button tooltips
    generateTooltip: 'Start generation',
    generatingTooltip: 'Generating...',
    fixPromptTooltip: 'Improve prompt with AI',
    fixingPromptTooltip: 'Improving prompt...',

    // Prompts Management
    promptsManagement: {
      title: 'Prompts',
      adminMode: 'Admin Mode',
      adminWarning: 'You are working in global admin mode with an organization you are not a member of.',
      backToAdmin: 'Back to Admin Panel',
      tabs: {
        style: 'Style',
        basic: 'Basic',
        workflow: 'Workflow',
      },
      create: 'Create',
      createButton: 'Create Prompt',
      createFirst: 'Create first',
      prompt: 'prompt',
      edit: 'Edit',
      delete: 'Delete',
      enable: 'Enable',
      disable: 'Disable',
      enabled: 'Enabled',
      disabled: 'Disabled',
      enabledInOrg: 'Enabled in Organization',
      disabledInOrg: 'Disabled in Organization',
      globalPromptReadonly: 'Read Only',
      copy: 'Copy',
      copyTooltip: 'Copy prompt to clipboard',
      copySuccess: 'Prompt copied to clipboard',
      copyError: 'Failed to copy prompt',
      duplicate: 'Duplicate',
      duplicateTooltip: 'Create a duplicate of this prompt',
      duplicateSuccess: 'Prompt duplicated successfully',
      globalPrompts: 'Global Prompts',
      organizationPrompts: 'Organization Prompts',
      noGlobalPrompts: 'No global prompts found.',
      noGlobalPromptsTitle: 'No global prompts',
      noOrgPrompts: 'No organization prompts found.',
      noPromptsTitle: 'No prompts',
      searchPlaceholder: 'Search prompts...',
      columns: {
        title: 'Title',
        description: 'Description',
        status: 'Status',
        created: 'Created At',
        createdBy: 'Creator',
        actions: 'Actions',
      },
      deleteConfirmTitle: 'Delete Prompt',
      deleteConfirmMessage: 'Are you sure you want to delete this prompt? This action cannot be undone.',
      deleteSuccess: 'Prompt deleted successfully',
      deleteError: 'Error deleting prompt',
      modal: {
        createTitle: 'Create Prompt',
        editTitle: 'Edit Prompt',
        titleLabel: 'Title',
        descriptionLabel: 'Description',
        bodyLabel: 'Prompt Body',
        globalLabel: 'Global prompt',
        globalHint: 'Make this prompt available to all organizations',
        createButton: 'Create',
        updateButton: 'Update',
        cancelButton: 'Cancel',
        titlePlaceholder: 'Enter prompt title...',
        descriptionPlaceholder: 'Enter prompt description...',
        bodyPlaceholder: 'Enter prompt text...',
        charactersCount: 'characters',
        titleMinLength: 'Title must be at least 3 characters long',
        titleMaxLength: 'Title must not exceed 100 characters',
        descriptionMinLength: 'Description must be at least 3 characters long',
        descriptionMaxLength: 'Description must not exceed 300 characters',
        bodyMinLength: 'Prompt body must be at least 10 characters long',
        bodyMaxLength: 'Prompt body must not exceed 3000 characters',
      },
    },

    // Admin panel sections
    admin: {
      title: 'Admin Panel',
      dashboard: 'Dashboard',
      users: 'Administrators',
      organizations: 'Organizations',
      globalPrompts: 'Global Prompts',
      backToDashboard: 'Back to Dashboard',
      navigation: 'Navigation',
      widgets: 'Widgets',
      widgetsDesc: 'Manage widget types and their display settings',
      createWidget: 'Create Widget',
      editWidget: 'Edit Widget',
      duplicateWidget: 'Duplicate Widget',
      widgetId: 'Widget ID',
      widgetName: 'Widget Name',
      widgetDescription: 'Description',
      widgetIcon: 'Icon',
      widgetActive: 'Active',
      displayType: 'Display Type',
      displayTypeSmall: 'Sidebar',
      displayTypeBig: 'Main Area',
      name: 'Name',
      description: 'Description',
      status: 'Status',
      actions: 'Actions',
      active: 'Active',
      inactive: 'Inactive',
      accessDenied: 'Access Denied',
      adminRequired: 'Administrator access required',
      noWidgets: 'No widget types found',
      noWidgetsDesc: 'Create your first widget type to get started',
      dynamicWidget: 'Dynamic Widget',
      dynamicWidgetDesc: 'Configure fields without code',
      dynamic: 'Dynamic',
      configureFields: 'Configure Fields',
      fields: 'Fields',
      configureFieldsDesc: 'Configure dynamic fields for this widget',
      addField: 'Add Field',
      editField: 'Edit Field',
      displayOrder: 'Display Order',
      configuredFields: 'Configured Fields',
      noFieldsYet: 'No fields configured yet',
      workflowsUsing: 'Workflows',
      workflowsUsingWidget: 'Workflows Using This Widget',
      noWorkflowsUsingWidget: 'No workflows are using this widget',
      viewWorkflows: 'View Workflows',
      widgetPreview: 'Widget Preview',
      widgetState: 'Widget State',
      fieldType: 'Field Type',
      fieldId: 'Field ID',
      fieldLabel: 'Field Label',
      tooltip: 'Tooltip',
      required: 'Required',
      placeholder: 'Placeholder',
      minLength: 'Min Length',
      maxLength: 'Max Length',
      multiline: 'Multiline',
      rows: 'Rows',
      minValue: 'Min Value',
      maxValue: 'Max Value',
      step: 'Step',
      defaultValue: 'Default Value',
      options: 'Options',
      optionsHelp: 'Enter each option on a new line',
      optionsHelpKeyValue: 'Enter each option on a new line. Use "Label::value" format (e.g., "HD Quality::hd") or just text.',
      maxSelections: 'Max Selections',
      // Dropdown Prompt field config
      dropdownPrompt: 'Dropdown Prompt',
      addOption: 'Add Option',
      optionLabel: 'Option label',
      selectPrompt: 'Select prompt...',
      removeOption: 'Remove option',
      copyVariables: 'Copy variables',
      variablesCopied: 'Copied!',
      copyFailed: 'Copy failed',
      pasteVariables: 'Paste variables',
      pasteFailed: 'Paste failed',
      nothingToPaste: 'Clipboard is empty',
      // Descriptions for dashboard cards
      usersDescription: 'System administrators and managers',
      organizationsDescription: 'Registered organizations',
      globalPromptsDescription: 'Global system prompts',
      activeUsersDescription: 'Recently active users',
      // Quick actions descriptions
      usersActionDesc: 'Manage system administrators and global roles',
      organizationsActionDesc: 'Manage organizations and their settings',
      globalPromptsActionDesc: 'Create and manage global system prompts',
      // Section navigation for EditWorkflowModal
      general: 'General',
      apiEndpoints: 'Dify Endpoints',
      tileConfig: 'Tile Config',
      tags: 'Tags',
      tagsDesc: 'Select tags for this workflow.',
      restrictions: 'Restrictions',
      api: 'API',
      apiDescription: 'API documentation and cURL examples for this workflow',
      references: 'References',
      editWorkflow: 'Edit Workflow',
      previewPayload: 'Preview request data',
      previewPayloadTitle: 'API Request Data Preview',
      clickToNavigate: 'Click to navigate between sections',
      hasErrors: 'Has errors',
      complete: 'Complete',
      basicInfo: 'Basic Information',
      workflowId: 'Workflow ID',
      workflowIdDesc: 'Unique identifier for URL routing',
      workflowTitle: 'Title',
      descriptions: 'Descriptions',
      descriptionRu: 'Description (Russian)',
      descriptionEn: 'Description (English)',
      configuration: 'Configuration',
      category: 'Category',
      actionButtonType: 'Action Button Type',
      inputFilesLogic: 'Input Files Logic',
      uploadFilesLogic: 'Upload Files Logic',
      availability: 'Availability',
      displayStatus: 'Display Status',
      displayStatusActive: 'Active',
      displayStatusNew: 'New',
      displayStatusArchived: 'Archived',
      displayStatusActiveDesc: 'Standard visibility in the workflow selector',
      displayStatusNewDesc: 'Shown at the top of the tile selector with a "New" badge',
      displayStatusArchivedDesc: 'Hidden by default, shown grayed out when "Show archived" is enabled',
      displayStatusUpdated: 'Display status updated',
      promptCharLimit: 'Prompt Character Limit',
      promptCharLimitDesc: 'Default: 5000 (min: 100, max: 50000)',
      singlePerRequest: 'Single per request',
      allPerRequest: 'All per request',
      none: 'None',
      pricingFormula: 'Pricing Formula',
      availableVariables: 'Available variables',
      examples: 'Examples',
      pricingFormulaHelp: {
        title: 'Pricing Formula Help',
        dynamicVariablesTitle: 'Dynamic Variables',
        dynamicVariablesDesc: 'Any parameter from workflow inputs can be used in the formula. Variable names match the input widget names.',
        dynamicVariablesExamples: 'Examples: num_images, width, height, quality, duration, steps, etc.',
        autoVariablesTitle: 'Auto-calculated Variables',
        examplesTitle: 'Formula Examples',
        operationsTitle: 'Supported Operations',
        descriptionColumn: 'Description',
        variables: {
          input_img_mpx: 'Input image megapixels (max from uploaded files)',
          input_img_count: 'Number of input (reference) images; price preview waits until at least one is uploaded',
          input_img_count_may_zero: 'Number of input images (0 if none uploaded, does not block calculation)',
          target_img_mpx: 'Output image megapixels (from width/height parameters)',
          target_img_width: 'Output image width in pixels',
          target_img_height: 'Output image height in pixels',
          target_long_side: 'Output image long side in pixels (max(width, height))',
          target_short_side: 'Output image short side in pixels (min(width, height))',
          target_aspect_ratio: 'Output image aspect ratio (long side / short side, ≥ 1; 0 if size is not set)',
          audio_duration: 'Audio duration in seconds (sum from uploaded files)',
          video_duration: 'Video duration in seconds (sum from uploaded files)',
          audio_duration_exact: 'Sum of audio durations in seconds, rounded up to hundredths, with no 1 s minimum per file. Audio required; falls back to audio_duration if the exact value is absent',
          video_duration_exact: 'Sum of video durations in seconds, rounded up to hundredths, with no 1 s minimum per file. Video required; falls back to video_duration if the exact value is absent',
          audio_duration_exact_may_zero: 'Derived from audio_duration_exact (or audio_duration if the exact value is absent); 0 without audio. Input-presence checks still apply',
          video_duration_exact_may_zero: 'Derived from video_duration_exact (or video_duration if the exact value is absent); 0 without video. Input-presence checks still apply',
          has_audio: 'Audio presence flag (1 if uploaded, 0 if not)',
          has_video: 'Video presence flag (1 if uploaded, 0 if not)',
          audio_duration_may_zero: 'Audio duration (0 if no audio uploaded, does not block calculation)',
          video_duration_may_zero: 'Video duration (0 if no video uploaded, does not block calculation)',
          video_width: 'Video width in pixels (max from uploaded files)',
          video_height: 'Video height in pixels (max from uploaded files)',
          video_mpx: 'Video megapixels (max from uploaded files)',
          prompt_length_1k: 'Prompt length in thousands of characters (length / 1000)',
          prompt_length_1k_may_zero: 'Prompt length in thousands of characters (0 if no prompt, does not block calculation)',
          prompt_length_ceil_100: 'Prompt length in hundreds of characters, stepped (Math.ceil(length / 100))',
          prompt_length_ceil_100_may_zero: 'Prompt length in hundreds of characters, stepped (0 if no prompt, does not block calculation)',
          text_length_ceil_100: 'Text field length in hundreds of characters, stepped (Math.ceil(length / 100))',
          text_length_ceil_100_may_zero: 'Text field length in hundreds of characters, stepped (0 if no text, does not block calculation)',
          has_prompt: '1 if prompt is provided, 0 if empty'
        },
        operations: {
          arithmetic: 'Arithmetic: +, -, *, /, %',
          comparison: 'Comparison: >, <, >=, <=, ===, !==',
          ternary: 'Ternary operator: condition ? value1 : value2',
          math: 'Math functions: Math.ceil(), Math.floor(), Math.round(), Math.min(), Math.max(), Math.abs()'
        }
      },
      widgetConfiguration: 'Widget Configuration',
      widgetConfigDesc: 'Drag widgets from left column to right to enable them.',
      enabledWidgets: 'Enabled Widgets',
      totalWidgets: 'Total',
      noWidgetTypes: 'No widget types available',
      noWidgetTypesDesc: 'Widget types must be configured in the system first.',
      widgetTips: 'Tips',
      widgetTip1: 'Drag widget right to enable',
      widgetTip2: 'Drag widget left to disable',
      widgetTip3: 'Widget order affects how they appear on the workflow page',
      availableWidgets: 'Available Widgets',
      searchWidgets: 'Search...',
      noWidgetsFound: 'No widgets found',
      noWidgetsAvailable: 'No widgets available',
      noWidgetsSelected: 'Select widgets to see preview',
      noWidgetsEnabled: 'No widgets enabled. Enable widgets to see preview.',
      selectWidgetsHint: 'Choose widgets from the left panel to configure your workflow',
      allWidgetsEnabled: 'All widgets enabled',
      dragToEnableHint: 'Drag right to enable',
      dragToReorderHint: 'Drag to reorder, drag left to disable',
      dropWidgetsHere: 'Drag widgets here to enable',
      orClickPlus: 'or click + button',
      enableWidget: 'Enable',
      disableWidget: 'Disable',
      moveUp: 'Move up',
      moveDown: 'Move down',
      apiEndpointsDesc: 'Configure API URLs for this workflow. Main URL is required, additional URLs are optional.',
      mainUrlConfigured: 'Main URL configured',
      mainUrlMissing: 'Main URL missing',
      totalEndpoints: 'Total',
      noApiEndpoints: 'No API endpoints configured',
      noApiEndpointsDesc: 'Add at least one main URL to enable this workflow.',
      tileConfigDesc: 'Configure how this workflow appears in the workflow gallery.',
      noTileConfigured: 'No tile configured',
      noTileConfiguredDesc: 'Select a display type above to configure how this workflow appears in the gallery.',
      sliderDesc: 'Interactive slider to compare images',
      autoSwitchDesc: 'Automatically switches between images',
      autoSwitchDelayHint: 'Time between image switches (500-10000ms)',
      videoUploadHint: 'Max file size: 20MB. Supported formats: MP4, WebM',
      contentRestrictions: 'Content Restrictions',
      contentRestrictionsDesc: 'Configure size and count limits for uploaded content.',
      outgoingImages: {
        title: 'Images sent to external APIs',
        description: 'Compress images, including gallery items and references, only when a file or the image batch exceeds its limit. Original assets are preserved.',
        enabled: 'Limit outgoing image sizes',
        format: 'Format when compressing',
        quality: 'Initial quality (%)',
        perImage: 'File size per image (MB)',
        total: 'Total image data after base64 (MB)',
        dimension: 'Maximum side when compressing (px)',
        units: '1 MB = 1,048,576 bytes. Limits up to 100 MB; fractional values are rounded down to whole bytes.',
        base64: 'The total includes base64 expansion (about 4/3). Leave room for text and JSON; this is not the full HTTP request size.',
        transparency: 'JPEG flattens transparency onto white; WebP preserves transparency. Format and dimensions change only when compression is needed.',
        invalid: 'Enter limits between one byte and 100 MB, quality 10–100%, and a maximum side of 512–8192 px.',
      },
      noInputWidgetsEnabled: 'No input widgets enabled',
      noInputWidgetsEnabledDesc: 'Enable "Input Images" or "Input Media" widget in the Widgets section to configure content restrictions.',
      forInputImages: 'for Input Images widget',
      forInputMedia: 'for Input Media widget',
      restrictionsTips: 'Tips',
      restrictionsTip1: 'Leave fields empty to use system defaults',
      restrictionsTip2: 'Size constraints help ensure consistent output quality',
      restrictionsTip3: 'File size limits prevent excessive upload times',
      // Input Text settings
      inputTextSettings: 'Input Text Settings',
      inputTextSettingsDesc: 'Configure the title and placeholder text for the input text widget.',
      inputTextTitle: 'Widget Title',
      inputTextPlaceholder: 'Placeholder Text',
      noInputTextWidget: 'Widget not enabled',
      noInputTextWidgetDesc: 'Enable "Input Text" widget in the Widgets section to configure its settings.',
      inputTextLayout: 'Layout Mode',
      inputTextSimple: 'Simple',
      inputTextSimpleDesc: 'One text field',
      inputTextDouble: 'Double',
      inputTextDoubleDesc: 'Two text fields',
      inputTextOutputKey: 'Output Key (API)',
      inputTextOutputKeyDesc: 'The key name used in the API payload (default: "prompt")',
      inputTextFieldId: 'Field ID (API Key)',
      inputTextFieldIdDesc: 'This key will be used in the API payload',
      inputTextCharLimit: 'Character Limit',
      inputTextRequired: 'Required',
      inputTextField1: 'Field 1',
      inputTextField2: 'Field 2',
      // Slots Input Media settings
      slotsInputMediaSettings: 'Slots Media Settings',
      slotsInputMediaSettingsDesc: 'Configure media upload slots with individual restrictions for each slot.',
      noSlotsInputMediaWidget: 'Widget not enabled',
      noSlotsInputMediaWidgetDesc: 'Enable "Slots Input Media" widget in the Widgets section to configure its settings.',
      acceptedFormats: 'Accepted Formats',
      acceptedFormatsHint: 'Uncheck formats to restrict them. At least 1 required.',
      allFormats: 'All formats',
      modelMediaType: '3D Model',
      modelRestrictions: '3D Model Restrictions',
      modelMaxFileSize: 'Max file size (MB)',
      modelMaxFileSizeHint: 'Maximum allowed size for each uploaded 3D model.',
      videoMinDuration: 'Min duration (sec)',
      videoMinPixels: 'Min pixels per frame',
      videoMaxPixels: 'Max pixels per frame',
      targetWidth: 'Target width (px)',
      targetWidthDesc: 'Image will be center-cropped and resized to the specified width',
      targetHeight: 'Target height (px)',
      targetHeightDesc: 'Image will be center-cropped and resized to the specified height',
      convertToJpeg: 'Convert to JPEG (remove transparency)',
      convertToJpegDesc: 'PNG with alpha channel will be converted to JPEG with white background',
      imageProcessingTitle: 'Image Processing',
      targetDimensionsPairWarning: 'Both width and height must be set for crop/resize to take effect',
      enableMask: 'Enable mask editor',
      enableMaskDesc: 'Show a "Mask" button on the filled slot to paint an inpainting mask',
      maskPayloadKey: 'Mask payload key',
      maskPayloadKeyPlaceholder: 'mask_image',
      maskPayloadKeyRequired: 'Mask payload key is required',
      enhanceMappings: 'Enhance Mappings',
      pipelineSteps: 'Pipeline Steps',
      pipelineStepsConfig: {
        title: 'Pipeline Steps',
        description: 'Configure multi-step pipeline execution for this workflow',
        stepName: 'Step Name',
        stepUrl: 'API URL',
        stepWorkflowUrl: 'Workflow URL',
        stepWorkflowUrlPlaceholder: 'https://api.loremax.ai/app/.../workflow',
        stepApiKey: 'API Key',
        workflowPrompt: 'Workflow Prompt',
        workflowPromptHint: 'Optional: Select a workflow prompt for this step',
        outputMappings: 'Output Mappings',
        sourceField: 'Source field',
        targetField: 'Target field',
        addMapping: 'Add mapping',
        extraParameters: 'Extra Parameters',
        extraParametersHint: 'These parameters will be added to the request data',
        parameterKey: 'Key',
        parameterValue: 'Value',
        addParameter: 'Add Parameter',
        deleteParameter: 'Delete parameter',
        addStep: 'Add Step',
        maxStepsReached: 'Maximum of 10 steps reached',
        emptyState: 'No pipeline steps configured. Add a step to create a multi-step workflow.',
        stepNumber: 'Step',
        deleteStep: 'Delete step',
        deleteMapping: 'Delete mapping',
        moveUp: 'Move up',
        moveDown: 'Move down',
        collapseStep: 'Collapse step',
        expandStep: 'Expand step',
        onErrorLabel: 'On Error',
        onErrorFail: 'Fail Pipeline',
        onErrorRetry: 'Retry Step',
        maxAttemptsLabel: 'Max Attempts',
        maxAttemptsHint: '1 to 5 attempts',
        retryDelayLabel: 'Retry Delay (sec)',
        retryDelayHint: '1 to 60 seconds',
      },
      pipelineTracing: {
        stepLabel: 'Step',
        status: {
          pending: 'Pending',
          running: 'Running',
          completed: 'Completed',
          failed: 'Failed',
          waiting_callback: 'Waiting for response',
        },
        input: 'Input',
        output: 'Output',
        response: 'Response',
        error: 'Error',
        duration: 'Duration',
        attempts: 'Attempts',
        attemptNumber: 'Attempt',
        pollCount: 'Poll Count',
        retryCount: 'Retry Count',
        noSteps: 'No steps to display',
        skipped: 'Skipped',
        resendStreaming: 'Resend (streaming)',
        resendBlocking: 'Resend (blocking)',
        resending: 'Resending...',
        resendResult: 'Resend Result',
        httpStatus: 'HTTP',
      },
      allSectionsWillBeSaved: 'All sections will be saved together',
      cancel: 'Cancel',
      saving: 'Saving...',
      saveWorkflow: 'Save Workflow',
      // DynamicWidget section
      addFieldHint: 'Add fields to create a widget',
      basic: 'Basic',
      design: 'Design',
      displayOrderDesc: 'Widget position among other widgets',
      fieldConfig: 'Field Configuration',
      fieldIdHelp: 'Unique field ID (letters and _)',
      label: 'Label',
      noDefault: 'No default',
      noFields: 'No fields added',
      preview: 'Preview',
      removeWidget: 'Remove widget',
      special1: 'Special',
      widgetInfo: 'Widget info',
      embedded: 'Embedded',
      // Workflow settings
      autoPromptEnhance: {
        label: 'Auto Prompt Enhance',
        description: 'Automatically enhance prompts using AI',
        mappingsLabel: 'Enhance Field Mappings',
        mappingsDescription: 'Configure how enhance API output fields map to generation input fields',
        sourceField: 'Source field',
        targetField: 'Target field',
        addMapping: 'Add mapping',
        defaultHint: 'If empty, defaults: text → prompt, is_nsfw → is_nsfw'
      },
      pipelineType: {
        label: 'Pipeline Type',
        description: 'Select how this workflow processes prompts',
        off: 'Off',
        offDescription: 'Standard execution via Dify Endpoints',
        autoPromptEnhance: 'Auto Prompt Enhance',
        autoPromptEnhanceDescription: 'Enhance prompts before generation (deprecated)',
        pipeline: 'Pipeline',
        pipelineDescription: 'Multi-step pipeline execution',
        deprecated: 'deprecated'
      },
      noRefundContentPolicy: {
        label: 'No refund on content policy violation',
        description: 'Do not refund tokens when content violates provider policy (e.g. xAI/Grok)'
      },
      multiTaskType: {
        label: 'Multi task type',
        help: 'Makes this model available in the Multi section for parallel generation. "None" excludes it from Multi. Only tag image2* / video2video on workflows that read the shared source_image / source_video slots. multiimage2_3d workflows must use all_per_request and read front_image / back_image / left_image / right_image. Otherwise the model is blocked or receives an empty variable.',
        updated: 'Multi task type updated',
        categoryMismatch: 'This task type does not match the workflow category — check which one is wrong',
        none: 'None',
        text2image: 'Text → Image',
        image2image: 'Image → Image',
        text2video: 'Text → Video',
        image2video: 'Image → Video',
        video2video: 'Video → Video',
        text2_3d: 'Text → 3D',
        image2_3d: 'Image → 3D',
        multiimage2_3d: 'Multi Image → 3D'
      },
      apiKeys: {
        title: 'API Keys',
        description: 'Manage API keys for programmatic access',
        noKeys: 'No API keys yet. Create one to get started.',
        columns: {
          name: 'Name',
          keyPrefix: 'Key Prefix',
          rateLimits: 'Rate Limits',
          status: 'Status',
          usage: 'Usage',
          lastUsed: 'Last Used',
          actions: 'Actions'
        },
        status: {
          active: 'Active',
          revoked: 'Revoked'
        },
        actions: {
          create: 'Create Key',
          edit: 'Edit',
          revoke: 'Revoke',
          revokeConfirm: 'Are you sure you want to revoke this API key?',
          regenerate: 'Regenerate',
          regenerateConfirm: 'Regenerate this API key? The current key stops working immediately — update every integration that uses it with the new key.',
          copy: 'Copy',
          done: 'Done'
        },
        createModal: {
          title: 'Create API Key',
          name: 'Name',
          description: 'Description',
          namePlaceholder: 'My API Key',
          descriptionPlaceholder: 'Optional description...',
          rateMinute: 'Rate/min',
          rateHour: 'Rate/hour'
        },
        keyCreatedModal: {
          title: 'API Key Created',
          regeneratedTitle: 'API Key Regenerated',
          warning: 'This is the only time you will see this key. Please copy it now and store it securely.'
        },
        validation: {
          nameRequired: 'Name is required'
        },
        messages: {
          loadError: 'Failed to load API keys',
          createError: 'Failed to create API key',
          updateError: 'Failed to update API key',
          revokeError: 'Failed to revoke API key',
          regenerateError: 'Failed to regenerate API key',
          regenerateConflict: 'This key has already been regenerated or revoked. The key list has been refreshed.',
          copyError: 'Failed to copy key'
        }
      },
      // Controller Dropdown & Variant config
      controllerDropdown: 'Controller Dropdown',
      onlyOneController: 'Only one Controller Dropdown is allowed per widget',
      controllerNeedsOptions: 'Controller Dropdown must have at least one option',
      controllerDuplicateValues: 'Controller Dropdown option values must be unique',
      variantConfig: 'Variant Configuration',
      defaultVariant: 'Default',
      variantOverrideHint: 'Only set values that differ from Default. Empty fields inherit the default config.',
      hiddenInVariant: 'Hidden for this variant',
      requiredField: 'Required field',
      requiredFieldHint: 'Generation is blocked until this field has a value. Applies to every variant; MCP profiles publish it as a required argument.',
      hiddenFieldHint: 'Hidden — not visible to users',
      hiddenTextPlaceholder: 'Constant text value...',
      hiddenTextLabel: 'Hidden Text',
      hiddenNumberLabel: 'Hidden Number',
      hiddenPromptLabel: 'Hidden Prompt',
      hiddenPromptNeedsPrompt: 'Hidden Prompt must have a prompt selected',
      selectedPromptId: 'Selected Prompt ID',
      override: 'override',
      variantOptionsHint: 'Leave empty to use default options',
      noOverridableFields: 'No overridable fields for this type. You can still hide it per variant.',
      controllerOptionsHelp: 'Each option needs a display label and a unique value identifier. The value is used to match variant configs in dependent fields.',
      optionValue: 'Option value',
      minWidth: 'Min Width',
      maxWidth: 'Max Width',
      minHeight: 'Min Height',
      maxHeight: 'Max Height',
      defaultWidth: 'Default Width',
      defaultHeight: 'Default Height'
    },

    adminUsers: {
      title: 'User Management',
      administrators: 'Administrators',
      assignRoleByEmail: 'Assign role by email',
      noAdministratorsFound: 'No administrators found',
      columns: {
        email: 'Email',
        name: 'Name',
        globalRole: 'Global Role',
        registered: 'Registered',
        lastActivity: 'Last Activity'
      },
      assignRole: {
        title: 'Assign role by email',
        emailLabel: 'User email',
        emailPlaceholder: 'user@example.com',
        roleLabel: 'Role',
        assignButton: 'Assign role',
        assigningButton: 'Assigning...'
      },
      userEmail: 'User email',
      roleDescriptions: 'Role descriptions',
      globalRole: 'Global role',
      registration: 'Registration',
      lastActivity: 'Last activity',
      noAdminsFound: 'No administrators found',
      assigningRole: 'Assigning...',
      assignRoleButton: 'Assign role',
      roleAssignNote: 'User must be registered in the system. After assigning administrator role, user will appear in the list above.',
      email: 'Email',
      name: 'Name',
      role: 'Role',
      regularUsers: {
        title: 'Regular Users',
        searchPlaceholder: 'Search by email or name...',
        noUsersFound: 'No users found',
        makeAdmin: 'Make Admin',
        confirmMakeAdmin: 'Are you sure you want to make {email} an admin?',
        selectRole: 'Select role',
        columns: {
          email: 'Email',
          name: 'Name',
          registered: 'Registered',
          lastActivity: 'Last Activity',
          actions: 'Actions'
        },
        pagination: {
          previous: 'Previous',
          next: 'Next',
          showing: 'Showing',
          of: 'of',
          users: 'users'
        }
      }
    },

    adminOrganizations: {
      title: 'Organization Management',
      organizationManagement: 'Organization Management',
      createOrganization: 'Create Organization',
      organizationName: 'Organization Name',
      generationLimit: 'Tokens',
      usage: 'Usage',
      userCount: 'Members',
      created: 'Created',
      actions: 'Actions',
      noOrgsFound: 'No organizations found',
      creatingOrg: 'Creating...',
      createOrgButton: 'Create Organization',
      nameLabel: 'Name',
      limitLabel: 'Generation Limit',
      namePlaceholder: 'Enter organization name',
      limitPlaceholder: 'e.g. 100000',
      save: 'Save',
      cancel: 'Cancel',
      edit: 'Edit',
      delete: 'Delete',
      manage: 'Manage',
      billingTypeColumn: 'Billing Type',
      createForm: {
        title: 'Create New Organization',
        nameLabel: 'Organization Name',
        namePlaceholder: 'Company name',
        limitLabel: 'Generation Limit',
        marginDiscountLabel: 'Margin Discount',
        marginDiscountHint: '0% = no discount',
        limitPlaceholder: '100000',
        createButton: 'Create Organization',
        creatingButton: 'Creating...',
        confirmMessage: 'Create organization "{name}" with limit {limit} generations?',
        successMessage: 'Organization "{name}" successfully created'
      },
      editLimit: {
        title: 'Edit Limit',
        save: 'Save',
        cancel: 'Cancel'
      },
      deleteOrganization: {
        title: 'Delete Organization',
        confirmMessage: 'Are you sure you want to delete organization "{name}"?\n\nThis action is irreversible and will remove all users from the organization.',
        successMessage: 'Organization "{name}" successfully deleted'
      },
      clearHistory: {
        title: 'Clear History',
        confirmMessage: 'Are you sure you want to clear all generation history and gallery data for "{name}"? This action cannot be undone.',
        successMessage: 'History cleared successfully for "{name}"'
      },
      nsfwSettings: {
        label: 'NSFW Content',
        enabled: 'Enabled',
        disabled: 'Disabled',
        enabledDesc: 'NSFW content allowed',
        disabledDesc: 'NSFW content is blocked',
        warning: 'Warning: Enabling NSFW content allows users to access adult-only workflows and prompts.',
        saveSuccess: 'NSFW settings updated successfully',
        saveError: 'Failed to update NSFW settings'
      },
      errors: {
        nameRequired: 'Enter organization name',
        limitInvalid: 'Enter valid generation limit',
        marginDiscountInvalid: 'Enter valid margin discount (0-99%)',
        deleteError: 'Error deleting organization',
        createError: 'Error creating organization',
        updateLimitError: 'Error updating limit',
        updateMarginDiscountError: 'Error updating margin discount',
        saveChangesError: 'Error saving changes'
      },
      messages: {
        settingsUpdated: 'Settings Updated',
        settingsUpdatedFor: 'Settings for "{name}" updated successfully',
        organizationUpdated: 'Organization "{name}" updated successfully',
      },
      actionButtons: {
        viewHistory: 'View History',
        deleteOrg: 'Delete Organization',
        manageOrg: 'Manage Organization',
        clearHistory: 'Clear History',
        select: 'Select',
        deselect: 'Deselect',
        edit: 'Edit'
      },
      actionsSection: {
        title: 'Actions for {name}',
        managementTitle: 'Management'
      },
      editModal: {
        title: 'Edit Organization',
        save: 'Save Changes',
        saveHint: 'Changes will be saved immediately'
      },
      sections: {
        general: 'General',
        apiKeys: 'API Keys',
        workflows: 'Workflows',
        domains: 'Domains',
        actions: 'Actions',
        debug: 'Debug',
        usage: 'Usage Statistics',
        info: 'Organization Info'
      },
      fields: {
        name: 'Organization Name',
        tokenLimit: 'Token Limit',
        marginDiscount: 'Margin Discount',
        paymentMethod: 'Payment Method',
        id: 'ID',
        createdAt: 'Created'
      },
      placeholders: {
        name: 'Enter organization name'
      },
      hints: {
        tokenLimit: 'Maximum tokens available for this organization',
        marginDiscount: 'Discount percentage on token costs (0% = no discount)'
      },
      paymentMethods: {
        none: 'None (Disabled)',
        standard: 'Standard (Bundles)',
        enterprise: 'Enterprise (Custom)',
        noneDesc: 'Billing disabled for this organization',
        standardDesc: 'Purchase from predefined token bundles',
        enterpriseDesc: 'Pay-what-you-want pricing'
      },
      stats: {
        tokensUsed: 'Tokens Used',
        tokenLimit: 'Token Limit',
        users: 'Users',
        usageProgress: 'Usage'
      },
      actionsPanel: {
        quickLinks: 'Quick Links',
        manageUsers: 'Manage Users',
        manageUsersDesc: 'View and manage organization members',
        viewHistory: 'View History',
        viewHistoryDesc: 'View generation history',
        dangerZone: 'Danger Zone',
        clearHistory: 'Clear Generation History',
        clearHistoryDesc: 'Remove all generation records for this organization',
        clearHistoryConfirm: 'Are you sure you want to clear all generation history for this organization? This action cannot be undone.',
        historyCleared: 'Generation history cleared successfully',
        clear: 'Clear',
        deleteOrg: 'Delete Organization',
        deleteOrgDesc: 'Permanently delete this organization and all associated data',
        deleteConfirmText: 'This action cannot be undone. Please type the organization name to confirm:',
        typeToConfirm: 'Type organization name...',
        confirmDelete: 'Delete Organization',
        delete: 'Delete'
      },
      debugPanel: {
        stripeCustomer: 'Stripe Customer',
        stripeCustomerId: 'Stripe Customer ID',
        notSet: 'Not set',
        setStripeCustomer: 'Set Stripe Customer ID',
        setStripeCustomerDesc: 'Manually set or replace the Stripe Customer ID for this organization.',
        set: 'Set',
        setConfirm: 'Set Stripe Customer ID?',
        setSuccess: 'Stripe Customer ID has been set successfully',
        resetStripeCustomer: 'Reset Stripe Customer',
        resetStripeCustomerDesc: 'Remove the Stripe Customer ID link. Use this when switching Stripe accounts.',
        resetConfirm: 'Are you sure you want to reset the Stripe Customer ID? This will unlink the organization from its Stripe customer. Billing address and invoices will be lost.',
        resetSuccess: 'Stripe Customer ID has been reset successfully'
      },
      workflows: {
        description: 'Manage which workflows are available for this organization',
        searchPlaceholder: 'Search workflows...',
        found: 'Found',
        of: 'of',
        columns: {
          id: 'ID',
          description: 'Description',
          availability: 'Availability'
        },
        noWorkflows: 'No workflows found',
        noResults: 'No matching workflows',
        global: 'Global',
        custom: 'Custom'
      },
      domains: {
        description: 'Manage domains for automatic user assignment. Users with emails from these domains will be automatically added to this organization.',
        addNew: 'Add New Domain',
        placeholder: 'example.com',
        add: 'Add',
        noDomains: 'No domains configured',
        addFirst: 'Add domains to enable automatic user assignment',
        confirmRemove: 'Are you sure you want to remove domain "{domain}"?',
        remove: 'Remove',
        validation: {
          required: 'Domain is required'
        },
        columns: {
          domain: 'Domain',
          addedBy: 'Added By',
          dateAdded: 'Date Added',
          actions: 'Actions'
        }
      }
    },

    organizationSettings: 'Organization Settings',

    adminWorkflows: {
      title: 'Workflow Management',
      workflowManagement: 'Workflow Management',
      createWorkflow: 'Create Workflow',
      editWorkflow: 'Edit Workflow',
      exportWorkflow: 'Export',
      deleteWorkflow: 'Delete Workflow',
      workflowId: 'Workflow ID',
      workflowTitle: 'Title',
      workflowUrls: 'URLs',
      workflowUrlMain: 'Main URL',
      workflowUrlAdditional1: 'Additional URL 1',
      workflowUrlAdditional2: 'Additional URL 2',
      workflowUrlAdditional3: 'Additional URL 3',
      description: 'Description',
      category: 'Category',
      workflowType: 'Type',
      availability: 'Availability',
      created: 'Created',
      actions: 'Actions',
      noWorkflowsFound: 'No workflows found',
      titleRequired: 'Title is required',
      mainUrlRequired: 'Main URL is required',
      manageUrls: 'Manage URLs',
      urlManager: {
        title: 'Manage Workflow URLs',
        mainUrl: 'Main URL',
        additionalUrl: 'Additional URL',
        urlIndex: 'URL {index}',
        required: 'Required',
        description: 'Description',
        apiKey: 'API Key',
        noApiKey: 'No API key',
        copy: 'Copy',
        copied: 'Copied',
        roleTranslate: '→ Translate',
        rolePromptEnhance: '→ Prompt Enhance',
        roleHintTranslate: 'This URL is used to translate the prompt',
        roleHintPromptEnhance: 'This URL is used to enhance the prompt',
        enhancerEndpointsTitle: 'Enhancer endpoints',
        enhancerEndpointsDesc: 'Prompt-enhancement endpoint for this workflow',
        enhancerEndpointsLoadError: 'Could not load enhancer endpoints',
        notConfigured: 'Not configured',
        configureUrl: 'Configure',
        saveError: 'Failed to save URL',
        workflowPromptPlaceholder: 'Select workflow prompt...',
        workflowPromptNote: 'Optional: Select a workflow prompt to use with this URL',
        extraParameters: 'Extra Parameters',
        extraParametersNote: 'These parameters will be added to the request data',
        parameterKey: 'Key',
        parameterValue: 'Value',
        addParameter: 'Add Parameter',
        addUrl: 'Add Additional URL',
        editUrl: 'Edit URL',
        deleteUrl: 'Delete URL',
        confirmDelete: 'Are you sure you want to delete {urlType}? This action cannot be undone.',
        addUrlTitle: 'Add URL',
        editUrlTitle: 'Edit URL',
        descriptionPlaceholder: 'Enter URL description...',
        urlPlaceholder: 'https://api.example.com/v1/endpoint',
        apiKeyPlaceholder: 'Enter API key...',
        apiKeyNote: 'Leave empty if the API key is included in the URL as a query parameter',
        saving: 'Saving...',
        save: 'Save',
        cancel: 'Cancel',
        close: 'Close',
        maxUrlsReached: 'Maximum number of URLs reached (6 total)',
        cannotDeleteMain: 'Cannot delete main workflow URL',
        apiUrl: 'API URL',
        difyWorkflowUrl: 'Dify Workflow URL',
        difyUrlPlaceholder: 'https://api.dify.ai/v1/workflows/run',
        extraParameters: 'Extra Parameters',
        extraParametersNote: 'These parameters will be added to the request data',
        parameterKey: 'Key',
        parameterValue: 'Value',
        addParameter: 'Add Parameter',
        openDifyUrl: 'Open Dify URL',
        extractToTextWorkflow: 'Extract to Text Workflow',
        extractConfirmTitle: 'Create Text Workflow',
        extractConfirmMessage: 'Create a new Text workflow using this enhance URL as main endpoint?',
        extracting: 'Creating...',
        extractSuccess: 'Text workflow created successfully',
        extractError: 'Failed to create text workflow',
        extractWorkflowSuffix: 'Prompt Enhance',
        extractMainUrlDescription: 'Main URL'
      },
      search: {
        placeholder: 'Search by title or description...',
        clear: 'Clear',
        resultsFound: 'results found',
        noResults: 'No results found',
        noResultsDesc: 'No workflows match the query "{query}"',
        clearSearch: 'Clear Search'
      },
      pagination: {
        showing: 'Showing',
        of: 'of',
        workflows: 'workflows',
        previous: 'Previous',
        next: 'Next'
      },
      tags: {
        title: 'Manage Workflow Tags',
        manageTags: 'Manage Tags',
        createTag: 'Create Tag',
        editTag: 'Edit Tag',
        deleteTag: 'Delete Tag',
        tagNameEn: 'Tag Name (English)',
        tagNameRu: 'Tag Name (Russian)',
        confirmDelete: 'Delete this tag? It will be removed from all workflows.',
        noTags: 'No tags yet',
        usedByWorkflows: 'Used by {count} workflows',
        columnTags: 'Tags',
        saveChanges: 'Save Changes',
        cancel: 'Cancel',
        close: 'Close',
        selectTags: 'Select Tags',
        noTagsSelected: 'No tags selected',
        tagCreated: 'Tag created successfully',
        tagUpdated: 'Tag updated successfully',
        tagDeleted: 'Tag deleted successfully',
        tagsAssigned: 'Tags assigned successfully',
        createNewTag: 'Create New Tag',
        displayOrder: 'Display Order'
      },
      tileDisplay: {
        title: 'Tile Configuration',
        none: 'No Tile',
        singleImage: 'Single Image',
        imagePair: 'Image Pair (before/after)',
        singleVideo: 'Video',
        uploadImage: 'Upload Image',
        uploadBefore: 'Upload "Before" Image',
        uploadAfter: 'Upload "After" Image',
        uploadVideo: 'Upload Video',
        comparisonMode: 'Comparison Mode',
        slider: 'Slider',
        autoSwitch: 'Auto-Switch',
        delayMs: 'Delay (ms)',
        uploading: 'Uploading...',
        deleteMedia: 'Delete',
        replaceMedia: 'Replace',
        confirmDeleteMedia: 'Delete this media?',
        fileUploaded: 'File uploaded',
        dropFileHere: 'Drop file here...',
        dragDrop: 'Drag file here or click to select',
        uploadError: 'File upload error'
      },
      workflowIdDesc: 'Unique workflow identifier',
      workflowIdEditDesc: 'If not specified, will be auto-generated',
      workflowCreated: 'Workflow created successfully',
      workflowUpdated: 'Workflow updated successfully',
      workflowDeleted: 'Workflow deleted successfully',
      workflowDuplicated: 'Workflow duplicated successfully',
      marginColumn: 'Margin',
      marginUpdated: 'Margin updated successfully',
      duplicateWorkflow: 'Duplicate',
      confirmDeleteWorkflow: 'Are you sure you want to delete this workflow?',
      additional: 'Additional',
      columns: {
        id: 'ID',
        title: 'Title',
        urls: 'URLs',
        description: 'Description',
        category: 'Category',
        availability: 'Availability',
        created: 'Created',
        actions: 'Actions'
      },
      exportModal: {
        title: 'Export Workflows',
        filterByCategory: 'Filter by category',
        allCategories: 'All categories',
        searchPlaceholder: 'Search...',
        selectAll: 'Select all',
        deselectAll: 'Deselect all',
        selectedCount: 'Selected: {selected} of {total}',
        exportButton: 'Export ({count})',
        exporting: 'Exporting...',
        widgetCount: '{count} widgets',
        urlCount: '{count} URLs',
        noWorkflowsToExport: 'No workflows to export'
      },
      importModal: {
        title: 'Import Workflows',
        selectFile: 'Select JSON file',
        foundWorkflows: 'Found {count} workflows in file',
        selectAllNew: 'Select all new ({count})',
        backToFile: 'Back',
        alreadyExists: 'Already exists',
        willSkip: 'Will be skipped',
        willUpdate: 'Will update',
        newWorkflow: 'New',
        importSelected: 'Import selected ({count})',
        importing: 'Importing...',
        newCount: '{count} new',
        existingCount: '{count} existing (will be skipped)',
        updateExisting: 'Update existing workflows',
        updateExistingDesc: 'Replace data for workflows that already exist'
      }
    },

    debug: {
      title: 'Debug Tools',
      subtitle: 'System maintenance and diagnostics',
      repairLinks: {
        title: 'Repair Links',
        description: 'Fixes broken category assignments when category hierarchy changes. Ensures all prompts point to valid root categories.',
        button: 'Repair',
        repairing: 'Repairing...',
        result: 'Result',
        promptsUpdated: 'Prompts updated',
        workflowsCleaned: 'Workflows cleaned',
        errorsOccurred: 'Errors',
        andMore: 'and',
        more: 'more',
        success: 'Repair completed successfully'
      },
      contentMigration: {
        title: 'Content Migration',
        description: 'Migrates images from external storage (fal.media, Backblaze) to content.loremax.ai for consistent CDN delivery.',
        button: 'Open Migration Tool',
        externalDomains: 'External domains to migrate',
        modal: {
          title: 'Content Migration',
          selectOrganization: 'Select Organization',
          chooseOrganization: 'Choose organization...',
          analyse: 'Analyse',
          analysing: 'Analysing...',
          migrate: 'Migrate',
          migrating: 'Migrating...',
          completed: 'Migration completed',
          cancelled: 'Migration cancelled',
          completedMessage: 'Migration completed: {count} URLs migrated',
          currentUrl: 'Current',
          succeeded: 'Succeeded',
          failed: 'Failed',
          errors: 'Errors',
          andMore: 'and',
          more: 'more',
          noMigrationNeeded: 'No migration needed',
          allUrlsInternal: 'All URLs are already on content.loremax.ai',
          cancel: 'Cancel',
          stop: 'Stop',
          close: 'Close',
          stats: {
            totalGenerations: 'Total generations',
            withExternalUrls: 'With external URLs',
            urlsToMigrate: 'URLs to migrate',
            byDomain: 'By domain'
          }
        }
      },
      tokenAudit: {
        title: 'Token Usage Audit',
        description: 'Compares cached organization usage counters with actual SUM of user counters to detect drift.',
        button: 'Run Audit',
        running: 'Auditing...',
        columns: {
          organization: 'Organization',
          limit: 'Limit',
          cached: 'Cached (org_usage)',
          sumUsers: 'SUM (users)',
          drift: 'Drift',
          users: 'Users'
        },
        noDrift: 'No drift detected — all counters are in sync',
        driftFound: 'Drift found in {count} organization(s)',
        noOrganizations: 'No organizations found',
        fixButton: 'Fix Drift',
        fixing: 'Fixing...',
        fixResult: 'Reconciled {fixed}/{total} organizations'
      }
    },

    adminPrompts: {
      title: 'Global Prompt Management',
      globalPrompts: 'Global Prompts',
      createPrompt: 'Create Reference',
      editPrompt: 'Edit Reference',
      deletePrompt: 'Delete Prompt',
      promptTitle: 'Prompt Title',
      promptBody: 'Prompt Body',
      promptType: 'Prompt Type',
      promptCategory: 'Category',
      noPromptsFound: 'No global prompts found',
      creatingPrompt: 'Creating...',
      createPromptButton: 'Create Reference',
      actions: 'Actions',
      created: 'Created',
      updated: 'Updated',
      author: 'Author',
      loadFromFiles: 'Load From Files',
      exportToFiles: 'Export To Files',
      exportPrompts: 'Export Prompts',
      importPrompts: 'Import Prompts',
      exporting: 'Exporting...',
      downloadReady: 'Download Ready',
      selectTypeToExport: 'Select type to export',
      exportPreview: 'Export Preview',
      noPromptsToExport: 'No prompts to export',
      preparingExport: 'Preparing export...',
      downloadStarted: 'Download started',
      exportFailed: 'Export failed',
      exportSuccess: 'Export completed successfully',
      cancel: 'Cancel',
      upload: 'Upload',
      download: 'Download',
      uploadFiles: 'Upload JSON Files',
      loadPrompts: 'Load Prompts',
      dragDropFiles: 'Drag & drop JSON files here, or click to select',
      dropFiles: 'Drop the files here...',
      supportedFormats: 'Supported formats: .json',
      uploadedFiles: 'Uploaded Files',
      searchPlaceholder: 'Search prompts...',
      noSearchResults: 'No prompts match your search',
      promptTypeStyle: 'Style',
      promptTypeBasic: 'Basic',
      promptTypeWorkflow: 'Workflow',
      enabled: 'Enabled',
      disabled: 'Disabled',
      promptEnabled: 'Prompt enabled',
      promptDisabled: 'Prompt disabled',
      promptTypeUpdated: 'Prompt type updated to',
      updateError: 'Failed to update prompt',
      exportInfo: 'Export Information',
      exportDescription: 'Prompts will be exported as individual JSON files packaged in a ZIP archive. The format is compatible with the "Load From Files" feature.',
      loading: 'Loading...'
    },
    
    
    // Organization Info Page
    organizationInformation: 'Organization Information',
    backToHome: 'Home',
    members: 'Members',
    generationLimit: 'Generation Limit',
    tokensRemaining: 'Tokens Remaining',
    used: 'Used',
    yourRole: 'Your Role',
    organizationMembers: 'Organization Members',
    yourGenerationHistory: 'Your Generation History',
    leaveOrganization: 'Leave Organization',
    leaving: 'Leaving...',
    cannotLeaveAsOnlyAdmin: 'You are the only administrator of this organization. Please assign another administrator before leaving the organization.',
    cannotLeaveOrganization: 'Cannot leave organization',
    leaveOrganizationConfirm: 'Are you sure you want to leave the organization',
    leave: 'Leave',
    cancel: 'Cancel',
    organizationLeft: 'Organization left',
    leftOrganizationSuccess: 'You have successfully left the organization',
    failedToLeaveOrganization: 'Failed to leave organization',
    error: 'Error',
    promptCopiedToClipboard: 'Prompt copied to clipboard',
    failedToCopyPrompt: 'Failed to copy prompt',
    loadingMembers: 'Loading members...',
    membersNotFound: 'Members not found',
    noGenerationsYet: 'You don\'t have any generations in this organization yet',
    loadMore: 'Load More',
    loading: 'Loading...',
    joinedOn: 'Joined',
    email: 'Email',
    name: 'Name',
    role: 'Role',
    joinedAt: 'Join Date',

    // Navigation keys
    nav: {
      home: 'Home',
      organization: 'Organization',
      manager: 'Manager',
      info: 'Info',
      history: 'History',
      navigateTo: 'Navigate to',
      workflow: 'Workflow',
      management: 'Management',
      managementDesc: 'Manage users and settings',
      prompts: 'Prompts',
      promptsDesc: 'Manage organization prompts',
      promptsOld: 'Prompts',
      promptsOldDesc: 'Prompts system',
      categories: 'Categories',
      categoriesDesc: 'Enable/disable prompt categories',
      corpPrompts: 'References',
      corpPromptsDesc: 'Manage organization references',
      myReferences: 'My References',
      myReferencesDesc: 'Personal references collection',
      organizationInfoDesc: 'View details and statistics',
      historyDesc: 'View generation history',
      actions: 'Actions',
      collections: 'Collections',
      collectionsDesc: 'Manage image collections',
      openInNewTab: 'Open in new tab',
      logout: 'Logout',
      allRefunds: 'All Refunds',
      allRefundsDesc: 'Token refunds across all organizations',
      billing: 'Billing',
      billingDesc: 'Purchase tokens',
      billingAddress: 'Billing Address',
      billingAddressDesc: 'Legal entity details for invoices',
      invoices: 'Invoices',
      invoicesDesc: 'View and download invoices'
    },

    // Organization Categories
    orgCategories: {
      title: 'Category Settings',
      description: 'Enable or disable categories for this organization. Disabled categories will not be available for prompt selection.',
      searchPlaceholder: 'Search categories...',
      allTypes: 'All Types',
      imageOnly: 'Image Only',
      videoOnly: 'Video Only',
      import: 'Import',
      export: 'Export',
      noCategories: 'No categories found',
      categoryEnabled: 'Category enabled',
      categoryDisabled: 'Category disabled',
      fetchError: 'Failed to load categories',
      toggleError: 'Failed to update category',
      exportSuccess: 'Export completed',
      exportError: 'Failed to export categories',
      importSuccess: 'Import completed',
      importError: 'Failed to import categories',
      imported: 'imported',
      skipped: 'skipped',
      // Edit/Delete organization categories
      edit: 'Edit',
      delete: 'Delete',
      editCategory: 'Edit Category',
      deleteCategory: 'Delete Category',
      confirmDelete: 'Confirm Delete',
      confirmDeleteMessage: 'Are you sure you want to delete this category? This action cannot be undone.',
      editSuccess: 'Category updated successfully',
      editError: 'Failed to update category',
      deleteSuccess: 'Category deleted successfully',
      deleteError: 'Failed to delete category',
      nameEn: 'Name (English)',
      nameRu: 'Name (Russian)',
      descriptionEn: 'Description (English)',
      descriptionRu: 'Description (Russian)',
      save: 'Save',
      cancel: 'Cancel',
      organizationOwned: 'Organization Category',
      // Create subcategory
      categoryCreated: 'Category created successfully',
      addSubcategory: 'Add subcategory',
      // Delete permission errors
      cannotDeleteOthersPrompts: 'Cannot delete category containing prompts from other users',
      cannotDeleteOthersPromptsDetail: 'This category contains {total} prompts, but only {yours} are yours. Only organization admins can delete categories with prompts from other users.',
      checkingPermissions: 'Checking permissions...',
      // Prompts list in delete modal
      promptsInCategory: 'Prompts in this category:',
      yourPrompt: '(yours)',
      otherUserPrompt: '(other user)',
      andMorePrompts: '...and {count} more',
      // Delete all categories
      deleteAll: 'Delete All',
      deleteAllTitle: 'Delete All Organization Categories',
      deleteAllConfirmMessage: 'This will delete ALL categories created by your organization. Global categories will not be affected. Type "delete" to confirm.',
      deleteAllSuccess: 'All organization categories deleted',
      deleteAllSuccessTitle: 'Categories Deleted Successfully',
      deleteAllResultMessage: 'Successfully deleted {count} organization categories.',
      deleteAllError: 'Failed to delete categories',
      noOrgCategoriesToDelete: 'No organization categories to delete',
      typeDeleteToConfirm: 'Type "delete" to confirm',
      // Import mode selection
      importModeTitle: 'Select Import Mode',
      importModeDescription: 'This organization already has custom categories. Choose how to handle them during import.',
      importModeMerge: 'Merge',
      importModeMergeDescription: 'Add new and update existing categories. Nothing will be deleted.',
      importModeReplace: 'Replace All',
      importModeReplaceDescription: 'Replace all organization categories with imported ones. Prompt assignments will be preserved for matching categories.',
      importModeReplaceWarning: 'Categories not in the import file will be deleted along with their prompt assignments.',
      // Import results - reactivation/cleanup
      reactivated: 'Reactivated',
      reactivatedDescription: 'prompt assignments preserved',
      cleanedUp: 'Cleaned up',
      cleanedUpDescription: 'obsolete categories removed'
    },

    // Analysis Config (Category Settings)
    analysisConfig: {
      title: 'Analysis API Configuration',
      apiUrl: 'API URL',
      apiUrlHelp: 'Endpoint URL for sending data for analysis',
      workflowUrl: 'Workflow URL',
      workflowUrlHelp: 'Link to the workflow (for reference)',
      apiKey: 'API Key',
      apiKeyHelp: 'Authorization key for analysis API requests',
      prompt: 'Analysis Prompt',
      promptHint: 'Select a prompt for analysis (optional)',
      extraParams: 'Extra Parameters',
      extraParamsHelp: 'Key-value pairs added to the analysis request',
      addParam: 'Add Parameter',
      paramKey: 'Key',
      paramValue: 'Value',
      fieldMapping: 'API Field Mapping Reference',
      requestFields: 'Request (POST):',
      responseFields: 'Response:',
      inheritHelp: 'Disable to inherit from parent category. API URL is required when enabled.',
      apiUrlRequired: 'API URL is required when analysis config is enabled',
      apiKeyRequired: 'API Key is required when analysis config is enabled',
    },

    // Organization Prompts
    orgReferences: {
      title: 'Organization References',
      description: 'Manage references for this organization. These references are available to all organization members.',
      userDescription: 'Browse and create references for your organization. You can edit and delete your own references.',
      searchPlaceholder: 'Search references...',
      allContent: 'All Content',
      sfwOnly: 'SFW Only',
      nsfwOnly: 'NSFW Only',
      create: 'Create Reference',
      createPrompt: 'Create Reference',
      editPrompt: 'Edit Reference',
      import: 'Import',
      export: 'Export',
      deleteAll: 'Delete All',
      totalPrompts: '{count} references',
      noPrompts: 'No organization references found',
      createFirst: 'Create your first reference',
      edit: 'Edit',
      delete: 'Delete',
      titleLabel: 'Title',
      titlePlaceholder: 'Enter reference title',
      descriptionLabel: 'Description',
      descriptionPlaceholder: 'Enter reference description',
      bodyLabel: 'Prompt Body',
      bodyPlaceholder: 'Enter the prompt body text',
      categoriesLabel: 'Categories',
      selectCategory: 'Select a category...',
      validationError: 'Title, body, and at least one category are required',
      createSuccess: 'Reference created successfully',
      createError: 'Failed to create reference',
      updateSuccess: 'Reference updated successfully',
      updateError: 'Failed to update reference',
      deleteSuccess: 'Reference deleted successfully',
      deleteError: 'Failed to delete reference',
      deleteConfirmTitle: 'Delete Reference',
      deleteConfirmMessage: 'Are you sure you want to delete "{title}"?',
      deleteAllConfirmTitle: 'Delete All References',
      deleteAllConfirmMessage: 'Are you sure you want to delete ALL organization references? This action cannot be undone. Type "delete" to confirm.',
      deleteAllSuccess: 'Deleted {count} references',
      deleteAllError: 'Failed to delete all references',
      exportSuccess: 'Export completed',
      exportError: 'Failed to export references',
      importSuccess: 'Import completed',
      importError: 'Failed to import references',
      fetchError: 'Failed to load references',
      imported: 'imported',
      skipped: 'skipped',
      typeDeleteToConfirm: 'Type "delete" to confirm',
      createReference: 'Create Reference',
      editReference: 'Edit Reference',
      viewReference: 'View Reference',
      mediaSection: 'Media References',
      mediaCounter: 'References ({current}/{max})',
      mediaUpload: 'Upload',
      mediaFromGallery: 'Gallery',
      mediaRemove: 'Remove',
      mediaDragHint: 'Drop files here or click a button',
      mediaMaxReached: 'Maximum media files reached ({max})',
      maxImagesReached: 'Maximum images reached ({max})',
      maxVideosReached: 'Maximum videos reached ({max})',
      maxAudioReached: 'Maximum audio files reached ({max})',
      limitsImages: 'Images: max {count}, up to {size} MB',
      limitsVideo: 'Video: max {count}, up to {size} MB',
      limitsAudio: 'Audio: max {count}, up to {size} MB',
      limitsDuration: ', max {min} min',
      mediaTypeImage: 'Image',
      mediaTypeVideo: 'Video',
      mediaTypeAudio: 'Audio',
      bodyOptionalLabel: 'Additional Data (keywords, formula)',
      bodyOptionalPlaceholder: 'Enter additional keywords, formulas, or optional data',
      analyzeReferences: 'Analyze References',
      analyzingReferences: 'Analyzing...',
      analyzeError: 'Failed to analyze references',
      autoFillAll: 'Auto Fill All',
      autoFillField: 'Auto Fill',
      autoFilling: 'Filling...',
      autoFillLocked: 'Field locked',
      autoFillUnlocked: 'Field unlocked',
      autoFillHelpText: 'AI analyzes media and fills unlocked fields. Lock a field to keep its value.',
      analyseReferences: 'Analyse References',
      analyseReferencesHint: 'Click to auto-fill all fields based on provided references. Lock fields you don\'t want to change.',
      analyseReferencesNoMedia: 'Add references (images, video, or audio) above to enable analysis.',
      analysisPromptPlaceholder: 'Add instructions for AI analysis (optional)...',
      runAnalysis: 'Run Analysis',
      runAutoAnalysis: 'Run Auto Analysis',
      cancelAnalysis: 'Cancel',
      noAnalysisUrl: 'Analysis URL not configured for this category',
      previewPayload: 'Preview request data',
      previewPayloadTitle: 'Analysis Request Data Preview',
      previewCurrent: 'Current',
      previewCopy: 'Copy',
      previewCopied: 'Copied',
      saving: 'Saving...',
      save: 'Save',
      cancel: 'Cancel',
      uploading: 'Uploading...',
      uploadError: 'File upload failed',
    },

    // Personal References
    personalReferences: {
      title: 'My References',
      description: 'Your personal references collection. Create and manage your own references.',
      searchPlaceholder: 'Search references...',
      create: 'Create Reference',
      noReferences: 'No personal references found',
      createFirst: 'Create your first reference',
      totalReferences: '{count} references',
      pageOf: '{current} of {total}',
      totalLabel: 'Total: {count}',
      fetchError: 'Failed to load references',
      deleteConfirmTitle: 'Delete Reference',
      deleteConfirmMessage: 'Are you sure you want to delete "{title}"?',
      deleteSuccess: 'Reference deleted successfully',
      deleteError: 'Failed to delete reference',
      allCategories: 'All Categories',
    },

    // 3D model viewer (GLB/glTF preview)
    model3d: {
      loading: 'Loading 3D model…',
      error: 'Failed to load the 3D model',
      errorHint: 'The file may be corrupted or unsupported. You can still download it.',
      unsupportedFormat: 'No preview for this format',
      unsupportedFormatHint: 'In-app preview supports .glb and .gltf only. Download the file to open it in a 3D editor.',
      download: 'Download model',
      alt: '3D model',
      badge: '3D',
      placeholderHint: 'Open to view the model',
      infoTitle: 'Model Info',
      vertices: 'Vertices',
      triangles: 'Triangles',
      meshes: 'Meshes',
      materials: 'Materials',
      textures: 'Textures',
      fileSize: 'File size',
      dimensions: 'Dimensions',
    },

    // Session References (temporary media in widget)
    sessionReference: {
      addButton: 'Add Reference',
      modalTitle: 'Add Session References',
      dropzone: 'Drop files here or click to browse',
      addAction: 'Add',
      legend: 'Session',
      limitReached: 'Session media limit reached',
      imagesCount: 'Img',
      videosCount: 'Video',
      audioCount: 'Audio',
      processing: 'Processing...',
      unsupportedType: 'Unsupported file type',
      uploadFailed: 'Upload failed',
      mediaMetadataLoading: 'Selected video or audio metadata is still loading',
      mediaMetadataFailed: 'Unable to determine the duration of selected video or audio',
      mediaMetadataRetry: 'Retry media measurement',
      changesPending: 'Close the session reference dialog before generating',
      singlePerRequestUnsupported: 'Reference Builder video or audio is not supported by this workflow billing mode',
      descriptionLabel: 'Description',
      descriptionPlaceholder: 'Enter description for this reference...',
      helpTitle: 'Session References',
      helpWhatTitle: 'What are Session References?',
      helpWhatText: 'Session References are temporary media items (images, videos, audio) that you add for the current generation session. Each reference is sent to the AI model along with its description to guide the output.',
      helpDescTitle: 'Why add descriptions?',
      helpDescText: 'Descriptions are sent alongside the media to the model. They help the AI understand what the reference represents, what style elements to extract, or how to use it in generation. The more specific the description, the better the result.',
      helpVsTitle: 'Session vs. Saved References',
      helpVsText: 'Saved References (created via "Create Reference") are permanent, categorized, and shared within your organization. Session References are for one-off or experimental use — quickly upload a reference image for the current task without creating a permanent entry. Use Session References when you want to test an idea, use a reference once, or iterate quickly.',
      helpExamplesTitle: 'Examples',
      helpExample1: 'Upload a mood board image with description "dark gothic atmosphere, candlelight, velvet textures"',
      helpExample2: 'Add a color palette screenshot described as "use these exact color tones for the background"',
      helpExample3: 'Reference a character sketch with "main character pose and proportions, keep the outfit style"',
      clickToRemoveHoldPreview: 'Click to remove, hold for preview',
    },

    // Collections System
    collections: {
      title: 'Collections',
      description: 'Manage image collections',
      createCollection: 'Create Collection',
      editCollection: 'Edit Collection',
      deleteCollection: 'Delete Collection',
      collectionName: 'Collection Name',
      collectionDescription: 'Collection Description',
      isPrivate: 'Private Collection',
      isDefault: 'Default Collection',
      totalImages: 'Total Images',
      imagesThisMonth: 'This Month',
      topContributors: 'Top Contributors',
      permissions: 'Permissions',
      managePermissions: 'Manage Permissions',
      addToCollection: 'Add to Collection',
      removeFromCollection: 'Remove from Collection',
      selectCollections: 'Select Collections',
      noCollections: 'No collections found',
      defaultCollection: 'Default',
      privateCollection: 'Private',
      publicCollection: 'Public',
      characters: 'characters',
      privateDesc: 'Accessible only to selected users',
      publicDesc: 'Accessible to all organization members',
      defaultCollectionDesc: 'All new images are automatically added to this collection',
      descriptionColumn: 'Description',
      viewPermission: 'View',
      editPermission: 'Edit',
      adminPermission: 'Admin',
      grantPermission: 'Grant Permission',
      revokePermission: 'Revoke Permission',
      userEmail: 'User Email',
      permissionType: 'Permission Type',
      grantedBy: 'Granted By',
      grantedAt: 'Granted At',
      collectionCreated: 'Collection created',
      collectionUpdated: 'Collection updated',
      collectionDeleted: 'Collection deleted',
      cannotDeleteDefault: 'Cannot delete default collection',
      collectionNotFound: 'Collection not found',
      accessDenied: 'Access denied',
      addedToCollections: 'Added to collections',
      removedFromCollection: 'Removed from collection',
      favoriteTooltip: 'Add to collections',
      columns: {
        name: 'Name',
        description: 'Description',
        type: 'Type',
        images: 'Images',
        created: 'Created',
        actions: 'Actions'
      },
      modal: {
        createTitle: 'Create Collection',
        editTitle: 'Edit Collection',
        deleteTitle: 'Delete Collection',
        deleteMessage: 'Are you sure you want to delete this collection? All images will be removed from it.',
        selectTitle: 'Select Collections',
        permissionsTitle: 'Manage Permissions',
        namePlaceholder: 'Enter collection name',
        descriptionPlaceholder: 'Enter collection description (optional)',
        userEmailPlaceholder: 'email@example.com'
      },
      messages: {
        nameRequired: 'Collection name is required',
        nameExists: 'Collection with this name already exists',
        createSuccess: 'Collection created successfully',
        createError: 'Error creating collection',
        updateSuccess: 'Collection updated successfully',
        updateError: 'Error updating collection',
        deleteSuccess: 'Collection deleted successfully',
        deleteError: 'Error deleting collection',
        permissionGranted: 'Permission granted',
        permissionRevoked: 'Permission revoked',
        permissionError: 'Error managing permissions'
      },
      stats: {
        totalCollections: 'Total Collections',
        totalImages: 'Total Images',
        privateCollections: 'Private Collections',
        mostPopular: 'Most Popular'
      }
    },

    // Billing Section
    billing: {
      title: 'Billing',
      creditsTab: 'Credits',
      currentBalance: 'Current Balance',
      tokensRemaining: 'tokens remaining',
      purchaseTokens: 'Purchase Tokens',
      enterAmount: 'Enter amount',
      youWillGet: 'You will get',
      tokensLabel: 'tokens',
      minAmount: 'Minimum €100.00',
      purchase: 'Pay',
      processing: 'Processing...',
      securePayment: 'Secure payment powered by Stripe',
      vatExclusiveNote: 'If your organization is subject to VAT, tax will be added on top of the displayed price at checkout',
      purchaseSuccess: 'Tokens purchased successfully!',
      purchaseCancelled: 'Payment was cancelled',
      paymentSuccessTitle: 'Payment Successful!',
      paymentSuccessMessage: 'Tokens have been credited to your organization balance.',
      paymentSuccessTokens: 'Tokens credited',
      paymentSuccessAmount: 'Amount paid',
      paymentSuccessPackage: 'Package',
      paymentSuccessBonus: 'Bonus',
      paymentSuccessViewInvoices: 'View Invoices',
      paymentSuccessClose: 'Close',
      transactionHistory: 'Transaction History',
      noTransactions: 'No transactions yet',
      date: 'Date',
      amount: 'Amount',
      tokens: 'Tokens',
      status: 'Status',
      statusPending: 'Pending',
      statusCompleted: 'Completed',
      statusFailed: 'Failed',
      statusRefunded: 'Refunded',
      rateInfo: '1000 tokens per €1',
      used: 'Used',
      usedLast30Days: 'Used Last 30 Days',
      usedLast7Days: 'Used Last 7 Days',
      // Bundle mode
      selectBundle: 'Select a Token Bundle',
      noPackages: 'No packages available',
      bestValue: 'Best Value',
      bonus: 'bonus',
      baseTokens: 'base',
      orEnterCustomAmount: 'Or enter a custom amount',
      // Billing not available
      billingNotAvailable: 'Billing Not Available',
      billingNotAvailableDesc: 'Token purchases are not available for this organization. Please contact your administrator.',
      billingAddressRequired: 'Please fill in your billing address before making a purchase',
      fillBillingAddress: 'Fill Billing Address',
      // Payment details
      billingType: 'Billing Type',
      pay: 'Pay',
      type: 'Type',
      enterpriseLabel: 'Enterprise',
      standardLabel: 'Standard',
      accessDenied: 'Access Denied',
      accessDeniedDescription: 'Only organization administrators and managers can top up balance and manage billing data.',
      yourRole: 'Your current role:',
    },

    // Billing Address
    billingAddress: {
      title: 'Billing Address',
      subtitle: 'Legal entity details for invoices',
      legalName: 'Legal Entity Name',
      legalNamePlaceholder: 'Immersive Tech Ltd',
      addressLine1: 'Address Line 1',
      addressLine1Placeholder: '28 Oktovriou, 367, Mediterranean Court',
      addressLine2: 'Address Line 2',
      addressLine2Placeholder: 'Suite, unit (optional)',
      city: 'City',
      cityPlaceholder: 'Limassol',
      postalCode: 'Postal Code',
      postalCodePlaceholder: '3107',
      state: 'State / Region',
      statePlaceholder: 'Region (optional)',
      country: 'Country',
      countryPlaceholder: 'Select a country',
      vatType: 'Tax ID Type',
      vatTypePlaceholder: 'Select type',
      vatId: 'Tax ID',
      vatIdPlaceholder: 'e.g. DE123456789',
      billingEmail: 'Billing Email',
      billingEmailPlaceholder: 'billing@company.com',
      save: 'Save',
      saving: 'Saving...',
      saveSuccess: 'Billing address saved successfully',
      saveError: 'Failed to save billing address',
      loadError: 'Failed to load billing address',
      required: 'Required field',
      noChanges: 'No changes to save',
      addressSavedTaxFailed: 'Address was saved, but the Tax ID is invalid. Please correct and save again.',
      taxIdErrorTitle: 'Tax ID Error',
      taxIdExpectedFormat: 'Expected format',
      taxIdErrorClose: 'Close',
      searchCountry: 'Search country...',
    },

    // Invoices
    invoices: {
      title: 'Invoices',
      subtitle: 'Invoice history from Stripe',
      invoiceNumber: 'Invoice #',
      date: 'Date',
      amount: 'Amount',
      status: 'Status',
      download: 'Download PDF',
      view: 'View',
      noInvoices: 'No invoices',
      noInvoicesDesc: 'Invoices will appear after your first payment',
      statusPaid: 'Paid',
      statusOpen: 'Open',
      statusDraft: 'Draft',
      statusVoid: 'Void',
      statusUncollectible: 'Uncollectible',
      loadError: 'Failed to load invoices',
      type: 'Type',
      tokens: 'Tokens',
      typeEnterprise: 'Enterprise',
    },

    // Auto Top-Up
    autoTopUp: {
      title: 'Auto Top-Up',
      subtitle: 'Automatically replenish tokens when balance is low',
      enabled: 'Enabled',
      disabled: 'Disabled',
      threshold: 'Balance threshold',
      thresholdHelp: 'Auto top-up will trigger when balance drops below this value',
      topupAmount: 'Top-up amount (excl. VAT)',
      topupAmountHelp: 'Net amount per top-up — VAT is added on top when charged',
      tokensEquivalent: '≈ {tokens} tokens',
      monthlyLimit: 'Monthly limit (excl. VAT)',
      monthlyLimitHelp: 'Maximum auto top-up spending per month, excluding VAT',
      monthlySpent: 'Spent this month (excl. VAT)',
      monthlyProgress: '{spent} of {limit} EUR',
      paymentMethod: 'Payment method',
      noPaymentMethod: 'No card saved. Make your first purchase to save a card.',
      cardEnding: 'Card •••• {last4}',
      expires: 'Expires {month}/{year}',
      lastError: 'Last error',
      save: 'Save',
      enableRequiresCard: 'A saved card is required to enable auto top-up',
      successEnabled: 'Auto top-up enabled',
      successDisabled: 'Auto top-up disabled',
      successUpdated: 'Auto top-up settings updated',
    },

    // Saved payment cards (Payment Methods billing tab)
    savedCards: {
      title: 'Payment Methods',
      defaultCard: 'Default',
      deleteCard: 'Delete card',
      confirmDeleteCard: 'Delete this saved card? This action cannot be undone.',
      cardDeleted: 'Card deleted',
      cardDeleteFailed: 'Failed to delete card',
      autoTopupDisabledNoCard: 'Card deleted. Auto top-up disabled — no card left to charge.',
      noCard: 'No saved cards. Make a purchase to save a card automatically.',
      cardEnding: 'Card •••• {last4}',
      expires: 'Expires {month}/{year}',
      addCard: 'Add card',
      makeDefault: 'Make default',
      cardAdded: 'Card added',
      cardAddCancelled: 'Card addition cancelled',
      addCardFailed: 'Failed to add card',
      makeDefaultFailed: 'Failed to set default card',
      defaultUpdated: 'Default card updated',
    },

    // Admin Billing
    adminBilling: {
      title: 'Billing Management',
      totalRevenue: 'Revenue',
      totalTokens: 'Tokens Sold',
      totalTransactions: 'Transactions',
      completed: 'Completed',
      pending: 'Pending',
      failed: 'Failed',
      searchPlaceholder: 'Search by organization or email...',
      allStatuses: 'All Statuses',
      statusPending: 'Pending',
      statusCompleted: 'Completed',
      statusFailed: 'Failed',
      statusRefunded: 'Refunded',
      transactionHistory: 'Transaction History',
      noTransactions: 'No transactions found',
      date: 'Date',
      organization: 'Organization',
      user: 'User',
      amount: 'Amount',
      tokens: 'Tokens',
      status: 'Status',
      provider: 'Provider',
      showing: 'Showing',
      of: 'of',
      previous: 'Previous',
      next: 'Next',
      // Purchase type
      purchaseType: 'Type',
      typeBundle: 'Bundle',
      typeEnterprise: 'Enterprise',
      packageName: 'Package',
      // Export
      exportCSV: 'Export CSV',
      exporting: 'Exporting...',
      noDataToExport: 'No data to export',
      exportError: 'Failed to export data',
      exportModalTitle: 'Export Billing Data',
      selectOrganizations: 'Organizations',
      selectAll: 'Select all',
      deselectAll: 'Deselect all',
      selectedCount: 'Selected: {count}',
      period: 'Period',
      exportProgress: 'Exporting: {org} ({current}/{total})',
      searchOrganizations: 'Search organizations...',
      cancel: 'Cancel',
      downloadCSV: 'Download CSV',
      month1: '1 month',
      month3: '3 months',
      month6: '6 months',
      year1: '1 year',
      custom: 'Custom',
      dateFrom: 'From date',
      dateTo: 'To date'
    },

    // Admin Refunds
    adminRefunds: {
      title: 'All Refunds',
      subtitle: 'Refunded tokens across all organizations',
      // Stats card
      statsTitle: '7-Day Statistics',
      totalRefunds: 'Total Refunds',
      totalRefundedTokens: 'Tokens Refunded',
      refundRate: 'Refund Rate',
      totalGenerations: 'Total Generations',
      last7Days: 'Last 7 days',
      topWorkflows: 'Top Workflows by Refunds',
      dailyChart: 'Daily Refunds',
      noRefundsInWindow: 'No refunds in this period',
      // Table columns
      date: 'Date',
      organization: 'Organization',
      user: 'User',
      workflow: 'Workflow',
      tokensCost: 'Tokens',
      errorMessage: 'Error Message',
      actions: 'Actions',
      viewData: 'Data',
      // Filters
      allWorkflows: 'All Workflows',
      filterByWorkflow: 'Filter by workflow',
      dateFrom: 'From date',
      dateTo: 'To date',
      resetFilters: 'Reset',
      // Pagination
      showing: 'Showing',
      of: 'of',
      previous: 'Previous',
      next: 'Next',
      // States
      loading: 'Loading...',
      noRefunds: 'No refunds found',
      noRefundsDescription: 'No refunds for the selected period',
      fetchError: 'Failed to load data',
      retryLoad: 'Retry',
      // Misc
      refunds: 'refunds',
      tokens: 'tokens',
      rate: '%',
      clearSelection: 'Clear selection',
      noResultsFor: 'No results for',
    },

    // Admin Service API Keys (lmx_adm_*)
    adminApiKeys: {
      title: 'Service API Keys',
      subtitle: 'lmx_adm_* keys for machine access to workflow configuration',
      createKey: 'Create Key',
      colName: 'Name',
      colScopes: 'Scopes',
      colPrefix: 'Prefix',
      colStatus: 'Status',
      colLastUsed: 'Last Used',
      colUsage: 'Usage',
      colExpires: 'Expires',
      colActions: 'Actions',
      statusActive: 'Active',
      statusRevoked: 'Revoked',
      statusExpired: 'Expired',
      edit: 'Edit',
      revoke: 'Revoke',
      never: '—',
      noExpiry: 'Never',
      noKeys: 'No keys yet. Create one to get started.',
      loading: 'Loading...',
      createTitle: 'Create Service Key',
      editTitle: 'Edit Service Key',
      nameLabel: 'Name',
      namePlaceholder: 'e.g. dify-migration',
      descriptionLabel: 'Description',
      descriptionPlaceholder: 'Optional description...',
      scopesLabel: 'Scopes',
      scopesHint: 'Select at least one scope',
      expiresLabel: 'Expiry (optional)',
      rateMinuteLabel: 'Rate/min',
      rateHourLabel: 'Rate/hour',
      nameRequired: 'Name is required',
      scopesRequired: 'Select at least one scope',
      save: 'Save',
      create: 'Create',
      cancel: 'Cancel',
      scopeWorkflows: 'Workflows',
      actionRead: 'Read',
      actionCreate: 'Create',
      actionUpdate: 'Update',
      actionDelete: 'Delete',
      keyCreatedTitle: 'Service Key Created',
      keyCreatedWarning: 'This is the only time you will see this key. Copy it now and store it securely.',
      copy: 'Copy',
      copied: 'Copied',
      done: 'Done',
      revokeConfirm: 'Are you sure you want to revoke this key? Access will stop immediately.',
      loadError: 'Failed to load keys',
      createSuccess: 'Key created',
      createError: 'Failed to create key',
      updateSuccess: 'Key updated',
      updateError: 'Failed to update key',
      revokeSuccess: 'Key revoked',
      revokeError: 'Failed to revoke key',
      copyError: 'Failed to copy key',
      auditTitle: 'Audit Log',
      auditFilterLabel: 'Filter by key',
      auditAllKeys: 'All keys',
      auditWhen: 'When',
      auditKey: 'Key',
      auditAction: 'Action',
      auditResource: 'Resource',
      auditStatus: 'Status',
      auditError: 'Error',
      auditEmpty: 'No audit entries yet',
      auditLoadError: 'Failed to load audit log',
      showing: 'Showing',
      of: 'of',
      previous: 'Previous',
      next: 'Next',
      page: 'Page',
      perPage: 'Per page',
    },

    // Admin Packages
    adminPackages: {
      title: 'Token Packages',
      createPackage: 'Create Package',
      editPackage: 'Edit Package',
      packagesList: 'Packages List',
      noPackages: 'No token packages found',
      createFirst: 'Create your first package',
      infoBannerTitle: 'Token Bundle System',
      infoBannerText: 'Standard organizations purchase from these predefined bundles. Enterprise organizations use pay-what-you-want pricing.',
      // Table columns
      columnOrder: 'Order',
      columnName: 'Name',
      columnPrice: 'Price',
      columnBaseTokens: 'Base Tokens',
      columnBonus: 'Bonus %',
      columnTotalTokens: 'Total Tokens',
      columnStatus: 'Status',
      columnActions: 'Actions',
      // Form fields
      fieldName: 'Package Name',
      fieldPrice: 'Price (USD)',
      fieldTokens: 'Base Tokens',
      fieldBonus: 'Bonus Percent',
      fieldSortOrder: 'Sort Order',
      fieldDescription: 'Description',
      fieldActive: 'Active (visible to users)',
      optional: 'optional',
      // Actions
      edit: 'Edit',
      delete: 'Delete',
      confirmDelete: 'Confirm',
      cancel: 'Cancel',
      save: 'Save Changes',
      create: 'Create Package',
      saving: 'Saving...',
      deleting: 'Deleting...',
      preview: 'Preview',
      statusActive: 'Active',
      statusInactive: 'Inactive',
      // Delete confirmation modal
      deleteConfirmTitle: 'Delete Package',
      deleteConfirmText: 'Are you sure you want to delete this package?',
      deleteConfirmWarning: 'This will mark the package as inactive. It can be reactivated later.'
    },

    // Workflow Page
    workflow: {
      selectWorkflow: 'Select a Workflow',
      selectWorkflowDesc: 'Choose a workflow to start generating media',
      workflowLabel: 'Workflow',
      selectWorkflowPlaceholder: 'Choose a workflow...',
      availableWorkflows: 'available workflows',
      videoComingSoon: 'Video Generation Coming Soon',
      videoComingSoonDesc: 'Video generation features will be available soon',
      loadingWorkflows: 'Loading Workflows...',
      noWorkflows: 'No Workflows Available',
      noWorkflowsDesc: 'No workflows are available for your organization. Contact your administrator.',
      imageGeneration: 'Image Generation',
      imageGenerationDesc: 'Create stunning AI-generated images with advanced tools and prompts.',
      comingSoon: 'New interface coming soon...',
      backToWorkflows: 'Back to Workflows',
      noWidgets: 'No Widgets Configured',
      noWidgetsDesc: 'This workflow has no widgets configured yet.',
      widgetComingSoon: 'Widget implementation coming soon',
      widgetLoadFailed: 'Failed to load settings',
      widgetLoadRetry: 'Retry',
      widgetLoading: 'Settings are still loading — try again in a moment',
      public: 'Public',
      restricted: 'Restricted',
      selectOrganization: 'Select Organization',
      selectOrganizationDesc: 'Select an active organization from the sidebar to access workflows.',
      generate: 'Generate',
      generateVideo: 'Generate Video',
      searchWorkflows: 'Search workflows...',
      searchWorkflowsPlaceholder: 'Search by title or description...',
      noWorkflowsFound: 'No workflows found',
      allWorkflows: 'All Workflows',
      filterByTag: 'Filter by tag',
      noWorkflowsWithTag: 'No workflows with this tag',
      showArchived: 'Show archived',
      newBadge: 'New',
      archivedBadge: 'Archived',
      favorites: 'Favorites',
      addToFavorites: 'Add to favorites',
      removeFromFavorites: 'Remove from favorites',
      keyboardShortcutMac: '⌘↩',
      keyboardShortcutWindows: 'Ctrl+↩',
      promptRequired: 'Please enter a prompt for generation',
      // Image size constraints
      imageSizeConstraints: 'Image Size Constraints',
      imageSizeConstraintsDesc: 'Set minimum and maximum image dimensions for Input Images widget. Leave empty for no restrictions.',
      minWidth: 'Min Width',
      minHeight: 'Min Height',
      maxWidth: 'Max Width',
      maxHeight: 'Max Height',
      defaultWidth: 'Default Width',
      defaultHeight: 'Default Height',
      tokensPerGeneration: 'tokens per generation',
      tokensForGeneration: 'tokens for generation',
      tokensForGenerations: 'tokens for generations',
      tokensRemaining: 'Tokens remaining',
      topUpTokens: 'Top up tokens',
      tokensTotal: 'tokens total',
      perRequest: 'per request',
      requests: 'requests',
      tokensEach: 'tokens each',
      requiresImages: 'Add images to calculate cost',
      requiresAudio: 'Add audio to calculate cost',
      requiresVideo: 'Add video to calculate cost',
      requiresAudioOrVideo: 'Add audio or video to calculate cost',
      requiresPrompt: 'Enter prompt to calculate cost',
      requiresText: 'Enter text to calculate cost',
      requiresAnyInput: 'Provide',
      inputAudio: 'audio',
      inputVideo: 'video',
      inputPrompt: 'prompt',
      inputText: 'text',
      orSeparator: 'or',
      invalidPricingFormula: 'Invalid pricing formula. Contact administrator.',
      invalidPricingAggregate: INVALID_PRICING_AGGREGATE_MESSAGES.en,
      contentPolicyChargeNotice: 'When the request is deemed to be in violation of content policy, the generation will still be charged.',
      calculating: 'Calculating...',
      limitExceededTitle: 'Token Limit Exceeded',
      organizationLimitExceeded: 'Organization token limit has been exceeded. Please contact your administrator.',
      actions: {
        generate: 'Generate',
        upscale: 'Upscale',
        process: 'Process',
        create: 'Create'
      },
      generating: 'Generating...',
      enhancing: 'Enhancing prompt...',
      processingAsync: 'Processing...',
      textNoContent: 'Text generated',
      pending: 'Pending...',
      queued: '{count} Queued',
      noSmallWidgets: 'No Small Widgets',
      noSmallWidgetsDesc: 'This workflow has no small widgets for the sidebar.',
      accessDenied: 'Access Denied',
      accessDeniedHint: 'This workflow is not available for your organization.',
      // Input Media Widget settings
      mediaContentSettings: 'Media Content Settings',
      mediaContentSettingsDesc: 'Configure limits for each media type. Leave empty for defaults.',
      imagesSettings: 'Images',
      videoSettings: 'Video',
      audioSettings: 'Audio',
      maxCount: 'Max Count',
      maxFileSize: 'Max Size (MB)',
      maxDuration: 'Max Duration (s)',
      validationError: 'Validation Error',
      // Pipeline step progress
      pipelineStep: 'Step {current}/{total}: {name}',
      pipelineStepCompact: '{current}/{total}',
      priceWithoutDiscount: 'Price without discount',
    },

    // Widgets
    widgets: {
      generationSettings: 'Generation Settings',
      generationSettingsDesc: 'Widget for configuring image generation parameters',
      styleSelector: 'Style Selector',
      styleSelectorDesc: 'Widget for selecting visual styles',
      imageUpload: 'Image Upload',
      imageUploadDesc: 'Widget for uploading reference images',
      promptEditor: 'Prompt Editor',
      promptEditorDesc: 'Edit and enhance your generation prompts',
      gallery: 'Content Gallery',
      galleryDesc: 'View and manage generated content',
      imageSize: 'Image Size',
      numImages: 'Number of Images',
      inferenceSteps: 'Inference Steps',
      fast: 'Fast',
      quality: 'Quality',
      guidanceScale: 'Guidance Scale',
      precise: 'Precise',
      creative: 'Creative',
      safety: 'Safety',
      safetyDisabled: 'Disabled',
      safetyStrict: 'Strict',
      safetyBalanced: 'Balanced',
      safetySoft: 'Soft',
      noStyles: 'No styles available',
      noStylesDesc: 'Contact your administrator to add styles',
      noStyle: 'No Style',
      noStyleDesc: 'Generate without style modification',
      loadingStyles: 'Loading styles...',
      searchStyles: 'Search styles...',
      noStylesFound: 'No styles found',
      stylePrompt: 'Style Prompt:',
      noPrompt: 'No Template',
      styleTemplate: 'Style Template',
      promptTemplate: 'Prompt Template',
      promptText: 'Prompt Text',
      loadingPrompts: 'Loading prompts...',
      expand: 'Expand',
      collapse: 'Collapse',
      prompt: 'Prompt',
      view: 'View',
      promptTitle: 'Style Prompt',
      aspectRatio: 'Aspect Ratio',
      aspectRatioDesc: 'Choose the aspect ratio for your generated images',
      numImagesDesc: 'Number of images to generate in one batch (1-16)',
      inferenceStepsDesc: 'Number of denoising steps. More steps = higher quality but slower generation',
      guidanceScaleDesc: 'How closely the AI follows your prompt. Higher values = more precise, lower values = more creative',
      safetyDesc: 'Content safety filter level. Disabled allows any content, Strict blocks most adult content',
      promptEnhancer: 'Prompt Enhancer',
      promptEnhancerDesc: 'Choose and enhance basic prompts',
      searchPrompts: 'Search prompts...',
      noPrompts: 'No prompts available',
      noPromptsDesc: 'Contact your administrator to add basic prompts',
      noPromptsFound: 'No prompts found',
      enterTextToTranslate: 'Enter text to translate',
      translatePrompt: 'Translate prompt',
      enterTextToEnhance: 'Enter text to enhance',
      enhancePrompt: 'Enhance prompt',
      selectTemplateAndEnterText: 'Select Style or Prompt Template and enter text to enhance',
      collectionsSelector: 'Collections Selector',
      collectionsSelectorDesc: 'Select collections to organize your generated images',
      originalPrompt: 'Original Prompt',
      enhancedPrompt: 'Enhanced Prompt',
      swapPrompts: 'Swap prompts',
      clearPrompt: 'Clear',
      translationError: 'Translation error',
      enhancePromptError: 'Enhance prompt error',
      dynamicWidget: 'Dynamic Widget',
      dynamicWidgetLoading: 'Loading widget configuration...',
      noFieldsConfigured: 'No fields configured for this widget',
      searchOptions: 'Search options...',
      searchOptionsLabel: 'Search options',
      refineOptions: 'Showing the first {count} options. Refine your search.',
      maxSelections: 'Maximum: {max}',
      
      // Input Images Widget
      inputImages: {
        title: 'Input Images',
        dropHere: 'Drop images here',
        dragOrClick: 'Drag images here or click to select',
        supportedFormats: 'Supports PNG, JPG, GIF, WEBP',
        maxImages: 'Max {max} images',
        noImages: 'No images uploaded',
        dragToStart: 'Drag and drop images to get started',
        selectAll: 'Select All',
        deselectAll: 'Deselect All',
        removeSelected: 'Remove Selected',
        pasteFromClipboard: 'Or press Ctrl+V to paste from clipboard',
        addMoreImages: 'Add more images to your collection',
        // Image size validation
        imageTooSmall: 'Image is too small',
        imageTooLarge: 'Image is too large',
        rejectedImages: 'Some images were rejected',
        invalidImage: 'Failed to load image'
      },

      // Input Media Widget (images, video, audio)
      inputMedia: {
        dropHere: 'Drop files here',
        dragOrClick: 'Drag files here or click to select',
        selectFromGallery: 'Select from gallery',
        gallerySelectionTitle: 'Select media from gallery',
        images: 'Images',
        videos: 'Videos',
        audio: 'Audio files',
        noMediaAllowed: 'No media types allowed',
        fileTooLarge: 'File too large',
        limitReached: 'Limit reached',
        durationTooShort: 'Duration too short',
        durationTooLong: 'Duration too long',
        invalidFile: 'Failed to load file',
        rejectedFiles: 'Files Rejected',
        limits: 'Limits',
        filename: 'Filename',
        dimensions: 'Dimensions',
        filesize: 'Size',
        selectedFromGallery: 'From gallery',
        maxSelectionReached: 'Selection limit reached',
        confirmSelection: 'Confirm selection',
        selectedCount: 'Selected',
        search: 'Search',
        addFromGallery: 'From gallery',
        addFromDisk: 'From disk',
        galleryDescription: 'Your generated files',
        imageAutoResized: 'Image resized to fit allowed dimensions',
        imageAutoCompressed: 'Image compressed to fit size limit',
        imageAutoResizedAndCompressed: 'Image resized and compressed',
        imageCroppedToTarget: 'Cropped to',
        imageResizedToTarget: 'Resized to',
        imageConvertedToJpeg: 'Converted to JPEG',
        imageCroppedAndConverted: 'Cropped and converted to JPEG',
        imageResizedAndConverted: 'Resized and converted to JPEG',
        imageAutoProcessedInfo: 'Automatically processed',
        selectionCounter: 'selected',
        selectionLimitReached: 'Limit reached',
        selectedSection: 'Selected',
        clearAllSelection: 'Clear all',
        videoWidthTooSmall: 'Video width too small',
        videoWidthTooLarge: 'Video width too large',
        videoHeightTooSmall: 'Video height too small',
        videoHeightTooLarge: 'Video height too large',
        videoPixelsTooSmall: 'Video pixel count too small',
        videoPixelsTooLarge: 'Video pixel count too large',
        videoMetadataLoading: 'Loading video metadata'
      },

      // Slots Input Media Widget
      slotsInputMedia: {
        title: 'Input Media',
        noSlotsConfigured: 'No slots configured',
        dropOrClick: 'Drop or click',
        upload: 'Upload',
        gallery: 'Gallery',
        paste: 'Paste',
        noImageInClipboard: 'No image in clipboard',
        required: 'Required',
        expectedType: 'Expected type',
        unsupportedFormat: 'Unsupported format',
        allowedFormats: 'Allowed formats',
        fileRejected: 'File rejected',
        modelType: '3D Model',
        modelMaxFileSizeHint: 'Maximum file size: {size} MB',
        modelUnsupportedInSmall: '3D models are supported only by the large slots media widget.',
        cropped: 'Cropped — click to adjust',
        cropModal: {
          title: 'Adjust Crop',
          apply: 'Apply',
          cancel: 'Cancel',
          resetCenter: 'Reset to Center',
          zoom: 'Zoom',
          error: 'Failed to apply crop',
        },
        errors: {
          invalidUrl: 'Invalid 3D model URL',
          fileTooLarge: 'File too large',
          durationTooShort: 'Duration too short',
          durationTooLong: 'Duration too long',
          videoWidthTooSmall: 'Video width too small',
          videoWidthTooLarge: 'Video width too large',
          videoHeightTooSmall: 'Video height too small',
          videoHeightTooLarge: 'Video height too large',
          videoPixelsTooSmall: 'Video pixel count too small',
          videoPixelsTooLarge: 'Video pixel count too large',
          stillProcessing: 'Images are still being processed',
          processingFailed: 'Failed to process image'
        }
      },

      // 3D Camera Control Widget
      camera3d: {
        title: '3D Camera Control',
        horizontalAngle: 'Horizontal',
        verticalAngle: 'Vertical',
        zoom: 'Zoom',
        horizontalAngleLabel: 'Horizontal Angle',
        verticalAngleLabel: 'Vertical Angle',
        zoomLabel: 'Zoom',
        presets: {
          front: 'Front',
          back: 'Back',
          left: 'Left',
          right: 'Right',
          top: 'Top',
          low: 'Low',
          threeQuarter: '3/4'
        },
        helpTitle: '3D Camera Control Help',
        helpWhatIs: 'What is the 3D Camera Control?',
        helpWhatIsDesc: 'This widget allows you to control camera position and angle for multi-view image generation.',
        helpControls: 'Controls',
        helpHorizontal: 'Green ring: Horizontal rotation angle',
        helpVertical: 'Pink arc: Vertical angle',
        helpZoom: 'Orange handle: Camera zoom',
        helpUsage: 'How to Use',
        helpUsageDesc: 'Drag the colored handles in the 3D view or use the sliders below. Use preset buttons for quick camera positioning.'
      },

      // AuraSR Upscale Settings Widget
      auraSrUpscale: {
        title: 'Upscale Settings',
        description: 'Configure upscaling parameters',
        upscalingFactor: 'Upscaling Factor',
        upscalingFactorDesc: 'Image upscaling multiplier. Currently only 4x is supported.',
        checkpoint: 'Checkpoint',
        checkpointDesc: 'Model version to use. v1 is more stable, v2 has latest improvements.',
        checkpointV1: 'v1 (Stable)',
        checkpointV2: 'v2 (Latest)',
        overlappingTiles: 'Overlapping Tiles',
        overlappingTilesDesc: 'Removes seams between tiles but doubles processing time. Use for better quality at cost of speed.',
        overlappingEnabled: 'Enabled (2x slower)',
        overlappingDisabled: 'Disabled (faster)',
        overlappingWarning: 'This will double the processing time but provide better quality by removing tile seams.'
      },

      // Clarity Upscaler Settings Widget
      clarityUpscaler: {
        title: 'Clarity Upscaler Settings',
        description: 'Configure clarity upscaling parameters',
        upscaleFactor: 'Upscale Factor',
        upscaleFactorDesc: 'Image upscaling multiplier from 1x to 4x',
        resemblance: 'Resemblance',
        resemblanceDesc: 'How much the upscaled image should resemble the original. Higher values preserve original appearance.',
        hiddenParamsInfo: 'Additional parameters are automatically configured for optimal results'
      },
      searchCollections: 'Search collections...',
      selectCollections: 'Search collections...',
      loadingCollections: 'Loading collections...',
      noCollectionsFound: 'No collections found',
      oneCollectionSelected: '1 collection selected',
      collectionsSelected: '{count} collections selected',
      selectedCollections: 'Selected Collections',
      selectedWorkflows: 'Selected Workflows',
      selectedUsers: 'Selected Users',
      selected: 'selected',
      
      // Gallery Filters Widget
      galleryFilters: 'Gallery Filters',
      galleryFiltersDesc: 'Filter and search gallery content',
      
      // Tooltips
      dateRangeTooltip: 'Filter images by creation date range',
      collectionsTooltip: 'Filter by collections containing the images',
      workflowsTooltip: 'Filter by workflow used to generate images',
      usersTooltip: 'Filter by users who created the images',
      dateFromTooltip: 'Start date for filtering',
      dateToTooltip: 'End date for filtering',
      clearFiltersTooltip: 'Remove all active filters and show all images',
      contentTypeTooltip: 'Filter by media type (images, videos, audio, or 3D)',
      selectedContentTypes: 'Selected content types',
      approveStateTooltip: 'Filter by like / dislike / approved mark',
      selectedApproveState: 'Selected approve state',
      removeFromSelection: 'Remove from selection'
    },

    // Mask Editor Modal
    maskEditor: {
      title: 'Mask Editor',
      brush: 'Brush',
      eraser: 'Eraser',
      brushSize: 'Brush size',
      undo: 'Undo',
      clear: 'Clear',
      zoomIn: 'Zoom in',
      zoomOut: 'Zoom out',
      apply: 'Apply',
      cancel: 'Cancel',
      hint: 'Paint over the area you want to edit. Unpainted areas stay unchanged.',
      openButton: 'Mask',
      maskApplied: 'Mask applied',
      maskNotReady: 'Mask is not ready yet — wait for export to finish',
      duplicateKey: 'Multiple slots use the same mask key — set distinct keys',
      keyCollision: 'Mask key collides with another request field — set a unique key',
      exportFailed: 'Failed to export mask',
      polygon: 'Polygon',
      polygonHint: 'Click to drop points. Double-click or Enter to close the area.',
      addImage: 'Add image',
      commitImage: 'Apply image',
      removeImage: 'Remove image',
      resizeHint: 'Drag the body to move, corners to resize, the top handle to rotate (Shift: snap 15° and free stretch).',
      rotateHint: 'Drag to rotate (hold Shift to snap to 15°)',
      tabCrop: 'Crop',
      tabMask: 'Mask',
    },

    // Organization Selector
    orgSelector: {
      selectOrganization: 'Select organization',
      exhausted: 'exhausted',
      availableOrganizations: 'Available organizations',
      memberSince: 'Member since',
      organizationInfo: 'Organization info',
      management: 'Management',
      adminPanel: 'Admin panel'
    },

    // Common UI elements
    common: {
      close: 'Close',
      save: 'Save',
      cancel: 'Cancel',
      create: 'Create',
      edit: 'Edit',
      delete: 'Delete',
      deleting: 'Deleting...',
      add: 'Add',
      saving: 'Saving...',
      loading: 'Loading...',
      understood: 'Got it!',
      loadMore: 'Load More',
      selectOrganization: 'Select Organization',
      selectOrganizationDesc: 'Please select an organization to view the gallery',
      error: 'An error occurred',
      processing: 'Processing...',
      safe: 'Safe',
      nsfw: 'NSFW',
      off: 'Off',
      on: 'On'
    },


    // Manager page
    manager: {
      title: 'Organization Management',
      organizationLimit: 'Organization Limit',
      organizationTokens: 'Organization Tokens',
      remaining: 'Remaining',
      allGenerationsHistory: 'All Generations History',
      inviteUser: 'Invite User',
      userManagement: 'User Management',
      users: 'Users',
      role: 'Role',
      customLimits: 'Custom Limits',
      limitGroup: 'Group',
      limits: 'Limits',
      usage: 'Usage',
      actions: 'Actions',
      setLimit: 'Set Limit',
      changeRole: 'Change Role',
      viewHistory: 'History',
      editUsage: 'Edit Usage',
      editUsageTitle: 'Edit Used Tokens Count',
      currentUsage: 'Current Usage',
      newUsage: 'New Value',
      usageUpdated: 'Usage updated',
      invalidUsageValue: 'Value must be a number >= 0',
      noUsers: 'No users found',
      loading: 'Loading...',
      error: 'Error',
      limitSet: 'Limit set',
      roleChanged: 'Role changed',
      userInvited: 'User successfully invited',
      inviteSuccess: 'User invited',
      invitePending: 'Invitation sent. The user will join the organization after signing in with Google:',
      invitePendingNoEmail: 'User added as pending, but the invitation email was not sent:',
      pendingInvitations: 'Pending Invitations',
      pendingInvited: 'Invited',
      pendingExpires: 'Expires',
      resendInvite: 'Resend invitation',
      deletePendingInvite: 'Cancel pending invitation',
      confirmDeletePending: 'Cancel the pending invitation for',
      pendingInviteDeleted: 'Pending invitation cancelled:',
      pendingInviteResent: 'Invitation resent:',
      pendingInviteResendFailed: 'Invitation refreshed, but the email could not be sent:',
      sharedPoolMode: 'Shared Pool Mode',
      sharedPoolInfo: 'Shared Token Pool',
      sharedPoolDescription: 'All users in this organization share a common pool of {limit} tokens. Individual limits are not applied.',
      individualLimitsNotUsed: 'Individual limits are not used in shared pool mode',
      globalAdminMode: 'You are working in global administrator mode with an organization you are not a member of.',
      backToAdmin: 'Back to Admin Panel',
      adminMode: 'Administrator Mode'
    },

    // Organization History page
    orgHistory: {
      title: 'Organization History',
      adminMode: 'Administrator Mode',
      adminWarning: 'You are working in global administrator mode with an organization you are not a member of.',
      backToAdmin: 'Back to Admin Panel',
      insufficientRights: 'Insufficient Rights',
      accessRequiredMessage: 'Admin or Manager rights required to access history',
      filters: 'Filters',
      searchByPrompt: 'Search by Prompt',
      searchPromptPlaceholder: 'Search by prompt text...',
      generationMode: 'Generation Mode',
      workflow: 'Workflow',
      searchWorkflowPlaceholder: 'Search by workflow ID...',
      allModes: 'All Modes',
      allWorkflows: 'All Workflows',
      user: 'User',
      allUsers: 'All Users',
      historyTitle: 'Generation History',
      loadingHistory: 'Loading history...',
      historyEmpty: 'Generation history is empty',
      date: 'Date',
      prompt: 'Prompt',
      mode: 'Mode',
      result: 'Result',
      images: 'Images',
      data: 'Data',
      cost: 'Cost',
      success: 'Success',
      error: 'Error',
      copyPromptHint: 'Click to copy',
      loadMore: 'Load More',
      loading: 'Loading...',
      promptCopied: 'Prompt copied to clipboard',
      promptCopyFailed: 'Failed to copy prompt',
      actions: 'Actions',
      deleteGeneration: 'Delete generation',
      deleteNotAllowed: 'Only global admins can delete generations',
      confirmDelete: 'Are you sure you want to delete this generation?',
      deleteSuccess: 'Generation deleted successfully',
      deleteFailed: 'Failed to delete generation',
      editGeneration: 'Edit generation',
      editGenerationTitle: 'Edit Generation Cost',
      tokenPrice: 'Token Price',
      tokenStatus: 'Token Status',
      tokenStatusPending: 'Pending',
      tokenStatusCompleted: 'Completed',
      tokenStatusRefunded: 'Refunded',
      saveChanges: 'Save Changes',
      editSuccess: 'Generation updated successfully',
      editFailed: 'Failed to update generation',
      prevPage: 'Previous',
      nextPage: 'Next',
      page: 'Page',
      showing: 'Showing',
      of: 'of',
      results: 'results',
      perPage: 'Per page',
      // Export functionality
      export: {
        button: 'Export Report',
        title: 'Export Statistics',
        period: 'Period',
        month1: '1 month',
        month3: '3 months',
        month6: '6 months',
        year1: '1 year',
        custom: 'Custom',
        dateFrom: 'From date',
        dateTo: 'To date',
        filterUser: 'User',
        filterWorkflow: 'Generation type',
        allUsers: 'All users',
        allWorkflows: 'All types',
        download: 'Download CSV',
        cancel: 'Cancel',
        loading: 'Generating report...',
        noData: 'No data for selected period',
        success: 'Report downloaded',
        error: 'Error creating report',
        includeLinks: 'Include content links',
        details: 'DETAILS',
        summary: 'SUMMARY',
        totalGenerations: 'Total generations',
        totalTokens: 'Total tokens',
        byUsers: 'BY USERS',
        byWorkflow: 'BY WORKFLOW',
        generations: 'Generations',
        tokens: 'Tokens',
        links: 'Links',
        reportTitle: 'Organization report',
        periodLabel: 'Period',
        includeRawData: 'Include raw input raw response',
        includeInput: 'Include input parameters (raw input)',
        includeResponse: 'Include API response (raw response)',
        rawInput: 'Raw Input',
        rawResponse: 'Raw Response',
        mark: 'Mark'
      },
      tracing: 'Tracing',
      tracingTitle: 'Pipeline Tracing',
      dataPopupCurrent: 'Current',
      dataPopupHistory: 'History',
      dataPopupTracing: 'Tracing',
      dataPopupCopy: 'Copy',
      dataPopupCopied: 'Copied!',
      dataPopupNoHistory: 'No request history yet. History will appear after you send requests.',
      dataPopupAllUsers: 'All users',
      dataPopupAllUsersEmpty: 'No requests for this workflow yet.',
      dataPopupAllUsersError: 'Failed to load requests. Close and reopen this window to retry.',
      dataPopupAllUsersLoading: 'Loading requests…',
      textPreview: 'Text',
      viewText: 'View text',
      category: 'Category',
      allCategories: 'All Categories',
      categoryImage: 'Image',
      categoryVideo: 'Video',
      categoryVoice: 'Voice',
      categoryText: 'Text',
      category3D: '3D',
      check: {
        button: 'Check',
        success: 'Generation completed',
        stillRunning: 'Generation still running',
        failed: 'Generation check failed',
      },
      externalActor: {
        via: 'via',
        title: 'External actor reported by the calling system',
      },
    },

    // Text result modal
    textResult: {
      title: 'Text Result',
      copy: 'Copy to Clipboard',
      copied: 'Copied!',
      download: 'Download as .txt',
      close: 'Close',
      tokens: 'tokens',
    },

    // Admin cross-org export
    adminExport: {
      title: 'Cross-Organization Export',
      button: 'Export Report',
      filterOrganization: 'Organization',
      allOrganizations: 'All Organizations',
      byOrganization: 'BY ORGANIZATION',
      organizationColumn: 'Organization',
      reportTitle: 'Organization Report',
      truncationWarning: 'Report contains only {count} of {total} records. Reduce the period or select a specific organization.',
      selectAll: 'Select all',
      deselectAll: 'Deselect all',
      selectedCount: 'Selected: {count}',
      searchOrganizations: 'Search organizations...',
      exportProgress: 'Exporting: {org} ({current}/{total})',
      cancel: 'Cancel',
    },

    // Settings Context
    settingsContext: {
      title: 'Settings',
      subtitle: 'Customize your experience',
      userSettings: 'User Settings',
      notifications: 'Notifications',
      notificationsDesc: 'Email and push notifications',
      enable: 'Enable',
      system: 'System',
      systemAdministration: 'System administration',
      sendFeedback: 'Send Feedback',
      sendFeedbackDesc: 'Report bugs or suggest features',
      logoutDesc: 'Sign out of your account',
      about: 'About',
      version: 'Version:',
      build: 'Build:',
      environment: 'Environment:',
      copyright: `© ${new Date().getFullYear()} LoreMax AI`,
      madeWith: 'Made with ❤️ for creators'
    },

    // Gallery Context
    galleryContext: {
      title: 'Gallery',
      searchImages: 'Search media...',
      filters: 'Filters',
      recent: 'Recent',
      viewAll: 'View All →',
      statistics: 'Statistics',
      totalImages: 'Total Images:',
      thisMonth: 'This Month:',
      storageUsed: 'Storage Used:',
      actions: 'Actions',
      exportAll: 'Export All',
      deleteSelected: 'Delete Selected',
      share: 'Share',
      downloadZip: 'Download Zip',
      favorites: 'Favorites',
      emptyState: 'Generate media to see them here'
    },

    // Gallery Widget - Live Generation
    galleryWidget: {
      generationResults: 'Generation Results',
      noGenerations: 'No generations yet',
      startGenerating: 'Start generating media to see them here',
      clearAll: 'Clear All',
      addFavorite: 'Add to favorites',
      removeFavorite: 'Remove from favorites',
      viewFull: 'View full image',
      download: 'Download',
      copyPrompt: 'Copy prompt',
      helpTitle: 'Gallery Help',
      helpWhatIs: 'What is the Generation Gallery?',
      helpWhatIsDesc: 'This is a live generation gallery that shows your AI image generations in real-time during the current session.',
      helpSessionOnly: 'Session-Only Storage',
      helpSessionOnlyDesc: 'All generations shown here are only available during your current session. When you refresh or reload the page, they will be moved to your history.',
      helpActions: 'Available Actions',
      helpFavorite: 'Star: Add to favorites',
      helpDownload: 'Download: Save image to device',
      helpCopy: 'Copy: Copy prompt to clipboard',
      helpPreview: 'Click anywhere: View full-size image',
      // Display settings
      displayOptions: 'Display Options',
      viewMode: 'View Mode',
      gridView: 'Grid',
      listView: 'List',
      zoom: 'Zoom',
      zoomLarge: 'Large',
      zoomMediumLarge: 'Medium+',
      zoomMedium: 'Medium',
      zoomMediumSmall: 'Medium-',
      zoomSmall: 'Small',
      settingsInfo: 'Information',
      gridDescription: 'Grid view shows images in a responsive grid',
      listDescription: 'List view shows images in a compact list format'
    },

    // Session Gallery Widget - for image generation page
    sessionGallery: {
      title: 'Session Gallery',
      helpTitle: 'Session Gallery Help',
      helpWhatIs: 'What is the Session Gallery?',
      helpWhatIsDesc: 'This is a live gallery that shows your AI image generations in real-time during the current generation session.',
      helpSessionOnly: 'Session-Only Storage',
      helpSessionOnlyDesc: 'All generations shown here are only available during your current session. When you refresh or reload the page, they will be moved to your history.',
      helpActions: 'Available Actions',
      helpFavorite: 'Star: Add to favorites',
      helpDownload: 'Download: Save image to device',
      helpCopy: 'Copy: Copy prompt to clipboard',
      helpPreview: 'Click anywhere: View full-size image',
      previousGeneration: 'Previous generation (↑)',
      nextGeneration: 'Next generation (↓)'
    },

    // Gallery Page - Comprehensive Content Gallery
    galleryPage: {
      title: 'Content Gallery',
      subtitle: 'View and manage all generated content',
      searchPlaceholder: 'Search prompts and descriptions...',
      filters: 'Filters',
      clearFilters: 'Clear Filters',
      activeFilters: 'Active filters:',
      clearAllFilters: 'Clear all filters',
      showFilters: 'Show Filters',
      hideFilters: 'Hide Filters',
      collections: 'Collections',
      allCollections: 'All Collections',
      users: 'Users',
      allUsers: 'All Users',
      workflows: 'Workflows',
      allWorkflows: 'All Workflows',
      dateRange: 'Date Range',
      dateFrom: 'From',
      dateTo: 'To',
      urlType: 'Image Type',
      allTypes: 'All Types',
      preview: 'Preview',
      original: 'Original',
      external: 'External',
      mixed: 'Mixed',
      displaySettings: 'Display Settings',
      viewMode: 'View Mode',
      gridView: 'Grid',
      listView: 'List',
      zoom: 'Zoom',
      zoomSmall: 'Small',
      zoomMediumSmall: 'Medium-',
      zoomMedium: 'Medium',
      zoomMediumLarge: 'Medium+',
      zoomLarge: 'Large',
      loading: 'Loading...',
      loadingMore: 'Loading more...',
      noResults: 'No results found',
      noResultsDesc: 'Try adjusting your search or filter settings',
      totalImages: 'Total Images',
      selectedImages: 'Selected Images',
      selectAll: 'Select All',
      deselectAll: 'Deselect All',
      bulkActions: 'Bulk Actions',
      downloadSelected: 'Download Selected',
      deleteSelected: 'Delete Selected',
      addToCollection: 'Add to Collection',
      removeFromCollection: 'Remove from Collection',
      imageDetails: 'Image Details',
      prompt: 'Prompt',
      createdAt: 'Created',
      createdBy: 'Created By',
      workflow: 'Workflow',
      collection: 'Collection',
      dimensions: 'Dimensions',
      fileSize: 'File Size',
      generationId: 'Generation ID',
      copyId: 'Copy ID',
      noAccess: 'No Access',
      noAccessDesc: 'You do not have access to the media gallery',
      errorLoading: 'Error Loading',
      errorLoadingDesc: 'Failed to load media. Please try refreshing the page.',
      retry: 'Retry',
      selectCollections: 'Search collections...',
      searchCollections: 'Search collections...',
      selectUsers: 'Select users...',
      searchUsers: 'Search users...',
      noUsersFound: 'No users found',
      selectWorkflows: 'Select workflows...',
      searchWorkflows: 'Search workflows...',
      filtersAvailableInGallery: 'Filters available in gallery',
      filterSelected: 'Selected',
      filterNoWorkflows: 'No workflows',
      filterNoUsers: 'No users',
      audioLabel: 'Audio',
      contentType: 'Content Type',
      allMedia: 'All',
      images: 'Images',
      videos: 'Videos',
      audio: 'Audio',
      threeD: '3D Models',
      textType: 'Text',
      selectContentTypes: 'Select content types...',
      searchContentTypes: 'Search content types...',
      noContentTypesFound: 'No content types found',
      approveState: 'Approve State',
      selectApproveState: 'Select approve state...',
      searchApproveState: 'Search approve state...',
      noApproveStateFound: 'No approve state found',
      // Prompt V2 display in preview modal
      selectedReferences: 'Selected References',
      noReferences: 'No reference images',
      references: 'References',
      referenceImages: 'Reference Images',
      holdToZoom: 'Hold to zoom',
      downloadFailed: 'All downloads failed',
      downloadPartialFail: '{count} file(s) failed to download',
      generationParams: 'Generation Parameters',
      booleanYes: 'Yes',
      booleanNo: 'No'
    },

    // Prompt Editor Widget
    promptEditor: {
      helpTitle: 'Prompt Editor Help',
      helpWhatIs: 'What is the Prompt Editor?',
      helpWhatIsDesc: 'The Prompt Editor is your main tool for creating and editing text prompts that describe the images you want to generate with AI.',
      helpHowToUse: 'How to Use',
      helpHowToUseDesc: 'Write a detailed description of the image you want to create. Be specific about:',
      helpSubject: 'Subject (person, object, scene)',
      helpStyle: 'Art style (realistic, cartoon, painting)',
      helpColors: 'Colors and lighting',
      helpComposition: 'Composition and details',
      helpTips: 'Tips for Better Results',
      helpTip1: 'Use specific, descriptive words',
      helpTip2: 'Separate ideas with commas',
      helpTip3: 'Start with the main subject',
      helpTip4: 'Add style keywords for better aesthetics'
    },

    // Modal
    modal: {
      close: 'Close'
    },

    // Help Context
    helpContext: {
      title: 'Help & Support',
      subtitle: 'Useful links and contacts',
      linksTitle: 'Important Links',
      termsOfService: 'General Terms',
      privacyNotice: 'Privacy Notice',
      supportEmail: 'Email Support',
      supportEmailAddress: 'support@loremax.ai',
      mainTitle: 'Welcome to Help Center',
      mainDescription: 'Here you will find useful links and contact information. Use the sidebar to access important documents and contact support.',
      documentation: 'Documentation',
      mcpIntegration: 'MCP Integration'
    },

    // MCP Documentation Page
    mcpDocs: {
      title: 'MCP Integration',
      backToHelp: 'Back to Help',
      loading: 'Loading...',
      loadError: 'Failed to load document',
      forLlm: 'For LLM'
    },

    // Video Context
    videoContext: {
      title: 'Video Generation',
      comingSoon: 'Coming soon...'
    },
    // Icon Bar
    iconBar: {
      home: 'Home',
      profile: 'Profile',
      image: 'Image',
      multi: 'Multi',
      gallery: 'Gallery',
      video: 'Video',
      audio: 'Audio',
      text: 'Text',
      threeD: '3D',
      settings: 'Settings',
      help: 'Help',
      collapse: 'Collapse',
      expand: 'Expand',
      admin: 'Admin'
    },

    // Multi (parallel multi-model generation)
    multiGen: {
      title: 'Multi generation',
      subtitle: 'Pick several models and generate across all of them at once',
      models: 'Models',
      taskType: 'Task type',
      noModelsForTab: 'No models for this task type',
      noTabs: 'No models available for Multi. Tag models with a task type in the admin panel.',
      settings: 'Settings',
      settingsFlyoutTitle: 'Model settings',
      settingsFlyoutClose: 'Close model settings',
      generate: 'Generate',
      generateCount: 'Generate ({count})',
      generating: 'Generating…',
      results: 'Results',
      totalCost: 'Total',
      noModelsSelected: 'Select at least one model',
      sharedInput: 'Shared input',
      noModelSettings: 'No adjustable settings',
      unsupportedModel: 'This model needs inputs Multi cannot provide — run it on its own page',
      multiSlotModel: 'This model needs several source media inputs — run it on its own page',
      multiViewAllPerRequestModel: 'This model processes one file per request — use all files in one request for Multi Image → 3D',
      requiredViewMissing: 'This model requires a source view that is not filled',
      modelInvalid: 'Fix model settings',
      sourceImageRequired: 'Add a source image',
      sourceVideoRequired: 'Add a source video',
      secondViewRequired: 'Upload at least two views (Front plus one more)',
      sharedInputInvalid: 'Fill in the required shared input fields',
      settingsLoading: 'Model settings are still loading — try again in a moment',
      prompt: 'Prompt',
      settingsLoadFailed: "Some models' settings failed to load — open them and press Retry",
      allModelsInvalid: 'All selected models have invalid settings — fix them and try again',
      someModelsSkipped: 'Skipped {count} model(s) with invalid settings',
      launchFailed: 'Could not start generation — please try again',
      loadError: 'Failed to load the model list',
      retry: 'Retry',
      pendingEstimates: '+{count} not estimated',
      tabs: {
        text2image: 'Text → Image',
        image2image: 'Image → Image',
        text2video: 'Text → Video',
        image2video: 'Image → Video',
        video2video: 'Video → Video',
        text2_3d: 'Text → 3D',
        image2_3d: 'Image → 3D',
        multiimage2_3d: 'Multi Image → 3D'
      }
    },

    // Organization Context
    organizationContext: {
      profile: 'Profile'
    },

    // Admin Context
    adminContext: {
      title: 'Admin Panel',
      subtitle: 'System administration',
      dashboard: 'Dashboard',
      dashboardDesc: 'System overview and statistics',
      users: 'Users',
      usersDesc: 'Manage system administrators',
      organizations: 'Organizations',
      organizationsDesc: 'Manage organizations and limits',
      prompts: 'Global Prompts',
      promptsDesc: 'Manage system-wide prompts',
      'prompts-v2': 'References',
      'prompts-v2Desc': 'Manage references with categories',
      'prompt-categories': 'Reference Categories',
      'prompt-categoriesDesc': 'Manage reference categories and subcategories',
      widgets: 'Widgets',
      widgetsDesc: 'Manage widget types and display settings',
      workflows: 'Workflows',
      workflowsDesc: 'Manage AI generation workflows',
      debug: 'Debug Tools',
      debugDesc: 'System maintenance and diagnostics',
      billing: 'Billing',
      billingDesc: 'View payment transactions',
      packages: 'Token Packages',
      packagesDesc: 'Manage token bundle packages',
      refunds: 'All Refunds',
      refundsDesc: 'Refunded tokens across all orgs',
      'api-keys': 'Service Keys',
      'api-keysDesc': 'Service API keys for machine access',
      quickStats: 'Quick Stats',
      administration: 'Administration',
      systemStatus: 'System Status',
      operational: 'Operational',
      connected: 'Connected',
      available: 'Available',
      active: 'Active',
      accessDenied: 'Access Denied',
      accessDeniedDesc: 'You do not have administrator privileges'
    },

    // PromptV2 System
    promptsV2: {
      title: 'References',
      subtitle: 'Manage references for Prompt Editor widget',
      createNew: 'Create Prompt',
      createPrivate: 'Create Private Prompt',
      editPrompt: 'Edit Prompt',
      deletePrompt: 'Delete Prompt',
      deleteConfirm: 'Are you sure you want to delete this prompt?',
      deleteAll: 'Delete All',
      deleteAllTitle: 'Delete all prompts?',
      confirmDeleteAll: 'This will delete ALL prompts and cannot be undone. Type "delete" to confirm:',
      allPromptsDeleted: 'All prompts deleted',
      noPrompts: 'No prompts found',
      searchPlaceholder: 'Search by title or content...',

      visibility: {
        label: 'Visibility',
        public: 'Public',
        corporate: 'Organization',
        private: 'Private',
        publicDesc: 'Available to all system users',
        corporateDesc: 'Available only to users in your organization',
        privateDesc: 'Available only to you'
      },

      nsfw: {
        label: 'NSFW Content',
        description: 'Mark this prompt as adult content. Only visible to organizations with NSFW enabled.',
        warning: 'This prompt will only be visible to organizations that have NSFW content enabled.'
      },

      filters: {
        all: 'All',
        public: 'Public',
        corporate: 'Organization',
        private: 'Private',
        category: 'Category',
        subcategory: 'Subcategory',
        selectCategory: 'Select category',
        selectSubcategory: 'Select subcategory',
        nsfwAll: 'All content',
        nsfwSafe: 'Safe only',
        nsfwOnly: 'NSFW only'
      },

      form: {
        title: 'Title',
        titlePlaceholder: 'Enter prompt title',
        titleTranslations: 'Title Translations',
        description: 'Description',
        descriptionPlaceholder: 'Enter prompt description...',
        descriptionTranslations: 'Description Translations',
        body: 'Content',
        bodyPlaceholder: 'Enter prompt text',
        bodyOptional: 'Content Optional',
        bodyOptionalPlaceholder: 'Enter optional additional prompt text...',
        imagesRequired: 'Required images',
        imagesOptional: 'Optional images',
        videoUrls: 'Video URLs',
        audioUrls: 'Audio URLs',
        visibility: 'Visibility',
        categories: 'Categories',
        selectCategories: 'Select categories',
        tileConfig: 'Tile Settings',
        charactersMode: 'Characters Mode',
        charactersModeDesc: 'Allows creating prompts with multiple characters',
        characters: 'Characters',
        addCharacter: 'Add Character',
        characterName: 'Character Name',
        characterPrompt: 'Character Prompt',
        characterSubcategory: 'Character Subcategory',
        removeCharacter: 'Remove Character'
      },

      visualSettings: 'Visual Settings',
      saveFirstToUploadMedia: 'Please save the prompt first to upload media',

      tileConfig: {
        displayType: 'Display Type',
        none: 'No Tile',
        singleImage: 'Single Image',
        imagePair: 'Image Pair (before/after)',
        singleVideo: 'Video',
        singleAudio: 'Audio',
        slideshow: 'Slideshow (up to 5 images)',

        uploadImage: 'Upload Image',
        uploadBefore: 'Upload "Before" Image',
        uploadAfter: 'Upload "After" Image',
        uploadVideo: 'Upload Video',
        uploadAudio: 'Upload Audio',
        slideshowImage: 'Image',

        comparisonMode: 'Comparison Mode',
        slider: 'Slider',
        autoSwitch: 'Auto Switch',
        autoSwitchDelay: 'Auto Switch Delay (ms)',

        slideshowTransition: 'Transition Effect',
        instant: 'Instant',
        fade: 'Fade',
        slide: 'Slide',
        slideshowDelay: 'Delay between slides (seconds)',

        uploading: 'Uploading...',
        deleteMedia: 'Delete',
        replaceMedia: 'Replace',
        confirmDeleteMedia: 'Delete this media?',
        fileUploaded: 'File uploaded',
        dropFileHere: 'Drop file here...',
        dragDrop: 'Drag file here or click to select',
        uploadError: 'File upload error'
      },

      // Messages as top-level properties
      created: 'Prompt created successfully',
      updated: 'Prompt updated successfully',
      deleted: 'Prompt deleted successfully',
      error: 'Error performing operation',
      loadError: 'Failed to load prompts',
      favoriteAdded: 'Added to favorites',
      favoriteRemoved: 'Removed from favorites',

      // Import/Export
      importExport: {
        export: 'Export',
        exportAll: 'Export All',
        exportOptions: 'Export Options',
        includeIds: 'Include prompt IDs',
        includeIdsDesc: 'Include database IDs for ID-based import mapping. When importing, prompts will be updated by ID instead of title.',
        import: 'Import',
        importing: 'Importing...',
        importPrompts: 'Import Prompts',
        selectFile: 'Select file',
        chooseFile: 'Choose file...',
        fileLoaded: 'File loaded',
        readyToImport: 'Ready to import from',
        invalidFormat: 'Invalid file format',
        invalidJson: 'Invalid JSON file',
        missingPrompts: 'Missing prompts array',
        updateMode: 'Update Mode',
        updateExisting: 'Update existing',
        updateExistingDesc: 'If a prompt with the same title is found - update data',
        skipExisting: 'Skip existing',
        skipExistingDesc: 'If a match is found - skip, import only new',
        importSuccess: 'Import completed',
        importedCount: 'Created',
        updatedCount: 'Updated',
        skippedCount: 'Skipped',
        exportSuccess: 'Export completed',
        categoryNotFound: 'Category not found',
        importResults: 'Import Results',
        errors: 'Errors',
        warnings: 'Warnings',
        noChanges: 'No changes',
        importedItems: 'Created prompts',
        updatedItems: 'Updated prompts',
        skippedItems: 'Skipped prompts'
      },
      sidebar: {
        general: 'General',
        content: 'Content',
        contentOptional: 'Optional',
        images: 'Images',
        media: 'Media',
        categories: 'Categories',
        visual: 'Visual'
      }
    },

    promptCategories: {
      title: 'Reference Categories',
      subtitle: 'Manage categories and subcategories for references',
      categories: 'Categories',
      subcategories: 'Subcategories',
      createCategory: 'Create Category',
      createSubcategory: 'Create Subcategory',
      createSubSubcategory: 'Create Sub-subcategory',
      editCategory: 'Edit Category',
      editSubcategory: 'Edit Subcategory',
      deleteCategory: 'Delete Category',
      deleteSubcategory: 'Delete Subcategory',
      confirmDelete: 'Are you sure you want to delete',
      deleteAll: 'Delete All',
      deleteAllTitle: 'Delete all categories?',
      confirmDeleteAll: 'This will delete ALL categories and cannot be undone. Type "delete" to confirm:',
      allCategoriesDeleted: 'All categories deleted',
      noCategories: 'No categories found',
      noSubcategories: 'No subcategories found',
      rootCategory: 'Root Category (No Parent)',
      parentCategoryHint: 'Select parent to create subcategory (max 3 levels)',
      maxDepthReached: 'Maximum nesting depth reached',
      repairAssignments: 'Repair Links',
      repairAssignmentsDescription: 'Update prompt-category links after hierarchy changes',
      repairSuccess: 'Links updated',
      repairError: 'Error repairing links',

      form: {
        name: 'Name',
        namePlaceholder: 'Enter name',
        description: 'Description',
        descriptionPlaceholder: 'Enter description',
        parentCategory: 'Parent Category',
        selectParent: 'Select category',
        isActive: 'Active',
        isActiveDesc: 'Inactive categories are hidden from users',
        analysisApiUrl: 'Analysis API URL',
        analysisApiUrlPlaceholder: 'https://api.example.com/analyze',
        analysisApiUrlHelp: 'URL to call for generating prompt descriptions from images. Leave empty to inherit from parent category.'
      },

      columns: {
        name: 'Name',
        description: 'Description',
        parentCategory: 'Category',
        promptCount: 'Prompts',
        subcategoryCount: 'Subcategories',
        contentType: 'Content Type',
        mode: 'Mode',
        selectionMode: 'Selection',
        status: 'Status',
        actions: 'Actions'
      },

      status: {
        active: 'Active',
        inactive: 'Inactive'
      },

      contentType: {
        image: 'Image',
        video: 'Video',
        both: 'Image & Video'
      },

      mode: {
        default: 'Default',
        characters: 'Characters'
      },

      selectionMode: {
        label: 'Selection Mode',
        multi: 'Multi',
        single: 'Single',
        multiDesc: '1 prompt from each subcategory',
        singleDesc: '1 prompt from entire category tree',
        inherited: 'Inherited',
        inheritedFrom: 'Inherited from parent'
      },

      // Messages as top-level properties
      categoryCreated: 'Category created successfully',
      categoryUpdated: 'Category updated successfully',
      categoryDeleted: 'Category deleted successfully',
      subcategoryCreated: 'Subcategory created successfully',
      subcategoryUpdated: 'Subcategory updated successfully',
      subcategoryDeleted: 'Subcategory deleted successfully',
      statusUpdated: 'Status updated successfully',
      error: 'Error performing operation',
      loadError: 'Failed to load data',

      // Import/Export
      importExport: {
        export: 'Export',
        exportAll: 'Export All',
        import: 'Import',
        importCategories: 'Import Categories',
        selectFile: 'Select file',
        chooseFile: 'Choose file...',
        fileLoaded: 'File loaded',
        readyToImport: 'Ready to import from',
        invalidFormat: 'Invalid file format',
        invalidJson: 'Invalid JSON file',
        missingCategories: 'Missing categories array',
        updateMode: 'Update Mode',
        updateExisting: 'Update existing',
        updateExistingDesc: 'If a match is found by ID or name - update data',
        skipExisting: 'Skip existing',
        skipExistingDesc: 'If a match is found - skip, import only new',
        importSuccess: 'Import completed',
        importedCount: 'Created',
        updatedCount: 'Updated',
        skippedCount: 'Skipped',
        exportSuccess: 'Export completed',
        importResults: 'Import Results',
        errors: 'Errors',
        noChanges: 'No changes',
        importedItems: 'Created categories',
        updatedItems: 'Updated categories',
        skippedItems: 'Skipped categories'
      },
      referenceLimits: {
        title: 'Reference Limits',
        description: 'Configure media limits for references in this category',
        mediaCountsTitle: 'Media Count Limits',
        maxTotal: 'Max Total',
        maxImages: 'Max Images',
        maxVideos: 'Max Videos',
        maxAudio: 'Max Audio',
        fileSizesTitle: 'File Size Limits (MB)',
        imageMaxSize: 'Image',
        videoMaxSize: 'Video',
        audioMaxSize: 'Audio',
        durationsTitle: 'Duration Limits (seconds)',
        videoMaxDuration: 'Video Max Duration',
        audioMaxDuration: 'Audio Max Duration',
        noLimit: 'No limit',
        compressionTitle: 'Image Compression',
        compressionEnabled: 'Enable compression',
        compressionQuality: 'Quality',
        compressionMaxDimension: 'Max Dimension (px)'
      },
      categoryModal: {
        editTitle: 'Edit Category',
        createTitle: 'New Category',
        sidebar: {
          general: 'General',
          names: 'Names & Descriptions',
          settings: 'Analysis API',
          limits: 'Reference Limits',
        },
      },
    },

    promptSelection: {
      title: 'Select Prompt',
      subtitle: 'Choose a prompt from available categories',
      searchPlaceholder: 'Search prompts...',
      noResults: 'No prompts found',
      selectPrompt: 'Select Prompt',
      favorites: 'Favorites',
      recent: 'Recent',
      category: 'Category',
      allCategories: 'All Categories',
      close: 'Close',

      tabs: {
        all: 'All',
        public: 'Public',
        corporate: 'Organization',
        private: 'My Prompts',
        favorites: 'Favorites'
      }
    },

    // User-created prompts (references)
    userPrompts: {
      addReference: 'Add reference',
      createReference: 'Create Reference',
      editReference: 'Edit Reference',
      viewReference: 'View Reference',
      titleLabel: 'Title',
      titlePlaceholder: 'Enter title',
      descLabel: 'Description',
      descPlaceholder: 'Enter description (optional)',
      bodyLabel: 'Prompt text',
      bodyPlaceholder: 'Enter prompt text',
      bodyOptionalLabel: 'Additional Data (keywords, formula)',
      bodyOptionalPlaceholder: 'Enter additional keywords, formulas, or optional data',
      promptDetailsTitle: 'Prompt Details',
      imagesLabel: 'Images (up to 10)',
      uploadFile: 'Upload file',
      pasteUrl: 'Paste URL',
      addImageUrl: 'Add image URL',
      visibilityLabel: 'Visibility',
      visibilityOrg: 'Organization',
      visibilityOrgDesc: 'Visible to all organization members',
      visibilityPrivate: 'Private',
      visibilityPrivateDesc: 'Only you can see',
      save: 'Save',
      cancel: 'Cancel',
      edit: 'Edit',
      delete: 'Delete',
      confirmDelete: 'Delete this reference?',
      saving: 'Saving...',
      uploading: 'Uploading...',
      createSuccess: 'Reference created successfully',
      updateSuccess: 'Reference updated successfully',
      deleteSuccess: 'Reference deleted successfully',
      createError: 'Failed to create reference',
      updateError: 'Failed to update reference',
      deleteError: 'Failed to delete reference',
      dragDropHint: 'Drag and drop images here or click to select',
      maxImages: 'Maximum 10 images',
      removeImage: 'Remove image',
      categoryLabel: 'Category',
      selectCategory: 'Select category',
      // Subcategory creation
      createSubcategory: 'Create Subcategory',
      addCategory: 'Add category',
      subcategoryName: 'Name',
      subcategoryNamePlaceholder: 'Enter name',
      subcategoryNameRequired: 'Name is required',
      subcategoryCreated: 'Subcategory created',
      selectionMode: 'Selection Mode',
      selectionModeSingle: 'Single',
      selectionModeMulti: 'Multiple',
      selectionModeDescription: 'Single: only one item can be selected. Multiple: several items can be selected.',
      generateDescription: 'Generate description',
      generatingDescription: 'Generating description...',
      generateDescriptionError: 'Failed to generate description',
      analyzeImages: 'Analyze Reference Images',
      analyzing: 'Analyzing...',
      expandAll: 'Expand All',
      collapseAll: 'Collapse All',
      invalidUrl: 'Invalid URL',
      uploadFailed: 'Upload failed',
      titleRequired: 'Title is required',
      saveFailed: 'Save failed',
      analyzingReferences: 'Analyzing references...',
    },

    promptEditorV2: {
      title: 'Reference Builder',
      description: 'Select references with categories and subcategories',
      selectCategory: 'Select category',
      selectedPrompt: 'Selected Prompt',
      selectedPrompts: 'Selected Prompts',
      noPromptsSelected: 'No prompts selected',
      noPromptsMessage: 'No prompts found',
      clickToSelect: 'Click to select',
      searchPlaceholder: 'Search prompts...',
      createPrivatePrompt: 'Create Private Prompt',
      style: 'Style',
      background: 'Background',
      characters: {
        title: 'Characters',
        characterNumber: 'Character',
        selectForCharacter: 'Select prompt...'
      },
      scenario: 'Scenario',
      errors: {
        noPromptSelected: 'Please select at least one prompt from the database',
        noCharactersSelected: 'Please select prompts for characters',
        promptRequired: 'Please enter a prompt for generation',
        promptOrSelectionRequired: 'Please enter a prompt or select at least one prompt from the database'
      },
      helpTitle: 'Reference Builder',
      helpWhatIs: 'What is the Reference Builder?',
      helpWhatIsDesc: 'The Reference Builder lets you compose AI generation requests using a library of visual, audio, and text references. Select references from organized categories to guide the AI model in creating exactly what you need.',
      helpCategories: 'Categories & References',
      helpCategoriesDesc: 'References are organized into categories (Characters, Camera, Objects, Mood, etc.). Click a category to browse and select references. Each reference can include images, videos, or audio that are sent to the AI model.',
      helpCatRecommended: 'Orange dot: Recommended — auto-selected, can be deselected',
      helpCatSelected: 'Green dot: Selected — manually chosen reference',
      helpCatOptional: 'Gray dot: Optional — available media from references',
      helpMediaLimits: 'Media Limits',
      helpMediaLimitsDesc: 'AI models accept a limited number of media files per generation. The counter (e.g., "8/14") shows how many media slots are used. You can select images, videos, and audio from references up to the configured limits.',
      helpSessionRef: 'Session References',
      helpSessionRefDesc: 'Use "Add Reference" to upload temporary references for the current session — quick uploads or gallery picks for one-off use. Saved references (via "Create Reference" in the References page) are permanent and shared across your organization.',
      helpPrompt: 'Prompt',
      helpPromptDesc: 'The text prompt at the bottom is combined with selected reference data and sent to the AI model. Reference descriptions and prompt text work together to guide the generation result.',
      helpExamplesTitle: 'Usage Examples',
      helpExamplesIntro: 'Here are common workflows using the Reference Builder:',
      helpEx1: 'Game asset: Select "Objects" category → pick a reference (e.g., "Wooden Chess Pawn") → its images and prompt are sent to the model along with your text prompt',
      helpEx2: 'Scene composition: Select references from "Place/Background" + "Characters" + "Camera" categories → the model receives style images and descriptions from each to compose the scene',
      helpEx3: 'Quick experiment: Click "Add Reference" → upload a photo → add description "use this color palette and lighting" → generate without creating a permanent reference',
      helpEx4: 'Style transfer: Select a "Mood" reference with style images → add a session reference with your own sketch → the model combines the style with your composition',
    },

    // API Error messages (Fal.AI and other providers)
    apiErrors: {
      providerUnavailable: 'API provider is temporarily unavailable. Please try again later.',
      generationTimeout: 'Generation timeout exceeded. Please try again.',
      contentPolicy: 'Content violates service usage policies.',
      imageTooSmall: 'Image is too small. Please use a larger image.',
      imageTooLarge: 'Image is too large. Please reduce the size and try again.',
      imageLoad: 'Failed to load image. Check the file and try again.',
      faceNotDetected: 'No face detected in the image.',
      unsupportedFormat: 'Unsupported file format.',
      fileTooLarge: 'File is too large. Please reduce the size and try again.',
      internalServer: 'Internal server error. Please try again later.',
      contentPolicyNoRefund: 'Content policy violations may result in tokens not being refunded, depending on workflow settings.',
      contentPolicyNoRefundConfirmed: 'Content policy violation detected. Tokens for this generation were not refunded.',
    },

    // Landing page
    landing: {
      tagline: 'Multi-Modal AI Platform',
      hero: {
        title: 'Create Images, Videos & More with AI',
        subtitle: 'Professional multi-modal AI platform powered by industry-leading models: Video (Veo, Sora, Kling), Images (FLUX, Imagen4, WAN), and specialized editing tools',
        cta: 'Start Creating Now',
        learn: 'Learn More'
      },
      stats: {
        images: 'Images Generated',
        users: 'Active Users',
        uptime: 'Uptime',
        support: 'Support'
      },
      features: {
        title: 'Powerful Features',
        subtitle: 'Everything you need to create professional AI-generated artwork',
        generation: {
          title: 'AI Image Generation',
          description: 'Create stunning images with cutting-edge Flux AI technology'
        },
        prompts: {
          title: 'Smart Prompts',
          description: 'Enhanced prompts with Google Gemini AI for better results'
        },
        gallery: {
          title: 'Organized Content Gallery',
          description: 'Manage and organize your creations in a professional content gallery'
        },
        organizations: {
          title: 'Team Collaboration',
          description: 'Work with your team and manage usage limits efficiently'
        }
      },
      cta: {
        title: 'Ready to Start Creating?',
        subtitle: 'Join thousands of creators using our AI-powered platform to bring their ideas to life',
        button: 'Get Started Free'
      },
      footer: {
        rights: 'All rights reserved.',
        terms: 'General Terms',
        privacy: 'Privacy Notice'
      }
    },

    // Top-level sections for navigation errors
    workflows: {
      title: 'Workflows',
      noWorkflows: 'No workflows'
    },
    
    users: {
      title: 'Users',
      noUsers: 'No users'
    },

    gallery: {
      displayOptions: 'Display Options',
      zoomSmall: 'Small',
      zoomMediumSmall: 'Medium-',
      zoomMedium: 'Medium',
      zoomMediumLarge: 'Medium+',
      zoomLarge: 'Large',
      viewMode: 'View Mode',
      gridView: 'Grid',
      listView: 'List',
      zoom: 'Zoom',
      settingsInfo: 'Settings are saved automatically',
      gridDescription: 'Grid view shows images in a responsive grid',
      listDescription: 'List view shows images in a compact list format',
      // Error handling
      error: 'Error',
      viewError: 'View Error',
      viewErrorDetails: 'View error details',
      errorDetails: 'Error Details',
      notRefunded: 'Not refunded',
      errorMessage: 'Error Message',
      apiErrorDetails: 'API Error Details',
      generationInfo: 'Generation Info',
      generationId: 'ID',
      timestamp: 'Time',
      prompt: 'Prompt',
      noPrompt: 'No prompt',
      copyError: 'Copy Error',
      copiedError: 'Copied!',
      close: 'Close',
      unknownError: 'Unknown error occurred',
      expand: 'Expand',
      collapse: 'Collapse',
      // Admin tracing tabs in ErrorDetailsModal
      errorTab: 'Error',
      tracingTab: 'Tracing',
      rawInputTab: 'Raw Input',
      rawResponseTab: 'Raw Response',
      loadingTrace: 'Loading trace data...',
      noTraceData: 'No trace data available',
      addFavorite: 'Add to favorites',
      removeFavorite: 'Remove from favorites',
      // Trash functionality
      trash: 'Trash',
      trashAutoHide: 'Items will be permanently deleted after 30 days',
      viewTrash: 'View deleted items',
      viewingTrash: 'Viewing trash',
      moveToTrash: 'Move to Trash',
      restore: 'Restore',
      select: 'Select',
      selectMode: 'Selection mode',
      selected: 'Selected',
      selectAll: 'Select All',
      deselectAll: 'Deselect All',
      confirmTrashTitle: 'Move to Trash?',
      confirmTrashMessage: 'Selected items will be moved to trash.',
      confirmTrashSingleMessage: 'This item will be moved to trash.',
      confirmTrashCount: 'Items selected: {count}',
      confirmTrashNote: 'Items will be permanently deleted after 30 days.',
      dontShowAgain: "Don't show this again",
      addToCollection: 'Add to Collection',
      removeFromCollection: 'Remove from Collection',
      addToCollectionMenu: 'Add to collection...',
      removeFrom: 'Remove from:',
      collectionActions: 'Collections',
      // Recreate functionality
      recreate: 'Recreate',
      workflowUnavailable: 'Workflow is unavailable or has been deleted',
      copyPrompt: 'Copy prompt',
      promptCopied: 'Copied!',
      download: 'Download',
      downloaded: 'Downloaded!',
      downloadOriginal: 'Download original',
      downloadWebP: 'Download WebP',
      downloadedWebP: 'Downloaded WebP!',
      mark: {
        like: 'Good',
        dislike: 'Bad',
        approved: 'Approved',
      },
      markFailed: 'Failed to update mark',
    },

    // Auth section
    auth: {
      signIn: 'Sign In',
      signUp: 'Sign Up',
      getStarted: 'Get Started',
      required: 'Authentication Required',
      loginRequired: 'Please sign in to continue',
      loginInstructions: 'You need to sign in to access the platform',
      loginToAccess: 'Sign in to access'
    },

    // Terms page
    terms: {
      title: 'General Terms',
      loading: 'Loading...',
      loadError: 'Failed to load document',
      backToHome: 'Back to Home'
    },

    // Privacy Notice page
    privacy: {
      title: 'Privacy Notice',
      loading: 'Loading...',
      loadError: 'Failed to load document',
      backToHome: 'Back to Home'
    },

    // Pricing page
    pricing: {
      title: 'Pricing',
      tagline: 'Simple token-based billing for AI creators',
      backToHome: 'Back to Home',
      contactSales: 'Contact Sales',
      hero: {
        title: 'Consumption-based billing for all creators',
        subtitle: 'Pay for what you use. No plans. No limits.',
        description: 'One unified balance for all image, 3D, and video models. All features included. Unlimited users. Full commercial rights.',
        tokenPrice: 'Token Price',
        tokenValue: '1 token = $0.001',
        estimatedImages: '≈ 30–60 images per $1'
      },
      features: {
        title: 'Everything included. No feature locks.',
        subtitle: 'All features are available to every user — you only pay for what you generate.',
        allModels: 'Access to all Image, 3D, and Video AI models',
        allModelsDesc: 'Use any available models',
        commercial: 'Commercial license for all users',
        commercialDesc: 'Use generated content commercially',
        unlimited: 'Unlimited members and projects',
        unlimitedDesc: 'Add as many users as you like',
        customTraining: 'Custom AI training for studios (on request)',
        customTrainingDesc: 'Train models on your data',
        workspace: 'Secure workspaces & Google SSO',
        workspaceDesc: 'Enterprise authentication and security',
        support: 'Email support (Standard SLA)',
        supportDesc: 'Technical support via email'
      },
      tokenPacks: {
        title: 'Buy Tokens',
        tokenPrice: '1 token = $0.001',
        neverExpire: 'Tokens never expire',
        description: 'Purchase once and use anytime. No limits, no expiration.',
        estimatedImages: 'images',
        mostPopular: 'Most Popular',
        contactForMore: 'Need more? Contact Sales for volume purchase'
      },
      subscription: {
        title: 'Subscription: Create more for the same budget',
        subtitle: 'Get up to 30% off every token with a LoreMax Subscription',
        monthly: {
          title: 'Monthly Plan',
          subtitle: 'Perfect for regular creators',
          price: 'from $29',
          period: '/month',
          discount: '10% off all tokens',
          description: 'Subscribe for $29, $100, $300/mo or any amount — you choose!'
        },
        annual: {
          title: 'Annual Plan',
          subtitle: 'Maximum savings for committed creators',
          price: 'from $290',
          period: '/year',
          discount: '30% off all tokens',
          description: 'Subscribe for $290, $1,200, $3,600/yr or any amount — you choose!',
          badge: 'Best Value'
        },
        example: 'Example:',
        exampleText: 'If you spend $500 on tokens each month, annual subscription saves you $150/mo — that\'s $1,800/year (30% off).',
        startSubscription: 'Start Subscription →',
        howItWorks: 'How it works:',
        howItWorksText: 'Subscription discounts apply automatically to all tokens included in your subscription size. Additional one-time token purchases get no discount.',
        calculator: {
          title: 'Savings Calculator',
          monthlySpend: 'Your monthly token spend: $',
          monthlySavings: 'Monthly savings (with annual Subscription):',
          yearlySavings: 'Yearly savings (with annual Subscription):',
          spendInTokens: 'Monthly spend in tokens:'
        }
      },
      enterprise: {
        badge: 'From $2,500/month or custom agreement',
        title: 'Enterprise and Studio Partners',
        subtitle: 'For teams managing high-volume pipelines and custom AI setups.',
        talkToSales: 'Talk to Sales →',
        features: {
          api: 'API access & volume discounts',
          invoicing: 'Flexible invoicing and purchase orders',
          workspace: 'Advanced workspace and user management',
          slack: 'Dedicated Slack support with SLA',
          customModels: 'Custom model training & pipeline optimization',
          earlyAccess: 'Early access to new features'
        }
      },
      faq: {
        title: 'Frequently Asked Questions',
        subtitle: 'Everything you need to know about LoreMax pricing',
        questions: {
          howPricing: {
            q: 'How does pricing work on LoreMax?',
            a: 'LoreMax keeps pricing simple — no seat licenses, no locked features. Everything runs on a transparent pay-as-you-go system powered by Tokens. Each generation — whether it\'s an image, video, 3D scene, or audio — consumes a certain number of Tokens. You only pay for what you create. Optional monthly or annual subscriptions provide lower token rates and more flexibility.'
          },
          runOut: {
            q: 'What happens if I run out of tokens?',
            a: 'You can top up your balance anytime. Purchase one-time Token Packs, or activate (or increase) a subscription to get discounted tokens automatically. Subscription tokens refresh at the start of each billing cycle for active subscribers.'
          },
          members: {
            q: 'How many members can join my workspace?',
            a: 'Unlimited. Invite as many team members as you like — designers, producers, or collaborators. All members share the same token balance within the organization, and you only pay for what your team creates. User limits and permissions can be customized in the Enterprise plan.'
          },
          cancel: {
            q: 'Can I still use LoreMax after cancelling a subscription?',
            a: 'Yes. All your generated content and account data remain accessible. You only need tokens on your balance to continue creating new assets. Your data stays available under the standard LoreMax retention policy.'
          },
          expire: {
            q: 'Do tokens expire?',
            a: 'One-time purchased tokens never expire and remain valid indefinitely until used. Subscription tokens renew automatically at the start of each billing cycle. Create when you want — no deadlines, no pressure.'
          },
          commercial: {
            q: 'Can I use generated content commercially?',
            a: 'Yes — all users receive a full commercial license for everything generated from public foundation models. For custom-trained models, you are responsible for ensuring you have rights to your training data. Use your creations freely in games, apps, trailers, marketing campaigns, and more.'
          },
          invoice: {
            q: 'Can I pay by invoice or purchase order?',
            a: 'Yes. Enterprise customers can pay via invoice, PO, or other agreed billing methods. Contact sales@loremax.ai for invoicing or payment options.'
          },
          discount: {
            q: 'What is the subscription discount?',
            a: 'Subscriptions make every token cheaper: 10% off with a monthly subscription, 30% off with an annual subscription. No limits — just lower cost per token.'
          },
          integrate: {
            q: 'Can I integrate LoreMax into our workflow or API?',
            a: 'Yes. Enterprise customers can access the LoreMax API and request custom pipeline integrations. Reach out to our Sales team for details: sales@loremax.ai'
          }
        }
      },
      footer: {
        copyright: '© 2025 LoreMax.ai - All rights reserved'
      }
    },

    // OpenAPI Modal
    openApiModal: {
      title: 'API Documentation',
      copy: 'Copy',
      copied: 'Copied!',
      close: 'Close'
    },

    // cURL Examples Modal
    curlExamplesModal: {
      title: 'cURL Examples',
      executeTitle: 'Execute Workflow',
      executeDescription: 'Start a new generation with this workflow',
      checkTitle: 'Check Generation Status',
      checkDescription: 'Poll the status of an async generation',
      request: 'Request',
      copy: 'Copy',
      copied: 'Copied!',
      copyAll: 'Copy All',
      copiedAll: 'Copied!',
      successResponse: 'Success Response',
      inProgressResponse: 'In Progress Response',
      errorResponse: 'Error Response',
      close: 'Close',
      loading: 'Loading schema...',
      availableParams: 'Available Parameters',
      availableParamsDesc: 'Parameters accepted by this workflow',
      parameters: 'Parameters',
      fileUploadNote: 'Note: This workflow supports file uploads via multipart/form-data',
      mediaInputs: 'Media Inputs (URLs)',
      rateLimiting: 'Rate Limiting',
      rateLimitingDesc: 'API requests are rate limited per API key',
      rateLimitNote: 'Rate limits are configured per API key. All successful responses include rate limit headers, except status checks (/generations/:id/check), which are not rate limited:',
      rateLimitExceeded: 'When rate limit is exceeded, you will receive a 429 response with Retry-After header indicating seconds to wait.',
      pipelineBadge: 'Pipeline — API v2',
      pipelineNote: 'This workflow uses a multi-step pipeline and requires API v2 endpoints.'
    },

    // Input Text Widget
    inputText: {
      title: 'Input Text',
      placeholder: 'Enter your text here...',
      field1: 'Field 1',
      field2: 'Field 2',
      requiredHint: 'required',
      optionalHint: 'optional',
      errors: {
        empty: 'Input is required',
        tooLong: 'Input is too long'
      }
    },

    // MCP OAuth Consent Page
    mcpAuth: {
      title: 'Authorize Application',
      subtitle: 'An external application is requesting access to your account',
      requestsAccess: 'requests access',
      selectOrganization: 'Select organization',
      scopeLabel: 'Requested access level',
      scopeRead: 'Read',
      scopeReadDesc: 'View your workflows, references, and balance',
      scopeStandard: 'Standard',
      scopeStandardDesc: 'Read + generate content and upload files',
      scopeFull: 'Full',
      scopeFullDesc: 'Standard + create and modify references',
      authorize: 'Authorize',
      deny: 'Deny',
      signingIn: 'Loading...',
      notSignedIn: 'Authentication required',
      signInRequired: 'You must sign in to authorize this application.',
      signInButton: 'Sign In',
      noOrganizations: 'No organizations available',
      noOrganizationsDesc: 'You have no organizations. Contact your administrator.',
      error: 'Authorization error',
      unknownClient: 'Unknown application',
      permissionsTitle: 'Permissions',
      authorizing: 'Authorizing...',
      authorizationDenied: 'Authorization denied. You can close this window.',
      invalidScope: 'Invalid scope requested. The application may be misconfigured.',
    }
  }
};

export function useLocalization(language: Language): LocalizationStrings {
  const [strings, setStrings] = useState<LocalizationStrings>(LOCALIZATION[language]);
  
  // Принудительно обновляем локализацию при изменении языка
  useEffect(() => {
    setStrings(LOCALIZATION[language]);
  }, [language]);
  
  
  return strings;
}
